import * as i0 from '@angular/core';
import { Injectable, Component, EventEmitter, ChangeDetectionStrategy, Inject, ChangeDetectorRef, ViewChild, Input, Output, Pipe, NgModule } from '@angular/core';
import { MareLoaderService, MareLoaderModule } from '@mare-common/ngx-mare-loader';
import * as i1 from '@angular/material/paginator';
import { MatPaginator, PageEvent, MatPaginatorModule } from '@angular/material/paginator';
import * as i1$1 from '@angular/material/dialog';
import { MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';
import * as i2 from '@angular/material/snack-bar';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import * as i4 from '@angular/common';
import { DOCUMENT, CommonModule } from '@angular/common';
import * as i4$1 from '@angular/flex-layout/flex';
import * as i5 from '@angular/material/toolbar';
import { MatToolbarModule } from '@angular/material/toolbar';
import * as i6 from '@angular/material/button';
import { MatButtonModule } from '@angular/material/button';
import * as i7 from '@angular/forms';
import { FormBuilder, Validators, FormControl, FormsModule, ReactiveFormsModule } from '@angular/forms';
import * as i8 from '@angular/material/core';
import { MatNativeDateModule, MatOptionModule } from '@angular/material/core';
import * as i9 from '@angular/material/checkbox';
import { MatCheckboxModule } from '@angular/material/checkbox';
import * as i10 from '@angular/material/form-field';
import { MatFormFieldModule } from '@angular/material/form-field';
import * as i2$1 from '@angular/material/icon';
import { MatIconModule } from '@angular/material/icon';
import * as i12 from '@angular/material/input';
import { MatInputModule } from '@angular/material/input';
import * as i13 from '@angular/material/select';
import { MatSelectModule } from '@angular/material/select';
import * as moment$1 from 'moment';
import { Subscription } from 'rxjs/internal/Subscription';
import { BehaviorSubject, of, fromEvent, merge, Observable } from 'rxjs';
import { catchError, finalize, debounceTime, distinctUntilChanged, tap } from 'rxjs/operators';
import * as i20 from '@ngx-translate/core';
import { TranslateService, TranslateModule } from '@ngx-translate/core';
import { cloneDeep } from 'lodash';
import { Router } from '@angular/router';
import * as i3$2 from '@mare-common/ngx-mare-common';
import { EventInteractionService } from '@mare-common/ngx-mare-common';
import * as i17 from '@angular/material/sort';
import { MatSort, MatSortModule } from '@angular/material/sort';
import * as i18 from '@angular/material/table';
import { MatTableDataSource, MatTableModule } from '@angular/material/table';
import { NgxDynamicFormComponent } from '@mare-common/ngx-dynamic-form';
import * as i1$2 from '@mare-common/ngx-mare-auth';
import { MareAuthModule } from '@mare-common/ngx-mare-auth';
import * as i3 from '@angular/flex-layout/extended';
import * as i10$1 from '@angular/material/card';
import { MatCardModule } from '@angular/material/card';
import * as i13$1 from '@angular/material/tooltip';
import { MatTooltipModule } from '@angular/material/tooltip';
import * as i7$1 from '@angular/material/datepicker';
import { MatDatepickerModule } from '@angular/material/datepicker';
import * as i11 from '@angular/material/radio';
import { MatRadioModule } from '@angular/material/radio';
import * as i3$1 from '@angular/platform-browser';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatChipsModule } from '@angular/material/chips';
import { MatDividerModule } from '@angular/material/divider';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatListModule } from '@angular/material/list';
import { MatMenuModule } from '@angular/material/menu';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatStepperModule } from '@angular/material/stepper';
import { GridsterModule } from 'angular-gridster2';
import { MatTableExporterModule } from '@mare-common/mat-table-exporter';
import { FlexLayoutModule } from '@angular/flex-layout';
import * as ItalianLocale from 'plotly.js/lib/locales/it.js';

class NgxDynamicDashboardService {
    constructor() { }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.9", ngImport: i0, type: NgxDynamicDashboardService, deps: [], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "16.2.9", ngImport: i0, type: NgxDynamicDashboardService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.9", ngImport: i0, type: NgxDynamicDashboardService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: function () { return []; } });

class NgxDynamicDashboardComponent {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.9", ngImport: i0, type: NgxDynamicDashboardComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.9", type: NgxDynamicDashboardComponent, selector: "lib-ngx-dynamic-dashboard", ngImport: i0, template: `
    <p>
      ngx-dynamic-dashboard works!
    </p>
  `, isInline: true }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.9", ngImport: i0, type: NgxDynamicDashboardComponent, decorators: [{
            type: Component,
            args: [{ selector: 'lib-ngx-dynamic-dashboard', template: `
    <p>
      ngx-dynamic-dashboard works!
    </p>
  ` }]
        }] });

class NgxDynamicDashboardCustomPaginator extends MatPaginator {
    set disabled(disabled) {
        this.isSettingDisabled = true;
        this._disabled = disabled;
        this.paginator.disabled = disabled;
    }
    get disabled() {
        return this._disabled;
    }
    constructor(paginator, changeDetectorRef) {
        super(paginator._intl, changeDetectorRef);
        this.paginator = paginator;
        this.changeDetectorRef = changeDetectorRef;
        this.isSettingDisabled = false;
        this.allignValues();
        this.page = new EventEmitter();
        this.paginator.page.subscribe((data) => {
            // console.log('CustomPaginator receive the paginator page event', data);
        });
    }
    allignValues() {
        this.pageSize = this.paginator.pageSize;
        this.pageIndex = this.paginator.pageIndex;
        this.length = this.paginator.length;
        this.disabled = this.paginator.disabled;
        //this.page = this.paginator.page;
    }
    inverseAllignValues() {
        this.paginator.pageSize = this.pageSize;
        this.paginator.pageIndex = this.pageIndex;
        this.paginator.length = this.length;
        this.paginator.disabled = this.disabled;
        //this.page = this.paginator.page;
    }
    // getNumberOfPages() {
    //     return this.paginator.getNumberOfPages();
    // }
    _changePageSize(pageSize) {
        if (!this.isSettingDisabled) {
            this.inverseAllignValues();
            this.paginator._changePageSize(pageSize);
        }
        this.isSettingDisabled = false;
    }
    publishEvent(page) {
        // console.log('CustomPaginator page event generated', page);
        this.page.emit(page);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.9", ngImport: i0, type: NgxDynamicDashboardCustomPaginator, deps: [{ token: i1.MatPaginator }, { token: i0.ChangeDetectorRef }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.9", type: NgxDynamicDashboardCustomPaginator, selector: "ngx-dynamic-dashboard-custom-paginator", usesInheritance: true, ngImport: i0, template: '<mat-paginator #paginator pageSize="10"></mat-paginator>', isInline: true, dependencies: [{ kind: "component", type: i1.MatPaginator, selector: "mat-paginator", inputs: ["disabled"], exportAs: ["matPaginator"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.9", ngImport: i0, type: NgxDynamicDashboardCustomPaginator, decorators: [{
            type: Component,
            args: [{
                    selector: 'ngx-dynamic-dashboard-custom-paginator',
                    template: '<mat-paginator #paginator pageSize="10"></mat-paginator>',
                }]
        }], ctorParameters: function () { return [{ type: i1.MatPaginator }, { type: i0.ChangeDetectorRef }]; } });

// import { ApiService } from 'app/main/shared/services/api.service';
class AdminEditComponent {
    constructor(dialogRef, datas, snackBar, dialog, ref) {
        this.dialogRef = dialogRef;
        this.datas = datas;
        this.snackBar = snackBar;
        this.dialog = dialog;
        this.ref = ref;
        this.hide1 = false;
        // Banks for ABI
        this.relatedBanks = [];
        this.banks = [];
        // File uploading variables
        this.formData = new FormData();
        this.logoId = '';
        this.fileLoading = false;
        // On change password emitter
        this.onChangePassword = new EventEmitter();
        this.onChangeUsername = new EventEmitter();
        this.onSendingPushNotification = new EventEmitter();
    }
    ngOnInit() {
        // Checks where dialog is opened from 
        if (this.datas) {
            this.formGroup = this.datas.formGroup;
        }
        if (this.datas.urlToUpload) {
            this.urlToUpload = this.datas.urlToUpload;
        }
        if (this.datas.uploadFunction) {
            this.uploadFunction = this.datas.uploadFunction;
        }
        if (this.datas.modals) {
            this.modals = this.datas.modals;
        }
        console.log('admin-edit-component');
    }
    ngAfterViewInit() {
        // // Checks for data and sets to input 
        // if (this.datas && this.datas.data) {
        //   if (this.datas.data.name) {
        //     this.formGroup.controls.name.setValue(this.datas.data.name);
        //   }
        //   if (this.datas.data.ruolo) {
        //     this.formGroup.controls.role.setValue(this.datas.data.ruolo);
        //   }
        //   if (this.datas.data.surname) {
        //     this.formGroup.controls.surname.setValue(this.datas.data.surname);
        //   }
        //   if (this.datas.data.abi) {
        //     this.formGroup.controls.abi.setValue(this.datas.data.abi);
        //   }
        //   if (this.datas.data.tipo) {
        //     this.formGroup.controls.type.setValue(this.datas.data.tipo);
        //   }
        // }
    }
    // File uploading 
    // documentInput(event) {
    //   if (this.uploadFunction != undefined && this.uploadFunction != null) {
    //     this.uploadFunction(event, this.formGroup);
    //   } else {
    //     const filesToUpload = <Array<File>>event.target.files;
    //     for (let i = 0; i < filesToUpload.length; i++) {
    //       this.formData.append('file', filesToUpload[i]);
    //     }
    //     if (this.urlToUpload == undefined || this.urlToUpload == null)
    //       this.urlToUpload = 'banca/logoUpload';
    //     this.api.postFileRequest(this.urlToUpload, this.formData)
    //       .subscribe((res: any) => {
    //         console.log(res);
    //         this.formGroup.controls.logo.setValue(res['payload']);
    //         this.newSnackbar('Logo caricato con successo', 'success');
    //       }, (err: any) => {
    //         console.log(err);
    //       }, () => {
    //       });
    //   }
    // }
    // Sends data back
    async sendData() {
        if (!this.formGroup.value['pushNotificationMsg']) {
            this.dialogRef.close({
                data: this.formGroup.value
            });
        }
        else {
            this.sendPushNotification();
        }
    }
    buttonClicked(bt, par) {
        let data = {};
        if (this.formGroup != undefined && this.formGroup != null) {
            data = {
                data: this.formGroup.value
            };
        }
        if (bt.action != undefined && bt.action != null) {
            try {
                bt.action(par);
            }
            catch (ex) {
                console.log(ex);
            }
        }
        let canClose = false;
        if (bt.closeDialog != undefined && bt.closeDialog != null)
            canClose = bt.closeDialog;
        if (canClose) {
            this.dialogRef.close(data);
        }
    }
    changePassword() {
        return this.onChangePassword.emit();
    }
    changeUsername() {
        return this.onChangeUsername.emit();
    }
    sendPushNotification() {
        return this.onSendingPushNotification.emit();
    }
    // New edit or create dialog
    newDialog(data, callback) {
        const dialog = this.dialog.open(AdminEditComponent, {
            width: '400px',
            panelClass: 'custom-panel-class',
            data: data,
        });
        dialog.afterClosed().subscribe((datas) => {
            if (datas) {
                callback(datas);
            }
        });
    }
    // Opens new snackbar
    newSnackbar(text, snackBarClass) {
        return this.snackBar.open(`${text}`, '', {
            duration: 2000,
            panelClass: snackBarClass,
        });
    }
    // Checks password
    // passwordConfirming(c: AbstractControl): { invalid: boolean } {
    //   if (c.get('password').value !== c.get('confirmPassword').value) {
    //     return { invalid: true };
    //   }
    // }
    getPswRequired(element) {
        if (element !== undefined && element != null && element.isRequired !== undefined && element.isRequired != null) {
            return element.isRequired;
        }
        else {
            // di default è sempre true se pre true per la Password a meno che non venga espliciato required=false;
            return true;
        }
    }
    openModal(modal) {
        const dialog = this.dialog.open(modal.controller, {
            width: '400px',
            panelClass: 'custom-panel-class',
            data: modal.data ? modal.data : {},
        });
        dialog.afterClosed().subscribe((datas) => {
            if (datas) {
                console.log(datas);
            }
            if (modal.afterClosedCallback != undefined && modal.afterClosedCallback != null)
                modal.afterClosedCallback(datas, this.formGroup, modal, this.ref);
        });
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.9", ngImport: i0, type: AdminEditComponent, deps: [{ token: i1$1.MatDialogRef }, { token: MAT_DIALOG_DATA }, { token: i2.MatSnackBar }, { token: i1$1.MatDialog }, { token: i0.ChangeDetectorRef }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.9", type: AdminEditComponent, selector: "app-admin-edit", ngImport: i0, template: "<mat-toolbar color=\"accent\" class=\"mat-toolbar-custom\">\n  <mat-toolbar-row class=\"profile-header-row\">\n    <span class=\"name-profile\">{{datas?.topHeader}}</span>\n    <button (click)=\"dialogRef.close()\" class=\"exit-button\" mat-mini-fab>\n      <mat-icon>close</mat-icon>\n    </button>\n  </mat-toolbar-row>\n</mat-toolbar>\n\n<div class=\"bank-details\">\n  <div class=\"bank-header\" *ngIf=\"datas?.header || datas?.changePassword\">\n    <ng-container *ngIf=\"datas?.header\">\n      {{datas?.header}}\n    </ng-container> \n    <button *ngIf=\"datas?.changePassword\" class=\"options-button\" mat-icon-button (click)=select.open()>\n      <mat-icon>more_vert</mat-icon>\n      <mat-select #select class=\"options-select\">\n        <mat-option (click)=\"changePassword()\">\n          <mat-icon color=\"primary\">phonelink_lock</mat-icon>Cambia Password\n        </mat-option>\n        <mat-option (click)=\"changeUsername()\">\n          <mat-icon color=\"primary\">person_outline</mat-icon>Cambia Username\n        </mat-option>\n      </mat-select>\n    </button>\n  </div>\n  <div class=\"bank-details-row\">\n\n    <form *ngIf=\"formGroup\" [formGroup]=\"formGroup\" fxLayout=\"column\" fxLayoutGap=\"16px\">\n\n      <mat-form-field *ngFor=\"let select of datas?.specialSelect\" class=\"detail-input\" appearance=\"outline\">\n        <mat-label>{{select?.placeholder}}</mat-label>\n        <mat-select formControlName=\"{{select?.formControlName}}\" [placeholder]=\"select?.placeholder\"\n          [multiple]=\"select?.multiple\">\n          <mat-option [value]=\"option?.name\" *ngFor=\"let option of select?.options; let i = index\"\n            [disabled]=\"option?.setDisabled\">\n            {{option?.name}}\n          </mat-option>\n        </mat-select>\n      </mat-form-field>\n\n\n      <mat-form-field *ngFor=\"let input of datas?.inputs\" class=\"detail-input\" appearance=\"outline\">\n        <mat-label>{{input?.placeholder}}</mat-label>\n        <input formControlName=\"{{input?.formControlName}}\" matInput [placeholder]=\"input?.placeholder\">\n        <mat-icon matSuffix *ngIf=\"input?.icon\">{{input?.icon}}</mat-icon>\n      </mat-form-field>\n\n      <div *ngFor=\"let input of datas?.checks\" class=\"detail-input\" appearance=\"outline\">\n        <mat-label>{{input?.label}}</mat-label>\n        <mat-checkbox matInput formControlName=\"{{input?.formControlName}}\"><small>{{input?.placeholder}}</small></mat-checkbox>\n        <mat-icon matSuffix *ngIf=\"input?.icon\">{{input?.icon}}</mat-icon>\n      </div>\n\n      <mat-form-field *ngFor=\"let input of datas?.textareas\" class=\"detail-input\" appearance=\"outline\">\n        <mat-label>{{input?.placeholder}}</mat-label>\n        <textarea formControlName=\"{{input?.formControlName}}\" matInput [placeholder]=\"input?.placeholder\"></textarea>\n        <mat-icon matSuffix *ngIf=\"input?.icon\">{{input?.icon}}</mat-icon>\n      </mat-form-field>\n\n\n      <!-- <mat-form-field *ngIf=\"!datas?.edit && datas?.username\" class=\"detail-input\" appearance=\"outline\">\n        <mat-label>Password</mat-label>\n        <input [type]=\"hide ? 'text' : 'password'\" matInput formControlName=\"password\" placeholder=\"Password\" required>\n        <button mat-icon-button matSuffix (click)=\"hide = !hide\" [attr.aria-label]=\"'Hide password'\"\n          [attr.aria-pressed]=\"hide\">\n          <mat-icon>{{hide ? 'visibility_off' : 'visibility'}}</mat-icon>\n        </button>\n      </mat-form-field> -->\n\n      <mat-form-field *ngFor=\"let password of datas?.passwords\" class=\"detail-input\" appearance=\"outline\">\n        <mat-label>{{password?.placeholder}}</mat-label>\n        <input [type]=\"hide1 ? 'text' : 'password'\" matInput formControlName=\"{{password?.formControlName}}\"\n          [placeholder]=\"password?.placeholder\"  [required]=\"getPswRequired(password)\">\n        <button mat-icon-button matSuffix (click)=\"hide1 = !hide1\" [attr.aria-label]=\"'Hide password'\"\n          [attr.aria-pressed]=\"hide1\">\n          <mat-icon>{{hide1 ? 'visibility_off' : 'visibility'}}</mat-icon>\n        </button>\n        <mat-error [hidden]=\"password?.formControlName?.valid\" class=\"alert-danger\">\n          Le password non coincidono\n        </mat-error>\n      </mat-form-field>\n\n\n      <mat-form-field *ngFor=\"let select of datas?.selects\" class=\"detail-input\" appearance=\"outline\">\n        <mat-label>{{select?.placeholder}}</mat-label>\n        <mat-select formControlName=\"{{select?.formControlName}}\" [placeholder]=\"select?.placeholder\"\n          [multiple]=\"select?.multiple\">\n          <mat-option [value]=\"option.value ? option.value : option?.name\" *ngFor=\"let option of select?.options; let i = index\"\n            [disabled]=\"option?.setDisabled\">\n            {{option?.name}}\n          </mat-option>\n        </mat-select>\n      </mat-form-field>\n\n    </form>\n\n  </div>\n\n  <div class=\"bank-details-row image-row flex-row\" *ngFor=\"let upload of datas?.uploads\">\n    <span class=\"bank-header\">{{upload?.placeholder}}</span>\n    <!-- <button color=\"accent\" *ngIf=\"!fileLoading\" class=\"add-files-button\" (click)=\"fileInput.click()\" mat-mini-fab>\n      <i class=\"material-icons\">add</i>\n      <form>\n        <input #fileInput type=\"file\" accept=\"image/jpeg,image/gif,image/png\" multiple (change)=\"documentInput($event)\"\n          style=\"display:none;\" />\n      </form>\n    </button> -->\n    <!-- <div *ngIf=\"fileLoading\">\n      <mat-progress-spinner diameter=\"40\" class=\"loading\" color=\"primary\" mode=\"indeterminate\">\n      </mat-progress-spinner>\n    </div> -->\n  </div>\n\n  <div class=\"bank-details-row image-row flex-row\" *ngFor=\"let modal of modals\">\n    <span class=\"bank-header\">{{modal?.placeholder}}</span>\n    <button color=\"accent\" *ngIf=\"!fileLoading\" class=\"add-files-button\" (click)=\"openModal(modal)\" mat-mini-fab>\n      <i class=\"material-icons\">add</i>\n    </button>\n    <span class=\"currentFile\" *ngIf=\"modal.currentVal\">\n      File corrente {{modal.currentVal.currentName}}\n    </span>\n    <!-- <button color=\"accent\" *ngIf=\"!fileLoading\" class=\"add-files-button\" (click)=\"fileInput.click()\" mat-mini-fab>\n      <i class=\"material-icons\">add</i>\n      <form>\n        <input #fileInput type=\"file\" accept=\"image/jpeg,image/gif,image/png\" multiple (change)=\"documentInput($event)\"\n          style=\"display:none;\" />\n      </form>\n    </button> -->\n    <!-- <div *ngIf=\"fileLoading\">\n      <mat-progress-spinner diameter=\"40\" class=\"loading\" color=\"primary\" mode=\"indeterminate\">\n      </mat-progress-spinner>\n    </div> -->\n  </div>\n\n  <div class=\"bank-details-row button-row\" *ngIf=\"formGroup && !datas?.buttons\" fxLayoutAlign=\"center center\">\n    <button (click)=\"sendData()\" color=\"accent\" *ngIf=\"formGroup\" [disabled]=\"!formGroup.valid\" class=\"flex-button\"\n      mat-flat-button>{{datas?.button}}</button>\n  </div>\n  <div class=\"bank-details-row flex-row\" *ngIf=\"datas?.buttons\">\n    <button *ngFor=\"let bt of datas.buttons\" (click)=\"buttonClicked(bt)\" color=\"{{bt.color ? bt.color : 'accent'}}\" class=\"flex-button\"\n      mat-flat-button>\n      <mat-icon *ngIf=\"bt.hasIcon\" >{{bt.iconName}}</mat-icon> {{bt.label}}</button>\n  </div>\n\n</div>", styles: [".mat-dialog-container{padding:0;max-height:80vh!important;overflow-y:auto!important}.profile-header-row{justify-content:space-between}.exit-button{box-shadow:none!important}.bank-details{padding:2%}.bank-header{padding:5%;font-weight:900;font-size:18px;width:100%}.detail-input{width:380px}.bank-details-image{width:300px;padding:2%;border:1.5px solid rgba(0,0,0,.1);border-radius:15px}.image-row{display:flex;flex-direction:column;align-items:center;width:100%}.flex-row{display:flex;flex-direction:row}.flex-button{margin-top:20px;margin-left:3px;margin-right:3px;flex:1;color:#fff!important}.add-files-button{margin-left:auto;justify-self:flex-end;margin-right:20px;box-shadow:none!important}.add-files-button i{color:#fff;vertical-align:auto!important}.title-button{margin-top:20px;width:100%;color:#fff!important}.options-select{visibility:hidden}.options-button{padding-left:8px!important;margin-left:15px!important}.loading{margin-right:20px}.mat-form-field-infix{padding:1em 0!important;border-top:.84375em solid transparent}\n"], dependencies: [{ kind: "directive", type: i4.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i4.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i4$1.DefaultLayoutDirective, selector: "  [fxLayout], [fxLayout.xs], [fxLayout.sm], [fxLayout.md],  [fxLayout.lg], [fxLayout.xl], [fxLayout.lt-sm], [fxLayout.lt-md],  [fxLayout.lt-lg], [fxLayout.lt-xl], [fxLayout.gt-xs], [fxLayout.gt-sm],  [fxLayout.gt-md], [fxLayout.gt-lg]", inputs: ["fxLayout", "fxLayout.xs", "fxLayout.sm", "fxLayout.md", "fxLayout.lg", "fxLayout.xl", "fxLayout.lt-sm", "fxLayout.lt-md", "fxLayout.lt-lg", "fxLayout.lt-xl", "fxLayout.gt-xs", "fxLayout.gt-sm", "fxLayout.gt-md", "fxLayout.gt-lg"] }, { kind: "directive", type: i4$1.DefaultLayoutGapDirective, selector: "  [fxLayoutGap], [fxLayoutGap.xs], [fxLayoutGap.sm], [fxLayoutGap.md],  [fxLayoutGap.lg], [fxLayoutGap.xl], [fxLayoutGap.lt-sm], [fxLayoutGap.lt-md],  [fxLayoutGap.lt-lg], [fxLayoutGap.lt-xl], [fxLayoutGap.gt-xs], [fxLayoutGap.gt-sm],  [fxLayoutGap.gt-md], [fxLayoutGap.gt-lg]", inputs: ["fxLayoutGap", "fxLayoutGap.xs", "fxLayoutGap.sm", "fxLayoutGap.md", "fxLayoutGap.lg", "fxLayoutGap.xl", "fxLayoutGap.lt-sm", "fxLayoutGap.lt-md", "fxLayoutGap.lt-lg", "fxLayoutGap.lt-xl", "fxLayoutGap.gt-xs", "fxLayoutGap.gt-sm", "fxLayoutGap.gt-md", "fxLayoutGap.gt-lg"] }, { kind: "directive", type: i4$1.DefaultLayoutAlignDirective, selector: "  [fxLayoutAlign], [fxLayoutAlign.xs], [fxLayoutAlign.sm], [fxLayoutAlign.md],  [fxLayoutAlign.lg], [fxLayoutAlign.xl], [fxLayoutAlign.lt-sm], [fxLayoutAlign.lt-md],  [fxLayoutAlign.lt-lg], [fxLayoutAlign.lt-xl], [fxLayoutAlign.gt-xs], [fxLayoutAlign.gt-sm],  [fxLayoutAlign.gt-md], [fxLayoutAlign.gt-lg]", inputs: ["fxLayoutAlign", "fxLayoutAlign.xs", "fxLayoutAlign.sm", "fxLayoutAlign.md", "fxLayoutAlign.lg", "fxLayoutAlign.xl", "fxLayoutAlign.lt-sm", "fxLayoutAlign.lt-md", "fxLayoutAlign.lt-lg", "fxLayoutAlign.lt-xl", "fxLayoutAlign.gt-xs", "fxLayoutAlign.gt-sm", "fxLayoutAlign.gt-md", "fxLayoutAlign.gt-lg"] }, { kind: "component", type: i5.MatToolbar, selector: "mat-toolbar", inputs: ["color"], exportAs: ["matToolbar"] }, { kind: "directive", type: i5.MatToolbarRow, selector: "mat-toolbar-row", exportAs: ["matToolbarRow"] }, { kind: "component", type: i6.MatButton, selector: "    button[mat-button], button[mat-raised-button], button[mat-flat-button],    button[mat-stroked-button]  ", inputs: ["disabled", "disableRipple", "color"], exportAs: ["matButton"] }, { kind: "component", type: i6.MatIconButton, selector: "button[mat-icon-button]", inputs: ["disabled", "disableRipple", "color"], exportAs: ["matButton"] }, { kind: "component", type: i6.MatMiniFabButton, selector: "button[mat-mini-fab]", inputs: ["disabled", "disableRipple", "color"], exportAs: ["matButton"] }, { kind: "directive", type: i7.ɵNgNoValidate, selector: "form:not([ngNoForm]):not([ngNativeValidate])" }, { kind: "directive", type: i7.DefaultValueAccessor, selector: "input:not([type=checkbox])[formControlName],textarea[formControlName],input:not([type=checkbox])[formControl],textarea[formControl],input:not([type=checkbox])[ngModel],textarea[ngModel],[ngDefaultControl]" }, { kind: "directive", type: i7.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { kind: "directive", type: i7.NgControlStatusGroup, selector: "[formGroupName],[formArrayName],[ngModelGroup],[formGroup],form:not([ngNoForm]),[ngForm]" }, { kind: "directive", type: i7.RequiredValidator, selector: ":not([type=checkbox])[required][formControlName],:not([type=checkbox])[required][formControl],:not([type=checkbox])[required][ngModel]", inputs: ["required"] }, { kind: "component", type: i8.MatOption, selector: "mat-option", exportAs: ["matOption"] }, { kind: "component", type: i9.MatCheckbox, selector: "mat-checkbox", inputs: ["disableRipple", "color", "tabIndex"], exportAs: ["matCheckbox"] }, { kind: "component", type: i10.MatFormField, selector: "mat-form-field", inputs: ["hideRequiredMarker", "color", "floatLabel", "appearance", "subscriptSizing", "hintLabel"], exportAs: ["matFormField"] }, { kind: "directive", type: i10.MatLabel, selector: "mat-label" }, { kind: "directive", type: i10.MatError, selector: "mat-error, [matError]", inputs: ["id"] }, { kind: "directive", type: i10.MatSuffix, selector: "[matSuffix], [matIconSuffix], [matTextSuffix]", inputs: ["matTextSuffix"] }, { kind: "component", type: i2$1.MatIcon, selector: "mat-icon", inputs: ["color", "inline", "svgIcon", "fontSet", "fontIcon"], exportAs: ["matIcon"] }, { kind: "directive", type: i12.MatInput, selector: "input[matInput], textarea[matInput], select[matNativeControl],      input[matNativeControl], textarea[matNativeControl]", inputs: ["disabled", "id", "placeholder", "name", "required", "type", "errorStateMatcher", "aria-describedby", "value", "readonly"], exportAs: ["matInput"] }, { kind: "component", type: i13.MatSelect, selector: "mat-select", inputs: ["disabled", "disableRipple", "tabIndex", "panelWidth", "hideSingleSelectionIndicator"], exportAs: ["matSelect"] }, { kind: "directive", type: i7.FormGroupDirective, selector: "[formGroup]", inputs: ["formGroup"], outputs: ["ngSubmit"], exportAs: ["ngForm"] }, { kind: "directive", type: i7.FormControlName, selector: "[formControlName]", inputs: ["formControlName", "disabled", "ngModel"], outputs: ["ngModelChange"] }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.9", ngImport: i0, type: AdminEditComponent, decorators: [{
            type: Component,
            args: [{ selector: 'app-admin-edit', changeDetection: ChangeDetectionStrategy.OnPush, template: "<mat-toolbar color=\"accent\" class=\"mat-toolbar-custom\">\n  <mat-toolbar-row class=\"profile-header-row\">\n    <span class=\"name-profile\">{{datas?.topHeader}}</span>\n    <button (click)=\"dialogRef.close()\" class=\"exit-button\" mat-mini-fab>\n      <mat-icon>close</mat-icon>\n    </button>\n  </mat-toolbar-row>\n</mat-toolbar>\n\n<div class=\"bank-details\">\n  <div class=\"bank-header\" *ngIf=\"datas?.header || datas?.changePassword\">\n    <ng-container *ngIf=\"datas?.header\">\n      {{datas?.header}}\n    </ng-container> \n    <button *ngIf=\"datas?.changePassword\" class=\"options-button\" mat-icon-button (click)=select.open()>\n      <mat-icon>more_vert</mat-icon>\n      <mat-select #select class=\"options-select\">\n        <mat-option (click)=\"changePassword()\">\n          <mat-icon color=\"primary\">phonelink_lock</mat-icon>Cambia Password\n        </mat-option>\n        <mat-option (click)=\"changeUsername()\">\n          <mat-icon color=\"primary\">person_outline</mat-icon>Cambia Username\n        </mat-option>\n      </mat-select>\n    </button>\n  </div>\n  <div class=\"bank-details-row\">\n\n    <form *ngIf=\"formGroup\" [formGroup]=\"formGroup\" fxLayout=\"column\" fxLayoutGap=\"16px\">\n\n      <mat-form-field *ngFor=\"let select of datas?.specialSelect\" class=\"detail-input\" appearance=\"outline\">\n        <mat-label>{{select?.placeholder}}</mat-label>\n        <mat-select formControlName=\"{{select?.formControlName}}\" [placeholder]=\"select?.placeholder\"\n          [multiple]=\"select?.multiple\">\n          <mat-option [value]=\"option?.name\" *ngFor=\"let option of select?.options; let i = index\"\n            [disabled]=\"option?.setDisabled\">\n            {{option?.name}}\n          </mat-option>\n        </mat-select>\n      </mat-form-field>\n\n\n      <mat-form-field *ngFor=\"let input of datas?.inputs\" class=\"detail-input\" appearance=\"outline\">\n        <mat-label>{{input?.placeholder}}</mat-label>\n        <input formControlName=\"{{input?.formControlName}}\" matInput [placeholder]=\"input?.placeholder\">\n        <mat-icon matSuffix *ngIf=\"input?.icon\">{{input?.icon}}</mat-icon>\n      </mat-form-field>\n\n      <div *ngFor=\"let input of datas?.checks\" class=\"detail-input\" appearance=\"outline\">\n        <mat-label>{{input?.label}}</mat-label>\n        <mat-checkbox matInput formControlName=\"{{input?.formControlName}}\"><small>{{input?.placeholder}}</small></mat-checkbox>\n        <mat-icon matSuffix *ngIf=\"input?.icon\">{{input?.icon}}</mat-icon>\n      </div>\n\n      <mat-form-field *ngFor=\"let input of datas?.textareas\" class=\"detail-input\" appearance=\"outline\">\n        <mat-label>{{input?.placeholder}}</mat-label>\n        <textarea formControlName=\"{{input?.formControlName}}\" matInput [placeholder]=\"input?.placeholder\"></textarea>\n        <mat-icon matSuffix *ngIf=\"input?.icon\">{{input?.icon}}</mat-icon>\n      </mat-form-field>\n\n\n      <!-- <mat-form-field *ngIf=\"!datas?.edit && datas?.username\" class=\"detail-input\" appearance=\"outline\">\n        <mat-label>Password</mat-label>\n        <input [type]=\"hide ? 'text' : 'password'\" matInput formControlName=\"password\" placeholder=\"Password\" required>\n        <button mat-icon-button matSuffix (click)=\"hide = !hide\" [attr.aria-label]=\"'Hide password'\"\n          [attr.aria-pressed]=\"hide\">\n          <mat-icon>{{hide ? 'visibility_off' : 'visibility'}}</mat-icon>\n        </button>\n      </mat-form-field> -->\n\n      <mat-form-field *ngFor=\"let password of datas?.passwords\" class=\"detail-input\" appearance=\"outline\">\n        <mat-label>{{password?.placeholder}}</mat-label>\n        <input [type]=\"hide1 ? 'text' : 'password'\" matInput formControlName=\"{{password?.formControlName}}\"\n          [placeholder]=\"password?.placeholder\"  [required]=\"getPswRequired(password)\">\n        <button mat-icon-button matSuffix (click)=\"hide1 = !hide1\" [attr.aria-label]=\"'Hide password'\"\n          [attr.aria-pressed]=\"hide1\">\n          <mat-icon>{{hide1 ? 'visibility_off' : 'visibility'}}</mat-icon>\n        </button>\n        <mat-error [hidden]=\"password?.formControlName?.valid\" class=\"alert-danger\">\n          Le password non coincidono\n        </mat-error>\n      </mat-form-field>\n\n\n      <mat-form-field *ngFor=\"let select of datas?.selects\" class=\"detail-input\" appearance=\"outline\">\n        <mat-label>{{select?.placeholder}}</mat-label>\n        <mat-select formControlName=\"{{select?.formControlName}}\" [placeholder]=\"select?.placeholder\"\n          [multiple]=\"select?.multiple\">\n          <mat-option [value]=\"option.value ? option.value : option?.name\" *ngFor=\"let option of select?.options; let i = index\"\n            [disabled]=\"option?.setDisabled\">\n            {{option?.name}}\n          </mat-option>\n        </mat-select>\n      </mat-form-field>\n\n    </form>\n\n  </div>\n\n  <div class=\"bank-details-row image-row flex-row\" *ngFor=\"let upload of datas?.uploads\">\n    <span class=\"bank-header\">{{upload?.placeholder}}</span>\n    <!-- <button color=\"accent\" *ngIf=\"!fileLoading\" class=\"add-files-button\" (click)=\"fileInput.click()\" mat-mini-fab>\n      <i class=\"material-icons\">add</i>\n      <form>\n        <input #fileInput type=\"file\" accept=\"image/jpeg,image/gif,image/png\" multiple (change)=\"documentInput($event)\"\n          style=\"display:none;\" />\n      </form>\n    </button> -->\n    <!-- <div *ngIf=\"fileLoading\">\n      <mat-progress-spinner diameter=\"40\" class=\"loading\" color=\"primary\" mode=\"indeterminate\">\n      </mat-progress-spinner>\n    </div> -->\n  </div>\n\n  <div class=\"bank-details-row image-row flex-row\" *ngFor=\"let modal of modals\">\n    <span class=\"bank-header\">{{modal?.placeholder}}</span>\n    <button color=\"accent\" *ngIf=\"!fileLoading\" class=\"add-files-button\" (click)=\"openModal(modal)\" mat-mini-fab>\n      <i class=\"material-icons\">add</i>\n    </button>\n    <span class=\"currentFile\" *ngIf=\"modal.currentVal\">\n      File corrente {{modal.currentVal.currentName}}\n    </span>\n    <!-- <button color=\"accent\" *ngIf=\"!fileLoading\" class=\"add-files-button\" (click)=\"fileInput.click()\" mat-mini-fab>\n      <i class=\"material-icons\">add</i>\n      <form>\n        <input #fileInput type=\"file\" accept=\"image/jpeg,image/gif,image/png\" multiple (change)=\"documentInput($event)\"\n          style=\"display:none;\" />\n      </form>\n    </button> -->\n    <!-- <div *ngIf=\"fileLoading\">\n      <mat-progress-spinner diameter=\"40\" class=\"loading\" color=\"primary\" mode=\"indeterminate\">\n      </mat-progress-spinner>\n    </div> -->\n  </div>\n\n  <div class=\"bank-details-row button-row\" *ngIf=\"formGroup && !datas?.buttons\" fxLayoutAlign=\"center center\">\n    <button (click)=\"sendData()\" color=\"accent\" *ngIf=\"formGroup\" [disabled]=\"!formGroup.valid\" class=\"flex-button\"\n      mat-flat-button>{{datas?.button}}</button>\n  </div>\n  <div class=\"bank-details-row flex-row\" *ngIf=\"datas?.buttons\">\n    <button *ngFor=\"let bt of datas.buttons\" (click)=\"buttonClicked(bt)\" color=\"{{bt.color ? bt.color : 'accent'}}\" class=\"flex-button\"\n      mat-flat-button>\n      <mat-icon *ngIf=\"bt.hasIcon\" >{{bt.iconName}}</mat-icon> {{bt.label}}</button>\n  </div>\n\n</div>", styles: [".mat-dialog-container{padding:0;max-height:80vh!important;overflow-y:auto!important}.profile-header-row{justify-content:space-between}.exit-button{box-shadow:none!important}.bank-details{padding:2%}.bank-header{padding:5%;font-weight:900;font-size:18px;width:100%}.detail-input{width:380px}.bank-details-image{width:300px;padding:2%;border:1.5px solid rgba(0,0,0,.1);border-radius:15px}.image-row{display:flex;flex-direction:column;align-items:center;width:100%}.flex-row{display:flex;flex-direction:row}.flex-button{margin-top:20px;margin-left:3px;margin-right:3px;flex:1;color:#fff!important}.add-files-button{margin-left:auto;justify-self:flex-end;margin-right:20px;box-shadow:none!important}.add-files-button i{color:#fff;vertical-align:auto!important}.title-button{margin-top:20px;width:100%;color:#fff!important}.options-select{visibility:hidden}.options-button{padding-left:8px!important;margin-left:15px!important}.loading{margin-right:20px}.mat-form-field-infix{padding:1em 0!important;border-top:.84375em solid transparent}\n"] }]
        }], ctorParameters: function () { return [{ type: i1$1.MatDialogRef }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [MAT_DIALOG_DATA]
                }] }, { type: i2.MatSnackBar }, { type: i1$1.MatDialog }, { type: i0.ChangeDetectorRef }]; } });

class AdminMessageComponent {
    constructor(dialogRef, datas, snackBar, dialog) {
        this.dialogRef = dialogRef;
        this.datas = datas;
        this.snackBar = snackBar;
        this.dialog = dialog;
    }
    ngOnInit() {
        console.log(this.datas);
    }
    ngAfterViewInit() {
    }
    // New edit or create dialog
    newDialog(data, callback) {
        console.log(data);
        const dialog = this.dialog.open(AdminMessageComponent, {
            width: '400px',
            panelClass: 'custom-panel-class',
            data: data,
        });
        dialog.afterClosed().subscribe((datas) => {
            if (datas) {
                callback(datas);
            }
        });
    }
    // Opens new snackbar
    newSnackbar(text, snackBarClass) {
        return this.snackBar.open(`${text}`, '', {
            duration: 2000,
            panelClass: snackBarClass,
        });
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.9", ngImport: i0, type: AdminMessageComponent, deps: [{ token: i1$1.MatDialogRef }, { token: MAT_DIALOG_DATA }, { token: i2.MatSnackBar }, { token: i1$1.MatDialog }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.9", type: AdminMessageComponent, selector: "app-admin-message", ngImport: i0, template: "<mat-toolbar color=\"accent\" class=\"mat-toolbar-custom\">\n  <mat-toolbar-row class=\"profile-header-row\">\n    <span class=\"name-profile\">{{datas.title}}</span>\n    <button (click)=\"dialogRef.close()\" class=\"exit-button\" mat-mini-fab>\n      <mat-icon>close</mat-icon>\n    </button>\n  </mat-toolbar-row>\n</mat-toolbar>\n\n<div class=\"bank-details\">\n  <div class=\"bank-header\" *ngIf=\"datas.subtitle\">\n    <span class=\"subheader\" >{{datas.subtitle}}</span>\n  </div>\n  <div class=\"bank-details-row\">\n    <span class=\"bodySpan\" >{{datas.body}}</span>\n\n  </div>\n\n</div>", styles: [".mat-dialog-container{padding:0 0 15px;max-height:80vh!important;overflow-y:auto!important}.bodySpan{font-size:1.2em}.profile-header-row{justify-content:space-between}.exit-button{box-shadow:none!important}.bank-details{padding:2%;margin-bottom:15px}.bank-header{padding:5%;font-weight:900;font-size:18px;width:100%}.detail-input{width:380px}.bank-details-image{width:300px;padding:2%;border:1.5px solid rgba(0,0,0,.1);border-radius:15px}.image-row{display:flex;flex-direction:column;align-items:center;width:100%}.flex-row{display:flex;flex-direction:row}.add-files-button{margin-left:auto;justify-self:flex-end;margin-right:20px;box-shadow:none!important}.add-files-button i{color:#fff;vertical-align:auto!important}.title-button{margin-top:20px;width:100%;color:#fff!important}.options-select{visibility:hidden}.options-button{padding-left:8px!important;margin-left:15px!important}.loading{margin-right:20px}.mat-form-field-infix{padding:1em 0!important;border-top:.84375em solid transparent}\n"], dependencies: [{ kind: "directive", type: i4.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "component", type: i5.MatToolbar, selector: "mat-toolbar", inputs: ["color"], exportAs: ["matToolbar"] }, { kind: "directive", type: i5.MatToolbarRow, selector: "mat-toolbar-row", exportAs: ["matToolbarRow"] }, { kind: "component", type: i6.MatMiniFabButton, selector: "button[mat-mini-fab]", inputs: ["disabled", "disableRipple", "color"], exportAs: ["matButton"] }, { kind: "component", type: i2$1.MatIcon, selector: "mat-icon", inputs: ["color", "inline", "svgIcon", "fontSet", "fontIcon"], exportAs: ["matIcon"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.9", ngImport: i0, type: AdminMessageComponent, decorators: [{
            type: Component,
            args: [{ selector: 'app-admin-message', template: "<mat-toolbar color=\"accent\" class=\"mat-toolbar-custom\">\n  <mat-toolbar-row class=\"profile-header-row\">\n    <span class=\"name-profile\">{{datas.title}}</span>\n    <button (click)=\"dialogRef.close()\" class=\"exit-button\" mat-mini-fab>\n      <mat-icon>close</mat-icon>\n    </button>\n  </mat-toolbar-row>\n</mat-toolbar>\n\n<div class=\"bank-details\">\n  <div class=\"bank-header\" *ngIf=\"datas.subtitle\">\n    <span class=\"subheader\" >{{datas.subtitle}}</span>\n  </div>\n  <div class=\"bank-details-row\">\n    <span class=\"bodySpan\" >{{datas.body}}</span>\n\n  </div>\n\n</div>", styles: [".mat-dialog-container{padding:0 0 15px;max-height:80vh!important;overflow-y:auto!important}.bodySpan{font-size:1.2em}.profile-header-row{justify-content:space-between}.exit-button{box-shadow:none!important}.bank-details{padding:2%;margin-bottom:15px}.bank-header{padding:5%;font-weight:900;font-size:18px;width:100%}.detail-input{width:380px}.bank-details-image{width:300px;padding:2%;border:1.5px solid rgba(0,0,0,.1);border-radius:15px}.image-row{display:flex;flex-direction:column;align-items:center;width:100%}.flex-row{display:flex;flex-direction:row}.add-files-button{margin-left:auto;justify-self:flex-end;margin-right:20px;box-shadow:none!important}.add-files-button i{color:#fff;vertical-align:auto!important}.title-button{margin-top:20px;width:100%;color:#fff!important}.options-select{visibility:hidden}.options-button{padding-left:8px!important;margin-left:15px!important}.loading{margin-right:20px}.mat-form-field-infix{padding:1em 0!important;border-top:.84375em solid transparent}\n"] }]
        }], ctorParameters: function () { return [{ type: i1$1.MatDialogRef }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [MAT_DIALOG_DATA]
                }] }, { type: i2.MatSnackBar }, { type: i1$1.MatDialog }]; } });

class PagedDataSource {
    constructor(loadPagedData, setLocalCounter) {
        this.loadPagedData = loadPagedData;
        this.setLocalCounter = setLocalCounter;
        this.paginator = null;
        this.dataSubject = new BehaviorSubject([]);
        this.loadingSubject = new BehaviorSubject(false);
        this.dataLoadedSubject = new BehaviorSubject(false);
        this.loading$ = this.loadingSubject.asObservable();
        this.loadingPagedData = false;
        console.log('PagedDataSource costructor');
    }
    connect(collectionViewer) {
        return this.dataSubject.asObservable();
    }
    disconnect(collectionViewer) {
        this.dataSubject.complete();
        this.loadingSubject.complete();
    }
    loadData(specificParameters, filterKey, filterValue, sortParam, sortDirection, pageIndex, pageSize, hideLoader) {
        console.log('loadData...');
        if (!hideLoader)
            this.loadingSubject.next(true);
        console.log("specificParameters= " + JSON.stringify(specificParameters));
        this.data = [];
        this.dataLoadedSubject.next(false);
        let obj = this._loadDataImplementation(specificParameters, filterKey, filterValue, sortParam, sortDirection, pageIndex, pageSize);
        obj = obj.pipe(catchError(() => of([])), finalize(() => {
            console.log('loadData finalize!');
            this.dataLoadedSubject.next(true);
            if (!hideLoader)
                this.loadingSubject.next(false);
        }));
        return obj.subscribe((resp) => {
            this.setLocalCounter(resp.totalCount);
            this.data = resp.payload;
            this.dataSubject.next(resp.payload);
        });
        // return obj;
    }
    loadDataMultipleQuery(specificParameters, filterKey, filterValue, sortParam, sortDirection, pageIndex, pageSize, multipleQuery, hideLoader) {
        console.log('loadData...');
        if (!hideLoader)
            this.loadingSubject.next(true);
        console.log("specificParameters= " + JSON.stringify(specificParameters));
        this.data = [];
        this.dataLoadedSubject.next(false);
        let obj = this._loadDataImplementationMultipleQuery(specificParameters, filterKey, filterValue, sortParam, sortDirection, pageIndex, pageSize, multipleQuery);
        obj = obj.pipe(catchError(() => of([])), finalize(() => {
            console.log('loadData finalize!');
            this.dataLoadedSubject.next(true);
            if (!hideLoader)
                this.loadingSubject.next(false);
        }));
        return obj.subscribe((resp) => {
            this.setLocalCounter(resp.totalCount);
            this.data = resp.payload;
            this.dataSubject.next(resp.payload);
        });
        // return obj;
    }
    loadChartData(specificParameters, filterKey, filterValue, sortParam, sortDirection, pageIndex, pageSize, graphicConfig, buildDatasource, hideLoader) {
        //console.log('loadchartData from graphic config:',graphicConfig);
        if (!hideLoader)
            this.loadingSubject.next(true);
        console.log("specificParameters= " + JSON.stringify(specificParameters));
        this.data = [];
        this.dataLoadedSubject.next(false);
        let obj = this._loadDataImplementationChart(specificParameters, filterKey, filterValue, sortParam, sortDirection, pageIndex, pageSize, graphicConfig);
        obj = obj.pipe(catchError(() => of([])), finalize(() => {
            console.log('loadData finalize!');
            this.dataLoadedSubject.next(true);
            if (!hideLoader)
                this.loadingSubject.next(false);
        }));
        return obj.subscribe((resp) => {
            this.setLocalCounter(resp.totalCount);
            if (resp.payload != null && resp.payload.length > 0) {
                this.data = resp.payload[0].result;
                this.loadingPagedData = false;
                buildDatasource();
                this.dataSubject.next(this.data);
            }
            else {
                this.data = [];
                this.loadingPagedData = false;
                this.dataSubject.next(this.data);
            }
        });
        // return obj;
    }
    loadDataWithOrCondition(andParameters, orParameters, filterKey, filterValue, sortParam, sortDirection, pageIndex, pageSize, hideLoader) {
        console.log('loadData...');
        if (!hideLoader)
            this.loadingSubject.next(true);
        this.dataLoadedSubject.next(false);
        let obj = this._loadDataImplementationWithOrCondition(andParameters, orParameters, filterKey, filterValue, sortParam, sortDirection, pageIndex, pageSize);
        obj = obj.pipe(catchError(() => of([])), finalize(() => {
            console.log('loadData finalize!');
            this.dataLoadedSubject.next(true);
            if (!hideLoader)
                this.loadingSubject.next(false);
        }));
        return obj.subscribe((resp) => {
            this.setLocalCounter(resp.totalCount);
            this.dataSubject.next(resp.payload);
            this.data = resp.payload;
        });
    }
    loadDataWithMultipleConditions(multipleQuery, filterKey, filterValue, sortParam, sortDirection, pageIndex, pageSize, hideLoader, multipleQueryGruop, customParams) {
        console.log('loadData...');
        if (!hideLoader)
            this.loadingSubject.next(true);
        this.dataLoadedSubject.next(false);
        let obj = this._loadDataImplementationWithMultipleCondition(multipleQuery, multipleQueryGruop, filterKey, filterValue, sortParam, sortDirection, pageIndex, pageSize, customParams);
        obj = obj.pipe(catchError(() => of([])), finalize(() => {
            console.log('loadData finalize!');
            this.dataLoadedSubject.next(true);
            if (!hideLoader)
                this.loadingSubject.next(false);
        }));
        return obj.subscribe((resp) => {
            this.setLocalCounter(resp.totalCount);
            this.dataSubject.next(resp.payload);
            this.data = resp.payload;
        });
    }
    _loadDataImplementation(specificParameters, filterKey, filterValue, sortParam, sortDirection, pageIndex, pageSize) {
        throw new Error("Method not implemented.");
    }
    _loadDataImplementationMultipleQuery(specificParameters, filterKey, filterValue, sortParam, sortDirection, pageIndex, pageSize, multipleQuery) {
        throw new Error("Method not implemented.");
    }
    _loadDataImplementationChart(specificParameters, filterKey, filterValue, sortParam, sortDirection, pageIndex, pageSize, graphicConfig) {
        throw new Error("Method not implemented.");
    }
    _loadDataImplementationWithOrCondition(andParameters, orParameters, filterKey, filterValue, sortParam, sortDirection, pageIndex, pageSize) {
        throw new Error("Method not implemented.");
    }
    _loadDataImplementationWithMultipleCondition(multipleQuery, multipleQueryGruop, filterKey, filterValue, sortParam, sortDirection, pageIndex, pageSize, customParams) {
        throw new Error("Method not implemented.");
    }
}

class CardContainerConfig {
    constructor(id, title, isRequiredDateFields, cssClasses, width, height, position, hideShadowBorder, wrapper, groupId, helpTitle, helpDescription, helpKey, helpWidth) {
        this.wrapper = 'mat-card';
        this.id = id;
        this.title = title;
        this.isRequiredDateFields = isRequiredDateFields ?? false;
        this.cssClasses = cssClasses ? cssClasses : '';
        this.width = width ?? undefined;
        this.height = height ?? undefined;
        this.position = position ?? undefined;
        this.hideShadowBorder = hideShadowBorder ?? undefined;
        this.wrapper = wrapper ? wrapper : 'mat-card';
        this.groupId = groupId ?? undefined;
        this.helpTitle = helpTitle ?? undefined;
        this.helpDescription = helpDescription ?? undefined;
        this.helpKey = helpKey ?? undefined;
        this.helpWidth = helpWidth ?? undefined;
    }
}

class TableDataSourceComponent extends PagedDataSource {
    constructor(loadPagedData, setLocalCounter) {
        super(loadPagedData, setLocalCounter);
        this.loadPagedData = loadPagedData;
        this.setLocalCounter = setLocalCounter;
    }
    _loadDataImplementationChart(specificParameters, filterKey, filterValue, sortParam, sortDirection, pageIndex, pageSize, graphicConfig) {
        return this.loadPagedData(specificParameters, filterKey, filterValue, sortParam, sortDirection, pageIndex, pageSize, graphicConfig);
    }
}

class AdminUtilComponent {
    setLoadDataSubscription(sub) {
        if (this.loadDataSubscription) {
            this.loadDataSubscription.unsubscribe();
        }
        this.loadDataSubscription = sub;
        return this.loadDataSubscription;
    }
    constructor(dialog, snackBar, injector) {
        this.dialog = dialog;
        this.snackBar = snackBar;
        this.injector = injector;
        this.pagedDataLoaded = false;
        this.isLoaderShowing = false;
        // Data variables
        this.data = [];
        // dataSource: MatTableDataSource<any> | PagedDataSource<any> = new MatTableDataSource<any>();
        this.dataSource = new MatTableDataSource(new Array());
        this.loader = this.injector.get(MareLoaderService);
        // this.pushNotificationService = this.injector.get(PushNotificationService);
        this.__formBuilder = this.injector.get(FormBuilder);
        // this.__navigationService = this.injector.get(NavigationService);
        // this.__accountService = this.injector.get(AccountService);
        this.__router = this.injector.get(Router);
        this.__eventInteractionService = this.injector.get(EventInteractionService);
        this.changeDetectionRef = this.injector.get(ChangeDetectorRef);
    }
    ngAfterViewInit() {
        this.initDataSourcePaginators();
        this.showToggleOrderBlock = false;
    }
    initDataSourcePaginators() {
        if (this.dataSource instanceof MatTableDataSource) {
            if (this.sort && this.dataSource.data.length > 0) {
                this.dataSource.sort = this.sort;
            }
            if (this.paginator && this.dataSource.data.length > 0) {
                //this.customPaginator = new CustomPaginator(this.paginator, this.changeDetectionRef);
                this.dataSource.paginator = this.paginator;
            }
        }
        else if (this.dataSource instanceof PagedDataSource) {
            if (this.searchInput) {
                fromEvent(this.searchInput.nativeElement, 'keyup')
                    .pipe(debounceTime(500), distinctUntilChanged(), tap(() => {
                    if (this.externalFilter) {
                        this.externalFilter = false;
                        this.filterKeys = this.filterKeysOrig;
                    }
                    if (!this.filterValue || this.filterValue.length > 2) {
                        this.paginator.pageIndex = 0;
                        this.loadPagedData(null, this.isExporting);
                    }
                }))
                    .subscribe();
                fromEvent(this.searchInput.nativeElement, 'keydown')
                    .pipe(debounceTime(500), distinctUntilChanged(), tap((event) => {
                    if (this.externalFilter) {
                        this.externalFilter = false;
                        this.filterKeys = this.filterKeysOrig;
                    }
                    var key = event.keyCode || event.charCode;
                    if (!this.filterValue || ((key == 8 || key == 46) && this.filterValue.length == 0)) {
                        this.paginator.pageIndex = 0;
                        this.loadPagedData(null, this.isExporting);
                    }
                }))
                    .subscribe();
            }
            if (this.paginator) {
                this.customPaginator = new NgxDynamicDashboardCustomPaginator(this.paginator, this.changeDetectionRef);
                this.dataSource.paginator = this.customPaginator;
                // this.dataSource.paginator = this.paginator;
            }
            if (this.sort && this.paginator) {
                this.sort.sortChange.subscribe(() => {
                    this.paginator.pageIndex = 0;
                    if (this.customPaginator) {
                        this.customPaginator.pageIndex = 0;
                        this.customPaginator.inverseAllignValues();
                    }
                });
                // merge(this.sort.sortChange, this.paginator.page).pipe(
                //   tap(
                //     (e) => this.loadPagedData(null)
                //     )
                // ).subscribe();
                if (this.loadPageSubscription) {
                    this.loadPageSubscription.unsubscribe();
                    this.loadPageSubscription = null;
                }
                this.loadPageSubscription = merge(this.sort.sortChange, this.paginator.page)
                    .subscribe((e) => {
                    this.loadPagedData(null, this.isExporting);
                });
            }
            else if (this.paginator) {
                // this.paginator.page.pipe(
                //   tap(
                //     (e) => this.loadPagedData(e)
                //     )
                // ).subscribe();
                if (this.loadPageSubscription) {
                    this.loadPageSubscription.unsubscribe();
                    this.loadPageSubscription = null;
                }
                this.loadPageSubscription = this.paginator.page.pipe(tap((e) => this.loadPagedData(e, this.isExporting))).subscribe((e) => {
                    this.loadPagedData(e, this.isExporting);
                });
            }
        }
    }
    ngOnDestroy() {
        if (this.loaderSubscription)
            this.loaderSubscription.unsubscribe();
        if (this.isLoaderShowing)
            this.hideLoader();
    }
    // New edit or create dialog
    /**
     * @deprecated Preferire dove possibile newDynamicDialog
     * @param data
     * @param afterClosedCallback
     * @param changePasswordCallback
     * @param changeUsernameCallback
     * @param sendingPushNotificationCallback
     */
    newDialog(data, afterClosedCallback, changePasswordCallback, changeUsernameCallback, sendingPushNotificationCallback) {
        const dialog = this.dialog.open(AdminEditComponent, {
            width: '400px',
            panelClass: 'custom-panel-class',
            data: data,
        });
        const componentInstance = dialog.componentInstance;
        if (changePasswordCallback) {
            componentInstance.onChangePassword.subscribe(() => {
                changePasswordCallback();
            });
        }
        if (changeUsernameCallback) {
            componentInstance.onChangeUsername.subscribe(() => {
                changeUsernameCallback();
            });
        }
        if (sendingPushNotificationCallback) {
            componentInstance.onSendingPushNotification.subscribe(() => {
                sendingPushNotificationCallback(dialog);
            });
        }
        dialog.afterClosed().subscribe((datas) => {
            if (datas && afterClosedCallback) {
                afterClosedCallback(datas);
            }
        });
        return dialog;
    }
    /**
     * This is the builder for the DynamicForm Component
     * @param data DynamicFormDataInput obj that contains all information needed in order to create the form
     * @param afterClosedCallback callback that is called after the dialog is closed
     * @param changePasswordCallback (optional) the callback that is called when the password is changed
     * @param changeUsernameCallback (optional) the callback that is called when the username is changed
     * @param sendingPushNotificationCallback (optional) the callback that is called when the push notification event is called
     */
    newDynamicDialog(data, afterClosedCallback, changePasswordCallback, changeUsernameCallback, sendingPushNotificationCallback) {
        let disableClose = false;
        if (data.disableClose)
            disableClose = data.disableClose;
        let newWidth = '600px';
        if (data.width) {
            newWidth = data.width;
        }
        let newClass = 'custom-panel-class-large';
        if (data.class) {
            newClass = data.class;
        }
        const dialog = this.dialog.open(NgxDynamicFormComponent, {
            width: newWidth,
            panelClass: newClass,
            data: data,
            disableClose: disableClose
        });
        if (changePasswordCallback) {
            dialog.componentInstance.onChangePassword.subscribe(() => {
                changePasswordCallback();
            });
        }
        if (changeUsernameCallback) {
            dialog.componentInstance.onChangeUsername.subscribe(() => {
                changeUsernameCallback();
            });
        }
        if (sendingPushNotificationCallback) {
            dialog.componentInstance.onSendingPushNotification.subscribe(() => {
                sendingPushNotificationCallback(dialog);
            });
        }
        dialog.afterClosed().subscribe((datas) => {
            if (datas && afterClosedCallback) {
                afterClosedCallback(datas);
            }
        });
        return dialog;
    }
    // Checks if there exists data
    checkData() {
        // if(this.dataSource instanceof MatTableDataSource) {
        //   if (this.data) {
        //     return !this.loading && (this.data.length === 0);
        //   } else {
        //     return false;
        //   }
        // } else {
        //   return !this.loading && (!this.dataCounter || this.dataCounter === 0);
        // }
        if (this.data) {
            //console.log("data counter: ", this.dataCounter);
            return !this.loading && (this.dataCounter === 0 || this.dataCounter == null);
        }
        else {
            return false;
        }
    }
    retrieveRolesOptionList() {
        let roles = [
            { value: 'UTENTE', name: 'UTENTE' },
            { value: 'AMMINISTRATORE', name: 'ADMIN' },
            { value: 'OPERATORE', name: 'SPECIALISTA' },
            { value: 'TENANT_ADMINISTRATOR', name: 'AMMINISTRATORE AZIENDALE' },
        ];
        return roles;
    }
    // New delete dialog
    // newElimina(data: any, callback: any) {
    //   const dialog = this.dialog.open(EliminazioneComponent, {
    //     data: `${data}`,
    //   });
    //   dialog.afterClosed().subscribe((datas) => {
    //     if (datas && datas['data']) {
    //       callback(datas);
    //     } else {
    //       callback(null);
    //     }
    //   });
    // }
    // // New delete dialog
    // newConfirmation(dataMessage: any, callback: any) {
    //   const dialog = this.dialog.open(EliminazioneComponent, {
    //     // data: `${data}`,
    //     data: dataMessage ? dataMessage : {
    //       newWay: true,
    //       title: 'Conferma Operazione',
    //       body: 'Sei sicuro?'
    //     }
    //   });
    //   dialog.afterClosed().subscribe((datas) => {
    //     if (datas && datas['data']) {
    //       callback(datas);
    //     } else {
    //       callback(null);
    //     }
    //   });
    // }
    // closeAllEmergencyByUserId(data: any, callback: any) {
    //   callback({ data: true });
    // }
    // Creates new data source for table and sets loading paginator and gets deleted banks
    newDataSource(data = [], newData, sorting) {
        return new Promise((resolve, reject) => {
            /*this.banks = await data.map((res: any, index: any) => {
            if (res.deleted === false) {
              return res;
            }
          });*/
            if (newData) {
                this.data = data;
            }
            this.dataSource = new MatTableDataSource(data);
            if (sorting)
                this.dataSource.sortingDataAccessor = sorting;
            if (this.sort && this.dataSource.data.length > 0) {
                this.dataSource.sort = this.sort;
            }
            if (this.paginator && this.dataSource.data.length > 0) {
                this.dataSource.paginator = this.paginator;
            }
            this.dataCounter = this.data == null ? 0 : this.data.length;
            this.loading = false;
            this.initDataSourcePaginators();
            resolve(this.dataSource);
        });
    }
    async newPagedSource(datasource, loadPagedData, loadSubscribedPagedData) {
        if (loadSubscribedPagedData) {
            const _this = this;
            this.loadPagedData = (e, isExporting) => {
                if (_this.pagedDataSubscription)
                    _this.pagedDataSubscription.unsubscribe();
                _this.pagedDataSubscription = loadSubscribedPagedData(isExporting);
                _this.pagedDataSubscription.add((data) => {
                    //console.log('data are loaded');
                    setTimeout(() => {
                        //console.log('generate paginator page event');
                        if (!e) {
                            e = new PageEvent();
                            e.length = _this.paginator.length;
                            e.pageIndex = _this.paginator.pageIndex;
                            e.pageSize = _this.paginator.pageSize;
                        }
                        if (_this.customPaginator)
                            _this.customPaginator.publishEvent(e);
                    }, 200);
                });
            };
        }
        else {
            this.loadPagedData = (e) => { loadPagedData(); };
        }
        this.dataSource = datasource;
        this.loading = false;
        this.loaderSubscription = this.dataSource.loadingSubject.subscribe((d) => {
            //this.loading = d;
            if (d == true) {
                this.showLoader();
            }
            else {
                this.hideLoader();
            }
        });
        this.initDataSourcePaginators();
    }
    // New snackbar
    newSnackbar(text, snackBarClass, duration, afterDismissed) {
        if (duration === undefined) {
            duration = 2000;
        }
        const ref = this.snackBar.open(`${text}`, '', {
            duration: duration,
            panelClass: snackBarClass,
            horizontalPosition: 'center',
        });
        if (afterDismissed) {
            ref.afterDismissed().subscribe(info => {
                afterDismissed();
            });
        }
        return ref;
    }
    toggleOrderBlock() {
        this.showToggleOrderBlock = !this.showToggleOrderBlock;
        if (this.dataTableElement) {
            const dataTableElement = this.dataTableElement['_elementRef'].nativeElement;
            if (this.showToggleOrderBlock) {
                // dataTableElement.getElementByTagName('thead')[0].classList.add('showMobile');
                dataTableElement.firstElementChild.classList.add('show-mobile');
            }
            else {
                // dataTableElement.getElementByTagName('thead')[0].classList.remove('showMobile');
                dataTableElement.firstElementChild.classList.remove('show-mobile');
            }
        }
    }
    setDataCounter(newCounter) {
        //console.log('setDataCounter', newCounter)
        if (!newCounter)
            newCounter = 0;
        this.paginator.length = newCounter;
        if (this.customPaginator)
            this.customPaginator.length = newCounter;
        this.dataCounter = newCounter;
    }
    newMessage(data, callback) {
        const dialog = this.dialog.open(AdminMessageComponent, {
            // data: `${data}`,
            width: '400px',
            panelClass: 'custom-panel-class',
            data: data
        });
        dialog.afterClosed().subscribe((datas) => {
            if (datas && datas['data']) {
                if (callback) {
                    callback(datas);
                }
            }
            else {
                if (callback) {
                    callback(null);
                }
            }
        });
    }
    sortData(item, property, sortInfo) {
        if (sortInfo.type == 'date') {
            const dateMomentObject = moment(item[property], sortInfo.format); // 1st argument - string, 2nd argument - format
            const dateObject = dateMomentObject.toDate();
            return dateObject.getTime();
        }
        else if (sortInfo.type == 'number') {
            return parseFloat(item[property]);
        }
        else {
            return item[property];
        }
    }
    showLoader() {
        this.isLoaderShowing = true;
        this.loader.showLoader();
        // this.loader.showText('prova ' + new Date().getTime())
    }
    updateLoaderText(text) {
        //this.loader.updateLoaderText(text);
    }
    showLoaderText(text) {
        this.isLoaderShowing = true;
        // this.loader.showText(text);
        this.loader.showLoader();
    }
    hideLoader() {
        this.isLoaderShowing = false;
        this.loader.hideLoader();
    }
    // openForPushNotification(i, element) {
    //   // const myFormGroup = this._formBuilder.group({
    //   //   pushNotificationMsg: ['', Validators.required],
    //   // });
    //   const pushNotificationFormGroup = this.__formBuilder.group({
    //     pushNotificationMsg: ['', Validators.required]
    //   });
    //   // Opens new dialog to change username
    //   const sendPushNotification = (dialog) => {
    //     const newPushNotificationMsg = {
    //       newPushNotificationMsg: pushNotificationFormGroup.controls.pushNotificationMsg.value,
    //       contactId: element['userId']
    //     };
    //     this.loading = true;
    //     this.pushNotificationService.sendGenericNotification(newPushNotificationMsg).subscribe((res: any) => {
    //       dialog.close();
    //       this.loading = false;
    //       this.snackBar.open('Notifica inviata', '', {
    //         duration: 3000,
    //         panelClass: 'success',
    //       });
    //     }, (error) => {
    //       this.loading = false;
    //       // console.error(error);
    //       // this.snackBarMat.open("Errore nell'invio della notifica", '', {
    //       //   duration: 3000,
    //       //   panelClass: 'warn',
    //       // });
    //     });
    //   };
    //   this.newDialog({
    //     topHeader: 'Invia notifica all\'utente',
    //     button: 'Invia notifica',
    //     changePassword: false,
    //     textareas: [
    //       { placeholder: 'Notifica da inviare', icon: 'textsms', formControlName: 'pushNotificationMsg' },
    //     ],
    //     formGroup: pushNotificationFormGroup,
    //     data: element
    //   }, (data) => { }, null, null, sendPushNotification);
    // }
    // sendContactNotification(i, element) {
    //   this.pushNotificationService.sendNotificationForVideocall(element['userId']).subscribe((res: any) => {
    //     this.loading = false;
    //     this.snackBar.open('Notifica inviata', 'Attenzione l\'utente potrebbe essere online a breve', {
    //       duration: 3000,
    //       panelClass: 'success',
    //     });
    //   }, (error) => {
    //     this.loading = false;
    //     console.error(error);
    //     this.snackBar.open("Errore nell'invio della richiesta", '', {
    //       duration: 3000,
    //       panelClass: 'warn',
    //     });
    //   });
    // }
    // getCurrentNavigationElement() {
    //   const currElem = this.__navigationService.checkCurrent();
    //   // console.log('currentElement', currElem);
    //   return currElem;
    // }
    // getCurrentNavigationElements(nav?: FuseNavigation[] | FuseNavigationItem[], ret?: Array<FuseNavigationItem>): Array<FuseNavigationItem> | null {
    // getCurrentNavigationElements(nav?: any[] , ret?: Array<any>): Array<any> {
    //     if (!nav)
    //     nav = this.__navigationService.navigation;
    //   if (!ret)
    //     ret = new Array<any>();
    //   if (nav) {
    //     for (let index = 0; index < nav.length; index++) {
    //       const element = nav[index];
    //       if (element.url && element.type == 'item' && this.__router.isActive(element.url, false)) {
    //         ret.push(element);
    //       }
    //       if (element.children) {
    //         this.getCurrentNavigationElements(element.children, ret);
    //       }
    //     }
    //     return ret;
    //   }
    //   return ret;
    // }
    // checkAuthCurrentNavigationElement() {
    //   const currElem = this.getCurrentNavigationElement();
    //   if (!currElem)
    //     return true;
    //   return this.__accountService.check(currElem);
    // }
    // checkAccessToPage(showError?: boolean) {
    //   return new Promise((resolve, reject) => {
    //     if (this.__accountService.isToInitAuths) {
    //       //console.log('AUTHS non presenti... è necessario attendere')
    //       setTimeout(() => {
    //         this.checkAccessToPage(showError).then((v) => {
    //           resolve(v);
    //         }).catch((e) => {
    //           reject(e)
    //         });
    //       }, 200);
    //       return;
    //     }
    //     const res: Array<any> = this.getCurrentNavigationElements();
    //     let redirect: string | null = null;
    //     // let showError = true;
    //     if (showError == undefined || showError == null)
    //       showError = true;
    //     for (const el of res) {
    //       let r = this.__accountService.check(el);
    //       if (typeof r == 'string') {
    //         redirect = r;
    //         showError = false;
    //       } else if (r) {
    //         resolve(true);
    //         return;
    //       }
    //     }
    //     if (!redirect) {
    //       redirect = '/admin/buy-licenses';
    //     }
    //     this.__router.navigateByUrl(redirect);
    //     if (showError) {
    //       this.newSnackbar(`Accesso negato`, 'warning');
    //     }
    //     throw new Error(`Accesso negato`);
    //     reject(false)
    //   })
    // }
    // chechCanAccessToPage(p: { val: string | string[], redirect: string, redirectIf?: string } | string | string[]): Promise<boolean> {
    //   return new Promise((resolve, reject) => {
    //     if (this.__accountService.isToInitAuths) {
    //       //console.log('AUTHS non presenti... è necessario attendere')
    //       setTimeout(() => {
    //         this.chechCanAccessToPage(p).then((v) => { resolve(v); }).catch((e) => reject(e));
    //       }, 200);
    //       return;
    //     }
    //     let cb = this.__accountService.checkPage(p)
    //     if (cb && cb == true)
    //       resolve(true)
    //     else
    //       resolve(false)
    //   })
    // }
    // checkAccessToPage() {
    //   const res = this.checkAuthCurrentNavigationElement();
    //   let val: boolean = null;
    //   let redirect = '/';
    //   let showError = true;
    //   if(typeof res == 'string') {
    //     val = false;
    //     redirect = res;
    //     showError = false;
    //   } else {
    //     val = res;
    //   }
    //   if(!val) {
    //     this.__router.navigateByUrl(redirect);
    //     if(showError) {
    //       this.newSnackbar(`Accesso negato`, 'warning');
    //     }
    //     throw new Error(`Accesso negato`);
    //   }
    // }
    rowClick(index, element) {
        console.log('Riga cliccata', index, element);
    }
    /**
     * This method is used in order to map an array of DynamicFormDataInputElement to a FormGroup
     * using the formControlName field.
     * @param elements An array of DynamicFormDataInputElement to extract the FormGroup
     * @param element The element object to extract the current control value
     */
    buildFormGroup(elements, element, customValidator) {
        let obj = {};
        for (const el of elements) {
            // const el = elements[index];
            if (el.formControlName) {
                obj[el.formControlName] = [];
                if (element && element[el.formControlName] != undefined && element[el.formControlName] != null) {
                    if (el.type == 'DATE' && element[el.formControlName])
                        obj[el.formControlName].push(new Date(element[el.formControlName]));
                    else
                        obj[el.formControlName].push(element[el.formControlName]);
                }
                else {
                    obj[el.formControlName].push('');
                }
                let validators = [];
                if (el.required)
                    validators.push(Validators.required);
                if (el.min)
                    validators.push(Validators.min(el.min));
                if (el.max)
                    validators.push(Validators.max(el.max));
                if (validators.length == 1) {
                    obj[el.formControlName].push(validators[0]);
                }
                else if (validators.length > 1) {
                    obj[el.formControlName].push(Validators.compose(validators));
                }
            }
        }
        if (customValidator) {
            return this.__formBuilder.group(obj, customValidator);
        }
        return this.__formBuilder.group(obj);
    }
    /**
     * This method is used to extract data from the DynamicForm result and map in an object ready
     * to send to the server
     *
     * @param startObj the initial object (is initialized with static data)
     * @param formGroup the form group to get controls name
     * @param data the DynamicForm response
     */
    buildObj(startObj, formGroup, data) {
        if (!data['data'])
            return null;
        data = data['data'];
        for (const key in formGroup.controls) {
            if (Object.prototype.hasOwnProperty.call(formGroup.controls, key)) {
                // const control = formGroup.controls[key];
                startObj[key] = data[key];
            }
        }
        return startObj;
    }
    exportTable(exporter, fileType, opts) {
        if (exporter && !this.isExporting) {
            if (this.exportingSub) {
                this.exportingSub.unsubscribe();
            }
            this.exportingSub = exporter.exportCompleted.subscribe((data) => {
                this.isExporting = false;
                this.hideLoader();
                //console.log('Stop exporting...')
            });
            //console.log('Start exporting...')
            this.isExporting = true;
            this.showLoader();
            exporter.exportTable(fileType, opts);
        }
    }
    setExternalFilterKey(externalFiler) {
        if (externalFiler) {
            this.filterKeysOrig = this.filterKeys;
            this.filterKeys = externalFiler;
            this.externalFilter = true;
            this.initDataSourcePaginators();
        }
    }
    contattaAssistenza() {
        this.__eventInteractionService.publishData({
            event: 'OPEN-ASSISTANCE-FORM'
        });
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.9", ngImport: i0, type: AdminUtilComponent, deps: [{ token: i1$1.MatDialog }, { token: i2.MatSnackBar }, { token: i0.Injector }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.9", type: AdminUtilComponent, selector: "app-admin-util", viewQueries: [{ propertyName: "sort", first: true, predicate: MatSort, descendants: true }, { propertyName: "searchInput", first: true, predicate: ["searchInput"], descendants: true }, { propertyName: "dataTableElement", first: true, predicate: ["dataTableElement"], descendants: true }, { propertyName: "paginator", first: true, predicate: MatPaginator, descendants: true }], ngImport: i0, template: '<p></p>', isInline: true }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.9", ngImport: i0, type: AdminUtilComponent, decorators: [{
            type: Component,
            args: [{ selector: 'app-admin-util', template: '<p></p>' }]
        }], ctorParameters: function () { return [{ type: i1$1.MatDialog }, { type: i2.MatSnackBar }, { type: i0.Injector }]; }, propDecorators: { sort: [{
                type: ViewChild,
                args: [MatSort]
            }], searchInput: [{
                type: ViewChild,
                args: ['searchInput']
            }], dataTableElement: [{
                type: ViewChild,
                args: ['dataTableElement']
            }], paginator: [{
                type: ViewChild,
                args: [MatPaginator]
            }] } });

class BaseTrace {
}
class Trace extends BaseTrace {
    constructor(name, xvalues, yvalues, value, previousValue, row, column, shapeType, color, fontSize, orientation, numberSuffix, valueformat, margin, zvalues) {
        super();
        this.name = name;
        this.xvalues = xvalues;
        this.yvalues = yvalues;
        this.value = value ?? undefined;
        this.previousValue = previousValue ?? undefined;
        this.row = row ?? undefined;
        this.column = column ?? undefined;
        this.shapeType = shapeType ?? undefined;
        this.color = color ?? undefined;
        this.fontSize = fontSize ?? undefined;
        this.orientation = orientation ?? undefined;
        this.numberSuffix = numberSuffix ?? undefined;
        this.valueformat = valueformat ?? undefined;
        this.margin = margin;
        this.zvalues = zvalues ?? undefined;
    }
}

class GraphicUtil {
    static sumAllValues(values) {
        // let partialSum=0; 
        let sum = 0;
        if (values.length > 0) {
            sum = values.reduce((prevValue, currentValue) => {
                //console.log(prevValue);
                if (typeof currentValue === 'number') {
                    return prevValue + currentValue;
                }
                else if (typeof currentValue === 'string') {
                    currentValue = currentValue.replace(/,/g, '');
                    currentValue = parseFloat(currentValue);
                    return prevValue + currentValue;
                }
                else {
                    // che fa???
                }
                return prevValue + currentValue;
            });
            // partialSum = values.reduce((prevValue, currentValue) =>{
            //     return prevValue + currentValue;
            // });
            /* for (let val of values) {
              if(typeof val === 'number') {
                sum += val;
              } else if(typeof val === 'string' || val instanceof string) {
                val = val.replace(/,/g, '')
                val = parseFloat(val);
                sum += val;
              } else {
                // che fa???
              }
            } */
        }
        // sum += partialSum;
        return sum;
    }
    static applyFunction(r) {
        let res = null;
        //r.value = eval(r.valueFunction);
        if (r && r.valueFunction) {
            let f = new Function('el', 'return ' + r.valueFunction);
            res = f(r.el);
        }
        return res;
    }
    static executeFunction(func) {
        let f = new Function('return ' + func);
        return f();
    }
    /**
     *
     * @param yaxis
     * @param xval
     * @param obj
     * @param result
     * @param notApplyFunctionToEqualXval se ha valore true verrà applicata la function indicata
     * (la somma\concatenazione in mancanza di function) a tutti i valori aventi uguale xval
     */
    static calculateResult(yaxis, xval, obj, result, notApplyFunctionToEqualXval) {
        let yval = this.getValFromObject(obj, yaxis.value);
        let zval = null;
        if (yaxis.zfield != null) {
            zval = this.getValFromObject(obj, yaxis.zfield);
        }
        let functionValues = new Array();
        if (yaxis.values) {
            functionValues = yaxis.values;
        }
        else if (yaxis.valuesList) {
            functionValues = yaxis.valuesList;
        }
        let res = null;
        if (notApplyFunctionToEqualXval == null || notApplyFunctionToEqualXval == false) {
            res = result.find((el) => el.label == xval);
        }
        if (!res) {
            let r = { label: xval, value: yval, calculatedValues: false, valueFunction: null, el: {}, zvalue: zval };
            if (functionValues.length > 0) {
                r.calculatedValues = true;
                r.valueFunction = yaxis.valueFunction;
                functionValues.forEach((fv) => {
                    r.el[fv] = this.getValFromObject(obj, fv);
                });
            }
            result.push(r);
        }
        else {
            res.value = res.value + yval;
            if (zval != null) {
                res.zvalue = res.zvalue + zval;
            }
            if (functionValues.length > 0) {
                functionValues.forEach((fv) => {
                    res.el[fv] = res.el[fv] + GraphicUtil.getValFromObject(obj, fv);
                });
            }
        }
    }
    static castToNumber(yval) {
        let ret;
        if (typeof yval === 'number') {
            ret = yval;
        }
        else if (typeof yval === 'string') {
            yval = yval.replace(/,/g, '');
            ret = +(yval);
        }
        else {
            //console.error("No number value, return null. Original value:", yval);
        }
        return ret;
    }
    static getValFromObject(obj, key) {
        let val = null;
        Object.keys(obj).forEach((k) => {
            if (k == key) {
                val = obj[key];
                return;
            }
        });
        return val;
    }
    static setValInObject(obj, key, newVal) {
        Object.keys(obj).forEach((k) => {
            if (k == key) {
                obj[key] = newVal;
                return;
            }
        });
    }
    static fillArrayWithZeroValues(value, xvalues, missedXValues) {
        let array = new Array();
        xvalues.forEach(xval => {
            //valore a zero per le date mancanti
            if (missedXValues.includes(xval)) {
                array.push(0);
            }
            else {
                //ricerco valore per quelle presenti
                let sum = 0;
                for (var index = 0; index < value.length; index++) {
                    let val = new Array();
                    val = value[index];
                    //In caso di più occorrenze dello stesso xval effettuo la somma
                    if (xval == val[0]) {
                        sum = sum + val[1];
                    }
                }
                array.push(sum);
            }
        });
        return array;
    }
    static getZeroedAndSummedValues(xvalues, missedXValues, data, yaxis, result) {
        let yvalues = new Array();
        xvalues.forEach((xval) => {
            let yval;
            if (missedXValues.includes(xval)) {
                yval = 0;
                yvalues.push(yval);
                result.push({ label: xval, value: yval });
            }
            else {
                //recupero tutti gli oggetti che hanno yaxis.xaxis = al valore di xval
                let filteredObjects = data.filter((obj) => obj[yaxis.xaxis] == xval);
                if (filteredObjects != null) {
                    filteredObjects.forEach((fo) => {
                        this.calculateResult(yaxis, xval, fo, result);
                    });
                    /* //ricavo tutti i valori
                    let values:Array<any>= filteredObjects.map( r => r[yaxis.value]);
                    //sommo tutti i valori
                    yval = GraphicUtil.sumAllValues(values);
                    result.push({label: xval, value: yval});
                    yvalues.push(yval); */
                }
            }
        });
        return yvalues;
    }
    static betweenValue(x, min, max) {
        return x >= min && x <= max;
    }
    static getIndexColumnArrayFromMatrix(matrix, index) {
        let column = [];
        //console.log(filteredData);
        if (matrix != null && matrix.length > 0) {
            //definisco funzione per ottenere una singola colonna da una matrice;
            const arrayColumn = (arr, n) => arr.map(x => x[n]);
            //ottengo la colonna dei valori
            column = arrayColumn(matrix, index);
        }
        return column;
    }
    //preelaborationrequired must be used if is needed to get the original data
    static initGraphicValues(graphicValues, yaxis, isTable, preElaborationRequired) {
        let xaxisFieldName = yaxis.xaxis;
        let fieldName = yaxis.value;
        let zFieldName = yaxis.zfield;
        let isFieldFiltering = false;
        let isFunctionFiltering = false;
        let isAggregation = false;
        //console.log('graphic values:',graphicValues," yaxis: ",yaxis);
        let res = null;
        if (isTable) {
            res = {
                xvalues: new Array(),
                xvaluesArray: new Array(),
                yvalues: [] = new Array(),
                filteredData: undefined,
                filterKeyUnit: null,
                aggregatedData: undefined,
                aggregatedGraphicValues: null,
                filteredGraphicValues: null,
                graphicValues: [] = new Array() //all graphic values
            };
            if (graphicValues.length > 0 && graphicValues[0]["_calculatedId_"])
                xaxisFieldName = "_calculatedId_";
        }
        else {
            res = {
                xvalues: new Set(),
                xvaluesArray: new Array(),
                yvalues: [] = new Array(),
                zvalues: [] = new Array(),
                filteredData: undefined,
                filterKeyUnit: null,
                aggregatedData: undefined,
                aggregatedGraphicValues: null,
                filteredGraphicValues: null,
                graphicValues: [] = new Array() //all graphic values
            };
        }
        let filter = yaxis.dataFilter;
        let aggregation = yaxis.dataAggregate;
        if (filter != undefined && filter != null) {
            res.filteredData = new Map();
            res.filteredGraphicValues = new Map();
            if (filter.filterField != undefined) {
                isFieldFiltering = true;
            }
            else if (filter.filterFunction != undefined) {
                isFunctionFiltering = true;
            }
        }
        else if (aggregation != undefined) {
            //aggrega per campo
            if (aggregation.aggregationField != undefined) {
                res.aggregatedData = new Map();
                res.aggregatedGraphicValues = new Map();
                isAggregation = true;
            }
        }
        for (const element of graphicValues) {
            const xax = element[xaxisFieldName];
            if (isTable) {
                res.xvalues.push(xax);
            }
            else {
                res.xvalues.add(xax);
            }
            res.xvaluesArray.push(xax);
            //filtro 
            /* in caso di filtering creo una mappa con:
                - campo chiave pari al valore del campo indicato in filterfield o filterfunction
                - valori associati al campo chiave gli oggetti aventi lo stesso valore come valore indicato dal campo chiave
            */
            if (isFieldFiltering || isFunctionFiltering) {
                //console.log("filtering: ",res.filteredData);
                //filtra per campo
                let filterKeyValue;
                let filterKeyField = null;
                if (filter) {
                    res.filterKeyUnit = filter.filterUnit;
                    if (isFieldFiltering && filter.filterField) {
                        filterKeyValue = element[filter.filterField];
                        filterKeyField = filter.filterField;
                    }
                    else {
                        const k = filter.filterFunction;
                        filterKeyValue = k.value(element);
                        filterKeyField = k.key;
                    }
                }
                if (res.filteredData.has(filterKeyValue)) {
                    if (zFieldName != null) {
                        res.filteredData.get(filterKeyValue).push([element[filterKeyField], element[fieldName], element[zFieldName]]);
                    }
                    else {
                        res.filteredData.get(filterKeyValue).push([element[filterKeyField], element[fieldName]]);
                    }
                    res.filteredGraphicValues.get(filterKeyValue).push(element);
                }
                else {
                    if (filter && filter.filterValue != null) {
                        if (filterKeyValue == filter.filterValue) {
                            res.filteredGraphicValues.set(filterKeyValue, new Array());
                            res.filteredGraphicValues.get(filterKeyValue).push(element);
                            res.filteredData.set(filterKeyValue, new Array());
                            if (zFieldName != null) {
                                res.filteredData.get(filterKeyValue).push([element[xaxisFieldName], element[fieldName], element[zFieldName]]);
                            }
                            else {
                                res.filteredData.get(filterKeyValue).push([element[xaxisFieldName], element[fieldName]]);
                            }
                        }
                    }
                    else {
                        res.filteredGraphicValues.set(filterKeyValue, new Array());
                        res.filteredGraphicValues.get(filterKeyValue).push(element);
                        res.filteredData.set(filterKeyValue, new Array());
                        if (zFieldName != null) {
                            res.filteredData.get(filterKeyValue).push([element[xaxisFieldName], element[fieldName], element[zFieldName]]);
                        }
                        else {
                            res.filteredData.get(filterKeyValue).push([element[xaxisFieldName], element[fieldName]]);
                        }
                    }
                }
            }
            //aggrego per campo
            else if (isAggregation) {
                //aggrega per campo
                if (aggregation.aggregationField != undefined) {
                    let key = element[xaxisFieldName];
                    let aggregatedResultField = 'aggregate_value_required';
                    let aggregateResult = 0;
                    let aggregateZval = 0;
                    if (aggregation.groupByFieldLabel != null) {
                        key = yaxis.label;
                    }
                    else if (aggregation.groupByField != null) {
                        key = element[aggregation.groupByField];
                    }
                    //filtra per campo
                    //if presente per consentire di fare l'aggregazione sia dai dati provenienti dal datamart, sia per i dati provenienti da cassandra
                    //sia per i dati non prelevati da remoto 
                    //console.log("yaxis value: ",yaxis.value)      
                    //&& (yaxis.showingPossibleMetric != null && !yaxis.showingPossibleMetric)
                    if (element[aggregatedResultField] != null) {
                        if ((yaxis.showingPossibleMetric != null && yaxis.showingPossibleMetric)) {
                            aggregateResult = Number.parseInt(element[fieldName]);
                        }
                        //yaxis.showingPossibleMetrics indica che si sta mostrando una metrica alternativa, quindi non bisogna usare i risultati aggregati
                        else {
                            aggregateResult = Number.parseInt(element[aggregatedResultField]);
                            //propago il valore nell'oggetto in modo da poterlo recuperare in fase di costruzione
                            element[fieldName] = aggregateResult;
                        }
                    }
                    //caso di fieldname contenente, ad esempio, "ga_users,ga_newusers"
                    /* else if(fieldName.indexOf(",")>0){
                      aggregateResult = Number.parseInt(graphicValues[i][fieldName]);
                      //console.log("campo di aggregazione: ", fieldName);
                    } */
                    else {
                        aggregateResult = Number.parseInt(element[fieldName]);
                        // console.log("campo di aggregazione: ", aggregation.aggregationField);
                    }
                    if (res.aggregatedData.has(key)) {
                        aggregateResult += res.aggregatedData.get(key)[1];
                        if (zFieldName != null) {
                            aggregateZval += res.aggregatedData.get(key)[2];
                            res.aggregatedData.set(key, [element[xaxisFieldName], aggregateResult, aggregateZval]);
                        }
                        else {
                            res.aggregatedData.set(key, [element[xaxisFieldName], aggregateResult]);
                        }
                        res.aggregatedGraphicValues.get(key).push(element);
                    }
                    else {
                        if (zFieldName != null) {
                            res.aggregatedData.set(key, [element[xaxisFieldName], aggregateResult, element[zFieldName]]);
                        }
                        else {
                            res.aggregatedData.set(key, [element[xaxisFieldName], aggregateResult]);
                        }
                        res.aggregatedGraphicValues.set(key, new Array());
                        res.aggregatedGraphicValues.get(key).push(element);
                    }
                    //console.log("aggregated data: ",res);
                }
            }
            else {
                if (preElaborationRequired == null) {
                    res.graphicValues.push(element);
                    res.yvalues.push(element[fieldName]);
                    if (res.zvalues != null && zFieldName != null) {
                        res.zvalues.push(element[zFieldName]);
                    }
                }
                else {
                    if (preElaborationRequired) {
                        res.graphicValues.push(element);
                        res.yvalues.push(element[fieldName]);
                        if (res.zvalues != null && zFieldName != null) {
                            res.zvalues.push(element[zFieldName]);
                        }
                    }
                    else {
                        res.yvalues.push(element[fieldName]);
                        if (res.zvalues != null && zFieldName != null) {
                            res.zvalues.push(element[zFieldName]);
                        }
                    }
                }
            }
        }
        if (isTable && res.xvaluesArray != null && res.xvaluesArray.length > 0) {
            const allXaxesNull = res.xvaluesArray.every((el) => el == null || el == undefined);
            if (allXaxesNull) {
                console.log('Sembra che ci sia un problema con il nome della variabile indicata nel campo xaxis dell\'yaxis: ' + yaxis.label + ' dato che tutti i valori risultano null o undefined');
            }
        }
        // console.log(res);
        return res;
    }
    static evalValueFuntion(values, valueFunctionStr, valueField) {
        for (const el of values) {
            el[valueField] = eval(valueFunctionStr);
        }
        return values;
    }
    static fillTemplate(templateString, templateVars) {
        return new Function("return `" + templateString + "`;").call(templateVars);
    }
    static templateLiteralsFunction(values, valueFunctionStr, valueField) {
        for (const el of values) {
            //   const templateString = valueFunctionStr;
            // console.log(this.fillTemplate(valueFunctionStr, el));
            //   const productImageUrl = el[valueField];
            el[valueField] = this.fillTemplate(valueFunctionStr, el);
        }
        // return  valueFunctionStr;
        //     const name = 'Naya';
        // const msg = `Hi ${name}`;
        return values;
        // for (const el of values) {
        // }
        //  return values;
    }
    /*  static evalValueFuntion(values: any[], valueFunctionStr: string, valueField: string): any[] {
       for (const el of values) {
         el[valueField] = eval(valueFunctionStr);
       }
       return values;
     } */
    static sort(xvalues, yvalues, sort, sortByField, zvalues) {
        //1) combine the arrays:
        var list = [];
        for (var j = 0; j < yvalues.length; j++) {
            if (zvalues != null) {
                list.push({ 'x': xvalues[j], 'y': yvalues[j], 'z': zvalues[j] });
            }
            else {
                list.push({ 'x': xvalues[j], 'y': yvalues[j] });
            }
        }
        //2) sort:
        if (sortByField) {
            list.sort(function (a, b) {
                //ordinamento per data
                if (moment$1(a.x, "DD/MM/YYYY", true).isValid() && moment$1(b.x, "DD/MM/YYYY", true).isValid()) {
                    const aDate = moment$1(a.x, "DD/MM/YYYY").toDate();
                    const bDate = moment$1(b.x, "DD/MM/YYYY").toDate();
                    //console.log("comparing date:",aDate, bDate);
                    return aDate.getTime() - bDate.getTime();
                }
                //ordinamento per stringa o valore
                else {
                    return ((a.x < b.x) ? -1 : ((a.x == b.x) ? 0 : 1));
                }
                //Sort could be modified to, for example, sort on the age 
                // if the name is the same.
            });
        }
        else {
            list.sort(function (a, b) {
                return ((a.y < b.y) ? -1 : ((a.y == b.y) ? 0 : 1));
                //Sort could be modified to, for example, sort on the age 
                // if the name is the same.
            });
        }
        //3) separate them back out:
        for (var k = 0; k < list.length; k++) {
            if (sort.toUpperCase() == 'ASC') {
                xvalues[k] = list[k].x;
                yvalues[k] = list[k].y;
                if (zvalues != null) {
                    zvalues[k] = list[k].z;
                }
            }
            else if (sort.toUpperCase() == 'DESC') {
                xvalues[k] = list[list.length - (k + 1)].x;
                yvalues[k] = list[list.length - (k + 1)].y;
                if (zvalues != null) {
                    zvalues[k] = list[list.length - (k + 1)].z;
                }
            }
        }
    }
    static sortObjectsListByField(values, field, sort) {
        //1) combine the arrays:
        let list = [];
        if (field == null) {
            return;
        }
        for (const element of values) {
            list.push({ 'x': element[field], 'value': element });
        }
        //2) sort:
        list.sort(function (a, b) {
            //ordinamento per data
            if (moment$1(a.x, "DD/MM/YYYY", true).isValid() && moment$1(b.x, "DD/MM/YYYY", true).isValid()) {
                const aDate = moment$1(a.x, "DD/MM/YYYY").toDate();
                const bDate = moment$1(b.x, "DD/MM/YYYY").toDate();
                //console.log("comparing date:",aDate, bDate);
                return aDate.getTime() - bDate.getTime();
            }
            //ordinamento per stringa o valore
            else {
                return ((a.x < b.x) ? -1 : ((a.x == b.x) ? 0 : 1));
            }
            //Sort could be modified to, for example, sort on the age 
            // if the name is the same.
        });
        //3) separate them back out:
        for (var k = 0; k < list.length; k++) {
            if (sort.toUpperCase() == 'ASC') {
                values[k] = list[k].value;
            }
            else if (sort.toUpperCase() == 'DESC') {
                values[k] = list[list.length - (k + 1)].value;
            }
        }
    }
    static buildUnit(unit, defaultUnit) {
        let convertedUnit = defaultUnit;
        switch (unit) {
            case 'ms':
                convertedUnit = 's';
                break;
            case 'millisecond':
                convertedUnit = 's';
                break;
            case 's':
            case 'second':
                convertedUnit = 's';
                break;
            case 'percentage':
            case 'perc':
            case '%':
                convertedUnit = '%';
                break;
            case '€':
            case 'EUR':
                convertedUnit = '€';
                break;
            default:
                convertedUnit = defaultUnit;
                break;
        }
        return convertedUnit;
    }
    static random_rgba() {
        var o = Math.round, r = Math.random, s = 255;
        return 'rgb(' + o(r() * s) + ',' + o(r() * s) + ',' + o(r() * s) + ')';
    }
    static convertValue(value, unit, defaultDgts) {
        let res = value;
        let dgts = defaultDgts ? defaultDgts : 3;
        if (value == null) {
            return res;
        }
        if (unit && typeof unit == 'string' && unit.includes('dgts')) {
            const mat = unit.match(/\d+/);
            if (mat) {
                let numDgts = mat[0]; // "3"
                if (numDgts || numDgts != null || numDgts != '') {
                    dgts = Number(numDgts);
                }
            }
            unit = 'dgts';
        }
        switch (unit) {
            case 'ms':
            case 'millisecond':
                res = Math.round((value / 1000) * 100) / 100;
                break;
            case 's':
            case 'second':
                res = Number(value.toFixed(3));
                break;
            case 'percentage':
            case 'perc':
            case '%':
                // res = Math.round(value*100)/100;
                // arrotondiamo alla terza cifra decimale
                res = Number(value.toFixed(3));
                break;
            case '€':
            case 'EUR':
                res = Number(value.toFixed(2));
                break;
            case 'dgts':
                res = Number(value.toFixed(dgts));
                break;
            case 'millesimal':
                res = Number(value.toFixed(6));
                break;
            default:
                res = value;
                if (value != null) {
                    res = Number(value.toFixed(dgts));
                }
                break;
        }
        return res;
    }
}

class Bar {
    constructor() {
        this.build = (initGraphicValues, translateService, graphConfig, yaxis) => {
            let graphicTrace = [];
            let yvalues = [];
            let xvalues = Array.from(initGraphicValues.xvalues.values());
            //console.log(xvalues);
            if (initGraphicValues.filteredGraphicValues != undefined) {
                //let filteredData: any = initGraphicValues.filteredData;
                let filteredGraphicValues = initGraphicValues.filteredGraphicValues;
                //this.printMap(filteredData);
                //console.log(filteredData);
                filteredGraphicValues.forEach((data, key) => {
                    yvalues = [];
                    let result = new Array();
                    const traceName = yaxis.label + ' - ' + key;
                    if (data != null) {
                        //ottengo la colonna con i valori delle ascisse
                        let actualxvalues = new Array();
                        data.forEach((obj) => {
                            let xval = GraphicUtil.getValFromObject(obj, yaxis.xaxis);
                            actualxvalues.push(xval);
                        });
                        //ottengo la colonna con i valori delle ascisse mancanti
                        let missedXValues = xvalues.filter(item => actualxvalues.indexOf(item) < 0);
                        //creo un array con ordintata pari a zero in corrispondenza delle ascisse mancanti
                        //e ordinata pari al valore in corrispondenza delle ascisse presenti
                        if (missedXValues.length > 0) {
                            //inizializzo result ai valori corretti settando a zero le date mancanti
                            //e, in caso di presenza di più valori per la stessa xval, li sommo
                            GraphicUtil.getZeroedAndSummedValues(xvalues, missedXValues, data, yaxis, result);
                        }
                        else {
                            data.forEach((obj) => {
                                //in questo caso l'xval lo valorizzo col campo dell'yaxis.xaxis, ossia il campo date in modo da sommare eventuali valori multipli presenti
                                let xval = GraphicUtil.getValFromObject(obj, yaxis.xaxis);
                                //valorizza result considerando la necessità di usare o meno le funzioni di calcolo
                                GraphicUtil.calculateResult(yaxis, xval, obj, result);
                            });
                        }
                        //ordinamento
                        /*  if(yaxis.sort){
                             this.sort(xvalues, yvalues, yaxis.sort);
                         } */
                        result.forEach((r) => {
                            if (r.calculatedValues) {
                                r.value = GraphicUtil.applyFunction(r);
                            }
                        });
                        let labels = result.map(r => r.label);
                        let values = result.map(r => r.value);
                        yvalues = values;
                        xvalues = labels;
                        /* //filtro risultati
                        if(yaxis.limitResult != null && yvalues.length > yaxis.limitResult){
                            xvalues = xvalues.splice(0, yaxis.limitResult);
                            yvalues = yvalues.splice(0, yaxis.limitResult);
                        } */
                        //ordinamento
                        if (yaxis.sort) {
                            this.sort(xvalues, yvalues, yaxis.sort, yaxis.sortByField);
                        }
                        const barTrace = new Trace(traceName, xvalues, yvalues, null, null, null, null, null, yaxis.color, null, graphConfig.orientation);
                        graphicTrace.push(this.buildGraphicTraceList(barTrace));
                        //console.log(lineGraphic);
                    }
                });
                //graphicTraces = graphicTraces.concat(graphicTraces);
            }
            else if (initGraphicValues.aggregatedGraphicValues != null) {
                let aggregatedDataGraphicValues = initGraphicValues.aggregatedGraphicValues;
                //console.log("aggregated graphic values: ",aggregatedDataGraphicValues);
                let result = new Array();
                aggregatedDataGraphicValues.forEach((data, key) => {
                    yvalues = [];
                    if (data != null) {
                        data.forEach((obj) => {
                            let xval = key;
                            /* //in questo caso l'xval lo valorizzo al campo usato per il groupby (label o field)
                            if(yaxis.dataAggregate.groupByFieldLabel){
                                xval = key;
                            }
                            else if(yaxis.dataAggregate.groupByField){
                                xval = GraphicUtil.getValFromObject(obj, key);
                            } */
                            //valorizza result considerando la necessità di usare o meno le funzioni di calcolo
                            GraphicUtil.calculateResult(yaxis, xval, obj, result);
                        });
                        //console.log(lineGraphic);
                    }
                });
                result.forEach((r) => {
                    if (r.calculatedValues) {
                        r.value = GraphicUtil.applyFunction(r);
                    }
                });
                let labels = result.map(r => r.label);
                let values = result.map(r => r.value);
                yvalues = values;
                xvalues = labels;
                /* //filtro risultati
                if(yaxis.limitResult != null && yvalues.length > yaxis.limitResult){
                    xvalues = xvalues.splice(0, yaxis.limitResult);
                    yvalues = yvalues.splice(0, yaxis.limitResult);
                } */
                //ordinamento
                if (yaxis.sort) {
                    this.sort(xvalues, yvalues, yaxis.sort, yaxis.sortByField);
                }
                const trace = new Trace(yaxis.label, xvalues, yvalues, null, null, null, null, null, yaxis.color, null, graphConfig.orientation);
                //this.initTrace(trace, graphConfig, yaxis);
                graphicTrace.push(this.buildGraphicTraceList(trace));
            }
            else if (initGraphicValues.aggregatedData != undefined) {
                let aggregatedData = initGraphicValues.aggregatedData;
                //this.printMap(aggregatedData);
                if (graphConfig.aggregateYAxis) {
                    yvalues = GraphicUtil.getIndexColumnArrayFromMatrix(Array.from(aggregatedData.values()), 1);
                    let sum = 0;
                    if (yvalues.length > 0) {
                        sum = yvalues.reduce((prevValue, currentValue) => {
                            return prevValue + currentValue;
                        });
                        yvalues = [sum];
                        xvalues = [yaxis.label];
                    }
                    const t = new Trace(graphConfig.title, xvalues, yvalues);
                    graphicTrace.push(this.buildGraphicTraceList(t));
                }
                else {
                    //if (yaxis.dataAggregate.aggregationField == yaxis.xaxis) {
                    yvalues = GraphicUtil.getIndexColumnArrayFromMatrix(Array.from(aggregatedData.values()), 1);
                    //ordinamento
                    if (yaxis.sort) {
                        this.sort(xvalues, yvalues, yaxis.sort, yaxis.sortByField);
                    }
                    //filtro risultati
                    if (yaxis.limitResult != null && yvalues.length > yaxis.limitResult) {
                        xvalues = xvalues.splice(0, yaxis.limitResult);
                        yvalues = yvalues.splice(0, yaxis.limitResult);
                    }
                    const t = new Trace(yaxis.label, xvalues, yvalues, null, null, null, null, null, yaxis.color, null, graphConfig.orientation);
                    graphicTrace.push(this.buildGraphicTraceList(t));
                }
                //graphicTraces = graphicTraces.concat(graphicTraces);
                //}
                //else {
                //this.newSnackbar("Errore nella configurazione del grafico: '" + graphConfig.title + " - " + yaxis.lable + "'", 'warning');
                //console.error("Errore nella configurazione del grafico: '" + graphConfig.title + " - " + yaxis.label + "'");
                //}
            }
            else {
                if (initGraphicValues.graphicValues != null && initGraphicValues.graphicValues.length > 0) {
                    let graphicValues = initGraphicValues.graphicValues;
                    let result = new Array();
                    graphicValues.forEach((obj) => {
                        //in questo caso l'xval lo valorizzo col campo dell'yaxis.xaxis, ossia il campo date in modo da sommare eventuali valori multipli presenti
                        let xval = GraphicUtil.getValFromObject(obj, yaxis.xaxis);
                        //valorizza result considerando la necessità di usare o meno le funzioni di calcolo
                        GraphicUtil.calculateResult(yaxis, xval, obj, result);
                    });
                    result.forEach((r) => {
                        if (r.calculatedValues) {
                            r.value = GraphicUtil.applyFunction(r);
                        }
                    });
                    let labels = result.map(r => r.label);
                    let values = result.map(r => r.value);
                    yvalues = values;
                    xvalues = labels;
                }
                else {
                    yvalues = initGraphicValues.yvalues;
                }
                /* //filtro risultati
                if(yaxis.limitResult != null && yvalues.length > yaxis.limitResult){
                    xvalues = xvalues.splice(0, yaxis.limitResult);
                    yvalues = yvalues.splice(0, yaxis.limitResult);
                } */
                //ordinamento
                if (yaxis.sort) {
                    this.sort(xvalues, yvalues, yaxis.sort, yaxis.sortByField);
                }
                const t = new Trace(yaxis.label, xvalues, yvalues, null, null, null, null, null, yaxis.color, null, graphConfig.orientation);
                graphicTrace = this.buildGraphicTraceList(t);
            }
            return graphicTrace;
        };
    }
    initTrace(trace, graphConfig, yaxis) {
        throw new Error("Method not implemented.");
    }
    buildUnit(unit, defaultUnit) {
        return GraphicUtil.buildUnit(unit, defaultUnit);
    }
    convertValue(value, unit) {
        return GraphicUtil.convertValue(value, unit);
    }
    sort(xvalues, yvalues, sortType, sortByField) {
        GraphicUtil.sort(xvalues, yvalues, sortType, sortByField);
    }
    buildLayout(graphConfig) {
        let numericUnit = graphConfig.numericUnit;
        if (!numericUnit) {
            numericUnit = graphConfig.tempNumericUnit;
        }
        let initLayout = {
            // width: graphConfig.width,
            height: graphConfig.height ? graphConfig.height : 450,
            title: '',
            grid: { rows: 1, columns: 1 },
            xaxis: {
                type: graphConfig.xaxesType,
                ticksuffix: graphConfig.orientation == 'h' ? numericUnit : null,
            },
            yaxis: {
                ticksuffix: graphConfig.orientation != 'h' ? numericUnit : null,
                automargin: true
            },
            showlegend: true,
            modebar: {
                bgcolor: 'transparent'
            },
            // shapes: []
        };
        initLayout.title = graphConfig.title;
        if (graphConfig.barmode != undefined) {
            initLayout.barmode = graphConfig.barmode;
            if (graphConfig.barmode == 'group') {
                if (graphConfig.bargap != undefined) {
                    initLayout.bargap = graphConfig.bargap;
                }
                else {
                    initLayout.bargap = '0.15';
                }
            }
        }
        if (graphConfig.predictionRef) {
            console.log('qui in predctions', graphConfig);
            initLayout.shapes = [
                // 1st highlight during Feb 4 - Feb 6
                {
                    type: 'rect',
                    // x-reference is assigned to the x-values
                    xref: 'paper',
                    // y-reference is assigned to the plot paper [0,1]
                    yref: 'paper',
                    x0: 0.75,
                    y0: 0,
                    x1: 1,
                    y1: 1,
                    fillcolor: '#fdc400',
                    opacity: 0.2,
                    line: {
                        width: 1,
                        color: '#fdc400'
                    }
                }
            ];
        }
        if (graphConfig.shapes) {
            console.log('qui in shapes', graphConfig);
            if (!initLayout.shapes)
                initLayout.shapes = [];
            initLayout.shapes = initLayout.shapes.concat(graphConfig.shapes);
            // initLayout.shapes =  [
            //     // 1st highlight during Feb 4 - Feb 6
            //             {
            //                 type: 'rect',
            //                 // x-reference is assigned to the x-values
            //                 xref: 'paper',
            //                 // y-reference is assigned to the plot paper [0,1]
            //                 yref: 'paper',
            //                 x0: 0.75,
            //                 y0: 0,
            //                 x1: 1,
            //                 y1: 1,
            //                 fillcolor: '#fdc400',
            //                 opacity: 0.2,
            //                 line: {
            //                     width: 1,
            //                     color: '#fdc400'
            //                 }
            //             }
            // ]
            console.log(initLayout.shapes, graphConfig.shapes);
        }
        return initLayout;
    }
    buildGraphicTraceList(trace, translateService) {
        let barGraphicTrace = {
            x: [],
            y: [],
            type: '',
            name: '',
            domain: {
                row: 0,
                column: 0
            },
            marker: {
                color: ''
            },
            text: []
        };
        barGraphicTrace.name = trace.name;
        if (trace.xvalues != null) {
            barGraphicTrace.x = trace.xvalues;
        }
        if (trace.yvalues != null) {
            barGraphicTrace.type = 'bar';
            barGraphicTrace.marker.color = trace.color;
            trace.yvalues.forEach((yval, index) => {
                yval = this.convertValue(yval, trace.numericUnit);
                barGraphicTrace.y.push(yval);
            });
        }
        if (trace.row != null) {
            barGraphicTrace.domain.row = trace.row;
        }
        if (trace.column != null) {
            barGraphicTrace.domain.column = trace.column;
        }
        if (trace.orientation != null && trace.orientation == 'h') {
            barGraphicTrace.orientation = 'h';
            barGraphicTrace.x = barGraphicTrace.y;
            barGraphicTrace.y = trace.xvalues;
        }
        return barGraphicTrace;
    }
}

class Bubble {
    constructor() {
        this.build = (initGraphicValues, translateService, graphConfig, yaxis) => {
            let graphicTrace = [];
            let yvalues = [];
            let zvalues = [];
            let xvalues = Array.from(initGraphicValues.xvalues.values());
            //console.log(xvalues);
            if (initGraphicValues.filteredData != undefined) {
                let filteredData = initGraphicValues.filteredData;
                let filteredGraphicValues = initGraphicValues.filteredGraphicValues;
                let key = null;
                if (yaxis.dataFilter?.filterField != null) {
                    key = yaxis.dataFilter.filterField;
                }
                else {
                    const k = yaxis.dataFilter?.filterFunction;
                    key = k.key;
                }
                //console.log(filteredGraphicValues);
                filteredGraphicValues.forEach((data, key) => {
                    yvalues = [];
                    let result = new Array();
                    const traceName = yaxis.label + ' - ' + key;
                    if (data != null) {
                        //ottengo la colonna con i valori delle ascisse
                        let actualxvalues = new Array();
                        data.forEach((obj) => {
                            let xval = GraphicUtil.getValFromObject(obj, yaxis.xaxis);
                            actualxvalues.push(xval);
                        });
                        //ottengo la colonna con i valori delle ascisse mancanti
                        let missedXValues = xvalues.filter(item => actualxvalues.indexOf(item) < 0);
                        //creo un array con ordintata pari a zero in corrispondenza delle ascisse mancanti
                        //e ordinata pari al valore in corrispondenza delle ascisse presenti
                        if (missedXValues.length > 0) {
                            //inizializzo result ai valori corretti settando a zero le date mancanti
                            //e, in caso di presenza di più valori per la stessa xval, li sommo
                            GraphicUtil.getZeroedAndSummedValues(xvalues, missedXValues, data, yaxis, result);
                        }
                        else {
                            data.forEach((obj) => {
                                //in questo caso l'xval lo valorizzo col campo dell'yaxis.xaxis, ossia il campo date in modo da sommare eventuali valori multipli presenti
                                let xval = GraphicUtil.getValFromObject(obj, yaxis.xaxis);
                                //valorizza result considerando la necessità di usare o meno le funzioni di calcolo
                                GraphicUtil.calculateResult(yaxis, xval, obj, result);
                            });
                        }
                        //ordinamento
                        /*  if(yaxis.sort){
                             this.sort(xvalues, yvalues, yaxis.sort);
                         } */
                        result.forEach((r) => {
                            if (r.calculatedValues) {
                                r.value = GraphicUtil.applyFunction(r);
                            }
                        });
                        let labels = result.map(r => r.label);
                        let values = result.map(r => r.value);
                        zvalues = result.map(r => r.zvalue);
                        yvalues = values;
                        xvalues = labels;
                        /* //filtro risultati
                        if(yaxis.limitResult != null && yvalues.length > yaxis.limitResult){
                            xvalues = xvalues.splice(0, yaxis.limitResult);
                            yvalues = yvalues.splice(0, yaxis.limitResult);
                        } */
                        //ordinamento
                        if (yaxis.sort) {
                            this.sort(xvalues, yvalues, yaxis.sort, null, zvalues);
                        }
                        let t = new Trace(traceName, xvalues, yvalues, null, null, null, null, yaxis.lineShape, yaxis.color, null, null, null, null, null, zvalues);
                        //init del trace della line
                        this.initTrace(t, graphConfig, yaxis);
                        var lineTrace = this.buildGraphicTraceList(t, translateService);
                        graphicTrace.push(lineTrace);
                        //console.log(lineGraphic);
                    }
                });
            }
            else if (initGraphicValues.aggregatedGraphicValues != null) {
                let aggregatedDataGraphicValues = initGraphicValues.aggregatedGraphicValues;
                //console.log("aggregated graphic values: ",aggregatedDataGraphicValues);
                let result = new Array();
                aggregatedDataGraphicValues.forEach((data, key) => {
                    yvalues = [];
                    const traceName = yaxis.label + ' - ' + key;
                    if (data != null) {
                        data.forEach((obj) => {
                            let xval = key;
                            /* //in questo caso l'xval lo valorizzo al campo usato per il groupby (label o field)
                            if(yaxis.dataAggregate.groupByFieldLabel){
                                xval = key;
                            }
                            else if(yaxis.dataAggregate.groupByField){
                                xval = GraphicUtil.getValFromObject(obj, key);
                            } */
                            //valorizza result considerando la necessità di usare o meno le funzioni di calcolo
                            GraphicUtil.calculateResult(yaxis, xval, obj, result);
                        });
                    }
                });
                result.forEach((r) => {
                    if (r.calculatedValues) {
                        r.value = GraphicUtil.applyFunction(r);
                    }
                });
                let labels = result.map(r => r.label);
                let values = result.map(r => r.value);
                zvalues = result.map(r => r.zvalue);
                yvalues = values;
                xvalues = labels;
                /* //filtro risultati
                if(yaxis.limitResult != null && yvalues.length > yaxis.limitResult){
                    xvalues = xvalues.splice(0, yaxis.limitResult);
                    yvalues = yvalues.splice(0, yaxis.limitResult);
                } */
                //ordinamento
                if (yaxis.sort) {
                    this.sort(xvalues, yvalues, yaxis.sort, null, zvalues);
                }
                const trace = new Trace(yaxis.label, xvalues, yvalues, null, null, null, null, null, yaxis.color, null, null, null, null, null, zvalues);
                this.initTrace(trace, graphConfig, yaxis);
                graphicTrace.push(this.buildGraphicTraceList(trace, translateService));
            }
            else if (initGraphicValues.aggregatedData != undefined) {
                let aggregatedData = initGraphicValues.aggregatedData;
                //this.printMap(aggregatedData);
                if (yaxis.dataAggregate.aggregationField == yaxis.xaxis) {
                    yvalues = GraphicUtil.getIndexColumnArrayFromMatrix(Array.from(aggregatedData.values()), 1);
                    zvalues = GraphicUtil.getIndexColumnArrayFromMatrix(Array.from(aggregatedData.values()), 2);
                    //ordinamento
                    if (yaxis.sort) {
                        this.sort(xvalues, yvalues, yaxis.sort, null, zvalues);
                    }
                    //filtro risultati
                    if (yaxis.limitResult != null && yvalues.length > yaxis.limitResult) {
                        xvalues = xvalues.splice(0, yaxis.limitResult);
                        yvalues = yvalues.splice(0, yaxis.limitResult);
                    }
                    let t = new Trace(yaxis.label, xvalues, yvalues, null, null, null, null, yaxis.lineShape, yaxis.color, null, null, null, null, null, zvalues);
                    //init del trace della line
                    this.initTrace(t, graphConfig, yaxis);
                    graphicTrace.push(this.buildGraphicTraceList(t, translateService));
                }
                else {
                    //this.newSnackbar("Errore nella configurazione del grafico: '"+graphConfig.title+" - "+yaxis.lable+"'", 'warning');
                    console.error("Errore nella configurazione del grafico: '" + graphConfig.title + " - " + yaxis.label + "'");
                }
            }
            else {
                if (initGraphicValues.graphicValues != null && initGraphicValues.graphicValues.length > 0) {
                    let graphicValues = initGraphicValues.graphicValues;
                    let result = new Array();
                    graphicValues.forEach((obj) => {
                        //in questo caso l'xval lo valorizzo col campo dell'yaxis.xaxis, ossia il campo date in modo da sommare eventuali valori multipli presenti
                        let xval = GraphicUtil.getValFromObject(obj, yaxis.xaxis);
                        //valorizza result considerando la necessità di usare o meno le funzioni di calcolo
                        GraphicUtil.calculateResult(yaxis, xval, obj, result);
                    });
                    result.forEach((r) => {
                        if (r.calculatedValues) {
                            r.value = GraphicUtil.applyFunction(r);
                        }
                    });
                    let labels = result.map(r => r.label);
                    let values = result.map(r => r.value);
                    zvalues = result.map(r => r.zvalue);
                    yvalues = values;
                    xvalues = labels;
                }
                //Else necessario per i grafici costruiti in modo statico
                else {
                    yvalues = initGraphicValues.yvalues;
                    zvalues = initGraphicValues.zvalues;
                }
                /* //filtro risultati
                if(yaxis.limitResult != null && yvalues.length > yaxis.limitResult){
                    xvalues = xvalues.splice(0, yaxis.limitResult);
                    yvalues = yvalues.splice(0, yaxis.limitResult);
                } */
                //ordinamento
                if (yaxis.sort) {
                    this.sort(xvalues, yvalues, yaxis.sort, null, zvalues);
                }
                let t = new Trace(yaxis.label, xvalues, yvalues, null, null, null, null, yaxis.lineShape, yaxis.color, null, null, null, null, null, zvalues);
                //init del trace della line
                this.initTrace(t, graphConfig, yaxis);
                graphicTrace = this.buildGraphicTraceList(t, translateService);
            }
            return graphicTrace;
        };
    }
    initTrace(t, graphConfig, yaxis) {
        /* t.shapeType = yaxis.lineShape;
        t.fill = yaxis.lineFill;
        t.fillcolor = yaxis.lineFillColor;
        if(yaxis.traceModeYaxis){
            t.mode = yaxis.traceModeYaxis;
        } */
        if (yaxis.numericUnit != null) {
            t.numericUnit = yaxis.numericUnit;
        }
        else {
            if (graphConfig.numericUnit != null) {
                t.numericUnit = graphConfig.numericUnit;
            }
        }
    }
    buildUnit(unit, defaultUnit) {
        return GraphicUtil.buildUnit(unit, defaultUnit);
    }
    convertValue(value, unit) {
        let res = value;
        if (value == null) {
            return res;
        }
        switch (unit) {
            case 'ms':
            case 'millisecond':
                res = Math.round((value / 1000) * 100) / 100;
                break;
            case 's':
            case 'second':
                res = Number(value.toFixed(3));
                break;
            case 'percentage':
            case 'perc':
            case '%':
                // res = Math.round(value*100)/100;
                // arrotondiamo alla terza cifra decimale
                res = Number(value.toFixed(3));
                break;
            case '€':
            case 'EUR':
                res = Number(value.toFixed(3));
                break;
            default:
                res = Number(value.toFixed(3));
                break;
        }
        return res;
    }
    sort(xvalues, yvalues, sortType, sortByField, zvalues) {
        GraphicUtil.sort(xvalues, yvalues, sortType, sortByField, zvalues);
    }
    buildLayout(graphConfig) {
        let numericUnit = graphConfig.numericUnit;
        if (!numericUnit) {
            numericUnit = graphConfig.tempNumericUnit;
        }
        let initLayout = {
            // width: graphConfig.width,
            height: graphConfig.height ? graphConfig.height : 450,
            title: '',
            grid: { rows: 1, columns: 1 },
            xaxis: {
                type: graphConfig.xaxesType,
            },
            yaxis: {
                ticksuffix: numericUnit
            },
            showlegend: true,
            modebar: {
                bgcolor: 'transparent'
            }
        };
        initLayout.title = graphConfig.title;
        return initLayout;
    }
    buildGraphicTraceList(trace, translateService) {
        const desired_maximum_marker_size = 15;
        let sizeText = null;
        if (translateService) {
            translateService.get('dashboard.widget.yaxis.z_field').subscribe((res) => {
                sizeText = res;
            });
        }
        let bubbleGraphicTrace = {
            x: [],
            y: [],
            mode: 'markers',
            name: '',
            domain: {
                row: 0,
                column: 0
            },
            marker: {
                size: [],
                sizeref: 1
            },
            text: []
        };
        bubbleGraphicTrace.name = trace.name;
        if (trace.xvalues != null) {
            bubbleGraphicTrace.x = trace.xvalues;
        }
        if (trace.zvalues != null) {
            bubbleGraphicTrace.marker.size = trace.zvalues;
            let sizeRef = 2.0 * Math.max(...bubbleGraphicTrace.marker.size) / (desired_maximum_marker_size ** 2);
            bubbleGraphicTrace.marker.sizeref = sizeRef;
        }
        if (trace.yvalues != null) {
            if (trace.color) {
                bubbleGraphicTrace.line.color = trace.color;
            }
            //console.log(lineGraphicTrace.line.color);
            bubbleGraphicTrace.mode = 'markers';
            if (trace.mode) {
                bubbleGraphicTrace.mode = trace.mode;
            }
            trace.yvalues.forEach((yval, index) => {
                yval = this.convertValue(yval, trace.numericUnit);
                bubbleGraphicTrace.y.push(yval);
                if (trace.xvalues != null && trace.zvalues != null) {
                    let ztext = bubbleGraphicTrace.marker.size[index] != null ? sizeText + ': ' + bubbleGraphicTrace.marker.size[index] : '';
                    bubbleGraphicTrace.text.push(ztext);
                }
            });
        }
        if (trace.row != null) {
            bubbleGraphicTrace.domain.row = trace.row;
        }
        if (trace.column != null) {
            bubbleGraphicTrace.domain.column = trace.column;
        }
        return bubbleGraphicTrace;
    }
}

class Funnel {
    constructor() {
        this.build = (initGraphicValues, translateService, graphConfig, yaxis) => {
            let graphicTrace = [];
            let yvalues = [];
            let xvalues = Array.from(initGraphicValues.xvalues.values());
            //console.log(xvalues);
            if (initGraphicValues.filteredGraphicValues != undefined) {
                //let filteredData: any = initGraphicValues.filteredData;
                let filteredGraphicValues = initGraphicValues.filteredGraphicValues;
                //this.printMap(filteredData);
                //console.log(filteredData);
                filteredGraphicValues.forEach((data, key) => {
                    yvalues = [];
                    let result = new Array();
                    const traceName = yaxis.label + ' - ' + key;
                    if (data != null) {
                        //ottengo la colonna con i valori delle ascisse
                        let actualxvalues = new Array();
                        data.forEach((obj) => {
                            let xval = GraphicUtil.getValFromObject(obj, yaxis.xaxis);
                            actualxvalues.push(xval);
                        });
                        //ottengo la colonna con i valori delle ascisse mancanti
                        let missedXValues = xvalues.filter(item => actualxvalues.indexOf(item) < 0);
                        //creo un array con ordintata pari a zero in corrispondenza delle ascisse mancanti
                        //e ordinata pari al valore in corrispondenza delle ascisse presenti
                        if (missedXValues.length > 0) {
                            //inizializzo result ai valori corretti settando a zero le date mancanti
                            //e, in caso di presenza di più valori per la stessa xval, li sommo
                            GraphicUtil.getZeroedAndSummedValues(xvalues, missedXValues, data, yaxis, result);
                        }
                        else {
                            data.forEach((obj) => {
                                //in questo caso l'xval lo valorizzo col campo dell'yaxis.xaxis, ossia il campo date in modo da sommare eventuali valori multipli presenti
                                let xval = GraphicUtil.getValFromObject(obj, yaxis.xaxis);
                                //valorizza result considerando la necessità di usare o meno le funzioni di calcolo
                                GraphicUtil.calculateResult(yaxis, xval, obj, result);
                            });
                        }
                        //ordinamento
                        /*  if(yaxis.sort){
                             this.sort(xvalues, yvalues, yaxis.sort);
                         } */
                        result.forEach((r) => {
                            if (r.calculatedValues) {
                                r.value = GraphicUtil.applyFunction(r);
                            }
                        });
                        let labels = result.map(r => r.label);
                        let values = result.map(r => r.value);
                        yvalues = values;
                        xvalues = labels;
                        /* //filtro risultati
                        if(yaxis.limitResult != null && yvalues.length > yaxis.limitResult){
                            xvalues = xvalues.splice(0, yaxis.limitResult);
                            yvalues = yvalues.splice(0, yaxis.limitResult);
                        } */
                        //ordinamento
                        if (yaxis.sort) {
                            this.sort(xvalues, yvalues, yaxis.sort, yaxis.sortByField);
                        }
                        if (yaxis.color == null) {
                            yaxis.color = GraphicUtil.random_rgba();
                        }
                        const trace = new Trace(traceName, xvalues, yvalues, null, null, null, null, null, yaxis.color, null, graphConfig.orientation);
                        graphicTrace.push(this.buildGraphicTraceList(trace, translateService));
                        //console.log(lineGraphic);
                    }
                });
                //graphicTraces = graphicTraces.concat(graphicTraces);
            }
            else if (initGraphicValues.aggregatedGraphicValues != null) {
                let aggregatedDataGraphicValues = initGraphicValues.aggregatedGraphicValues;
                //console.log("aggregated graphic values: ",aggregatedDataGraphicValues);
                let result = new Array();
                aggregatedDataGraphicValues.forEach((data, key) => {
                    yvalues = [];
                    if (data != null) {
                        data.forEach((obj) => {
                            let xval = key;
                            /* //in questo caso l'xval lo valorizzo al campo usato per il groupby (label o field)
                            if(yaxis.dataAggregate.groupByFieldLabel){
                                xval = key;
                            }
                            else if(yaxis.dataAggregate.groupByField){
                                xval = GraphicUtil.getValFromObject(obj, key);
                            } */
                            //valorizza result considerando la necessità di usare o meno le funzioni di calcolo
                            GraphicUtil.calculateResult(yaxis, xval, obj, result);
                        });
                        //console.log(lineGraphic);
                    }
                });
                result.forEach((r) => {
                    if (r.calculatedValues) {
                        r.value = GraphicUtil.applyFunction(r);
                    }
                });
                let labels = result.map(r => r.label);
                let values = result.map(r => r.value);
                yvalues = values;
                xvalues = labels;
                /* //filtro risultati
                if(yaxis.limitResult != null && yvalues.length > yaxis.limitResult){
                    xvalues = xvalues.splice(0, yaxis.limitResult);
                    yvalues = yvalues.splice(0, yaxis.limitResult);
                } */
                //ordinamento
                if (yaxis.sort) {
                    this.sort(xvalues, yvalues, yaxis.sort, yaxis.sortByField);
                }
                if (yaxis.color == null) {
                    yaxis.color = GraphicUtil.random_rgba();
                }
                const trace = new Trace(yaxis.label, xvalues, yvalues, null, null, null, null, null, yaxis.color, null, graphConfig.orientation);
                //this.initTrace(trace, graphConfig, yaxis);
                graphicTrace.push(this.buildGraphicTraceList(trace, translateService));
            }
            else if (initGraphicValues.aggregatedData != undefined) {
                let aggregatedData = initGraphicValues.aggregatedData;
                //this.printMap(aggregatedData);
                if (graphConfig.aggregateYAxis) {
                    yvalues = GraphicUtil.getIndexColumnArrayFromMatrix(Array.from(aggregatedData.values()), 1);
                    let sum = 0;
                    if (yvalues.length > 0) {
                        sum = yvalues.reduce((prevValue, currentValue) => {
                            return prevValue + currentValue;
                        });
                        yvalues = [sum];
                        xvalues = [yaxis.label];
                    }
                    const t = new Trace(graphConfig.title, xvalues, yvalues);
                    graphicTrace.push(this.buildGraphicTraceList(t, translateService));
                }
                else {
                    //if (yaxis.dataAggregate.aggregationField == yaxis.xaxis) {
                    yvalues = GraphicUtil.getIndexColumnArrayFromMatrix(Array.from(aggregatedData.values()), 1);
                    //ordinamento
                    if (yaxis.sort) {
                        this.sort(xvalues, yvalues, yaxis.sort, yaxis.sortByField);
                    }
                    //filtro risultati
                    if (yaxis.limitResult != null && yvalues.length > yaxis.limitResult) {
                        xvalues = xvalues.splice(0, yaxis.limitResult);
                        yvalues = yvalues.splice(0, yaxis.limitResult);
                    }
                    if (yaxis.color == null) {
                        yaxis.color = GraphicUtil.random_rgba();
                    }
                    const t = new Trace(yaxis.label, xvalues, yvalues, null, null, null, null, null, yaxis.color, null, graphConfig.orientation);
                    graphicTrace.push(this.buildGraphicTraceList(t, translateService));
                }
                //graphicTraces = graphicTraces.concat(graphicTraces);
                //}
                //else {
                //this.newSnackbar("Errore nella configurazione del grafico: '" + graphConfig.title + " - " + yaxis.lable + "'", 'warning');
                //console.error("Errore nella configurazione del grafico: '" + graphConfig.title + " - " + yaxis.label + "'");
                //}
            }
            else {
                if (initGraphicValues.graphicValues != null && initGraphicValues.graphicValues.length > 0) {
                    let graphicValues = initGraphicValues.graphicValues;
                    let result = new Array();
                    graphicValues.forEach((obj) => {
                        //in questo caso l'xval lo valorizzo col campo dell'yaxis.xaxis, ossia il campo date in modo da sommare eventuali valori multipli presenti
                        let xval = GraphicUtil.getValFromObject(obj, yaxis.xaxis);
                        //valorizza result considerando la necessità di usare o meno le funzioni di calcolo
                        GraphicUtil.calculateResult(yaxis, xval, obj, result);
                    });
                    result.forEach((r) => {
                        if (r.calculatedValues) {
                            r.value = GraphicUtil.applyFunction(r);
                        }
                    });
                    let labels = result.map(r => r.label);
                    let values = result.map(r => r.value);
                    yvalues = values;
                    xvalues = labels;
                }
                else {
                    yvalues = initGraphicValues.yvalues;
                }
                /* //filtro risultati
                if(yaxis.limitResult != null && yvalues.length > yaxis.limitResult){
                    xvalues = xvalues.splice(0, yaxis.limitResult);
                    yvalues = yvalues.splice(0, yaxis.limitResult);
                } */
                if (yaxis.color == null) {
                    yaxis.color = GraphicUtil.random_rgba();
                }
                //ordinamento
                if (yaxis.sort) {
                    this.sort(xvalues, yvalues, yaxis.sort, yaxis.sortByField);
                }
                const t = new Trace(yaxis.label, xvalues, yvalues, null, null, null, null, null, yaxis.color, null, graphConfig.orientation);
                graphicTrace = this.buildGraphicTraceList(t, translateService);
            }
            return graphicTrace;
        };
    }
    initTrace(trace, graphConfig, yaxis) {
        throw new Error("Method not implemented.");
    }
    buildUnit(unit, defaultUnit) {
        return GraphicUtil.buildUnit(unit, defaultUnit);
    }
    convertValue(value, unit) {
        return GraphicUtil.convertValue(value, unit);
    }
    sort(xvalues, yvalues, sortType, sortByField) {
        GraphicUtil.sort(xvalues, yvalues, sortType, sortByField);
    }
    buildLayout(graphConfig) {
        let numericUnit = graphConfig.numericUnit;
        if (!numericUnit) {
            numericUnit = graphConfig.tempNumericUnit;
        }
        let initLayout = {
            // width: graphConfig.width,
            height: graphConfig.height ? graphConfig.height : 450,
            title: '',
            showlegend: false,
            funnelmode: "stack",
            margin: { l: 130, r: 0 },
            // shapes: []
        };
        initLayout.title = graphConfig.title;
        if (graphConfig.predictionRef) {
            console.log('qui in predctions', graphConfig);
            initLayout.shapes = [
                // 1st highlight during Feb 4 - Feb 6
                {
                    type: 'rect',
                    // x-reference is assigned to the x-values
                    xref: 'paper',
                    // y-reference is assigned to the plot paper [0,1]
                    yref: 'paper',
                    x0: 0.75,
                    y0: 0,
                    x1: 1,
                    y1: 1,
                    fillcolor: '#fdc400',
                    opacity: 0.2,
                    line: {
                        width: 1,
                        color: '#fdc400'
                    }
                }
            ];
        }
        if (graphConfig.shapes) {
            console.log('qui in shapes', graphConfig);
            if (!initLayout.shapes)
                initLayout.shapes = [];
            initLayout.shapes = initLayout.shapes.concat(graphConfig.shapes);
            // initLayout.shapes =  [
            //     // 1st highlight during Feb 4 - Feb 6
            //             {
            //                 type: 'rect',
            //                 // x-reference is assigned to the x-values
            //                 xref: 'paper',
            //                 // y-reference is assigned to the plot paper [0,1]
            //                 yref: 'paper',
            //                 x0: 0.75,
            //                 y0: 0,
            //                 x1: 1,
            //                 y1: 1,
            //                 fillcolor: '#fdc400',
            //                 opacity: 0.2,
            //                 line: {
            //                     width: 1,
            //                     color: '#fdc400'
            //                 }
            //             }
            // ]
            console.log(initLayout.shapes, graphConfig.shapes);
        }
        return initLayout;
    }
    buildGraphicTraceList(trace, translateService) {
        let ofInitialPercentageText = null;
        let ofPreviousPercentageText = null;
        let ofTotalPercentageText = null;
        if (translateService) {
            translateService.get(['dashboard.widget.chart_info.of_initial_percentage',
                'dashboard.widget.chart_info.of_previous_percentage',
                'dashboard.widget.chart_info.of_total_percentage'])
                .subscribe((res) => {
                //console.log(res);
                ofInitialPercentageText = res['dashboard.widget.chart_info.of_initial_percentage'];
                ofPreviousPercentageText = res['dashboard.widget.chart_info.of_previous_percentage'];
                ofTotalPercentageText = res['dashboard.widget.chart_info.of_total_percentage'];
            });
        }
        let funnelGraphicTrace = {
            x: [],
            y: [],
            type: '',
            name: '',
            opacity: 0.90,
            hovertemplate: "%{percentInitial}" + (ofInitialPercentageText != null ? ofInitialPercentageText : '') + "<br>" +
                "%{percentPrevious}" + (ofPreviousPercentageText != null ? ofPreviousPercentageText : '') + "<br>" +
                "%{percentTotal}" + (ofTotalPercentageText != null ? ofTotalPercentageText : '') + "<br>",
            marker: {
                color: []
            },
            textinfo: "value"
        };
        funnelGraphicTrace.name = trace.name;
        if (trace.yvalues != null) {
            funnelGraphicTrace.type = 'funnel';
            funnelGraphicTrace.marker.color = new Array();
            this.sort(trace.xvalues ?? [], trace.yvalues, 'DESC'); //il funnel necessita dei valori ordinati in modo decrescente
            trace.yvalues.forEach((yval, index) => {
                let bluComp = 180 - index * 2;
                funnelGraphicTrace.marker.color.push(trace.color);
                yval = this.convertValue(yval, trace.numericUnit);
                funnelGraphicTrace.y.push(yval);
            });
            funnelGraphicTrace.x = cloneDeep(funnelGraphicTrace.y);
            //se è un numero lo obbligo ad essere stringa per una corretta visualizzazione
            trace.xvalues = trace.xvalues?.map((xv) => isNaN(+xv) ? xv : xv + ';');
            funnelGraphicTrace.y = cloneDeep(trace.xvalues);
        }
        if (trace.row != null) {
            funnelGraphicTrace.domain.row = trace.row;
        }
        if (trace.column != null) {
            funnelGraphicTrace.domain.column = trace.column;
        }
        //console.log('funnel:',funnelGraphicTrace);
        return funnelGraphicTrace;
    }
}

class Maparea extends BaseTrace {
    constructor(name, xvalues, yvalues, value, previousValue, row, column, shapeType, color, fontSize, orientation, numberSuffix, valueformat, margin, zvalues, areavalues) {
        super();
        this.name = name;
        this.xvalues = xvalues;
        this.yvalues = yvalues;
        this.value = value;
        this.row = row;
        this.column = column;
        this.color = color;
        this.fontSize = fontSize;
        this.numberSuffix = numberSuffix;
        this.valueformat = valueformat;
        this.margin = margin;
        this.areavalues = areavalues;
        this.previousValue = previousValue;
        this.shapeType = shapeType;
        this.orientation = orientation;
        this.zvalues = zvalues;
    }
}

class Heatmap {
    constructor() {
        this.build = (initGraphicValues, translateService, graphConfig, yaxis, yaxisIndex, value, previousValue) => {
            let tableData = new Array();
            let tableHeaders = new Set();
            let yvalues = [];
            let xvalues = Array.from(initGraphicValues.xvalues.values());
            let areas = [];
            //console.log(xvalues);
            if (initGraphicValues.filteredData != undefined) {
                let filteredData = initGraphicValues.filteredData;
                let filterKeyUnit = initGraphicValues.filterKeyUnit;
                let filterKeyField;
                let filteredGraphicValues = initGraphicValues.filteredGraphicValues;
                if (yaxis.dataFilter?.filterField) {
                    filterKeyField = yaxis.dataFilter.filterField;
                }
                else {
                    const k = yaxis.dataFilter?.filterFunction;
                    filterKeyField = k.key;
                }
                let result = new Array();
                filteredGraphicValues.forEach((data, key) => {
                    const traceName = yaxis.label; // yaxis.lable + ' - ' + key;
                    if (data != null) {
                        //nel caso della pie mi preoccupo solo di aggregare rispetto al filterfield
                        data.forEach((obj) => {
                            let xval = GraphicUtil.getValFromObject(obj, filterKeyField);
                            //valorizza result considerando la necessità di usare o meno le funzioni di calcolo
                            GraphicUtil.calculateResult(yaxis, xval, obj, result);
                        });
                    }
                });
                result.forEach((r) => {
                    let numericUnit;
                    let areaUnit = null;
                    if (yaxis.numericUnit != null) {
                        numericUnit = yaxis.numericUnit;
                    }
                    else {
                        if (graphConfig.numericUnit != null) {
                            numericUnit = graphConfig.numericUnit;
                        }
                    }
                    if (r.calculatedValues) {
                        r.value = GraphicUtil.applyFunction(r);
                    }
                    tableData.push(this.buildGraphicTraceElement(yaxis.label, r.value, r.label, numericUnit, filterKeyUnit));
                });
            }
            else if (initGraphicValues.aggregatedGraphicValues != null) {
                let aggregatedDataGraphicValues = initGraphicValues.aggregatedGraphicValues;
                let result = new Array();
                //console.log("aggregated graphic values: ",aggregatedDataGraphicValues);
                const traceName = yaxis.label;
                aggregatedDataGraphicValues.forEach((data, key) => {
                    yvalues = [];
                    if (data != null) {
                        data.forEach((obj) => {
                            let xval = key;
                            /* //in questo caso l'xval lo valorizzo al campo usato per il groupby (label o field)
                            if(yaxis.dataAggregate.groupByFieldLabel){
                                xval = key;
                            }
                            else if(yaxis.dataAggregate.groupByField){
                                xval = GraphicUtil.getValFromObject(obj, key);
                            } */
                            //valorizza result considerando la necessità di usare o meno le funzioni di calcolo
                            GraphicUtil.calculateResult(yaxis, xval, obj, result);
                        });
                    }
                });
                result.forEach((r) => {
                    let numericUnit;
                    if (yaxis.numericUnit != null) {
                        numericUnit = yaxis.numericUnit;
                    }
                    else {
                        if (graphConfig.numericUnit != null) {
                            numericUnit = graphConfig.numericUnit;
                        }
                    }
                    if (r.calculatedValues) {
                        r.value = GraphicUtil.applyFunction(r);
                        // if(yaxis.templateString){
                        //     r.value = GraphicUtil.templateLiteralsFunction(r.value, yaxis.templateString, yaxis.value);
                        //             console.log('templateString');
                        //         }
                    }
                    tableData.push(this.buildGraphicTraceElement(yaxis.label, r.value, r.label, numericUnit));
                });
            }
            else if (initGraphicValues.aggregatedData != undefined) {
                let aggregatedData = initGraphicValues.aggregatedData;
                //this.printMap(aggregatedData);
                if (yaxis.dataAggregate.aggregationField == yaxis.xaxis) {
                    yvalues = GraphicUtil.getIndexColumnArrayFromMatrix(Array.from(aggregatedData.values()), 1);
                    //ordinamento
                    if (yaxis.sort) {
                        this.sort(xvalues, yvalues, yaxis.sort);
                    }
                    //filtro risultati
                    if (yaxis.limitResult != null && yvalues.length > yaxis.limitResult) {
                        xvalues = xvalues.splice(0, yaxis.limitResult);
                        yvalues = yvalues.splice(0, yaxis.limitResult);
                    }
                    let t = new Maparea(yaxis.label, xvalues, yvalues);
                    this.initTrace(t, graphConfig, yaxis);
                    tableData = this.buildGraphicTraceList(t);
                }
                else {
                    //this.newSnackbar("Errore nella configurazione del grafico: '" + graphConfig.title + " - " + yaxis.lable + "'", 'warning');
                    console.error("Errore nella configurazione del grafico: '" + graphConfig.title + " - " + yaxis.label + "'");
                }
            }
            else {
                if (initGraphicValues.graphicValues != null && initGraphicValues.graphicValues.length > 0) {
                    let graphicValues = initGraphicValues.graphicValues;
                    // let result:Array<any> = new Array <any>();
                    // graphicValues.forEach((obj:any) => {
                    //     //in questo caso l'xval lo valorizzo col campo dell'yaxis.xaxis, ossia il campo date in modo da sommare eventuali valori multipli presenti
                    //     let xval = GraphicUtil.getValFromObject(obj, yaxis.xaxis);
                    //     //valorizza result considerando la necessità di usare o meno le funzioni di calcolo
                    //     GraphicUtil.calculateResult(yaxis, xval, obj, result);
                    // });
                    // result.forEach((r)=>{
                    //     if(r.calculatedValues){
                    //         r.value = GraphicUtil.applyFunction(r);
                    //     }
                    // });
                    let labels = graphicValues.map(r => r.territorio);
                    let values = graphicValues.map(r => r.value);
                    yvalues = values;
                    xvalues = labels;
                    areas = graphicValues.map(r => r.typeTerritorio);
                }
                //Else necessario per i grafici costruiti in modo statico
                else {
                    yvalues = initGraphicValues.yvalues;
                }
                /* //filtro risultati
                if(yaxis.limitResult != null && yvalues.length > yaxis.limitResult){
                    xvalues = xvalues.splice(0, yaxis.limitResult);
                    yvalues = yvalues.splice(0, yaxis.limitResult);
                } */
                //ordinamento
                // if(yaxis.sort){
                //     this.sort(xvalues, yvalues, yaxis.sort);
                // }
                let t = new Maparea(yaxis.label, xvalues, yvalues);
                t.areavalues = areas;
                this.initTrace(t, graphConfig, yaxis);
                tableData = this.buildGraphicTraceList(t);
            }
            return tableData;
        };
    }
    initTrace(t, graphConfig, yaxis) {
        if (yaxis.numericUnit != null) {
            t.numericUnit = yaxis.numericUnit;
        }
        else {
            if (graphConfig.numericUnit != null) {
                t.numericUnit = graphConfig.numericUnit;
            }
        }
    }
    buildUnit(unit, defaultUnit) {
        return GraphicUtil.buildUnit(unit, defaultUnit);
    }
    convertValue(value, unit, localeString) {
        let res = value;
        if (value == null) {
            return res;
        }
        switch (unit) {
            case 'ms':
            case 'millisecond':
                res = Math.round((value / 1000) * 100) / 100;
                break;
            case 's':
            case 'second':
                res = Number(value.toFixed(3));
                ;
                break;
            case 'percentage':
            case 'perc':
            case '%':
                // res = Math.round(value*100)/100;
                // arrotondiamo alla terza cifra decimale
                res = Number(value.toFixed(3));
                break;
            default:
                res = Number(value.toFixed(3));
                ;
                break;
        }
        return res;
    }
    sort(xvalues, yvalues, sortType) {
        console.log('in sort');
        GraphicUtil.sort(xvalues, yvalues, sortType);
    }
    buildLayout(graphConfig) {
        return null;
    }
    buildGraphicTraceElement(name, yval, xval, numericUnit, filterKeyUnit, area) {
        let keyUnit = null;
        if (filterKeyUnit) {
            keyUnit = filterKeyUnit;
        }
        let td = {
            rowHeader: xval,
            rowHeaderUnit: keyUnit,
            colHeader: name,
            colArea: area
        };
        td[name] = yval;
        if (yval == null) {
            td[name] = 'N.A.';
        }
        if (numericUnit) {
            const unit = this.buildUnit(numericUnit, numericUnit);
            //console.log("------- unit: "+unit);
            if (unit.toUpperCase() == 'URL') {
                td[name] = "<a href=\"" + yval + "\"  target=\"_blank\">" + yval + "</a>";
                ;
            }
            else {
                if (yval == null) {
                    td[name] = 'N.A.';
                }
                else {
                    const convYval = this.convertValue(yval, numericUnit);
                    //console.log('yval:',yval,'convYval:',convYval);
                    td[name] = convYval.toLocaleString("it-IT", { minimumFractionDigits: 0, maximumFractionDigits: 3 }) + " " + unit;
                }
            }
        }
        else {
            td[name] = yval;
        }
        return td;
    }
    buildGraphicTraceList(trace) {
        let ret = new Array();
        trace.yvalues?.forEach((ele, index) => {
            if (trace.xvalues && trace.areavalues) {
                let td = this.buildGraphicTraceElement(trace.name, ele, trace.xvalues[index], trace.numericUnit, null, trace.areavalues[index]);
                ret.push(td);
                //console.log(td);
            }
        });
        return ret;
    }
}

class Indicator {
    constructor() {
        this.build = (initGraphicValues, translateService, graphConfig, yaxis, yaxisIndex) => {
            let graphicTrace = [];
            let yvalues = [];
            let xvalues = Array.from(initGraphicValues.xvalues.values());
            //console.log(xvalues);
            if (initGraphicValues.filteredData != undefined) {
                let filterKeyField;
                let filteredData = initGraphicValues.filteredData;
                let filteredGraphicValues = initGraphicValues.filteredGraphicValues;
                if (yaxis.dataFilter?.filterField) {
                    filterKeyField = yaxis.dataFilter.filterField;
                }
                else {
                    const k = yaxis.dataFilter?.filterFunction;
                    filterKeyField = k.key;
                }
                let result = new Array();
                filteredGraphicValues.forEach((data, key) => {
                    yvalues = [];
                    if (data != null) {
                        //nel caso della pie mi preoccupo solo di aggregare rispetto al filterfield
                        data.forEach((obj) => {
                            let xval = GraphicUtil.getValFromObject(obj, filterKeyField);
                            //Mi accerto che il valore sia di tipo numerico, altrimenti lo converto (caso di selezione di una metrica di tipo stringa
                            //che contiene numeri, ad esempio: 'ga_sessionstotransaction' in 'google_analytics_userspurchase_b2c')
                            let temp = GraphicUtil.getValFromObject(obj, yaxis.value);
                            temp = GraphicUtil.castToNumber(temp);
                            GraphicUtil.setValInObject(obj, yaxis.value, temp);
                            //valorizza result considerando la necessità di usare o meno le funzioni di calcolo
                            GraphicUtil.calculateResult(yaxis, xval, obj, result);
                        });
                    }
                });
                result.forEach((r) => {
                    if (r.calculatedValues) {
                        r.value = GraphicUtil.applyFunction(r);
                    }
                });
                //console.log(result);
                let labels = result.map(r => r.label);
                let values = result.map(r => r.value);
                let indicatorValue = 0;
                indicatorValue = GraphicUtil.sumAllValues(values);
                let previuosValue = yaxis.previousValue ? yaxis.previousValue : null;
                let t = new Trace(yaxis.label, null, null, indicatorValue, previuosValue, 0, yaxisIndex);
                //inizializza il layout del trace t sulla base del graphconfig e dell'yaxis
                this.initTrace(t, graphConfig, yaxis);
                graphicTrace.push(this.buildGraphicTraceList(t));
            }
            else if (initGraphicValues.aggregatedGraphicValues != null) {
                let aggregatedDataGraphicValues = initGraphicValues.aggregatedGraphicValues;
                let result = new Array();
                //console.log("aggregated graphic values: ",aggregatedDataGraphicValues);
                const traceName = yaxis.label;
                aggregatedDataGraphicValues.forEach((data, key) => {
                    yvalues = [];
                    if (data != null) {
                        data.forEach((obj) => {
                            let xval = key;
                            //in questo caso l'xval lo valorizzo al campo usato per il groupby (label o field)
                            /* if(yaxis.dataAggregate.groupByFieldLabel){
                                xval = key;
                            }
                            else if(yaxis.dataAggregate.groupByField){
                                xval = GraphicUtil.getValFromObject(obj, key);
                            } */
                            //Mi accerto che il valore sia di tipo numerico, altrimenti lo converto (caso di selezione di una metrica di tipo stringa
                            //che contiene numeri, ad esempio: 'ga_sessionstotransaction' in 'google_analytics_userspurchase_b2c')
                            let temp = GraphicUtil.getValFromObject(obj, yaxis.value);
                            temp = GraphicUtil.castToNumber(temp);
                            GraphicUtil.setValInObject(obj, yaxis.value, temp);
                            //valorizza result considerando la necessità di usare o meno le funzioni di calcolo
                            GraphicUtil.calculateResult(yaxis, xval, obj, result);
                        });
                        //ordinamento
                        /*  if(yaxis.sort){
                             this.sort(xvalues, yvalues, yaxis.sort);
                         } */
                    }
                });
                result.forEach((r) => {
                    if (r.calculatedValues) {
                        r.value = GraphicUtil.applyFunction(r);
                    }
                });
                let labels = result.map(r => r.label);
                let values = result.map(r => r.value);
                let indicatorValue = 0;
                indicatorValue = GraphicUtil.sumAllValues(values);
                let previuosValue = yaxis.previousValue ? yaxis.previousValue : null;
                let trace = new Trace(yaxis.label, null, null, indicatorValue, previuosValue, 0, yaxisIndex);
                /* yvalues = values;
                xvalues = labels;
                const trace:Trace = new Trace(traceName, xvalues, yvalues, null, null, 0, yaxisIndex, null, yaxis.color);*/
                this.initTrace(trace, graphConfig, yaxis);
                graphicTrace.push(this.buildGraphicTraceList(trace));
                //console.log(lineGraphic);
            }
            else if (initGraphicValues.aggregatedData != undefined) {
                // console.log('aggregatedData');
                let aggregatedData = initGraphicValues.aggregatedData;
                //this.printMap(aggregatedData);
                if (yaxis.dataAggregate.aggregationField == yaxis.xaxis) {
                    yvalues = GraphicUtil.getIndexColumnArrayFromMatrix(Array.from(aggregatedData.values()), 1);
                    let result = 0;
                    if (yvalues.length > 0) {
                        GraphicUtil.sumAllValues(yvalues);
                    }
                    /* va migliorato il controllo se esiste una value function per il quale il dato non deve essere sommato */
                    if (yaxis.dataAggregate.aggregationFunctionString == 'average' || (yaxis.valueFunction && yaxis.valueFunction.indexOf('/') != -1)) {
                        result = (Math.round(result) / yvalues.length);
                        // Math.round(sum)/yvalues.length;
                    }
                    let previousValue = yaxis.previousValue ? yaxis.previousValue : null;
                    let t = new Trace(yaxis.label, null, null, result, previousValue, 0, yaxisIndex);
                    //inizializza il layout del trace t sulla base del graphconfig e dell'yaxis
                    this.initTrace(t, graphConfig, yaxis);
                    graphicTrace.push(this.buildGraphicTraceList(t));
                    //console.log("yaxis index: " + yaxisIndex);
                }
                else {
                    //this.newSnackbar("Errore nella configurazione del grafico: '"+graphConfig.title+" - "+yaxis.lable+"'", 'warning');
                    console.error("Errore nella configurazione del grafico: '" + graphConfig.title + " - " + yaxis.label + "'");
                }
            }
            else {
                let indicatorValue = null;
                let previousValue = null;
                if (initGraphicValues.graphicValues != null && initGraphicValues.graphicValues.length > 0) {
                    let graphicValues = initGraphicValues.graphicValues;
                    let result = new Array();
                    graphicValues.forEach((obj) => {
                        //xval unico in modo da sommare tutti i valori 
                        let xval = 'xval';
                        //Mi accerto che il valore sia di tipo numerico, altrimenti lo converto (caso di selezione di una metrica di tipo stringa
                        //che contiene numeri, ad esempio: 'ga_sessionstotransaction' in 'google_analytics_userspurchase_b2c')
                        let temp = GraphicUtil.getValFromObject(obj, yaxis.value);
                        temp = GraphicUtil.castToNumber(temp);
                        GraphicUtil.setValInObject(obj, yaxis.value, temp);
                        //valorizza result considerando la necessità di usare o meno le funzioni di calcolo
                        GraphicUtil.calculateResult(yaxis, xval, obj, result);
                    });
                    result.forEach((r) => {
                        if (r.calculatedValues) {
                            r.value = GraphicUtil.applyFunction(r);
                        }
                    });
                    let labels = result.map(r => r.label);
                    let values = result.map(r => r.value);
                    indicatorValue = GraphicUtil.sumAllValues(values);
                    previousValue = yaxis.previousValue ? yaxis.previousValue : null;
                    //console.log('simple trace 1', yaxis);
                }
                else {
                    yvalues = initGraphicValues.yvalues;
                    indicatorValue = GraphicUtil.sumAllValues(yvalues);
                    previousValue = yaxis.previousValue ? yaxis.previousValue : null;
                    //console.log('simple trace 2', yaxis);
                }
                let t = new Trace(yaxis.label, null, null, indicatorValue, previousValue, 0, yaxisIndex);
                //inizializza il layout del trace t sulla base del graphconfig e dell'yaxis
                this.initTrace(t, graphConfig, yaxis);
                graphicTrace = this.buildGraphicTraceList(t);
            }
            return graphicTrace;
        };
    }
    initTrace(t, graphConfig, yaxis) {
        if (yaxis.row != undefined) {
            t.row = yaxis.row;
        }
        if (yaxis.column != undefined) {
            t.column = yaxis.column;
        }
        if (graphConfig.delta != null) {
            t.delta = graphConfig.delta;
        }
        if (graphConfig.fontSize != null) {
            t.fontSize = graphConfig.fontSize;
        }
        if (graphConfig.fontColor != null) {
            t.fontColor = graphConfig.fontColor;
        }
        if (graphConfig.valueformat != null) {
            t.valueformat = graphConfig.valueformat;
        }
        if (yaxis.numericUnit != null) {
            t.numericUnit = yaxis.numericUnit;
        }
        else {
            if (graphConfig.numericUnit != null) {
                t.numericUnit = graphConfig.numericUnit;
            }
        }
        if (graphConfig.mode != null) {
            t.mode = graphConfig.mode;
        }
    }
    buildUnit(unit, defaultUnit) {
        return GraphicUtil.buildUnit(unit, defaultUnit);
    }
    convertValue(value, unit) {
        // let res: Number = value;
        // let dgts: Number = 3;
        // if(value == null){
        //     return null;
        // }
        // if (unit.includes('dgts')) {
        //     let numDgts = unit.match(/\d+/)[0] // "3"
        //     if(numDgts || numDgts != null || numDgts != ''){
        //         dgts = Number(numDgts);
        //     } else {
        //         dgts = 2;
        //     }
        //     unit = 'dgts';
        // }
        // switch (unit) {
        //     case 'ms':
        //     case 'millisecond':
        //         res = Math.round((value/1000)*100)/100;
        //         break;
        //     case 's':
        //     case 'second':
        //         res = Number(value.toFixed(3));
        //         break;
        //     case 'percentage':
        //     case 'perc':
        //     case '%':
        //         // res = Math.round(value*100)/100;
        //         // arrotondiamo alla terza cifra decimale
        //         res = Number(value.toFixed(2));
        //         break;
        //     case '€':
        //     case 'EUR':
        //         res = Number(value.toFixed(2));
        //         break;
        //     case 'dgts':
        //         res = Number(value.toFixed(dgts));
        //         break;
        //     default:
        //         res = value;
        //         if(value != null){
        //             res = Number(value.toFixed(3));
        //         }
        //         break;
        // }
        // return res;
        return GraphicUtil.convertValue(value, unit);
    }
    sort(xvalues, yvalues, sortType) {
    }
    buildLayout(graphConfig) {
        let initLayout = {
            // width: graphConfig.width != null ? graphConfig.width : 450,
            height: graphConfig.height ? graphConfig.height : 75,
            //title: '',
            grid: { rows: 1, columns: 1, pattern: 'indipendent' },
            showlegend: true,
            modebar: {
                bgcolor: 'transparent'
            },
        };
        initLayout.grid.columns = graphConfig.yaxis?.length;
        initLayout.grid.rows = graphConfig.yaxis?.length;
        //initLayout.title = graphConfig.title;
        //  console.log('in graph config',graphConfig);
        return initLayout;
    }
    buildGraphicTraceList(trace) {
        let indicatorGraphicTrace = {
            title: {
                text: trace.name,
                font: { size: 17 }
            },
            mode: 'number',
            type: 'indicator',
            value: 0,
            delta: null,
            gauge: null,
            domain: {
                row: 0,
                column: 0
            },
            number: {
                valueformat: null,
                font: {
                    size: 36,
                    color: '#333333'
                }
            }
        };
        // console.log(trace);
        if (trace.value != null) {
            indicatorGraphicTrace.value = trace.value;
            //console.log("row: "+ graphicTrace.domain.row+ " col: "+ graphicTrace.domain.column)
        }
        if (trace.mode != null) {
            indicatorGraphicTrace.mode = trace.mode;
            if (trace.mode.indexOf('gauge') > 0) {
                indicatorGraphicTrace.gauge = { axis: { range: [null, 100] } };
            }
        }
        if (trace.previousValue != null) {
            indicatorGraphicTrace.mode = "number+delta";
            const reference = trace.previousValue;
            const valueFormat = trace.delta && trace.delta.valueformat ? trace.delta.valueformat : '';
            const increasingObj = trace.delta && trace.delta.increasing ? trace.delta.increasing : null;
            const decreasingObj = trace.delta && trace.delta.increasing ? trace.delta.decreasing : null;
            indicatorGraphicTrace.delta = { relative: false, reference: reference, valueformat: valueFormat, increasing: increasingObj, decreasing: decreasingObj };
        }
        if (trace.row != null) {
            indicatorGraphicTrace.domain.row = trace.row;
        }
        if (trace.column != null) {
            indicatorGraphicTrace.domain.column = trace.column;
        }
        if (trace.fontSize != null) {
            indicatorGraphicTrace.number.font.size = trace.fontSize;
        }
        if (trace.fontColor != null) {
            indicatorGraphicTrace.number.font.color = trace.fontColor;
        }
        if (trace.numericUnit != null) {
            indicatorGraphicTrace.value = this.convertValue(indicatorGraphicTrace.value, trace.numericUnit);
            if (trace.numericUnit == '%' || trace.numericUnit == 'perc' || trace.numericUnit == 'percentage') {
                indicatorGraphicTrace.number.valueformat = '€.3f';
                indicatorGraphicTrace.number.suffix = this.buildUnit(trace.numericUnit, trace.numberSuffix ?? "");
            }
            if (trace.numericUnit == '€') {
                indicatorGraphicTrace.number.valueformat = '€.2f';
                indicatorGraphicTrace.number.suffix = this.buildUnit(trace.numericUnit, '€');
            }
            if (trace.numericUnit.includes('dgts')) {
                const match = trace.numericUnit.match(/\d+/);
                if (match) {
                    let numDgts = match[0]; // "3"
                    if (!numDgts || numDgts == null || numDgts == '') {
                        numDgts = '2';
                    }
                    indicatorGraphicTrace.number.valueformat = '.' + numDgts + 'f';
                    indicatorGraphicTrace.number.suffix = this.buildUnit(trace.numericUnit, '');
                }
            }
            else {
                indicatorGraphicTrace.number.suffix = this.buildUnit(trace.numericUnit, trace.numberSuffix ?? "");
            }
        }
        else {
            if (trace.value != undefined && trace.value < 10000 && (indicatorGraphicTrace.number.valueformat == null || indicatorGraphicTrace.number.valueformat == '')) {
                //intero
                //se il numero è intero applico di default il formato float onde evitare rounding
                //altrimenti arrotondo
                if (Number.isInteger(trace.value)) {
                    indicatorGraphicTrace.number.valueformat = 'f';
                }
                // else {
                //     indicatorGraphicTrace.number.valueformat = '.f';
                // }
            }
        }
        if (trace.numberSuffix != null) {
            indicatorGraphicTrace.number.suffix = trace.numberSuffix;
        }
        if (trace.valueformat != null) {
            indicatorGraphicTrace.number.valueformat = trace.valueformat;
        }
        indicatorGraphicTrace.margin = { t: 0, b: 0, l: 0, r: 0 };
        return indicatorGraphicTrace;
    }
}

class Line {
    constructor() {
        this.build = (initGraphicValues, translateService, graphConfig, yaxis) => {
            let graphicTrace = [];
            let yvalues = [];
            let xvalues = Array.from(initGraphicValues.xvalues.values());
            //console.log(xvalues);
            if (initGraphicValues.filteredData != undefined) {
                let filteredData = initGraphicValues.filteredData;
                let filteredGraphicValues = initGraphicValues.filteredGraphicValues;
                let key = null;
                if (yaxis.dataFilter?.filterField != null) {
                    key = yaxis.dataFilter?.filterField;
                }
                else {
                    const k = yaxis.dataFilter?.filterFunction;
                    key = k.key;
                }
                //console.log(filteredGraphicValues);
                filteredGraphicValues.forEach((data, key) => {
                    yvalues = [];
                    let result = new Array();
                    const traceName = yaxis.label + ' - ' + key;
                    if (data != null) {
                        //ottengo la colonna con i valori delle ascisse
                        let actualxvalues = new Array();
                        data.forEach((obj) => {
                            let xval = GraphicUtil.getValFromObject(obj, yaxis.xaxis);
                            actualxvalues.push(xval);
                        });
                        //ottengo la colonna con i valori delle ascisse mancanti
                        let missedXValues = xvalues.filter(item => actualxvalues.indexOf(item) < 0);
                        //creo un array con ordintata pari a zero in corrispondenza delle ascisse mancanti
                        //e ordinata pari al valore in corrispondenza delle ascisse presenti
                        if (missedXValues.length > 0) {
                            //inizializzo result ai valori corretti settando a zero le date mancanti
                            //e, in caso di presenza di più valori per la stessa xval, li sommo
                            GraphicUtil.getZeroedAndSummedValues(xvalues, missedXValues, data, yaxis, result);
                        }
                        else {
                            data.forEach((obj) => {
                                //in questo caso l'xval lo valorizzo col campo dell'yaxis.xaxis, ossia il campo date in modo da sommare eventuali valori multipli presenti
                                let xval = GraphicUtil.getValFromObject(obj, yaxis.xaxis);
                                //valorizza result considerando la necessità di usare o meno le funzioni di calcolo
                                GraphicUtil.calculateResult(yaxis, xval, obj, result);
                            });
                        }
                        //ordinamento
                        /*  if(yaxis.sort){
                             this.sort(xvalues, yvalues, yaxis.sort);
                         } */
                        result.forEach((r) => {
                            if (r.calculatedValues) {
                                r.value = GraphicUtil.applyFunction(r);
                            }
                        });
                        let labels = result.map(r => r.label);
                        let values = result.map(r => r.value);
                        yvalues = values;
                        xvalues = labels;
                        /* //filtro risultati
                        if(yaxis.limitResult != null && yvalues.length > yaxis.limitResult){
                            xvalues = xvalues.splice(0, yaxis.limitResult);
                            yvalues = yvalues.splice(0, yaxis.limitResult);
                        } */
                        //ordinamento
                        if (yaxis.sort) {
                            this.sort(xvalues, yvalues, yaxis.sort);
                        }
                        let t = new Trace(traceName, xvalues, yvalues, null, null, null, null, yaxis.lineShape, yaxis.color);
                        //init del trace della line
                        this.initTrace(t, graphConfig, yaxis);
                        let lineTrace = this.buildGraphicTraceList(t);
                        graphicTrace.push(lineTrace);
                        //console.log(lineGraphic);
                    }
                });
            }
            else if (initGraphicValues.aggregatedGraphicValues != null) {
                let aggregatedDataGraphicValues = initGraphicValues.aggregatedGraphicValues;
                //console.log("aggregated graphic values: ",aggregatedDataGraphicValues);
                let result = new Array();
                aggregatedDataGraphicValues.forEach((data, key) => {
                    yvalues = [];
                    const traceName = yaxis.label + ' - ' + key;
                    if (data != null) {
                        data.forEach((obj) => {
                            let xval = key;
                            /* //in questo caso l'xval lo valorizzo al campo usato per il groupby (label o field)
                            if(yaxis.dataAggregate.groupByFieldLabel){
                                xval = key;
                            }
                            else if(yaxis.dataAggregate.groupByField){
                                xval = GraphicUtil.getValFromObject(obj, key);
                            } */
                            //valorizza result considerando la necessità di usare o meno le funzioni di calcolo
                            GraphicUtil.calculateResult(yaxis, xval, obj, result);
                        });
                    }
                });
                result.forEach((r) => {
                    if (r.calculatedValues) {
                        r.value = GraphicUtil.applyFunction(r);
                    }
                });
                let labels = result.map(r => r.label);
                let values = result.map(r => r.value);
                yvalues = values;
                xvalues = labels;
                /* //filtro risultati
                if(yaxis.limitResult != null && yvalues.length > yaxis.limitResult){
                    xvalues = xvalues.splice(0, yaxis.limitResult);
                    yvalues = yvalues.splice(0, yaxis.limitResult);
                } */
                //ordinamento
                if (yaxis.sort) {
                    this.sort(xvalues, yvalues, yaxis.sort);
                }
                const trace = new Trace(yaxis.label, xvalues, yvalues, null, null, null, null, null, yaxis.color, null, graphConfig.orientation);
                this.initTrace(trace, graphConfig, yaxis);
                graphicTrace.push(this.buildGraphicTraceList(trace));
            }
            else if (initGraphicValues.aggregatedData != undefined) {
                let aggregatedData = initGraphicValues.aggregatedData;
                //this.printMap(aggregatedData);
                if (yaxis.dataAggregate.aggregationField == yaxis.xaxis) {
                    yvalues = GraphicUtil.getIndexColumnArrayFromMatrix(Array.from(aggregatedData.values()), 1);
                    //ordinamento
                    if (yaxis.sort) {
                        this.sort(xvalues, yvalues, yaxis.sort);
                    }
                    //filtro risultati
                    if (yaxis.limitResult != null && yvalues.length > yaxis.limitResult) {
                        xvalues = xvalues.splice(0, yaxis.limitResult);
                        yvalues = yvalues.splice(0, yaxis.limitResult);
                    }
                    let t = new Trace(yaxis.label, xvalues, yvalues, null, null, null, null, yaxis.lineShape, yaxis.color);
                    //init del trace della line
                    this.initTrace(t, graphConfig, yaxis);
                    graphicTrace.push(this.buildGraphicTraceList(t));
                }
                else {
                    //this.newSnackbar("Errore nella configurazione del grafico: '"+graphConfig.title+" - "+yaxis.lable+"'", 'warning');
                    console.error("Errore nella configurazione del grafico: '" + graphConfig.title + " - " + yaxis.label + "'");
                }
            }
            else {
                if (initGraphicValues.graphicValues != null && initGraphicValues.graphicValues.length > 0) {
                    let graphicValues = initGraphicValues.graphicValues;
                    let result = new Array();
                    graphicValues.forEach((obj) => {
                        //in questo caso l'xval lo valorizzo col campo dell'yaxis.xaxis, ossia il campo date in modo da sommare eventuali valori multipli presenti
                        let xval = GraphicUtil.getValFromObject(obj, yaxis.xaxis);
                        //valorizza result considerando la necessità di usare o meno le funzioni di calcolo
                        GraphicUtil.calculateResult(yaxis, xval, obj, result);
                    });
                    result.forEach((r) => {
                        if (r.calculatedValues) {
                            r.value = GraphicUtil.applyFunction(r);
                        }
                    });
                    let labels = result.map(r => r.label);
                    let values = result.map(r => r.value);
                    yvalues = values;
                    xvalues = labels;
                }
                //Else necessario per i grafici costruiti in modo statico
                else {
                    yvalues = initGraphicValues.yvalues;
                }
                /* //filtro risultati
                if(yaxis.limitResult != null && yvalues.length > yaxis.limitResult){
                    xvalues = xvalues.splice(0, yaxis.limitResult);
                    yvalues = yvalues.splice(0, yaxis.limitResult);
                } */
                //ordinamento
                if (yaxis.sort) {
                    this.sort(xvalues, yvalues, yaxis.sort);
                }
                let t = new Trace(yaxis.label, xvalues, yvalues, null, null, null, null, yaxis.lineShape, yaxis.color);
                //init del trace della line
                this.initTrace(t, graphConfig, yaxis);
                graphicTrace = this.buildGraphicTraceList(t);
            }
            return graphicTrace;
        };
    }
    initTrace(t, graphConfig, yaxis) {
        t.shapeType = yaxis.lineShape;
        t.fill = yaxis.lineFill;
        t.fillcolor = yaxis.lineFillColor;
        if (yaxis.traceModeYaxis) {
            t.mode = yaxis.traceModeYaxis;
        }
        if (yaxis.numericUnit != null) {
            t.numericUnit = yaxis.numericUnit;
        }
        else {
            if (graphConfig.numericUnit != null) {
                t.numericUnit = graphConfig.numericUnit;
            }
        }
    }
    buildUnit(unit, defaultUnit) {
        return GraphicUtil.buildUnit(unit, defaultUnit);
    }
    convertValue(value, unit) {
        // let res:Number = value;
        // if(value == null){
        //     return null;
        // }
        // switch (unit) {
        //     case 'ms':
        //     case 'millisecond':
        //         res = Math.round((value/1000)*100)/100;
        //         break;
        //     case 's':
        //     case 'second':
        //         res = Number(value.toFixed(3));
        //         break;
        //     case 'percentage':
        //     case 'perc':
        //     case '%':
        //         // res = Math.round(value*100)/100;
        //         // arrotondiamo alla terza cifra decimale
        //         res = Number(value.toFixed(3));
        //         break;
        //     case '€':
        //     case 'EUR':
        //         res = Number(value.toFixed(3));
        //         break;
        //     default:
        //         res = Number(value.toFixed(3));
        //         break;
        // }
        // return res;
        return GraphicUtil.convertValue(value, unit);
    }
    sort(xvalues, yvalues, sortType) {
        GraphicUtil.sort(xvalues, yvalues, sortType);
    }
    buildLayout(graphConfig) {
        let numericUnit = graphConfig.numericUnit;
        if (!numericUnit) {
            numericUnit = graphConfig.tempNumericUnit;
        }
        let initLayout = {
            // width: graphConfig.width,
            height: graphConfig.height ? graphConfig.height : 450,
            title: '',
            grid: { rows: 1, columns: 1 },
            xaxis: {
                type: graphConfig.xaxesType,
            },
            yaxis: {
                ticksuffix: numericUnit
            },
            showlegend: true,
            modebar: {
                bgcolor: 'transparent'
            }
        };
        initLayout.title = graphConfig.title;
        return initLayout;
    }
    buildGraphicTraceList(trace, translateService) {
        let lineGraphicTrace = {
            x: [],
            y: [],
            mode: '',
            name: '',
            domain: {
                row: 0,
                column: 0
            },
            line: {
                shape: 'spline',
                color: ''
            }
        };
        lineGraphicTrace.name = trace.name;
        if (trace.xvalues != null) {
            lineGraphicTrace.x = trace.xvalues;
        }
        if (trace.yvalues != null) {
            lineGraphicTrace.type = 'scatter';
            if (trace.shapeType) {
                lineGraphicTrace.line.shape = trace.shapeType;
            }
            if (trace.fill) {
                lineGraphicTrace.fill = trace.fill;
                if (trace.fillcolor) {
                    lineGraphicTrace.fillcolor = trace.fillcolor;
                }
                else {
                    lineGraphicTrace.fillcolor = 'rgba(100,199,105,0.5)';
                }
            }
            if (trace.color) {
                lineGraphicTrace.line.color = trace.color;
            }
            //console.log(lineGraphicTrace.line.color);
            lineGraphicTrace.mode = 'lines+markers';
            if (trace.mode) {
                lineGraphicTrace.mode = trace.mode;
            }
            trace.yvalues.forEach((yval) => {
                yval = this.convertValue(yval, trace.numericUnit);
                lineGraphicTrace.y.push(yval);
            });
        }
        if (trace.row != null) {
            lineGraphicTrace.domain.row = trace.row;
        }
        if (trace.column != null) {
            lineGraphicTrace.domain.column = trace.column;
        }
        return lineGraphicTrace;
    }
}

class Pie {
    constructor() {
        this.build = (initGraphicValues, translateService, graphConfig, yaxis, yaxisIndex) => {
            let graphicTrace = [];
            let yvalues = [];
            let xvalues = Array.from(initGraphicValues.xvalues.values());
            // console.log(initGraphicValues);
            if (initGraphicValues.filteredData != undefined) {
                let filterKeyField;
                let filteredGraphicValues = initGraphicValues.filteredGraphicValues;
                if (yaxis.dataFilter?.filterField) {
                    filterKeyField = yaxis.dataFilter.filterField;
                }
                else {
                    const k = yaxis.dataFilter?.filterFunction;
                    filterKeyField = k.key;
                }
                //this.printMap(filteredData);
                //console.log(filteredData);
                let result = new Array();
                filteredGraphicValues.forEach((data, key) => {
                    yvalues = [];
                    if (data != null) {
                        //nel caso della pie mi preoccupo solo di aggregare rispetto al filterfield
                        data.forEach((obj) => {
                            let xval = GraphicUtil.getValFromObject(obj, filterKeyField);
                            //valorizza result considerando la necessità di usare o meno le funzioni di calcolo
                            GraphicUtil.calculateResult(yaxis, xval, obj, result);
                        });
                    }
                });
                result.forEach((r) => {
                    if (r.calculatedValues) {
                        r.value = GraphicUtil.applyFunction(r);
                    }
                });
                let labels = result.map(r => r.label);
                let values = result.map(r => r.value);
                /* //filtro risultati
                if(yaxis.limitResult != null && yvalues.length > yaxis.limitResult){
                    xvalues = xvalues.splice(0, yaxis.limitResult);
                    yvalues = yvalues.splice(0, yaxis.limitResult);
                } */
                //ordinamento
                if (yaxis.sort) {
                    this.sort(xvalues, yvalues, yaxis.sort);
                }
                const t = new Trace(yaxis.label, labels, values, null, null, 0, yaxisIndex);
                this.initTrace(t, graphConfig, yaxis);
                graphicTrace.push(this.buildGraphicTraceList(t));
            }
            else if (initGraphicValues.aggregatedGraphicValues != null) {
                let aggregatedDataGraphicValues = initGraphicValues.aggregatedGraphicValues;
                let result = new Array();
                //console.log("aggregated graphic values: ",aggregatedDataGraphicValues);
                const traceName = yaxis.label;
                aggregatedDataGraphicValues.forEach((data, key) => {
                    yvalues = [];
                    if (data != null) {
                        data.forEach((obj) => {
                            let xval = key;
                            /* //in questo caso l'xval lo valorizzo al campo usato per il groupby (label o field)
                            if(yaxis.dataAggregate.groupByFieldLabel){
                                xval = key;
                            }
                            else if(yaxis.dataAggregate.groupByField){
                                xval = GraphicUtil.getValFromObject(obj, key);
                            } */
                            //valorizza result considerando la necessità di usare o meno le funzioni di calcolo
                            GraphicUtil.calculateResult(yaxis, xval, obj, result);
                        });
                    }
                });
                result.forEach((r) => {
                    if (r.calculatedValues) {
                        r.value = GraphicUtil.applyFunction(r);
                    }
                });
                let labels = result.map(r => r.label);
                let values = result.map(r => r.value);
                yvalues = values;
                xvalues = labels;
                /* //filtro risultati
                if(yaxis.limitResult != null && yvalues.length > yaxis.limitResult){
                    xvalues = xvalues.splice(0, yaxis.limitResult);
                    yvalues = yvalues.splice(0, yaxis.limitResult);
                } */
                //ordinamento
                if (yaxis.sort) {
                    this.sort(xvalues, yvalues, yaxis.sort);
                }
                const trace = new Trace(traceName, xvalues, yvalues, null, null, 0, yaxisIndex, null, yaxis.color);
                this.initTrace(trace, graphConfig, yaxis);
                graphicTrace.push(this.buildGraphicTraceList(trace));
                //console.log(lineGraphic);
            }
            else if (initGraphicValues.aggregatedData != undefined) {
                let aggregatedData = initGraphicValues.aggregatedData;
                //this.printMap(aggregatedData);
                if (graphConfig.aggregateYAxis) {
                    yvalues = GraphicUtil.getIndexColumnArrayFromMatrix(Array.from(aggregatedData.values()), 1);
                    let sum = 0;
                    if (yvalues.length > 0) {
                        sum = yvalues.reduce((prevValue, currentValue) => {
                            return prevValue + currentValue;
                        });
                        yvalues = [sum];
                        xvalues = [yaxis.label];
                    }
                    const t = new Trace(graphConfig.title, xvalues, yvalues, null, null, 0, yaxisIndex);
                    this.initTrace(t, graphConfig, yaxis);
                    graphicTrace.push(this.buildGraphicTraceList(t));
                }
                else { //if (yaxis.dataAggregate.aggregationField == yaxis.xaxis) {
                    yvalues = GraphicUtil.getIndexColumnArrayFromMatrix(Array.from(aggregatedData.values()), 1);
                    //ordinamento
                    if (yaxis.sort) {
                        this.sort(xvalues, yvalues, yaxis.sort);
                    }
                    //filtro risultati
                    if (yaxis.limitResult != null && yvalues.length > yaxis.limitResult) {
                        xvalues = xvalues.splice(0, yaxis.limitResult);
                        yvalues = yvalues.splice(0, yaxis.limitResult);
                    }
                    const t = new Trace(yaxis.label, xvalues, yvalues, null, null, 0, yaxisIndex);
                    this.initTrace(t, graphConfig, yaxis);
                    graphicTrace.push(this.buildGraphicTraceList(t));
                    //console.log("yaxis index: " + yaxisIndex);
                }
            }
            else {
                if (initGraphicValues.graphicValues != null && initGraphicValues.graphicValues.length > 0) {
                    let graphicValues = initGraphicValues.graphicValues;
                    let result = new Array();
                    console.log("result: ", result);
                    graphicValues.forEach((obj) => {
                        //in questo caso l'xval lo valorizzo col campo dell'yaxis.xaxis, ossia il campo date in modo da sommare eventuali valori multipli presenti
                        let xval = GraphicUtil.getValFromObject(obj, yaxis.xaxis);
                        //valorizza result considerando la necessità di usare o meno le funzioni di calcolo
                        GraphicUtil.calculateResult(yaxis, xval, obj, result);
                    });
                    result.forEach((r) => {
                        if (r.calculatedValues) {
                            r.value = GraphicUtil.applyFunction(r);
                        }
                    });
                    let labels = result.map(r => r.label);
                    let values = result.map(r => r.value);
                    yvalues = values;
                    xvalues = labels;
                }
                else {
                    yvalues = initGraphicValues.yvalues;
                }
                /* //filtro risultati
                if(yaxis.limitResult != null && yvalues.length > yaxis.limitResult){
                    xvalues = xvalues.splice(0, yaxis.limitResult);
                    yvalues = yvalues.splice(0, yaxis.limitResult);
                } */
                //ordinamento
                if (yaxis.sort) {
                    this.sort(xvalues, yvalues, yaxis.sort);
                }
                const t = new Trace(yaxis.label, xvalues, yvalues, null, null, 0, yaxisIndex);
                this.initTrace(t, graphConfig, yaxis);
                graphicTrace = this.buildGraphicTraceList(t);
            }
            return graphicTrace;
        };
    }
    initTrace(t, graphConfig, yaxis) {
        if (graphConfig.labels != undefined) {
            t.labels = graphConfig.labels;
        }
        if (graphConfig.colors != undefined) {
            t.colors = graphConfig.colors;
        }
        if (graphConfig.numericUnit != undefined) {
            t.numericUnit = graphConfig.numericUnit;
        }
        t.limitPieResults = graphConfig.limitPieResults;
    }
    buildUnit(unit, defaultUnit) {
        return GraphicUtil.buildUnit(unit, defaultUnit);
    }
    convertValue(value, unit) {
        // let res:Number = value;
        // if(value == null){
        //     return null;
        // }
        // switch (unit) {
        //     case 'ms':
        //     case 'millisecond':
        //         res = Math.round((value/1000)*100)/100;
        //         break;
        //     case 's':
        //     case 'second':
        //         res = Number(value.toFixed(3));
        //         break;
        //     case 'percentage':
        //     case 'perc':
        //     case '%':
        //         // res = Math.round(value*100)/100;
        //         // arrotondiamo alla terza cifra decimale
        //         res = Number(value.toFixed(3));
        //         break;
        //     case '€':
        //     case 'EUR':
        //         res = Number(value.toFixed(2));
        //         break;
        //     case 'millesimal':
        //         res = Number(value.toFixed(6));
        //         // res =value.toExponential();
        //         break;
        //     default:
        //         res = Number(value.toFixed(3));
        //         break;
        // }
        // return res;
        return GraphicUtil.convertValue(value, unit);
    }
    sort(xvalues, yvalues, sortType) {
        GraphicUtil.sort(xvalues, yvalues, sortType);
    }
    buildLayout(graphConfig) {
        let initLayout = {
            // width: graphConfig.width,
            height: graphConfig.height ? graphConfig.height : 450,
            title: '',
            grid: { rows: 1, columns: 1 },
            showlegend: true,
            modebar: {
                bgcolor: 'transparent'
            },
            margin: { "t": 50, "b": 50, "l": 10, "r": 10 },
        };
        initLayout.grid.columns = graphConfig.yaxis?.length;
        initLayout.title = graphConfig.title;
        return initLayout;
    }
    buildGraphicTraceList(trace, translateService) {
        const limitValues = 5; //numero massimo di valori da visualizzare 
        let pieGraphicTrace = {
            values: [],
            type: 'pie',
            name: '',
            labels: [],
            domain: {
                row: 0,
                column: 0
            },
            marker: {
                colors: ''
            }
        };
        pieGraphicTrace.name = trace && trace.name ? trace.name.trim() : '';
        if (trace.xvalues != null) {
            //console.log("values: ",trace.xvalues);
            let newXvalues = trace.xvalues.map((xval) => {
                if (pieGraphicTrace.name != null && pieGraphicTrace.name.length > 0) {
                    if (xval != null && xval != '') {
                        xval = pieGraphicTrace.name + ' - ' + xval;
                    }
                    else {
                        xval = pieGraphicTrace.name;
                    }
                }
                return xval;
            });
            pieGraphicTrace.labels = newXvalues;
        }
        if (trace.labels != null) {
            pieGraphicTrace.labels = trace.labels;
        }
        if (trace.colors != null) {
            pieGraphicTrace.marker.colors = trace.colors;
        }
        if (trace.yvalues != null) {
            //pieGraphicTrace.values = trace.yvalues;
            trace.yvalues.forEach((yval) => {
                yval = this.convertValue(yval, trace.numericUnit);
                pieGraphicTrace.values.push(yval);
            });
            //limitazione dei risultati da visualizzare nella pie 
            if (trace.limitPieResults && trace.yvalues.length > limitValues) {
                this.sort(pieGraphicTrace.labels, pieGraphicTrace.values, "DESC");
                let otherValue = 0;
                for (var i = limitValues; i < pieGraphicTrace.values.length; i++) {
                    otherValue += pieGraphicTrace.values[i];
                }
                pieGraphicTrace.values.splice(limitValues, pieGraphicTrace.values.length - limitValues);
                pieGraphicTrace.labels.splice(limitValues, pieGraphicTrace.labels.length - limitValues);
                pieGraphicTrace.values.push(otherValue);
                let otherLabel;
                if (pieGraphicTrace.name != null && pieGraphicTrace.name.length > 0) {
                    otherLabel = pieGraphicTrace.name + " - ";
                }
                otherLabel += 'Altro';
                pieGraphicTrace.labels.push('Altro');
            }
        }
        if (trace.row != null) {
            pieGraphicTrace.domain.row = trace.row;
        }
        if (trace.column != null) {
            pieGraphicTrace.domain.column = trace.column;
        }
        //console.log("pie trace: ",pieGraphicTrace);
        return pieGraphicTrace;
    }
}

class Radar {
    constructor() {
        this.build = (initGraphicValues, translateService, graphConfig, yaxis, yaxisIndex) => {
            let graphicTrace = [];
            let yvalues = [];
            let xvalues = Array.from(initGraphicValues.xvalues.values());
            //console.log(xvalues);
            if (initGraphicValues.filteredData != undefined) {
                let filterKeyField;
                let filteredData = initGraphicValues.filteredData;
                let filteredGraphicValues = initGraphicValues.filteredGraphicValues;
                if (yaxis.dataFilter?.filterField) {
                    filterKeyField = yaxis.dataFilter.filterField;
                }
                else {
                    const k = yaxis.dataFilter?.filterFunction;
                    filterKeyField = k.key;
                }
                let result = new Array();
                filteredGraphicValues.forEach((data, key) => {
                    yvalues = [];
                    if (data != null) {
                        //nel caso della pie mi preoccupo solo di aggregare rispetto al filterfield
                        data.forEach((obj) => {
                            let xval = GraphicUtil.getValFromObject(obj, filterKeyField);
                            //valorizza result considerando la necessità di usare o meno le funzioni di calcolo
                            GraphicUtil.calculateResult(yaxis, xval, obj, result);
                        });
                    }
                });
                result.forEach((r) => {
                    if (r.calculatedValues) {
                        r.value = GraphicUtil.applyFunction(r);
                    }
                });
                let labels = result.map(r => r.label);
                let values = result.map(r => r.value);
                /* //filtro risultati
                if(yaxis.limitResult != null && yvalues.length > yaxis.limitResult){
                    xvalues = xvalues.splice(0, yaxis.limitResult);
                    yvalues = yvalues.splice(0, yaxis.limitResult);
                } */
                //ordinamento
                if (yaxis.sort) {
                    this.sort(xvalues, yvalues, yaxis.sort);
                }
                const t = new Trace(yaxis.label, labels, values, null, null, 0, yaxisIndex, null, yaxis.color);
                graphicTrace.push(this.buildGraphicTraceList(t));
            }
            else if (initGraphicValues.aggregatedGraphicValues != null) {
                let aggregatedDataGraphicValues = initGraphicValues.aggregatedGraphicValues;
                let result = new Array();
                //console.log("aggregated graphic values: ",aggregatedDataGraphicValues);
                const traceName = yaxis.label;
                aggregatedDataGraphicValues.forEach((data, key) => {
                    yvalues = [];
                    if (data != null) {
                        data.forEach((obj) => {
                            let xval = key;
                            //in questo caso l'xval lo valorizzo al campo usato per il groupby (label o field)
                            /* if(yaxis.dataAggregate.groupByFieldLabel){
                                xval = key;
                            }
                            else if(yaxis.dataAggregate.groupByField){
                                xval = GraphicUtil.getValFromObject(obj, key);
                            } */
                            //valorizza result considerando la necessità di usare o meno le funzioni di calcolo
                            GraphicUtil.calculateResult(yaxis, xval, obj, result);
                        });
                        //ordinamento
                        /*  if(yaxis.sort){
                             this.sort(xvalues, yvalues, yaxis.sort);
                         } */
                    }
                });
                result.forEach((r) => {
                    if (r.calculatedValues) {
                        r.value = GraphicUtil.applyFunction(r);
                    }
                });
                let labels = result.map(r => r.label);
                let values = result.map(r => r.value);
                yvalues = values;
                xvalues = labels;
                /* //filtro risultati
                if(yaxis.limitResult != null && yvalues.length > yaxis.limitResult){
                    xvalues = xvalues.splice(0, yaxis.limitResult);
                    yvalues = yvalues.splice(0, yaxis.limitResult);
                } */
                //ordinamento
                if (yaxis.sort) {
                    this.sort(xvalues, yvalues, yaxis.sort);
                }
                const trace = new Trace(traceName, xvalues, yvalues, null, null, 0, yaxisIndex, null, yaxis.color);
                //this.initTrace(trace, graphConfig, yaxis);
                graphicTrace.push(this.buildGraphicTraceList(trace));
                //console.log(lineGraphic);
            }
            else if (initGraphicValues.aggregatedData != undefined) {
                let aggregatedData = initGraphicValues.aggregatedData;
                //this.printMap(aggregatedData);
                if (yaxis.dataAggregate.aggregationField == yaxis.xaxis) {
                    yvalues = GraphicUtil.getIndexColumnArrayFromMatrix(Array.from(aggregatedData.values()), 1);
                    //ordinamento
                    if (yaxis.sort) {
                        this.sort(xvalues, yvalues, yaxis.sort);
                    }
                    //filtro risultati
                    if (yaxis.limitResult != null && yvalues.length > yaxis.limitResult) {
                        xvalues = xvalues.splice(0, yaxis.limitResult);
                        yvalues = yvalues.splice(0, yaxis.limitResult);
                    }
                    const t = new Trace(yaxis.label, xvalues, yvalues, null, null, 0, yaxisIndex, null, yaxis.color);
                    graphicTrace.push(this.buildGraphicTraceList(t));
                    //graphicTraces = graphicTraces.concat(graphicTraces);
                }
                else {
                    //this.newSnackbar("Errore nella configurazione del grafico: '" + graphConfig.title + " - " + yaxis.lable + "'", 'warning');
                    console.error("Errore nella configurazione del grafico: '" + graphConfig.title + " - " + yaxis.label + "'");
                }
            }
            else {
                if (initGraphicValues.graphicValues != null && initGraphicValues.graphicValues.length > 0) {
                    let graphicValues = initGraphicValues.graphicValues;
                    let result = new Array();
                    graphicValues.forEach((obj) => {
                        //in questo caso l'xval lo valorizzo col campo dell'yaxis.xaxis, ossia il campo date in modo da sommare eventuali valori multipli presenti
                        let xval = GraphicUtil.getValFromObject(obj, yaxis.xaxis);
                        //valorizza result considerando la necessità di usare o meno le funzioni di calcolo
                        GraphicUtil.calculateResult(yaxis, xval, obj, result);
                    });
                    result.forEach((r) => {
                        if (r.calculatedValues) {
                            r.value = GraphicUtil.applyFunction(r);
                        }
                    });
                    let labels = result.map(r => r.label);
                    let values = result.map(r => r.value);
                    yvalues = values;
                    xvalues = labels;
                }
                else {
                    yvalues = initGraphicValues.yvalues;
                }
                /* //filtro risultati
                if(yaxis.limitResult != null && yvalues.length > yaxis.limitResult){
                    xvalues = xvalues.splice(0, yaxis.limitResult);
                    yvalues = yvalues.splice(0, yaxis.limitResult);
                } */
                //ordinamento
                if (yaxis.sort) {
                    this.sort(xvalues, yvalues, yaxis.sort);
                }
                const t = new Trace(yaxis.label, xvalues, yvalues, null, null, 0, yaxisIndex, null, yaxis.color);
                graphicTrace = this.buildGraphicTraceList(t);
            }
            return graphicTrace;
        };
    }
    initTrace(trace, graphConfig, yaxis) {
        throw new Error("Method not implemented.");
    }
    buildUnit(unit, defaultUnit) {
        return GraphicUtil.buildUnit(unit, defaultUnit);
    }
    convertValue(value, unit) {
        // let res:Number = value;
        // if(value == null){
        //     return null;
        // }
        // switch (unit) {
        //     case 'ms':
        //     case 'millisecond':
        //         res = Math.round((value/1000)*100)/100;
        //         break;
        //     case 's':
        //     case 'second':
        //         res = Number(value.toFixed(3));;
        //         break;
        //     case 'percentage':
        //     case 'perc':
        //     case '%':
        //         // res = Math.round(value*100)/100;
        //         // arrotondiamo alla terza cifra decimale
        //         res = Number(value.toFixed(3));
        //         break;
        //     case '€':
        //     case 'EUR':
        //         res = Number(value.toFixed(2));
        //         break;
        //     default:
        //         res = Number(value.toFixed(3));;
        //         break;
        // }
        // return res;
        return GraphicUtil.convertValue(value, unit);
    }
    sort(xvalues, yvalues, sortType) {
        GraphicUtil.sort(xvalues, yvalues, sortType);
    }
    //grid: { rows: 1, columns: 1 }
    buildLayout(graphConfig) {
        let numericUnit = graphConfig.numericUnit;
        if (!numericUnit) {
            numericUnit = graphConfig.tempNumericUnit;
        }
        let initLayout = {
            // width: graphConfig.width,
            height: graphConfig.height ? graphConfig.height : 450,
            title: '',
            showlegend: false,
            paper_bgcolor: 'transparent',
            modebar: {
                bgcolor: 'transparent'
            },
            polar: {
                radialaxis: {
                    visible: true,
                    range: [0, 50],
                    ticksuffix: numericUnit
                }
            },
            margin: { "t": 50, "b": 50, "l": 50, "r": 50 },
        };
        if (graphConfig.range) {
            initLayout.polar.radialaxis.range = graphConfig.range;
        }
        /* in caso di più array il radar li dispone sempre nello stesso chart, non si comporta come la pie
        che in caso di più array crea pie diverse */
        //initLayout.grid.columns = graphConfig.yaxis.length;
        initLayout.title = graphConfig.title;
        return initLayout;
    }
    buildGraphicTraceList(trace, translateService) {
        let radarGraphicTrace = {
            theta: [],
            r: [],
            type: '',
            name: '',
            fill: 'toself',
            hovertemplate: '<b>%{theta}</b>:%{r}'
        };
        radarGraphicTrace.name = trace.name;
        if (trace.xvalues != null) {
            let cleanXValue = new Array();
            //apici necessari perché al radar danno fastidio le date
            cleanXValue = trace.xvalues.map((xv) => "'" + xv + "'");
            radarGraphicTrace.theta = cleanXValue;
        }
        if (trace.yvalues != null) {
            radarGraphicTrace.type = 'scatterpolar';
            //radarGraphicTrace.r = trace.yvalues;
            trace.yvalues.forEach((yval) => {
                yval = this.convertValue(yval, trace.numericUnit);
                radarGraphicTrace.r.push(yval);
            });
        }
        /* if (trace.row != null) {
            radarGraphicTrace.domain.row = trace.row;
        }
        if (trace.column != null) {
            radarGraphicTrace.domain.column = trace.column;
        } */
        // console.log("radar trace: ",radarGraphicTrace);
        return radarGraphicTrace;
    }
}

class Table {
    constructor() {
        this.build = (initGraphicValues, translateService, graphConfig, yaxis, yaxisIndex, value, previousValue) => {
            let tableData = new Array();
            let tableHeaders = new Set();
            let yvalues = [];
            let xvalues = Array.from(initGraphicValues.xvalues.values());
            //console.log(xvalues);
            if (initGraphicValues.filteredData != undefined) {
                let filteredData = initGraphicValues.filteredData;
                let filterKeyUnit = initGraphicValues.filterKeyUnit;
                let filterKeyField;
                let filteredGraphicValues = initGraphicValues.filteredGraphicValues;
                if (yaxis.dataFilter?.filterField) {
                    filterKeyField = yaxis.dataFilter.filterField;
                }
                else {
                    const k = yaxis.dataFilter?.filterFunction;
                    filterKeyField = k.key;
                }
                let result = new Array();
                filteredGraphicValues.forEach((data, key) => {
                    const traceName = yaxis.label; // yaxis.lable + ' - ' + key;
                    if (data != null) {
                        //nel caso della pie mi preoccupo solo di aggregare rispetto al filterfield
                        data.forEach((obj) => {
                            let xval = GraphicUtil.getValFromObject(obj, filterKeyField);
                            //valorizza result considerando la necessità di usare o meno le funzioni di calcolo
                            GraphicUtil.calculateResult(yaxis, xval, obj, result);
                        });
                    }
                });
                result.forEach((r) => {
                    let numericUnit;
                    if (yaxis.numericUnit != null) {
                        numericUnit = yaxis.numericUnit;
                    }
                    else {
                        if (graphConfig.numericUnit != null) {
                            numericUnit = graphConfig.numericUnit;
                        }
                    }
                    if (r.calculatedValues) {
                        r.value = GraphicUtil.applyFunction(r);
                    }
                    tableData.push(this.buildGraphicTraceElement(yaxis.label, r.value, r.label, numericUnit, filterKeyUnit));
                });
            }
            else if (initGraphicValues.aggregatedGraphicValues != null) {
                let aggregatedDataGraphicValues = initGraphicValues.aggregatedGraphicValues;
                let result = new Array();
                //console.log("aggregated graphic values: ",aggregatedDataGraphicValues);
                const traceName = yaxis.label;
                aggregatedDataGraphicValues.forEach((data, key) => {
                    yvalues = [];
                    if (data != null) {
                        data.forEach((obj) => {
                            let xval = key;
                            /* //in questo caso l'xval lo valorizzo al campo usato per il groupby (label o field)
                            if(yaxis.dataAggregate.groupByFieldLabel){
                                xval = key;
                            }
                            else if(yaxis.dataAggregate.groupByField){
                                xval = GraphicUtil.getValFromObject(obj, key);
                            } */
                            //valorizza result considerando la necessità di usare o meno le funzioni di calcolo
                            GraphicUtil.calculateResult(yaxis, xval, obj, result);
                        });
                    }
                });
                result.forEach((r) => {
                    let numericUnit;
                    if (yaxis.numericUnit != null) {
                        numericUnit = yaxis.numericUnit;
                    }
                    else {
                        if (graphConfig.numericUnit != null) {
                            numericUnit = graphConfig.numericUnit;
                        }
                    }
                    if (r.calculatedValues) {
                        r.value = GraphicUtil.applyFunction(r);
                        // if(yaxis.templateString){
                        //     r.value = GraphicUtil.templateLiteralsFunction(r.value, yaxis.templateString, yaxis.value);
                        //             console.log('templateString');
                        //         }
                    }
                    tableData.push(this.buildGraphicTraceElement(yaxis.label, r.value, r.label, numericUnit));
                });
            }
            else if (initGraphicValues.aggregatedData != undefined) {
                let aggregatedData = initGraphicValues.aggregatedData;
                //this.printMap(aggregatedData);
                if (yaxis.dataAggregate.aggregationField == yaxis.xaxis) {
                    yvalues = GraphicUtil.getIndexColumnArrayFromMatrix(Array.from(aggregatedData.values()), 1);
                    //ordinamento
                    if (yaxis.sort) {
                        this.sort(xvalues, yvalues, yaxis.sort);
                    }
                    //filtro risultati
                    if (yaxis.limitResult != null && yvalues.length > yaxis.limitResult) {
                        xvalues = xvalues.splice(0, yaxis.limitResult);
                        yvalues = yvalues.splice(0, yaxis.limitResult);
                    }
                    let t = new Trace(yaxis.label, xvalues, yvalues);
                    this.initTrace(t, graphConfig, yaxis);
                    tableData = this.buildGraphicTraceList(t);
                }
                else {
                    //this.newSnackbar("Errore nella configurazione del grafico: '" + graphConfig.title + " - " + yaxis.lable + "'", 'warning');
                    console.error("Errore nella configurazione del grafico: '" + graphConfig.title + " - " + yaxis.label + "'");
                }
            }
            else {
                yvalues = initGraphicValues.yvalues;
                if (initGraphicValues.graphicValues != null && initGraphicValues.graphicValues.length > 0) {
                    let graphicValues = initGraphicValues.graphicValues;
                    let result = new Array();
                    graphicValues.forEach((obj) => {
                        //in questo caso l'xval lo valorizzo col campo dell'yaxis.xaxis, ossia il campo date in modo da sommare eventuali valori multipli presenti
                        let xval = GraphicUtil.getValFromObject(obj, yaxis.xaxis);
                        if (yaxis.valueFunction) {
                            //valorizza result considerando la necessità di usare o meno le funzioni di calcolo e senza aggregare su 
                            //tutti i valori 
                            GraphicUtil.calculateResult(yaxis, xval, obj, result, true);
                        }
                        else {
                            result.push({ label: xval, value: GraphicUtil.getValFromObject(obj, yaxis.value) });
                        }
                    });
                    result.forEach((r) => {
                        if (r.calculatedValues) {
                            r.value = GraphicUtil.applyFunction(r);
                        }
                    });
                    let labels = result.map(r => r.label);
                    let values = result.map(r => r.value);
                    yvalues = values;
                    xvalues = labels;
                }
                //Else necessario per i grafici costruiti in modo statico
                else {
                    yvalues = initGraphicValues.yvalues;
                }
                /* //filtro risultati
                if(yaxis.limitResult != null && yvalues.length > yaxis.limitResult){
                    xvalues = xvalues.splice(0, yaxis.limitResult);
                    yvalues = yvalues.splice(0, yaxis.limitResult);
                } */
                //ordinamento
                if (yaxis.sort) {
                    this.sort(xvalues, yvalues, yaxis.sort);
                }
                let t = new Trace(yaxis.label, xvalues, yvalues);
                this.initTrace(t, graphConfig, yaxis);
                tableData = this.buildGraphicTraceList(t);
            }
            return tableData;
        };
    }
    initTrace(t, graphConfig, yaxis) {
        if (yaxis.numericUnit != null) {
            t.numericUnit = yaxis.numericUnit;
        }
        else {
            if (graphConfig.numericUnit != null) {
                t.numericUnit = graphConfig.numericUnit;
            }
        }
    }
    buildUnit(unit, defaultUnit) {
        return GraphicUtil.buildUnit(unit, defaultUnit);
    }
    convertValue(value, unit, localeString) {
        let res = value;
        if (value == null) {
            return res;
        }
        switch (unit) {
            case 'ms':
            case 'millisecond':
                res = Math.round((value / 1000) * 100) / 100;
                break;
            case 's':
            case 'second':
                res = Number(value.toFixed(3));
                ;
                break;
            case 'percentage':
            case 'perc':
            case '%':
                // res = Math.round(value*100)/100;
                // arrotondiamo alla terza cifra decimale
                res = Number(value.toFixed(3));
                break;
            default:
                res = Number(value.toFixed(3));
                ;
                break;
        }
        return res;
    }
    sort(xvalues, yvalues, sortType) {
        console.log('in sort');
        GraphicUtil.sort(xvalues, yvalues, sortType);
    }
    buildLayout(graphConfig) {
        return null;
    }
    buildGraphicTraceElement(name, yval, xval, numericUnit, filterKeyUnit) {
        let keyUnit;
        if (filterKeyUnit) {
            keyUnit = filterKeyUnit;
        }
        let td = {
            rowHeader: xval,
            rowHeaderUnit: keyUnit,
            colHeader: name
        };
        td[name] = yval;
        if (yval == null) {
            td[name] = 'N.A.';
        }
        if (numericUnit) {
            const unit = this.buildUnit(numericUnit, numericUnit);
            //console.log("------- unit: "+unit);
            if (unit.toUpperCase() == 'URL') {
                td[name] = "<a href=\"" + yval + "\"  target=\"_blank\">" + yval + "</a>";
                ;
            }
            else {
                if (yval == null) {
                    td[name] = 'N.A.';
                }
                else {
                    const convYval = this.convertValue(yval, numericUnit);
                    //console.log('yval:',yval,'convYval:',convYval);
                    td[name] = convYval.toLocaleString("it-IT", { minimumFractionDigits: 0, maximumFractionDigits: 3 }) + " " + unit;
                }
            }
        }
        else {
            td[name] = yval;
        }
        return td;
    }
    buildGraphicTraceList(trace) {
        let ret = new Array();
        trace.yvalues?.forEach((ele, index) => {
            if (trace.xvalues) {
                let td = this.buildGraphicTraceElement(trace.name, ele, trace.xvalues[index], trace.numericUnit, undefined);
                ret.push(td);
            }
            //console.log(td);
        });
        return ret;
    }
}

class GraphicFactory {
    static createGraphic(graphConfig, values, translateService) {
        let result = {
            graphicData: [],
            graphicLayout: null,
            config: {
                responsive: true,
                displaylogo: false,
                modeBarButtonsToRemove: ['pan2d',
                    'select2d',
                    'lasso2d',
                    'zoomIn2d',
                    'zoomOut2d',
                    'autoScale2d',
                    'hoverClosestCartesian',
                    'hoverCompareCartesian',
                    'hoverClosestGl2d',
                    'hoverClosestPie',
                    'toggleHover',
                    'sendDataToCloud',
                    'toggleSpikelines',
                    'resetViewMapbox']
            },
            graphicOptions: {
                sort: null,
                template: null
            }
        };
        let graphicTraces = [];
        if (values != undefined && values != null && values.length > 0) {
            if (graphConfig.idFunction) {
                values = GraphicUtil.evalValueFuntion(values, graphConfig.idFunction, "_calculatedId_");
            }
            //console.log('GraphicFactory', graphConfig)
            let yaxisNumericUnits = new Array();
            switch (graphConfig.type) {
                case 'LINE':
                    graphConfig.yaxis?.forEach((yaxis) => {
                        if (yaxis.numericUnit) {
                            yaxisNumericUnits.push(yaxis.numericUnit);
                        }
                        //TODO risolvere bug lato backend che non fa due query in caso dello stesso yaxis
                        let initGraphicValues = GraphicUtil.initGraphicValues(values ?? [], yaxis);
                        //console.log(initGraphicValues);
                        let lineTrace = new Line().build(initGraphicValues, translateService, graphConfig, yaxis);
                        adaptGraphicTraces(initGraphicValues, lineTrace);
                    });
                    //ricavo l'unità di misura dagli yaxis verificando che tutti gli yaxis abbiano la stessa
                    graphConfig.tempNumericUnit = retrieveNumericUnitFromYaxis(yaxisNumericUnits);
                    result.graphicData = graphicTraces;
                    result.graphicLayout = new Line().buildLayout(graphConfig);
                    graphConfig.tempNumericUnit = null;
                    break;
                case 'BUBBLE':
                    graphConfig.yaxis?.forEach((yaxis) => {
                        if (yaxis.numericUnit) {
                            yaxisNumericUnits.push(yaxis.numericUnit);
                        }
                        //TODO risolvere bug lato backend che non fa due query in caso dello stesso yaxis
                        let initGraphicValues = GraphicUtil.initGraphicValues(values ?? [], yaxis);
                        //console.log(initGraphicValues);
                        let lineTrace = new Bubble().build(initGraphicValues, translateService, graphConfig, yaxis);
                        adaptGraphicTraces(initGraphicValues, lineTrace);
                    });
                    //ricavo l'unità di misura dagli yaxis verificando che tutti gli yaxis abbiano la stessa
                    graphConfig.tempNumericUnit = retrieveNumericUnitFromYaxis(yaxisNumericUnits);
                    result.graphicData = graphicTraces;
                    result.graphicLayout = new Bubble().buildLayout(graphConfig);
                    graphConfig.tempNumericUnit = null;
                    break;
                case 'BAR':
                    graphConfig.yaxis?.forEach((yaxis) => {
                        if (yaxis.numericUnit) {
                            yaxisNumericUnits.push(yaxis.numericUnit);
                        }
                        let initGraphicValues = GraphicUtil.initGraphicValues(values ?? [], yaxis);
                        //console.log(initGraphicValues);
                        var barTrace = new Bar().build(initGraphicValues, translateService, graphConfig, yaxis);
                        adaptGraphicTraces(initGraphicValues, barTrace);
                    });
                    //ricavo l'unità di misura dagli yaxis verificando che tutti gli yaxis abbiano la stessa
                    graphConfig.tempNumericUnit = retrieveNumericUnitFromYaxis(yaxisNumericUnits);
                    result.graphicData = graphicTraces;
                    result.graphicLayout = new Bar().buildLayout(graphConfig);
                    graphConfig.tempNumericUnit = null;
                    break;
                case 'FUNNEL':
                    graphConfig.yaxis?.forEach((yaxis) => {
                        if (yaxis.numericUnit) {
                            yaxisNumericUnits.push(yaxis.numericUnit);
                        }
                        let initGraphicValues = GraphicUtil.initGraphicValues(values ?? [], yaxis);
                        //console.log(initGraphicValues);
                        var funnelTrace = new Funnel().build(initGraphicValues, translateService, graphConfig, yaxis);
                        adaptGraphicTraces(initGraphicValues, funnelTrace);
                    });
                    //ricavo l'unità di misura dagli yaxis verificando che tutti gli yaxis abbiano la stessa
                    graphConfig.tempNumericUnit = retrieveNumericUnitFromYaxis(yaxisNumericUnits);
                    result.graphicData = graphicTraces;
                    result.graphicLayout = new Funnel().buildLayout(graphConfig);
                    graphConfig.tempNumericUnit = null;
                    break;
                case 'PIE':
                    graphConfig.yaxis?.forEach((yaxis, yaxisIndex) => {
                        let initGraphicValues = GraphicUtil.initGraphicValues(values ?? [], yaxis);
                        var pieTrace = new Pie().build(initGraphicValues, translateService, graphConfig, yaxis, yaxisIndex);
                        console.log(initGraphicValues, pieTrace);
                        adaptGraphicTraces(initGraphicValues, pieTrace);
                    });
                    if (graphConfig.aggregateYAxis) {
                        let aggregatedGraphicTraces;
                        graphicTraces.forEach((gt, index) => {
                            if (index == 0) {
                                aggregatedGraphicTraces = gt;
                            }
                            else {
                                aggregatedGraphicTraces.labels = aggregatedGraphicTraces.labels.concat(gt.labels);
                                aggregatedGraphicTraces.values = aggregatedGraphicTraces.values.concat(gt.values);
                            }
                        });
                        graphicTraces = [aggregatedGraphicTraces];
                    }
                    result.graphicData = graphicTraces;
                    result.graphicLayout = new Pie().buildLayout(graphConfig);
                    console.log('graphicPieTraces', graphicTraces);
                    break;
                case 'RADAR':
                    graphConfig.yaxis?.forEach((yaxis, yaxisIndex) => {
                        if (yaxis.numericUnit) {
                            yaxisNumericUnits.push(yaxis.numericUnit);
                        }
                        let initGraphicValues = GraphicUtil.initGraphicValues(values ?? [], yaxis);
                        // let initGraphicValues = GraphicUtil.initGraphicValues(values, yaxis);
                        var radarTrace = new Radar().build(initGraphicValues, translateService, graphConfig, yaxis, yaxisIndex);
                        adaptGraphicTraces(initGraphicValues, radarTrace);
                    });
                    let max = 0;
                    let traceSingleOccurrency = new Array();
                    let traceMultipleOccurrency = new Array();
                    //in caso di radar e di trace con valore unico vado a unire i valori unici in un unico array
                    graphicTraces.forEach((gt, index) => {
                        if (index == 0) {
                            if (gt.theta.length == 1) {
                                traceSingleOccurrency = traceSingleOccurrency.concat(gt);
                            }
                            else {
                                traceMultipleOccurrency = traceMultipleOccurrency.concat(gt);
                            }
                        }
                        else {
                            if (gt.theta.length == 1) {
                                traceSingleOccurrency[0].theta.push(gt.theta[0]);
                                traceSingleOccurrency[0].r.push(gt.r[0]);
                            }
                            else {
                                traceMultipleOccurrency = traceMultipleOccurrency.concat(gt);
                            }
                        }
                    });
                    graphicTraces = new Array();
                    graphicTraces = graphicTraces.concat(...traceSingleOccurrency);
                    graphicTraces = graphicTraces.concat(...traceMultipleOccurrency);
                    graphicTraces.forEach((gt) => {
                        const tmpMax = Math.max(...gt.r);
                        if (tmpMax > max) {
                            max = tmpMax;
                        }
                    });
                    result.graphicData = graphicTraces;
                    graphConfig.range = [0, max];
                    //ricavo l'unità di misura dagli yaxis verificando che tutti gli yaxis abbiano la stessa
                    graphConfig.tempNumericUnit = retrieveNumericUnitFromYaxis(yaxisNumericUnits);
                    result.graphicLayout = new Radar().buildLayout(graphConfig);
                    break;
                case 'INDICATOR':
                    graphConfig.yaxis?.forEach((yaxis, yaxisIndex) => {
                        let initGraphicValues = GraphicUtil.initGraphicValues(values ?? [], yaxis);
                        var indicatorTrace = new Indicator().build(initGraphicValues, translateService, graphConfig, yaxis, yaxisIndex);
                        //console.log("it trace:"+indicatorTrace);
                        adaptGraphicTraces(initGraphicValues, indicatorTrace);
                    });
                    result.graphicData = graphicTraces;
                    result.graphicLayout = new Indicator().buildLayout(graphConfig);
                    break;
                case 'TABLE':
                case 'HEATMAP':
                    let headers = new Array();
                    let clickEventInfo = { onClickEvents: null, filterField: null };
                    headers.push('rowHeader');
                    // console.log('table values ',values);
                    graphConfig.yaxis?.forEach((yaxis, yaxisIndex) => {
                        if (yaxis.dataFilter && yaxis.onClick) {
                            clickEventInfo.onClickEvents = new Array();
                            clickEventInfo.onClickEvents.push(yaxis.onClick);
                            clickEventInfo.filterField = yaxis.dataFilter.filterField;
                        }
                        else if (yaxis.onClick && yaxis.onClick.funct) {
                            clickEventInfo.onClickEvents = new Array();
                            clickEventInfo.onClickEvents.push(yaxis.onClick);
                        }
                        if (yaxis.templateString) {
                            values = GraphicUtil.templateLiteralsFunction(values ?? [], yaxis.templateString, yaxis.value);
                            // console.log('templateString');
                        }
                        let initGraphicValues = GraphicUtil.initGraphicValues(values ?? [], yaxis, true);
                        // let initGraphicValues = GraphicUtil.initGraphicValues(values, yaxis);
                        var tableTrace = new Table().build(initGraphicValues, translateService, graphConfig, yaxis);
                        tableTrace.forEach(tableElement => {
                            //recupero l'elemento corrispondente al rowheader che non è stato ancora valorizzato, onde evitare di sovrascrivere campi che hanno lo stesso valore di rowheader
                            const foundIndex = graphicTraces.findIndex(gtElement => (gtElement.rowHeader == tableElement.rowHeader && gtElement[tableElement.colHeader] == null));
                            if (foundIndex >= 0) {
                                let ele = graphicTraces[foundIndex];
                                ele[tableElement.colHeader] = tableElement[tableElement.colHeader];
                                graphicTraces[foundIndex] = ele;
                            }
                            else {
                                graphicTraces.push(tableElement);
                            }
                        });
                        //adaptGraphicTraces(initGraphicValues, tableTrace);
                        headers.push(yaxis.label);
                    });
                    result.graphicData = graphicTraces;
                    //console.log(result.graphicData);
                    if (graphConfig.tableHideRawColumn)
                        headers.splice(0, 1);
                    if (graphConfig.tableSortDefaultColumn) {
                        result.graphicOptions.sort = graphConfig.tableSortDefaultColumn;
                    }
                    if (graphConfig.tableSortDefaultOrder) {
                        result.graphicOptions.sortOrder = graphConfig.tableSortDefaultOrder;
                    }
                    result.graphicLayout = headers;
                    result.clickEventInfo = clickEventInfo;
                    //console.log(result)
                    break;
            }
            //result.config={locale:'it'}
        }
        else {
            result.graphicData = graphicTraces;
            result.graphicLayout = null;
        }
        //console.log(result);
        return result;
        function adaptGraphicTraces(initGraphicValues, trace) {
            if (initGraphicValues.filteredData != undefined) {
                graphicTraces = graphicTraces.concat(trace);
            }
            else if (initGraphicValues.aggregatedData != undefined) {
                graphicTraces = graphicTraces.concat(trace);
            }
            else {
                graphicTraces.push(trace);
            }
        }
        function retrieveNumericUnitFromYaxis(yaxisNumericUnits) {
            let tempNumericUnit = "";
            if (yaxisNumericUnits && yaxisNumericUnits.length > 0) {
                let resNumericUnit = yaxisNumericUnits.every((nu) => (nu != null && nu.toUpperCase() == yaxisNumericUnits[0].toUpperCase()));
                if (resNumericUnit) {
                    tempNumericUnit = GraphicUtil.buildUnit(yaxisNumericUnits[0], yaxisNumericUnits[0]);
                }
            }
            return tempNumericUnit;
        }
    }
    static createGraphicObj(graphConfig, valuesMap, translateService) {
        let result = {
            graphicData: [],
            graphicLayout: null,
            config: {
                responsive: true,
                displaylogo: false,
                modeBarButtonsToRemove: ['pan2d',
                    'select2d',
                    'lasso2d',
                    'zoomIn2d',
                    'zoomOut2d',
                    'autoScale2d',
                    'hoverClosestCartesian',
                    'hoverCompareCartesian',
                    'hoverClosestGl2d',
                    'hoverClosestPie',
                    'toggleHover',
                    'sendDataToCloud',
                    'toggleSpikelines',
                    'resetViewMapbox']
            },
            graphicOptions: {
                sort: null,
                template: null
            }
        };
        let graphicTraces = [];
        // if (values != undefined && values != null && values.length > 0) {
        if (valuesMap) {
            //console.log('GraphicFactory', graphConfig)
            switch (graphConfig.type) {
                case 'LINE':
                    graphConfig.yaxis?.forEach((yaxis) => {
                        let values = valuesMap[yaxis.table];
                        if (!values || values.length <= 0)
                            return;
                        // let valsToUse: any[] = values;
                        // if (!yaxis.value && yaxis.values) {
                        //     yaxis.value = yaxis.values.join(',')
                        // }
                        // if (yaxis.valueFunction) {
                        //     valsToUse = GraphicUtil.evalValueFuntion(values, yaxis.valueFunction, yaxis.value);
                        // }
                        let initGraphicValues = GraphicUtil.initGraphicValues(values, yaxis, null, null);
                        //console.log(initGraphicValues);
                        let lineTrace = new Line().build(initGraphicValues, translateService, graphConfig, yaxis);
                        adaptGraphicTraces(initGraphicValues, lineTrace);
                    });
                    result.graphicData = graphicTraces;
                    result.graphicLayout = new Line().buildLayout(graphConfig);
                    break;
                case 'BUBBLE':
                    graphConfig.yaxis?.forEach((yaxis) => {
                        let values = valuesMap[yaxis.table];
                        if (!values || values.length <= 0)
                            return;
                        // let valsToUse: any[] = values;
                        // if (!yaxis.value && yaxis.values) {
                        //     yaxis.value = yaxis.values.join(',')
                        // }
                        // if (yaxis.valueFunction) {
                        //     valsToUse = GraphicUtil.evalValueFuntion(values, yaxis.valueFunction, yaxis.value);
                        // }
                        let initGraphicValues = GraphicUtil.initGraphicValues(values, yaxis, null, null);
                        //console.log(initGraphicValues);
                        let lineTrace = new Bubble().build(initGraphicValues, translateService, graphConfig, yaxis);
                        adaptGraphicTraces(initGraphicValues, lineTrace);
                    });
                    result.graphicData = graphicTraces;
                    result.graphicLayout = new Bubble().buildLayout(graphConfig);
                    break;
                case 'BAR':
                    graphConfig.yaxis?.forEach((yaxis) => {
                        let values = valuesMap[yaxis.table];
                        if (!values || values.length <= 0)
                            return;
                        // let valsToUse: any[] = values;
                        // if (!yaxis.value && yaxis.values) {
                        //     yaxis.value = yaxis.values.join(',')
                        // }
                        // if (yaxis.valueFunction) {
                        //     valsToUse = GraphicUtil.evalValueFuntion(values, yaxis.valueFunction, yaxis.value);
                        // }
                        let preElaboration = null;
                        if (yaxis.preElaborationRequired) {
                            preElaboration;
                        }
                        let initGraphicValues = GraphicUtil.initGraphicValues(values, yaxis, null, yaxis.preElaborationRequired);
                        var funnelTrace = new Bar().build(initGraphicValues, translateService, graphConfig, yaxis);
                        adaptGraphicTraces(initGraphicValues, funnelTrace);
                    });
                    result.graphicData = graphicTraces;
                    // console.log('qui ini graphic factory');
                    result.graphicLayout = new Bar().buildLayout(graphConfig);
                    // result.graphicLayout.shapes = [
                    //     // 1st highlight during Feb 4 - Feb 6
                    //     {
                    //         type: 'rect',
                    //         // x-reference is assigned to the x-values
                    //         xref: 'x',
                    //         // y-reference is assigned to the plot paper [0,1]
                    //         yref: 'paper',
                    //         x0: '2021',
                    //         y0: 0,
                    //         x1: '2021',
                    //         y1: 1,
                    //         fillcolor: '#fdc400',
                    //         opacity: 0.2,
                    //         line: {
                    //             width: 120,
                    //             color: '#fdc400'
                    //         }
                    //     }]
                    break;
                case 'FUNNEL':
                    graphConfig.yaxis?.forEach((yaxis) => {
                        let values = valuesMap[yaxis.table];
                        if (!values || values.length <= 0)
                            return;
                        // let valsToUse: any[] = values;
                        // if (!yaxis.value && yaxis.values) {
                        //     yaxis.value = yaxis.values.join(',')
                        // }
                        // if (yaxis.valueFunction) {
                        //     valsToUse = GraphicUtil.evalValueFuntion(values, yaxis.valueFunction, yaxis.value);
                        // }
                        let preElaboration = null;
                        if (yaxis.preElaborationRequired) {
                            preElaboration;
                        }
                        let initGraphicValues = GraphicUtil.initGraphicValues(values, yaxis, null, yaxis.preElaborationRequired);
                        var barTrace = new Funnel().build(initGraphicValues, translateService, graphConfig, yaxis);
                        adaptGraphicTraces(initGraphicValues, barTrace);
                    });
                    result.graphicData = graphicTraces;
                    // console.log('qui ini graphic factory');
                    result.graphicLayout = new Funnel().buildLayout(graphConfig);
                    // result.graphicLayout.shapes = [
                    //     // 1st highlight during Feb 4 - Feb 6
                    //     {
                    //         type: 'rect',
                    //         // x-reference is assigned to the x-values
                    //         xref: 'x',
                    //         // y-reference is assigned to the plot paper [0,1]
                    //         yref: 'paper',
                    //         x0: '2021',
                    //         y0: 0,
                    //         x1: '2021',
                    //         y1: 1,
                    //         fillcolor: '#fdc400',
                    //         opacity: 0.2,
                    //         line: {
                    //             width: 120,
                    //             color: '#fdc400'
                    //         }
                    //     }]
                    break;
                case 'PIE':
                    graphConfig.yaxis?.forEach((yaxis, yaxisIndex) => {
                        let values = valuesMap[yaxis.table];
                        if (!values || values.length <= 0)
                            return;
                        // let valsToUse: any[] = values;
                        // if (!yaxis.value && yaxis.values) {
                        //     yaxis.value = yaxis.values.join(',')
                        // }
                        // if (yaxis.valueFunction) {
                        //     valsToUse = GraphicUtil.evalValueFuntion(values, yaxis.valueFunction, yaxis.value);
                        // }
                        let initGraphicValues = GraphicUtil.initGraphicValues(values, yaxis, null, null);
                        var pieTrace = new Pie().build(initGraphicValues, translateService, graphConfig, yaxis, yaxisIndex);
                        adaptGraphicTraces(initGraphicValues, pieTrace);
                    });
                    if (graphConfig.aggregateYAxis) {
                        let aggregatedGraphicTraces;
                        graphicTraces.forEach((gt, index) => {
                            if (index == 0) {
                                aggregatedGraphicTraces = gt;
                            }
                            else {
                                aggregatedGraphicTraces.labels = aggregatedGraphicTraces.labels.concat(gt.labels);
                                aggregatedGraphicTraces.values = aggregatedGraphicTraces.values.concat(gt.values);
                            }
                        });
                        graphicTraces = [aggregatedGraphicTraces];
                    }
                    result.graphicData = graphicTraces;
                    result.graphicLayout = new Pie().buildLayout(graphConfig);
                    break;
                case 'INDICATOR':
                    graphConfig.yaxis?.forEach((yaxis, yaxisIndex) => {
                        let values = valuesMap[yaxis.table];
                        if (!values || values.length <= 0)
                            return;
                        // let valsToUse: any[] = values;
                        // if (!yaxis.value && yaxis.values) {
                        //     yaxis.value = yaxis.values.join(',')
                        // }
                        // if (yaxis.valueFunction) {
                        //     valsToUse = GraphicUtil.evalValueFuntion(values, yaxis.valueFunction, yaxis.value);
                        //     // console.log('valsToUe --------------------',valsToUse);
                        // }
                        let initGraphicValues = GraphicUtil.initGraphicValues(values, yaxis, null, null);
                        var indicatorTrace = new Indicator().build(initGraphicValues, translateService, graphConfig, yaxis, yaxisIndex);
                        //console.log("it trace:"+indicatorTrace);
                        adaptGraphicTraces(initGraphicValues, indicatorTrace);
                    });
                    result.graphicData = graphicTraces;
                    result.graphicLayout = new Indicator().buildLayout(graphConfig);
                    break;
                //TODO
                case 'TABLE':
                    let headers = new Array();
                    let clickEventInfo = { onClickEvents: null, filterField: null };
                    headers.push('rowHeader');
                    //console.log('table values ',values);
                    graphConfig.yaxis?.forEach((yaxis, yaxisIndex) => {
                        if (yaxis.dataFilter && yaxis.onClick) {
                            clickEventInfo.onClickEvents = new Array();
                            clickEventInfo.onClickEvents.push(yaxis.onClick);
                            clickEventInfo.filterField = yaxis.dataFilter.filterField;
                        }
                        else if (yaxis.onClick && yaxis.onClick.funct) {
                            clickEventInfo.onClickEvents = new Array();
                            clickEventInfo.onClickEvents.push(yaxis.onClick);
                        }
                        else if (yaxis.onClick) {
                            clickEventInfo.onClickEvents = new Array();
                            clickEventInfo.onClickEvents.push(yaxis.onClick);
                            clickEventInfo.type = yaxis.onClick.type;
                        }
                        let values = valuesMap[yaxis.table];
                        if (!values || values.length <= 0)
                            return;
                        if (graphConfig.idFunction) {
                            if (!values[0]["_calculatedId_"])
                                values = GraphicUtil.evalValueFuntion(values, graphConfig.idFunction, "_calculatedId_");
                        }
                        let valsToUse = values;
                        let initGraphicValues = GraphicUtil.initGraphicValues(valsToUse, yaxis, true, false);
                        var tableTrace = new Table().build(initGraphicValues, translateService, graphConfig, yaxis, null, null, null);
                        tableTrace.forEach(tableElement => {
                            if (yaxisIndex == 0) {
                                graphicTraces.push(tableElement);
                            }
                            else {
                                //recupero l'elemento corrispondente al rowheader che non è stato ancora valorizzato, onde evitare di sovrascrivere campi che hanno lo stesso valore di rowheader
                                const foundIndex = graphicTraces.findIndex(gtElement => (gtElement.rowHeader == tableElement.rowHeader && gtElement[tableElement.colHeader] == null));
                                if (foundIndex >= 0) {
                                    let ele = graphicTraces[foundIndex];
                                    ele[tableElement.colHeader] = tableElement[tableElement.colHeader];
                                    graphicTraces[foundIndex] = ele;
                                }
                                else {
                                    graphicTraces.push(tableElement);
                                }
                            }
                        });
                        //adaptGraphicTraces(initGraphicValues, tableTrace);
                        headers.push(yaxis.label);
                    });
                    result.graphicData = graphicTraces;
                    //console.log(result.graphicData);
                    if (graphConfig.tableHideRawColumn)
                        headers.splice(0, 1);
                    if (graphConfig.tableSortDefaultColumn) {
                        result.graphicOptions.sort = graphConfig.tableSortDefaultColumn;
                    }
                    if (graphConfig.tableSortDefaultOrder) {
                        result.graphicOptions.sortOrder = graphConfig.tableSortDefaultOrder;
                    }
                    result.graphicLayout = headers;
                    result.clickEventInfo = clickEventInfo;
                    //console.log(result)
                    break;
                case 'RADAR':
                    graphConfig.yaxis?.forEach((yaxis, yaxisIndex) => {
                        let values = valuesMap[yaxis.table];
                        if (!values || values.length <= 0)
                            return;
                        // let valsToUse: any[] = values;
                        // if (!yaxis.value && yaxis.values) {
                        //     yaxis.value = yaxis.values.join(',')
                        // }
                        // if (yaxis.valueFunction) {
                        //     valsToUse = GraphicUtil.evalValueFuntion(values, yaxis.valueFunction, yaxis.value);
                        // }
                        let initGraphicValues = GraphicUtil.initGraphicValues(values, yaxis, null, null);
                        // let initGraphicValues = GraphicUtil.initGraphicValues(values, yaxis);
                        var barTrace = new Radar().build(initGraphicValues, translateService, graphConfig, yaxis, yaxisIndex);
                        adaptGraphicTraces(initGraphicValues, barTrace);
                    });
                    let max = 0;
                    graphicTraces.forEach((gt) => {
                        const tmpMax = Math.max(...gt.r);
                        if (tmpMax > max) {
                            max = tmpMax;
                        }
                    });
                    result.graphicData = graphicTraces;
                    graphConfig.range = [0, max];
                    result.graphicLayout = new Radar().buildLayout(graphConfig);
                    break;
            }
            //result.config={locale:'it'}
        }
        else {
            result.graphicData = graphicTraces;
            result.graphicLayout = null;
        }
        //console.log(result);
        return result;
        function adaptGraphicTraces(initGraphicValues, trace) {
            if (initGraphicValues.filteredData != undefined) {
                graphicTraces = graphicTraces.concat(trace);
            }
            else if (initGraphicValues.aggregatedData != undefined) {
                graphicTraces = graphicTraces.concat(trace);
            }
            else {
                graphicTraces.push(trace);
            }
        }
    }
    static createYaxisTraceGraphic(graphConfig, yaxis, values, yaxisIndex, translateService) {
        let result = {
            graphicData: [],
            graphicLayout: null,
            config: {
                responsive: true,
                displaylogo: false,
                modeBarButtonsToRemove: ['pan2d',
                    'select2d',
                    'lasso2d',
                    'zoomIn2d',
                    'zoomOut2d',
                    'autoScale2d',
                    'hoverClosestCartesian',
                    'hoverCompareCartesian',
                    'hoverClosestGl2d',
                    'hoverClosestPie',
                    'toggleHover',
                    'sendDataToCloud',
                    'toggleSpikelines',
                    'resetViewMapbox']
            },
            graphicOptions: {
                sort: null,
                template: null
            }
        };
        let graphicTraces = [];
        if (values != undefined && values != null && values.length > 0) {
            if (graphConfig.idFunction) {
                values = GraphicUtil.evalValueFuntion(values, graphConfig.idFunction, "_calculatedId_");
            }
            //console.log('GraphicFactory', graphConfig)
            let yaxisNumericUnits = new Array();
            //fix per grafici che non hanno valorizzato correttamente value e values
            if (yaxis.value == null && yaxis.values != null) {
                yaxis.value = yaxis.values.join();
            }
            switch (graphConfig.type) {
                case 'LINE':
                    if (yaxis.numericUnit) {
                        yaxisNumericUnits.push(yaxis.numericUnit);
                    }
                    //TODO risolvere bug lato backend che non fa due query in caso dello stesso yaxis
                    let initLineGraphicValues = GraphicUtil.initGraphicValues(values, yaxis);
                    //console.log(initGraphicValues);
                    let lineTrace = new Line().build(initLineGraphicValues, translateService, graphConfig, yaxis);
                    adaptGraphicTraces(initLineGraphicValues, lineTrace);
                    //ricavo l'unità di misura dagli yaxis verificando che tutti gli yaxis abbiano la stessa
                    graphConfig.tempNumericUnit = retrieveNumericUnitFromYaxis(yaxisNumericUnits);
                    result.graphicData = graphicTraces;
                    result.graphicLayout = new Line().buildLayout(graphConfig);
                    graphConfig.tempNumericUnit = null;
                    break;
                case 'BUBBLE':
                    if (yaxis.numericUnit) {
                        yaxisNumericUnits.push(yaxis.numericUnit);
                    }
                    //TODO risolvere bug lato backend che non fa due query in caso dello stesso yaxis
                    let initBubbleGraphicValues = GraphicUtil.initGraphicValues(values, yaxis);
                    //console.log(initGraphicValues);
                    let bubbleTrace = new Bubble().build(initBubbleGraphicValues, translateService, graphConfig, yaxis);
                    adaptGraphicTraces(initBubbleGraphicValues, bubbleTrace);
                    //ricavo l'unità di misura dagli yaxis verificando che tutti gli yaxis abbiano la stessa
                    graphConfig.tempNumericUnit = retrieveNumericUnitFromYaxis(yaxisNumericUnits);
                    result.graphicData = graphicTraces;
                    result.graphicLayout = new Bubble().buildLayout(graphConfig);
                    graphConfig.tempNumericUnit = null;
                    break;
                case 'BAR':
                    if (yaxis.numericUnit) {
                        yaxisNumericUnits.push(yaxis.numericUnit);
                    }
                    let initBarGraphicValues = GraphicUtil.initGraphicValues(values, yaxis);
                    //console.log(initGraphicValues);
                    var barTrace = new Bar().build(initBarGraphicValues, translateService, graphConfig, yaxis);
                    adaptGraphicTraces(initBarGraphicValues, barTrace);
                    //ricavo l'unità di misura dagli yaxis verificando che tutti gli yaxis abbiano la stessa
                    graphConfig.tempNumericUnit = retrieveNumericUnitFromYaxis(yaxisNumericUnits);
                    result.graphicData = graphicTraces;
                    result.graphicLayout = new Bar().buildLayout(graphConfig);
                    graphConfig.tempNumericUnit = null;
                    break;
                case 'FUNNEL':
                    if (yaxis.numericUnit) {
                        yaxisNumericUnits.push(yaxis.numericUnit);
                    }
                    let initFunnelGraphicValues = GraphicUtil.initGraphicValues(values, yaxis);
                    //console.log(initGraphicValues);
                    var funnelTrace = new Funnel().build(initFunnelGraphicValues, translateService, graphConfig, yaxis);
                    adaptGraphicTraces(initFunnelGraphicValues, funnelTrace);
                    //ricavo l'unità di misura dagli yaxis verificando che tutti gli yaxis abbiano la stessa
                    graphConfig.tempNumericUnit = retrieveNumericUnitFromYaxis(yaxisNumericUnits);
                    result.graphicData = graphicTraces;
                    result.graphicLayout = new Funnel().buildLayout(graphConfig);
                    graphConfig.tempNumericUnit = null;
                    break;
                case 'PIE':
                    let initPieGraphicValues = GraphicUtil.initGraphicValues(values, yaxis);
                    var pieTrace = new Pie().build(initPieGraphicValues, translateService, graphConfig, yaxis, yaxisIndex);
                    adaptGraphicTraces(initPieGraphicValues, pieTrace);
                    if (graphConfig.aggregateYAxis) {
                        let aggregatedGraphicTraces;
                        graphicTraces.forEach((gt, index) => {
                            if (index == 0) {
                                aggregatedGraphicTraces = gt;
                            }
                            else {
                                aggregatedGraphicTraces.labels = aggregatedGraphicTraces.labels.concat(gt.labels);
                                aggregatedGraphicTraces.values = aggregatedGraphicTraces.values.concat(gt.values);
                            }
                        });
                        graphicTraces = [aggregatedGraphicTraces];
                    }
                    result.graphicData = graphicTraces;
                    result.graphicLayout = new Pie().buildLayout(graphConfig);
                    break;
                case 'RADAR':
                    if (yaxis.numericUnit) {
                        yaxisNumericUnits.push(yaxis.numericUnit);
                    }
                    let initRadarGraphicValues = GraphicUtil.initGraphicValues(values, yaxis);
                    // let initGraphicValues = GraphicUtil.initGraphicValues(values, yaxis);
                    var radarTrace = new Radar().build(initRadarGraphicValues, translateService, graphConfig, yaxis, yaxisIndex);
                    adaptGraphicTraces(initRadarGraphicValues, radarTrace);
                    //ricavo l'unità di misura dagli yaxis verificando che tutti gli yaxis abbiano la stessa
                    graphConfig.tempNumericUnit = retrieveNumericUnitFromYaxis(yaxisNumericUnits);
                    result.graphicData = graphicTraces;
                    result.graphicLayout = new Radar().buildLayout(graphConfig);
                    break;
                case 'INDICATOR':
                    let initIndicatorGraphicValues = GraphicUtil.initGraphicValues(values, yaxis);
                    var indicatorTrace = new Indicator().build(initIndicatorGraphicValues, translateService, graphConfig, yaxis, yaxisIndex);
                    //console.log("it trace:"+indicatorTrace);
                    adaptGraphicTraces(initIndicatorGraphicValues, indicatorTrace);
                    result.graphicData = graphicTraces;
                    result.graphicLayout = new Indicator().buildLayout(graphConfig);
                    break;
                case 'TABLE':
                    // case 'HEATMAP':
                    let clickEventInfo = { onClickEvents: null, filterField: null };
                    //console.log('table values ',values);
                    if (yaxis.dataFilter && yaxis.onClick) {
                        clickEventInfo.onClickEvents = new Array();
                        clickEventInfo.onClickEvents.push(yaxis.onClick);
                        clickEventInfo.filterField = yaxis.dataFilter.filterField;
                    }
                    else if (yaxis.onClick && yaxis.onClick.funct) {
                        clickEventInfo.onClickEvents = new Array();
                        clickEventInfo.onClickEvents.push(yaxis.onClick);
                    }
                    if (yaxis.templateString) {
                        values = GraphicUtil.templateLiteralsFunction(values, yaxis.templateString, yaxis.value);
                        console.log('templateString');
                    }
                    // if (graphConfig.type == 'HEATMAP') {
                    //     yaxis.dataFilter = null;
                    // }
                    let initGraphicValues = GraphicUtil.initGraphicValues(values, yaxis, true);
                    // let initGraphicValues = GraphicUtil.initGraphicValues(values, yaxis);
                    var tableTrace = new Table().build(initGraphicValues, translateService, graphConfig, yaxis);
                    result.graphicData = tableTrace;
                    //console.log(result.graphicData);
                    if (graphConfig.tableSortDefaultColumn) {
                        result.graphicOptions.sort = graphConfig.tableSortDefaultColumn;
                    }
                    if (graphConfig.tableSortDefaultOrder) {
                        result.graphicOptions.sortOrder = graphConfig.tableSortDefaultOrder;
                    }
                    result.clickEventInfo = clickEventInfo;
                    //console.log(result)
                    break;
                case 'HEATMAP':
                    yaxis.dataFilter = null;
                    let initHeatmapGraphicValues = GraphicUtil.initGraphicValues(values, yaxis, false);
                    var tableTrace = new Heatmap().build(initHeatmapGraphicValues, translateService, graphConfig, yaxis);
                    result.graphicData = tableTrace;
                    break;
            }
            //result.config={locale:'it'}
        }
        else {
            result.graphicData = graphicTraces;
            result.graphicLayout = null;
        }
        //        console.log(result);
        return result;
        function adaptGraphicTraces(initGraphicValues, trace) {
            if (initGraphicValues.filteredData != undefined) {
                graphicTraces = graphicTraces.concat(trace);
            }
            else if (initGraphicValues.aggregatedData != undefined) {
                graphicTraces = graphicTraces.concat(trace);
            }
            else {
                graphicTraces.push(trace);
            }
        }
        function retrieveNumericUnitFromYaxis(yaxisNumericUnits) {
            let tempNumericUnit = "";
            if (yaxisNumericUnits && yaxisNumericUnits.length > 0) {
                let resNumericUnit = yaxisNumericUnits.every((nu) => (nu != null && nu.toUpperCase() == yaxisNumericUnits[0].toUpperCase()));
                if (resNumericUnit) {
                    tempNumericUnit = GraphicUtil.buildUnit(yaxisNumericUnits[0], yaxisNumericUnits[0]);
                }
            }
            return tempNumericUnit;
        }
    }
}

class GraphicElementConfig {
    constructor(id, title, startDate, endDate, dateFieldName, cssClasses) {
        this.id = id;
        this.title = title;
        this.startDate = startDate;
        this.endDate = endDate;
        this.dateFieldName = dateFieldName;
        this.cssClasses = cssClasses ?? [];
    }
}

class GraphicConfig extends GraphicElementConfig {
    constructor(id, type, dataMartSource, title, startDate, endDate, dateFieldName, yaxis, requestFilterDates, actualValue, lastValue, modeArr, valueformat, numberSuffix, barmode, bargap, predictionRef) {
        super(id, title ?? "", startDate, endDate, dateFieldName ?? "");
        this.x = 0;
        this.y = 0;
        this.rows = 4;
        this.cols = 12;
        this.numberSuffix = null; // INDICATOR
        this.tempNumericUnit = null; // usato quando non è specificato il numeric unit e si ricava dal numeric unit degli yaxis
        this.numericUnit = null;
        this.limitPieResults = true; //limita il numero di risultati da visualizzare nelle pie
        this.tableHideRawColumn = false;
        this.tableDisableAddPlotrows = false;
        /** end table paged info*/
        this.valueformat = '.4s'; // https://github.com/d3/d3-format/tree/v1.4.5#d3-forma es .0% => rounded percentage
        this.displaylogo = false;
        this.autosize = false;
        this.type = type;
        this.dataMartSource = dataMartSource;
        this.yaxis = yaxis;
        this.requestFilterDates = requestFilterDates;
        this.mode = modeArr && modeArr.length > 1 ? modeArr.join('+') : 'number';
        if (valueformat)
            this.valueformat = valueformat;
        this.displaylogo = false;
        if (numberSuffix != undefined)
            this.numberSuffix = numberSuffix;
        if (barmode != undefined)
            this.barmode = barmode;
        this.bargap = bargap;
        this.predictionRef = predictionRef;
    }
}

class DashboardServiceAdapter {
}

class DashboardService extends DashboardServiceAdapter {
    constructor(api) {
        super();
        this.api = api;
        // serviceEndpoint: string = "https://app.markerweb.it/dmj/api";
        this.serviceEndpoint = "/dmj/api";
        this.api.setEnvironment(this.serviceEndpoint, undefined, undefined);
    }
    getChartsData(body, force) {
        let url = 'bo/dashboard/chartsData';
        if (force)
            url += '?force=true';
        return new Observable((observer) => {
            this.api.postRequest(url, body).then((s) => {
                s.subscribe((data) => {
                    observer.next(data);
                    observer.complete();
                });
            });
        });
    }
    getPagedChartData(specificParameters, searchKeys, searchValue, sortParam, sortDirection, pageNumber, pageSize, graphConfig, force) {
        let url = 'bo/dashboard/pagedChartsData';
        let body = { graphConfigs: [graphConfig] };
        //console.log(graphConfig);
        let data = {
            params: {
                pageNumber: pageNumber,
                pageSize: pageSize
            }
        };
        if (searchValue && searchKeys) {
            data.params['searchValue'] = searchValue;
            data.params['searchKeys'] = searchKeys;
        }
        if (sortParam) {
            data.params['sortParam'] = sortParam;
            data.params['sortDirection'] = sortDirection;
        }
        if (specificParameters) {
            for (const key in specificParameters) {
                if (Object.prototype.hasOwnProperty.call(specificParameters, key)) {
                    data.params[key] = specificParameters[key];
                }
            }
        }
        let params = null;
        if (data.params != null) {
            for (const key in data.params) {
                if (Object.prototype.hasOwnProperty.call(data.params, key)) {
                    if (params == null) {
                        params = key + "=" + data.params[key];
                    }
                    else {
                        params += "&" + key + "=" + data.params[key];
                    }
                }
            }
        }
        if (force) {
            if (params) {
                params += '&force=true';
            }
            else {
                params == 'force=true';
            }
        }
        if (params) {
            url += '?' + params;
        }
        return new Observable((observer) => {
            this.api.postRequest(url, body).then((s) => {
                s.subscribe((data) => {
                    observer.next(data);
                    observer.complete();
                });
            });
        });
    }
    createDashboard(body) {
        return this.api.postRequest(`dashboards/`, body);
    }
    deleteDashboard(dashboardId) {
        return this.api.deleteRequest(`dashboards/` + dashboardId);
    }
    deleteDashboardWidget(dashboardId, dashboardWidgetId) {
        return this.api.deleteRequest(`dashboards/` + dashboardId + `/` + dashboardWidgetId);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.9", ngImport: i0, type: DashboardService, deps: [{ token: i1$2.ApiOauthService }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "16.2.9", ngImport: i0, type: DashboardService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.9", ngImport: i0, type: DashboardService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: function () { return [{ type: i1$2.ApiOauthService }]; } });

class DateUtils {
    static getZeroedTimeDate(date) {
        let d = null;
        if (!date) {
            let temp = new Date();
            d = new Date(Date.UTC(temp.getUTCFullYear(), temp.getUTCMonth(), temp.getUTCDate()));
        }
        else {
            d = new Date(Date.UTC(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate()));
        }
        d.setUTCHours(0, 0, 0, 1);
        return d;
    }
    static getMidnightDownDate(date) {
        let d = null;
        if (!date) {
            let temp = new Date();
            d = new Date(Date.UTC(temp.getUTCFullYear(), temp.getUTCMonth(), temp.getUTCDate()));
        }
        else {
            d = new Date(Date.UTC(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate()));
        }
        d.setUTCHours(0, 0, 0, 1);
        return d;
    }
    static getMidnightUpDate(date) {
        let d = null;
        if (!date) {
            let temp = new Date();
            d = new Date(Date.UTC(temp.getUTCFullYear(), temp.getUTCMonth(), temp.getUTCDate()));
        }
        else {
            d = new Date(Date.UTC(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate()));
        }
        d.setUTCHours(0, 0, 0, 1);
        return d;
    }
    static getPastDaysDate(date, days) {
        let d = new Date(date.getTime() - (days * 1000 * 60 * 60 * 24));
        d = this.getZeroedTimeDate(d);
        return d;
        // pastDate.set();
        // return pastDate;
    }
    static getPastMonthsDate(date, months) {
        let pastMonth = date;
        pastMonth.setMonth(pastMonth.getMonth() - months);
        return pastMonth;
    }
}

class BaseDashboardComponent extends AdminUtilComponent {
    constructor(dialog, snackBar, injector) {
        super(dialog, snackBar, injector);
        this.dialog = dialog;
        this.injector = injector;
        this.graphicCards = new Array();
        this.graphConfigs = [];
        this.showGlobalPageSelector = true;
        this.showGlobalPossibleMetricsSelector = false;
        const yesterday = DateUtils.getPastDaysDate(new Date(), 1);
        this.startFilteringDate = DateUtils.getZeroedTimeDate(yesterday);
        this.endFilteringDate = DateUtils.getZeroedTimeDate(yesterday);
        this.dashboardService = injector.get(DashboardService);
        this.translateService = injector.get(TranslateService);
        this.defaultLang = this.translateService.defaultLang;
        //aggiornamento menu delle possibilit visualizzazione delle metriche combiante
        this.multipleDatasourceMetricsList = new Array();
        this.translateService.get('dashboard.widget.combination_metrics_view_all').subscribe((res) => {
            this.multipleDatasourceMetricsList.push({ id: 'ALL', label: res });
        });
        this.translateService.get('dashboard.widget.combination_metrics_view_combination').subscribe((res) => {
            this.multipleDatasourceMetricsList.push({ id: 'COMBINATION', label: res });
        });
        this.translateService.get('dashboard.widget.combination_metrics_view_singular').subscribe((res) => {
            this.multipleDatasourceMetricsList.push({ id: 'SINGULAR', label: res });
        });
    }
    ngOnInit() {
    }
    updatePagedGraphic(gc, cardContainer) {
        return new Promise((resolve, reject) => {
            if (!gc.requestFilterDates) {
                gc.startDate = this.startFilteringDate;
                gc.endDate = this.endFilteringDate;
            }
            let gcList = new Array();
            gcList.push(gc);
            if (cardContainer == null) {
                this.initGraphicCardContainer(gcList);
            }
            this.dashboardService.getPagedChartData(null, null, null, null, "ASC", gc.pageNumber, gc.pageSize, gc).subscribe((res) => {
                let allGraphicConfigValues = res.payload;
                //console.log("paging info: ",res.pageSize, res.currentPage, res.totalCount);
                //console.log("all graphic values: ", allGraphicConfigValues);
                if (allGraphicConfigValues.length == 0) {
                    this.initEmptyGraphicCardContainer(gcList);
                }
                else {
                    this.initValuedGraphicCardContainer(gcList, allGraphicConfigValues, cardContainer);
                }
                resolve(true);
            }, (error) => {
                //in caso di errore non faccio vedere alcun risultato e inserisco un messaggio di error nel log
                //this.hideLoader();
                this.initEmptyGraphicCardContainer(gcList);
                console.log(error);
                reject(false);
            });
        });
    }
    updateGraphics(gcList, update) {
        return new Promise((resolve, reject) => {
            //console.log("update graphics method");
            gcList.forEach((graphConfig, index) => {
                if (!graphConfig.requestFilterDates) {
                    graphConfig.startDate = this.startFilteringDate;
                    graphConfig.endDate = this.endFilteringDate;
                }
            });
            console.log(gcList);
            let obj = {};
            //console.log(gcList);
            if (gcList && gcList.length > 0) {
                obj.graphConfigs = gcList;
                this.initGraphicCardContainer(gcList);
                this.dashboardService.getChartsData(obj).subscribe((res) => {
                    let allGraphicConfigValues = res.payload;
                    //console.log("all graphic values: ", allGraphicConfigValues);
                    if (allGraphicConfigValues.length == 0) {
                        this.initEmptyGraphicCardContainer(gcList);
                    }
                    else {
                        this.initValuedGraphicCardContainer(gcList, allGraphicConfigValues);
                    }
                    resolve(true);
                }, (error) => {
                    //in caso di errore non faccio vedere alcun risultato e inserisco un messaggio di error nel log
                    //this.hideLoader();
                    this.initEmptyGraphicCardContainer(gcList);
                    console.log(error);
                    reject(false);
                });
            }
            else {
                resolve(true);
            }
        });
    }
    initValuedGraphicCardContainer(list, allGraphicConfigValues, cardContainer) {
        list.forEach(async (graphConfig) => {
            let graphicConfigValues = allGraphicConfigValues.filter((el) => { return el.graphicInfo.id == graphConfig.id; });
            let graphic = GraphicFactory.createGraphic(graphConfig, null);
            if (graphicConfigValues != null && graphicConfigValues.length > 0) {
                let singleGraphicConfigValue = null;
                let headers = new Array();
                headers.push('rowHeader');
                let multipleDatasourceMap = new Map();
                graphConfig.yaxis?.forEach((yax, yaxisIndex) => {
                    headers.push(yax.label);
                    if (graphConfig.tableHideRawColumn) {
                        headers.splice(0, 1);
                    }
                    singleGraphicConfigValue = this.findCorrectChartValues(graphicConfigValues, yax);
                    //console.log("yax:", yax, " values: ", singleGraphicConfigValue);
                    if (singleGraphicConfigValue) {
                        let graphicValues = singleGraphicConfigValue.result;
                        let chartTrace = GraphicFactory.createYaxisTraceGraphic(graphConfig, yax, graphicValues, yaxisIndex, this.translateService);
                        if (graphConfig.multipleDatasourceMetrics != null) {
                            if (graphConfig.multipleDatasourceMetricsVisualization != null && graphConfig.multipleDatasourceMetricsVisualization != 'SINGULAR') {
                                const metricOfCombination = graphConfig.multipleDatasourceMetrics.find((mdm) => mdm.values.includes(yax.label + ';' + yax.value));
                                if (metricOfCombination != null) {
                                    let t = cloneDeep(chartTrace);
                                    multipleDatasourceMap.set(yax.label + ';' + yax.value, t);
                                }
                            }
                            //nel caso in cui è richiesta la visualizzaione della solo combinazione annullo il chartrace attuale
                            if (graphConfig.multipleDatasourceMetricsVisualization != null &&
                                graphConfig.multipleDatasourceMetricsVisualization == 'COMBINATION') {
                                chartTrace = null;
                            }
                        }
                        //mappa che associa ad ogni yaxis i valori
                        //Fuori dal for scorro la mappa e credo dei nuovi yaxis per le nuove line
                        if (chartTrace != null) {
                            this.initDataAndLayout(graphConfig, graphic, chartTrace, headers);
                        }
                        if (graphConfig.type == 'HEATMAP') {
                            graphic.graphicData = graphicValues;
                        }
                    }
                    else {
                        console.info("no data found for yaxis:", yax);
                        graphic = GraphicFactory.createGraphic(graphConfig, null);
                    }
                });
                //console.log("data: ",graphic.graphicData);
                //verifico se l'yaxis è previsto dalla combinazione di metriche
                if (graphConfig.multipleDatasourceMetrics != null && graphConfig.multipleDatasourceMetrics.length > 0 &&
                    graphConfig.multipleDatasourceMetricsVisualization != 'SINGULAR') {
                    graphConfig.multipleDatasourceMetrics.forEach((mdm, index) => {
                        let metricTraces = new Array();
                        mdm.values.forEach((m) => {
                            let metricKey = Array.from(multipleDatasourceMap.keys()).find((k) => m == k);
                            if (metricKey != null) {
                                metricTraces.push(multipleDatasourceMap.get(metricKey));
                            }
                        });
                        //console.log("TRACES: ",metricTraces);
                        if (graphConfig.type == 'TABLE' || graphConfig.type == 'HEATMAP') {
                            headers.push(mdm.label);
                        }
                        let trace = this.buildCombinedTrace(graphConfig, metricTraces, mdm.fieldsFunction, mdm.label, graphic.graphicData.length);
                        if (trace != null) {
                            this.initDataAndLayout(graphConfig, graphic, trace, headers);
                        }
                    });
                }
            }
            else {
                graphic = GraphicFactory.createGraphic(graphConfig);
            }
            //setto categoryorder e category array nel layout per evitare il problema di valori mancanti e dell'ordinamento 
            //sull'asse x. Gestisce autonomamente la corrispondenza posizionale degli array x e y
            //https://plotly.com/javascript/reference/layout/xaxis/#layout-xaxis-categoryarray
            if (graphConfig.type == 'BUBBLE' || graphConfig.type == 'LINE' || graphConfig.type == 'BAR') {
                const allXValues = new Array();
                await this.getOrderedXAxisValues(graphic).then((res) => {
                    if (res != null && graphic.graphicLayout != null) {
                        if (graphic.graphicLayout.xaxis == null) {
                            graphic.graphicLayout.xaxis = { categoryorder: "array", categoryarray: res };
                        }
                        else {
                            graphic.graphicLayout.xaxis.categoryorder = "array";
                            graphic.graphicLayout.xaxis.categoryarray = res;
                        }
                    }
                })
                    .catch((rej) => {
                    console.log(rej);
                });
            }
            if (graphConfig.type == 'BUBBLE') {
                this.adaptBubbleChart(graphic);
            }
            if (graphConfig.type == 'RADAR') {
                //in caso di radar e di trace con singolo valore, essi vengono uniti in un unico trace al 
                //fine di essere mostrati in modo coerente. in caso di radar e di trace con valori multipli 
                //essi vengono semplici moltiplicati
                this.adaptRadarTraces(graphic);
            }
            if (graphConfig.type == 'FUNNEL') {
                //concatenazione dei trace del funnel, lo stacked funnel non è previsto in questo momento
                this.adaptFunnelTraces(graphic);
            }
            if (graphConfig.type == 'BAR') {
                //Aggiunta della trendline sul bar chart
                this.addTrendLineToBarChart(graphConfig, graphic);
            }
            let ccc = null;
            if (cardContainer != null) {
                ccc = cardContainer;
            }
            else {
                ccc = this.graphicCardContainers[graphConfig.id];
            }
            if (ccc != null) {
                if (graphConfig.helpKey) {
                    ccc.helpKey = graphConfig.helpKey;
                }
                ccc.loaderVisible = false;
                console.log("updateing graph");
                this._updateGraph(ccc, graphConfig, graphic);
            }
        });
    }
    initEmptyGraphicCardContainer(list) {
        list.forEach(graphConfig => {
            let ccc = this.graphicCardContainers[graphConfig.id];
            if (graphConfig.helpKey) {
                ccc.helpKey = graphConfig.helpKey;
            }
            ccc.loaderVisible = false;
            let graphic = GraphicFactory.createGraphic(graphConfig);
            this._updateGraph(ccc, graphConfig, graphic);
        });
    }
    initGraphicCardContainer(list) {
        list.forEach(graphConfig => {
            let cardContainer = new CardContainerConfig(graphConfig.id, graphConfig.title, graphConfig.requestFilterDates ?? false, null, null, null, null, true); //hideShadowBorder a true permette di nascondere i bordi della matcard nel componente
            let graphic = GraphicFactory.createGraphic(graphConfig, null);
            if (!this.graphicCardContainers) {
                this.graphicCardContainers = {};
            }
            cardContainer.loaderVisible = true;
            //console.log('updateing ',cardContainer);
            if (graphConfig.helpKey) {
                cardContainer.helpKey = graphConfig.helpKey;
            }
            this.graphicCardContainers[graphConfig.id] = cardContainer;
            this.initGraphicCards(graphConfig, graphic, cardContainer);
        });
    }
    buildTablePagedDatasource(graphConfig, graphicConfigValues) {
        let graphic = GraphicFactory.createGraphic(graphConfig, null);
        if (graphicConfigValues != null && graphicConfigValues.length > 0) {
            let headers = new Array();
            headers.push('rowHeader');
            //tabella di mapping valori header colonne tabella, necessaria per il sorting
            graphConfig.tableHeaderMaps = new Array();
            let multipleDatasourceMap = new Map();
            graphConfig.yaxis?.forEach((yax, yaxisIndex) => {
                if (yaxisIndex == 0) {
                    graphConfig.tableHeaderMaps.push({ tableField: 'rowHeader', originalField: yax.xaxis });
                }
                headers.push(yax.label);
                graphConfig.tableHeaderMaps.push({ tableField: yax.label, originalField: yax.value });
                if (graphConfig.tableHideRawColumn) {
                    headers.splice(0, 1);
                }
                //singleGraphicConfigValue = this.findCorrectChartValues(graphicConfigValues, yax);
                //console.log("yax:", yax, " values: ", singleGraphicConfigValue);
                let graphicValues = graphicConfigValues;
                let chartTrace = GraphicFactory.createYaxisTraceGraphic(graphConfig, yax, graphicValues, yaxisIndex, this.translateService);
                if (graphConfig.multipleDatasourceMetrics != null) {
                    if (graphConfig.multipleDatasourceMetricsVisualization != null && graphConfig.multipleDatasourceMetricsVisualization != 'SINGULAR') {
                        const metricOfCombination = graphConfig.multipleDatasourceMetrics.find((mdm) => mdm.values.includes(yax.label + ';' + yax.value));
                        if (metricOfCombination != null) {
                            let t = cloneDeep(chartTrace);
                            multipleDatasourceMap.set(yax.label + ';' + yax.value, t);
                        }
                    }
                    //nel caso in cui è richiesta la visualizzaione della solo combinazione annullo il chartrace attuale
                    if (graphConfig.multipleDatasourceMetricsVisualization != null &&
                        graphConfig.multipleDatasourceMetricsVisualization == 'COMBINATION') {
                        chartTrace = null;
                    }
                }
                //mappa che associa ad ogni yaxis i valori
                //Fuori dal for scorro la mappa e credo dei nuovi yaxis per le nuove line
                if (chartTrace != null) {
                    this.initDataAndLayout(graphConfig, graphic, chartTrace, headers);
                }
                if (graphConfig.type == 'HEATMAP') {
                    graphic.graphicData = graphicValues;
                }
            });
            //console.log("data: ",graphic.graphicData);
            //verifico se l'yaxis è previsto dalla combinazione di metriche
            if (graphConfig.multipleDatasourceMetrics != null && graphConfig.multipleDatasourceMetrics.length > 0 &&
                graphConfig.multipleDatasourceMetricsVisualization != 'SINGULAR') {
                graphConfig.multipleDatasourceMetrics.forEach((mdm, index) => {
                    let metricTraces = new Array();
                    mdm.values.forEach((m) => {
                        let metricKey = Array.from(multipleDatasourceMap.keys()).find((k) => m == k);
                        if (metricKey != null) {
                            metricTraces.push(multipleDatasourceMap.get(metricKey));
                        }
                    });
                    //console.log("TRACES: ",metricTraces);
                    if (graphConfig.type == 'TABLE' || graphConfig.type == 'HEATMAP') {
                        headers.push(mdm.label);
                    }
                    let trace = this.buildCombinedTrace(graphConfig, metricTraces, mdm.fieldsFunction, mdm.label, graphic.graphicData.length);
                    if (trace != null) {
                        this.initDataAndLayout(graphConfig, graphic, trace, headers);
                    }
                });
            }
            this.dataSource.data = graphic.graphicData;
            // console.log("paged data: ", graphic.graphicData);
            // console.log("paged data2: ", this.dataSource.data);
        }
        else {
            graphic = GraphicFactory.createGraphic(graphConfig, null);
        }
    }
    getOrderedXAxisValues(graphic) {
        return new Promise((res, rej) => {
            let ret = new Array();
            let xValues = new Set();
            if (graphic != null && graphic.graphicData) {
                //col set evito duplicati
                graphic.graphicData.forEach(gd => {
                    if (gd.x != null) {
                        gd.x.forEach((el) => {
                            xValues.add(el);
                        });
                    }
                });
            }
            ret = Array.from(xValues);
            ret.sort(function (a, b) {
                //ordinamento per data
                if (moment$1(a, "DD/MM/YYYY", true).isValid() && moment$1(b, "DD/MM/YYYY", true).isValid()) {
                    const aDate = moment$1(a, "DD/MM/YYYY").toDate();
                    const bDate = moment$1(b, "DD/MM/YYYY").toDate();
                    //console.log("comparing date:",aDate, bDate);
                    return aDate.getTime() - bDate.getTime();
                }
                //ordinamento per stringa o valore
                else {
                    return ((a < b) ? -1 : ((a == b) ? 0 : 1));
                }
            });
            res(ret);
        });
    }
    adaptBubbleChart(graphic) {
        if (graphic != null && graphic.graphicData != null) {
            //calcolo e setto il maxsizeref in modo da avere tutte le bolle dimensionate in modo uniforme
            let maxRef = 0;
            graphic.graphicData.forEach((gd) => {
                if (gd.marker != null && gd.marker.sizeref != null) {
                    if (gd.marker.sizeref) {
                        maxRef = gd.marker.sizeref;
                    }
                }
            });
            graphic.graphicData.forEach((gd) => {
                if (gd.marker == null) {
                    gd.marker = { sizeref: maxRef };
                }
                else {
                    gd.marker.sizeref = maxRef;
                }
            });
        }
    }
    adaptRadarTraces(graphic) {
        let max = 0;
        if (graphic != null && graphic.graphicData != null) {
            let traceSingleOccurrency = new Array();
            let traceMultipleOccurrency = new Array();
            //in caso di radar e di trace con valore unico vado a unire i valori unici in un unico array
            graphic.graphicData.forEach((gt, index) => {
                if (index == 0) {
                    if (gt.theta.length == 1) {
                        traceSingleOccurrency = traceSingleOccurrency.concat(gt);
                    }
                    else {
                        traceMultipleOccurrency = traceMultipleOccurrency.concat(gt);
                    }
                }
                else {
                    if (gt.theta.length == 1 && traceSingleOccurrency.length > 0) {
                        traceSingleOccurrency[0].theta.push(gt.theta[0]);
                        traceSingleOccurrency[0].r.push(gt.r[0]);
                    }
                    else {
                        traceMultipleOccurrency = traceMultipleOccurrency.concat(gt);
                    }
                }
            });
            graphic.graphicData = new Array();
            graphic.graphicData = graphic.graphicData.concat(...traceSingleOccurrency);
            graphic.graphicData = graphic.graphicData.concat(...traceMultipleOccurrency);
            //console.log(graphic.graphicData);
            graphic.graphicData.forEach((gt, index) => {
                const tmpMax = Math.max(...gt.r);
                if (tmpMax > max) {
                    max = tmpMax;
                }
            });
        }
        if (graphic.graphicLayout != null) {
            graphic.graphicLayout.showlegend = false;
            if (graphic.graphicData != null && graphic.graphicData.length == 1) {
                graphic.graphicData[0].name = '';
            }
            //mostro la legenda in caso di più gruppi di valori
            if (graphic.graphicData != null && graphic.graphicData.length > 1) {
                graphic.graphicLayout.showlegend = true;
            }
            graphic.graphicLayout.polar.radialaxis.range = [0, max];
        }
    }
    adaptFunnelTraces(graphic) {
        if (graphic != null && graphic.graphicData != null && graphic.graphicData.length > 0) {
            let trace = cloneDeep(graphic.graphicData[0]);
            let multipleTrace = new Array();
            if (trace.marker != null) {
                trace.marker.color = null;
            }
            let tracesMax = trace.x.length > 0 ? Math.max(...trace.x) : 0;
            //in caso di funnel e di trace con valore unico vado a unire i valori unici in un unico array
            //altrimenti li concateno a quelli esistenti in modo da avere uno stacked
            graphic.graphicData.forEach((gt, index) => {
                if (index > 0) {
                    if (gt.x.length > 0) {
                        if (gt.x.length == 1) {
                            trace.x = trace.x.concat(gt.x);
                            trace.y = trace.y.concat(gt.y);
                            trace.marker.color = null;
                        }
                        else {
                            multipleTrace.push(gt);
                            gt.marker.color = null;
                        }
                        //update max- il max del trace è sempre nel primo valore per costruzione
                        if (gt.x[0] > tracesMax) {
                            tracesMax = gt.x[0];
                        }
                    }
                }
            });
            //inizio sezione di ordinamento degli array x e y dei trace considerando:
            // - il valore massimo di x tra tutti i traces
            // - l'array y del trace che contiene il valore massimo
            //cerco il trace che contiene il valore massimo
            let found = trace.x.find((x) => x == tracesMax);
            if (found == null) {
                found = multipleTrace.find((mt) => mt.x[0] == tracesMax);
            }
            else {
                found = trace;
            }
            let orderedTrace = cloneDeep(trace);
            let orderedMultipleTrace = cloneDeep(multipleTrace);
            //uso l'array del trace contenente il valore massimo nell'array x per ordinare gli array x e y degli altri traces 
            //in modo da rispettare l'ordine previsto nell'array y del trace contenente il valore massimo
            if (found != null && found.y.length > 0) {
                found.y.forEach((fy, index) => {
                    this.reorderTraceArray(trace, orderedTrace, fy, index);
                    this.reorderTraceArray(multipleTrace, orderedMultipleTrace, fy, index);
                });
            }
            graphic.graphicData = new Array();
            graphic.graphicData.push(orderedTrace);
            graphic.graphicData = graphic.graphicData.concat(...orderedMultipleTrace);
            //console.log(graphic.graphicData);
            if (graphic.graphicData.y != null && graphic.graphicData.x != null) {
                GraphicUtil.sort(graphic.graphicData.y, graphic.graphicData.x, 'DESC');
            }
        }
        if (graphic.graphicLayout != null) {
            graphic.graphicLayout.showlegend = false;
        }
    }
    //ordina gli array x e y del newOrderedTrace sulla base del valore di fy e della nuova posizione
    reorderTraceArray(trace, newOrderedTrace, fy, newPositionIndex) {
        if (trace != null && trace.x != null && trace.y != null) {
            let foundIndex = trace.y.findIndex((y) => y == fy);
            if (foundIndex >= 0) {
                newOrderedTrace.y.splice(newPositionIndex, 1, trace.y[foundIndex]);
                newOrderedTrace.x.splice(newPositionIndex, 1, trace.x[foundIndex]);
            }
        }
    }
    initDataAndLayout(graphConfig, graphic, chartTrace, headers) {
        if (graphConfig.type != 'TABLE' && graphConfig.type != 'HEATMAP') {
            graphic.graphicData = graphic.graphicData.concat(...chartTrace.graphicData);
            graphic.graphicLayout = chartTrace.graphicLayout;
        }
        else {
            //la tabella restituisce sempre un array di un unico valore
            const tableTrace = chartTrace.graphicData;
            tableTrace.forEach(tableElement => {
                //recupero l'elemento corrispondente al rowheader che non è stato ancora valorizzato, onde evitare di sovrascrivere campi che hanno lo stesso valore di rowheader
                const foundIndex = graphic.graphicData.findIndex(gtElement => (gtElement.rowHeader == tableElement.rowHeader && gtElement[tableElement.colHeader] == null));
                if (foundIndex >= 0) {
                    let ele = graphic.graphicData[foundIndex];
                    ele[tableElement.colHeader] = tableElement[tableElement.colHeader];
                    graphic.graphicData[foundIndex] = ele;
                }
                else {
                    graphic.graphicData.push(tableElement);
                }
            });
            graphic.graphicLayout = headers;
            graphic.clickEventInfo = chartTrace.clickEventInfo;
        }
    }
    buildCombinedTrace(graphConfig, metricTraces, func, traceTitle, totalTrace) {
        let trace = null;
        if (metricTraces != null && metricTraces.length > 0) {
            trace = cloneDeep(metricTraces[0]);
            let result = {
                x: [], y: [], size: [], theta: [], r: [], labels: [], values: [], value: 0,
                tableElement: [], name: '', titles: [], numericUnit: ''
            };
            metricTraces.forEach((mt, index) => {
                if (mt.graphicData != null && mt.graphicData.length > 0) {
                    //console.log("metric trace: ",mt);
                    const graphicData = mt.graphicData[0];
                    //console.log(graphicData);
                    switch (graphConfig.type) {
                        //line
                        case 'LINE':
                        case 'BAR':
                        case 'BUBBLE':
                            //gli array sono già ordinati
                            if (mt.graphicData.length == 1) {
                                if (result.x.length == 0) {
                                    result.x = cloneDeep(graphicData.x);
                                    result.y = cloneDeep(graphicData.y);
                                    if (graphConfig.type == 'BUBBLE' && graphicData.marker != null) {
                                        result.size = cloneDeep(graphicData.marker.size);
                                    }
                                }
                                else {
                                    //in caso di elementi comuni nei due array x, aggiorno result applicando la funzione indicata
                                    //in caso di nuovo elemento lo aggiungo e poi riordino sulla base dei valori della x 
                                    this.updateResult(graphicData, result, func, graphConfig);
                                }
                            }
                            //aggregazione o filtering 
                            else {
                                result.x = [];
                                result.y = [];
                                mt.graphicData.forEach((gd) => {
                                    let filteringName = gd.name.replace(/.* -/gm, traceTitle);
                                    //init array
                                    if (result['x' + filteringName] == null) {
                                        result['x' + filteringName] = new Array();
                                        result['y' + filteringName] = new Array();
                                        result['size' + filteringName] = new Array();
                                        //result.titles = new Array<any>();
                                    }
                                    if (result['x' + filteringName].length == 0) {
                                        result['x' + filteringName] = cloneDeep(gd.x);
                                        result['y' + filteringName] = cloneDeep(gd.y);
                                        if (graphConfig.type == 'BUBBLE' && gd.marker != null) {
                                            result['size' + filteringName] = cloneDeep(gd.marker.size);
                                        }
                                        result.titles.push(filteringName);
                                    }
                                    else {
                                        console.log('update result:', result);
                                        this.updateResult(gd, result, func, graphConfig, filteringName);
                                    }
                                });
                                console.log("result: ", result);
                            }
                            break;
                        //radar
                        case 'RADAR':
                            //theta ed r
                            //gli array sono già ordinati
                            if (result.theta.length == 0) {
                                result.theta = cloneDeep(graphicData.theta);
                                result.r = cloneDeep(graphicData.r);
                            }
                            else {
                                //in caso di elementi comuni nei due array x, aggiorno result applicando la funzione indicata
                                //in caso di nuovo elemento lo aggiungo e poi riordino sulla base dei valori della x 
                                this.updateResult(graphicData, result, func, graphConfig);
                            }
                            break;
                        //pie
                        case 'PIE':
                            //labels, values
                            //gli array sono già ordinati
                            if (result.labels.length == 0) {
                                result.labels = this.updateLabels(graphicData.labels, graphicData.name, traceTitle);
                                //result.labels = cloneDeep(graphicData.labels);
                                result.values = cloneDeep(graphicData.values);
                            }
                            else {
                                if (graphicData != null) {
                                    graphicData.labels = this.updateLabels(graphicData.labels, graphicData.name, traceTitle);
                                }
                                //in caso di elementi comuni nei due array x, aggiorno result applicando la funzione indicata
                                //in caso di nuovo elemento lo aggiungo e poi riordino sulla base dei valori della x 
                                this.updateResult(graphicData, result, func, graphConfig);
                            }
                            break;
                        //indicator
                        case 'INDICATOR':
                            //value
                            if (index == 0) {
                                result.value = graphicData.value;
                            }
                            else {
                                //le funzioni saranno applicate solo in caso di risultati diversi da not a number
                                if (!isNaN(result.value)) {
                                    let appliedFunc;
                                    if (func == '%') {
                                        appliedFunc = result.value + '/' + graphicData.value + '*100';
                                        result.numericUnit = '%';
                                    }
                                    //workaround for formula like '(firstFactor- secondFactor)/secondFactor*100
                                    //planned for two istat charts
                                    else if (func == '-%') {
                                        appliedFunc = '(' + result.value + '-' + graphicData.value + ')/' + graphicData.value + '*100';
                                        result.numericUnit = '%';
                                    }
                                    else {
                                        appliedFunc = result.value + func + graphicData.value;
                                    }
                                    /* if(func =='-%'){
                                      appliedFunc = '('+result.value +'-'+graphicData.value+')/'+graphicData.value+'*100';
                                    } */
                                    result.value = GraphicUtil.executeFunction(appliedFunc);
                                    //console.log(result.value);
                                }
                            }
                            break;
                        //table
                        case 'TABLE':
                            if (result.tableElement.length == 0) {
                                mt.graphicData.forEach((gd) => {
                                    const varName = gd["colHeader"];
                                    let obj = { "rowHeader": gd["rowHeader"], rowHeaderUnit: null, "colHeader": traceTitle };
                                    obj[traceTitle] = gd[varName];
                                    result.tableElement.push(obj);
                                });
                            }
                            else {
                                mt.graphicData.forEach((gd, i) => {
                                    const foundElementAlreadyPresent = result.tableElement.findIndex((te) => te.rowHeader == gd.rowHeader);
                                    if (foundElementAlreadyPresent >= 0) {
                                        const varName = gd.colHeader;
                                        const varNameResult = result.tableElement[foundElementAlreadyPresent].colHeader;
                                        let appliedFunc;
                                        if (func == '%') {
                                            appliedFunc = result.tableElement[foundElementAlreadyPresent][varNameResult] + '/' + gd[varName] + '*100';
                                        }
                                        else {
                                            appliedFunc = result.tableElement[foundElementAlreadyPresent][varNameResult] + func + gd[varName];
                                        }
                                        //console.log("updating:",varNameResult," with ",varName, " function: ",appliedFunc);
                                        let res = GraphicUtil.executeFunction(appliedFunc);
                                        result.tableElement[foundElementAlreadyPresent][varNameResult] = res;
                                        result.tableElement[foundElementAlreadyPresent].numericUnit = '%';
                                    }
                                    else {
                                        const varName = gd["colHeader"];
                                        let obj = { "rowHeader": gd.rowHeader, rowHeaderUnit: null, "colHeader": traceTitle };
                                        obj[traceTitle] = gd[varName];
                                        result.tableElement.push(obj);
                                    }
                                });
                            }
                            //console.log(result.tableElement);
                            break;
                        case 'HEATMAP':
                            if (result.tableElement.length == 0) {
                                mt.graphicData.forEach((gd) => {
                                    const varName = gd["colHeader"];
                                    let obj = { "rowHeader": gd["rowHeader"], rowHeaderUnit: null, "colHeader": traceTitle, "colArea": gd["colArea"] };
                                    obj[traceTitle] = gd[varName];
                                    result.tableElement.push(obj);
                                });
                            }
                            else {
                                mt.graphicData.forEach((gd, i) => {
                                    const foundElementAlreadyPresent = result.tableElement.findIndex((te) => te.rowHeader == gd.rowHeader);
                                    if (foundElementAlreadyPresent >= 0) {
                                        const varName = gd.colHeader;
                                        const varNameResult = result.tableElement[foundElementAlreadyPresent].colHeader;
                                        let appliedFunc;
                                        if (func == '%') {
                                            appliedFunc = result.tableElement[foundElementAlreadyPresent][varNameResult] + '/' + gd[varName] + '*100';
                                        }
                                        else {
                                            appliedFunc = result.tableElement[foundElementAlreadyPresent][varNameResult] + func + gd[varName];
                                        }
                                        //console.log("updating:",varNameResult," with ",varName, " function: ",appliedFunc);
                                        let res = GraphicUtil.executeFunction(appliedFunc);
                                        result.tableElement[foundElementAlreadyPresent][varNameResult] = res;
                                        result.tableElement[foundElementAlreadyPresent].numericUnit = '%';
                                    }
                                    else {
                                        const varName = gd["colHeader"];
                                        let obj = { "rowHeader": gd.rowHeader, rowHeaderUnit: null, "colHeader": traceTitle, "colArea": gd["colArea"] };
                                        obj[traceTitle] = gd[varName];
                                        result.tableElement.push(obj);
                                    }
                                });
                            }
                            //console.log(result.tableElement);
                            break;
                        case 'FUNNEL':
                            //gli array sono già ordinati
                            if (mt.graphicData.length == 1) {
                                if (result.x.length == 0) {
                                    result.x = cloneDeep(graphicData.x);
                                    result.y = cloneDeep(graphicData.y);
                                }
                                else {
                                    //in caso di elementi comuni nei due array x, aggiorno result applicando la funzione indicata
                                    //in caso di nuovo elemento lo aggiungo e poi riordino sulla base dei valori della x 
                                    this.updateResult(graphicData, result, func, graphConfig);
                                }
                            }
                            //aggregazione o filtering 
                            else {
                                result.x = [];
                                result.y = [];
                                mt.graphicData.forEach((gd) => {
                                    let filteringName = gd.name.replace(/.* -/gm, traceTitle);
                                    //init array
                                    if (result['x' + filteringName] == null) {
                                        result['x' + filteringName] = new Array();
                                        result['y' + filteringName] = new Array();
                                        //result.titles = new Array<any>();
                                    }
                                    if (result['x' + filteringName].length == 0) {
                                        result['x' + filteringName] = cloneDeep(gd.x);
                                        result['y' + filteringName] = cloneDeep(gd.y);
                                        result.titles.push(filteringName);
                                    }
                                    else {
                                        this.updateResult(gd, result, func, graphConfig, filteringName);
                                    }
                                });
                                console.log("result: ", result);
                            }
                            break;
                    }
                }
            });
            //valorizzazione nuovo trace
            switch (graphConfig.type) {
                //line
                case 'LINE':
                case 'BAR':
                case 'BUBBLE':
                    //simple line
                    if (result.x != null) {
                        //TODO in caso di bubble l'ordinamento deve portarsi anche lo zvalues
                        GraphicUtil.sort(result.x, result.y, 'ASC', true, result.size);
                        let t = new Trace(traceTitle, result.x, result.y, null, null, null, null, null, null, null, null, null, null, null, result.size);
                        if (graphConfig.type == 'LINE') {
                            trace.graphicData = [new Line().buildGraphicTraceList(t, this.translateService)];
                        }
                        else if (graphConfig.type == 'BAR') {
                            trace.graphicData = [new Bar().buildGraphicTraceList(t, this.translateService)];
                        }
                        else {
                            trace.graphicData = [new Bubble().buildGraphicTraceList(t, this.translateService)];
                        }
                    }
                    //aggregated line
                    else {
                        if (result.titles != null) {
                            result.titles.forEach((t, index) => {
                                GraphicUtil.sort(result['x' + t], result['y' + t], 'ASC', true, result['size' + t]);
                                let tr = new Trace(t, result['x' + t], result['y' + t], null, null, null, null, null, null, null, null, null, null, null, result['size' + t]);
                                trace.graphicData[index] = [new Bubble().buildGraphicTraceList(tr, this.translateService)];
                            });
                        }
                    }
                    //trace.graphicLayout.title = title;
                    break;
                //radar
                case 'RADAR':
                    //theta ed r
                    let radarTrace = new Trace(traceTitle, result.theta, result.r);
                    trace.graphicData = [new Radar().buildGraphicTraceList(radarTrace, this.translateService)];
                    break;
                //pie
                case 'PIE':
                    //labels, values
                    //value
                    let t = new Trace(traceTitle, result.labels, result.values);
                    trace.graphicData = [new Pie().buildGraphicTraceList(t, this.translateService)];
                    //aggiornamento eventuale griglia
                    if (trace.graphicLayout != null && trace.graphicLayout.grid != null) {
                        trace.graphicLayout.grid.rows = 1;
                        trace.graphicLayout.grid.columns = totalTrace + 1;
                        //per il momento è gestito lo spostamento solo in base alla colonna
                        if (trace.graphicData[0].domain != null) {
                            trace.graphicData[0].domain.column = totalTrace;
                        }
                    }
                    break;
                //indicator
                case 'INDICATOR':
                    //value
                    if (!isNaN(result.value)) {
                        trace.graphicData[0].value = Number(result.value).toFixed(2);
                        if (result.numericUnit == '%') {
                            trace.graphicData[0].number.suffix = '%';
                        }
                    }
                    if (trace && trace.graphicData && trace.graphicData.length > 0) {
                        trace.graphicData[0].title.text = traceTitle ? traceTitle : '';
                    }
                    //aggiornamento eventuale griglia
                    if (trace.graphicLayout != null && trace.graphicLayout.grid != null) {
                        trace.graphicLayout.grid.rows = totalTrace + 1;
                        trace.graphicLayout.grid.columns = totalTrace + 1;
                        //per il momento è gestito lo spostamento solo in base alla colonna
                        if (trace.graphicData[0].domain != null) {
                            trace.graphicData[0].domain.column = totalTrace;
                        }
                    }
                    break;
                case 'TABLE':
                case 'HEATMAP':
                    //GraphicUtil.sortObjectsListByField(result.tableElement, 'rowHeader', 'DESC');
                    trace.graphicData = result.tableElement;
                    break;
                case 'FUNNEL':
                    //simple line
                    if (result.y != null) {
                        GraphicUtil.sort(result.y, result.x, 'DESC');
                        let traceFunnel = new Trace(traceTitle, result.y, result.x);
                        trace.graphicData = [new Funnel().buildGraphicTraceList(traceFunnel, this.translateService)];
                    }
                    //aggregated line
                    else {
                        if (result.titles != null) {
                            const color = GraphicUtil.random_rgba();
                            result.titles.forEach((t, index) => {
                                GraphicUtil.sort(result['y' + t], result['x' + t], 'DESC');
                                let traceFunnel = new Trace(t, result['y' + t], result['x' + t]);
                                trace.graphicData = [new Funnel().buildGraphicTraceList(traceFunnel, this.translateService)];
                            });
                        }
                    }
                    //trace.graphicLayout.title = title;
                    break;
            }
        }
        return trace;
    }
    updateLabels(labels, name, traceTitle) {
        let ret = new Array();
        if (labels == null || labels.length == 0) {
            return ret;
        }
        labels.forEach((lab) => {
            const newLabel = lab.replace(name, traceTitle);
            ret.push(newLabel);
        });
        return ret;
    }
    updateResult(graphicData, result, func, gc, filteringName) {
        //line e bar
        if ((gc.type == 'BAR' || gc.type == 'LINE' || gc.type == 'BUBBLE') && graphicData.x != null) {
            graphicData.x.forEach((el, i) => {
                let foundElementAlreadyPresent;
                if (filteringName != null) {
                    foundElementAlreadyPresent = result['x' + filteringName].findIndex((ele) => ele == el);
                }
                else {
                    foundElementAlreadyPresent = result.x.findIndex((ele) => ele == el);
                }
                if (foundElementAlreadyPresent >= 0) {
                    let appliedFuncY;
                    let appliedFuncZ;
                    if (filteringName != null) {
                        appliedFuncY = this.buildFunctionBasedOnGraphicType(gc.type, result['y' + filteringName][foundElementAlreadyPresent], graphicData.y[i], func);
                        if (result['size' + filteringName] != null && result['size' + filteringName].length) {
                            appliedFuncZ = this.buildFunctionBasedOnGraphicType(gc.type, result['size' + filteringName][foundElementAlreadyPresent], graphicData.marker.size[i], func);
                        }
                    }
                    else {
                        appliedFuncY = this.buildFunctionBasedOnGraphicType(gc.type, result.y[foundElementAlreadyPresent], graphicData.y[i], func);
                        if (result.size != null && result.size.length > 0) {
                            appliedFuncZ = this.buildFunctionBasedOnGraphicType(gc.type, result.size[foundElementAlreadyPresent], graphicData.marker.size[i], func);
                        }
                    }
                    //console.log("updating:",el," ",graphicData.y[i], " function: ",appliedFunc);
                    let resY = GraphicUtil.executeFunction(appliedFuncY);
                    let resZ;
                    if (appliedFuncZ) {
                        resZ = GraphicUtil.executeFunction(appliedFuncZ);
                    }
                    if (!isNaN(resY)) {
                        if (filteringName != null) {
                            result['y' + filteringName][foundElementAlreadyPresent] = Number(Math.round(Number(resY) * 100) / 100);
                        }
                        else {
                            result.y[foundElementAlreadyPresent] = Number(Math.round(Number(resY) * 100) / 100);
                        }
                    }
                    if (resZ != undefined && !isNaN(resZ)) {
                        if (filteringName != null) {
                            result['size' + filteringName][foundElementAlreadyPresent] = Number(Math.round(Number(resZ) * 100) / 100);
                        }
                        else {
                            result.size[foundElementAlreadyPresent] = Number(Math.round(Number(resZ) * 100) / 100);
                        }
                    }
                }
                else {
                    //console.log("adding:",el," ",graphicData.y[i]);
                    //da ordinare sulla base dei valori di x in seguito
                    if (filteringName != null) {
                        result['x' + filteringName].push(el);
                        result['y' + filteringName].push(graphicData.y[i]);
                        if (graphicData.marker != null && graphicData.marker.size != null) {
                            result['size' + filteringName].push(graphicData.marker.size[i]);
                        }
                    }
                    else {
                        result.x.push(el);
                        result.y.push(graphicData.y[i]);
                        if (graphicData.marker != null && graphicData.marker.size != null) {
                            result.size.push(graphicData.marker.size[i]);
                        }
                    }
                }
            });
        }
        //pie
        else if (gc.type == 'PIE' && graphicData.labels != null) {
            graphicData.labels.forEach((el, i) => {
                const foundElementAlreadyPresent = result.labels.findIndex((ele) => ele == el);
                if (foundElementAlreadyPresent >= 0) {
                    let appliedFunc = this.buildFunctionBasedOnGraphicType(gc.type, result.values[foundElementAlreadyPresent], graphicData.values[i], func);
                    //console.log("updating:",el," ",graphicData.y[i], " function: ",appliedFunc);
                    let res = GraphicUtil.executeFunction(appliedFunc);
                    if (!isNaN(res)) {
                        result.values[foundElementAlreadyPresent] = Number(Math.round(Number(res) * 100) / 100);
                    }
                }
                else {
                    //console.log("adding:",el," ",graphicData.y[i]);
                    //da ordinare sulla base dei valori di x in seguito
                    result.labels.push(el);
                    result.values.push(graphicData.values[i]);
                }
            });
        }
        //radar
        else if (gc.type == 'RADAR' && graphicData.theta != null) {
            graphicData.theta.forEach((el, i) => {
                const foundElementAlreadyPresent = result.theta.findIndex((ele) => ele == el);
                if (foundElementAlreadyPresent >= 0) {
                    let appliedFunc = this.buildFunctionBasedOnGraphicType(gc.type, result.r[foundElementAlreadyPresent], graphicData.r[i], func);
                    //console.log("updating:",el," ",graphicData.y[i], " function: ",appliedFunc);
                    let res = GraphicUtil.executeFunction(appliedFunc);
                    // if (!res.isNaN) {
                    if (!isNaN(res)) {
                        result.r[foundElementAlreadyPresent] = Number(Math.round(Number(res) * 100) / 100);
                    }
                }
                else {
                    //console.log("adding:",el," ",graphicData.y[i]);
                    //da ordinare sulla base dei valori di x in seguito
                    result.theta.push(el);
                    result.r.push(graphicData.r[i]);
                }
            });
        }
        else if (gc.type == 'FUNNEL' && graphicData.y != null) {
            graphicData.y.forEach((el, i) => {
                let foundElementAlreadyPresent;
                if (filteringName != null) {
                    foundElementAlreadyPresent = result['y' + filteringName].findIndex((ele) => ele == el);
                }
                else {
                    foundElementAlreadyPresent = result.y.findIndex((ele) => ele == el);
                }
                if (foundElementAlreadyPresent >= 0) {
                    let appliedFunc;
                    if (filteringName != null) {
                        appliedFunc = this.buildFunctionBasedOnGraphicType(gc.type, result['x' + filteringName][foundElementAlreadyPresent], graphicData.x[i], func);
                    }
                    else {
                        appliedFunc = this.buildFunctionBasedOnGraphicType(gc.type, result.x[foundElementAlreadyPresent], graphicData.x[i], func);
                    }
                    //console.log("updating:",el," ",graphicData.y[i], " function: ",appliedFunc);
                    let res = GraphicUtil.executeFunction(appliedFunc);
                    if (!isNaN(res)) {
                        if (filteringName != null) {
                            result['x' + filteringName][foundElementAlreadyPresent] = Number(Math.round(Number(res) * 100) / 100);
                        }
                        else {
                            result.x[foundElementAlreadyPresent] = Number(Math.round(Number(res) * 100) / 100);
                        }
                    }
                }
                else {
                    //console.log("adding:",el," ",graphicData.y[i]);
                    //da ordinare sulla base dei valori di x in seguito
                    if (filteringName != null) {
                        result['y' + filteringName].push(el);
                        result['x' + filteringName].push(graphicData.x[i]);
                    }
                    else {
                        result.y.push(el);
                        result.x.push(graphicData.x[i]);
                    }
                }
            });
        }
    }
    buildFunctionBasedOnGraphicType(type, firstFactor, secondFactor, func) {
        let appliedFunc;
        if ((type == 'BAR' || type == 'LINE' || type == 'BUBBLE')) {
            if (func == '%') {
                appliedFunc = firstFactor + '/' + secondFactor + '*100';
            }
            else {
                appliedFunc = firstFactor + func + secondFactor;
            }
        }
        else if (type == 'PIE') {
            if (func == '%') {
                appliedFunc = firstFactor + '/' + secondFactor + '*100';
            }
            else {
                appliedFunc = firstFactor + func + secondFactor;
            }
        }
        else if (type == 'RADAR') {
            if (func == '%') {
                appliedFunc = firstFactor + '/' + secondFactor + '*100';
            }
            else {
                appliedFunc = firstFactor + func + secondFactor;
            }
        }
        else if (type == 'FUNNEL') {
            if (func == '%') {
                appliedFunc = firstFactor + '/' + secondFactor + '*100';
            }
            else {
                appliedFunc = firstFactor + func + secondFactor;
            }
        }
        return appliedFunc;
    }
    updateSingleGraph(graphConfig) {
        return new Promise((resolve, reject) => {
            console.log("update single graph config method");
            if (!graphConfig.requestFilterDates) {
                graphConfig.startDate = this.startFilteringDate;
                graphConfig.endDate = this.endFilteringDate;
            }
            //console.log(gcList);
            let obj = {
                graphConfigs: []
            };
            obj.graphConfigs.push(graphConfig);
            let cardContainer = this.graphicCardContainers[graphConfig.id];
            //grafico appena salvato
            if (cardContainer == null) {
                cardContainer = this.graphicCardContainers[graphConfig.graphConfigId];
                cardContainer.id = graphConfig.id;
                cardContainer.graphConfigId = graphConfig.graphConfigId;
                if (graphConfig.helpKey != null) {
                    cardContainer.helpKey = graphConfig.helpKey;
                }
            }
            cardContainer.loaderVisible = true;
            if (cardContainer == null) {
                resolve(true);
            }
            this.dashboardService.getChartsData(obj).subscribe(async (res) => {
                let allGraphicConfigValues = res.payload;
                //console.log("all graphic values: ", allGraphicConfigValues);
                cardContainer.title = graphConfig.title;
                cardContainer.helpTitle = graphConfig.title;
                if (allGraphicConfigValues.length == 0) {
                    this.initEmptyGraphicCardContainer(obj.graphConfigs);
                }
                else {
                    this.initValuedGraphicCardContainer(obj.graphConfigs, allGraphicConfigValues, cardContainer);
                }
                cardContainer.loaderVisible = false;
                if (graphConfig.helpKey) {
                    cardContainer.helpKey = graphConfig.helpKey;
                }
                resolve(true);
            }, (error) => {
                //in caso di errore non faccio vedere alcun risultato e inserisco un messaggio di error nel log 
                this.initEmptyGraphicCardContainer(obj);
                console.log(error);
                reject(false);
            });
        });
    }
    addTrendLineToBarChart(graphConfig, graphic) {
        if (graphConfig.showTrendLineBarChart) {
            //console.log('bar:',graphic.graphicData);
            let xValues = new Array();
            let yValues = new Array();
            graphic.graphicData.forEach((gd) => {
                gd.x.forEach((xval, index) => {
                    const found = xValues.find((el) => el == xval);
                    if (found) {
                        if (gd.y[index] != null) {
                            yValues[index] = yValues[index] + gd.y[index];
                        }
                    }
                    else {
                        xValues.push(xval);
                        if (gd.y[index] != null) {
                            yValues.push(gd.y[index]);
                        }
                    }
                });
            });
            const t = new Trace('Andamento', xValues, yValues);
            //personalizzazione line
            t.mode = 'lines+markers';
            t.color = 'rgb(211, 84, 0)';
            let lineTrace = new Line().buildGraphicTraceList(t);
            lineTrace.line.width = 3;
            graphic.graphicData.push(lineTrace);
        }
    }
    //if the yaxis has dataaggregation the result array will be found based on dataaggregatekey
    //if the yaxis hasn't data aggreggation the result array will be found based on not presence of dataaggregatekey
    findCorrectChartValues(graphicConfigValues, yax) {
        let singleGraphicConfigValue = null;
        if (!yax.dataAggregate) {
            singleGraphicConfigValue = graphicConfigValues.find((el) => el.graphicInfo.tableName == yax.table);
        }
        else if (yax.dataAggregate && yax.dataAggregate.groupByFieldLabel) {
            singleGraphicConfigValue = graphicConfigValues.find((el) => el.graphicInfo.dataAggregate.groupByFieldLabel == yax.dataAggregate.groupByFieldLabel);
        }
        else {
            const aggregateKey = yax.table + "," + yax.value + "," + yax.id + "," + yax.idFieldName + "," + yax.dataAggregate.groupByField + "," +
                yax.dataAggregate.aggregationFunctionString?.toUpperCase();
            singleGraphicConfigValue = graphicConfigValues.find((el) => (el.graphicInfo.dataAggregate != null && el.graphicInfo.dataAggregateKey == aggregateKey));
        }
        return singleGraphicConfigValue;
    }
    updateGraphicsOld(gcList, update) {
        return new Promise((resolve, reject) => {
            gcList.forEach((graphConfig) => {
                if (!graphConfig.requestFilterDates) {
                    graphConfig.startDate = this.startFilteringDate;
                    graphConfig.endDate = this.endFilteringDate;
                }
            });
            //console.log(gcList);
            let obj = {};
            obj.graphConfigs = gcList;
            console.log(gcList);
            if (gcList && gcList.length > 0) {
                this.dashboardService.getChartsData(obj).subscribe((res) => {
                    let allGraphicConfigValues = res.payload;
                    console.log("all graphic values: ", allGraphicConfigValues);
                    gcList.forEach(graphConfig => {
                        allGraphicConfigValues.forEach(singleGraphicConfigValue => {
                            console.log("single graphic value: ", singleGraphicConfigValue);
                            if (!update || !graphConfig.requestFilterDates) {
                                if (singleGraphicConfigValue.graphicInfo.id == graphConfig.id) {
                                    let graphicValues = singleGraphicConfigValue.result;
                                    let graphic = GraphicFactory.createGraphic(graphConfig, graphicValues);
                                    let cardContainer = new CardContainerConfig(graphConfig.id, graphConfig.title, graphConfig.requestFilterDates ?? false, null, null, null, null, true); //hideShadowBorder a true permette di nascondere i bordi della matcard nel componente
                                    this.initGraphicCards(graphConfig, graphic, cardContainer);
                                    //this.plotlyData.push({ data: graphic.graphicData, layout: graphic.graphicLayout });
                                }
                            }
                        });
                    });
                    resolve(true);
                }, (error) => {
                    //this.hideLoader();
                    console.log(error);
                    reject(false);
                });
            }
            else {
                resolve(true);
            }
        });
    }
    initGraphicCards(graphConfig, graphic, cardContainer) {
        let graphicCard = {
            graphConfiguration: GraphicConfig,
            x: graphConfig.x ? graphConfig.x : 0,
            y: graphConfig.y ? graphConfig.y : 0,
            rows: graphConfig.rows ? graphConfig.rows : 4,
            cols: graphConfig.cols ? graphConfig.cols : 12,
            config: { responsive: true },
            layout: { title: graphConfig.title },
            cardContainerConfig: CardContainerConfig,
            isRequiredDateFields: graphConfig.requestFilterDates,
            dashboardCardPagedDataSource: null,
            graphic: {
                data: [],
                layout: {},
                config: {}
            },
            table: {
                headers: [],
                data: [],
                clickEventInfo: null
            }
        };
        graphicCard.graphConfiguration = graphConfig;
        graphicCard.cardContainerConfig = cardContainer;
        if (graphConfig.type != 'TABLE' && graphConfig.type != 'HEATMAP') {
            //console.log(graphic.graphicData)
            graphicCard.table = null;
            graphicCard.heatmap = null;
            if (graphic != null) {
                graphicCard.graphic = {
                    data: graphic.graphicData, layout: graphic.graphicLayout,
                    config: graphic.config, possibleMetrics: graphConfig.possibleMetrics,
                    possibleMultipleMetrics: graphConfig.multipleDatasourceMetrics != null ? this.multipleDatasourceMetricsList : null
                };
            }
        }
        else if (graphConfig.type == 'TABLE') {
            graphicCard.graphic = null;
            graphicCard.heatmap = null;
            if (graphic != null) {
                graphicCard.table = {
                    data: graphic.graphicData,
                    layout: graphic.graphicLayout,
                    clickEventInfo: graphic.clickEventInfo
                };
            }
        }
        //heatmap case
        else {
            graphicCard.graphic = null;
            graphicCard.table = null;
            if (graphic != null) {
                graphicCard.heatmap = {
                    data: graphic.graphicData,
                    layout: graphic.graphicLayout,
                    clickEventInfo: graphic.clickEventInfo
                };
            }
        }
        // graphicCard.config = { responsive: true }
        this.graphicCards.push(graphicCard);
        return graphicCard;
    }
    updateGraphicsBySelectorDate(filterDateFields) {
        return new Promise(async (res, rej) => {
            //console.log("sd:", filterDateFields.startDate, " ed: ", filterDateFields.endDate);
            this.startFilteringDate = filterDateFields.startDate;
            this.endFilteringDate = filterDateFields.endDate;
            this.graphConfigs.forEach(element => {
                if (!element.requestFilterDates) {
                    element.startDate = this.startFilteringDate;
                    element.endDate = this.endFilteringDate;
                }
            });
            this.graphicCards = this.graphicCards.filter(gc => {
                return gc.isRequiredDateFields;
            });
            //tabelle paginate
            let pagedTableChart = this.graphConfigs.filter((gc) => {
                return (gc.pageNumber != null && gc.pageSize != null);
            });
            //singola chiamata per ogni tabella 
            pagedTableChart.forEach(async (pt) => {
                await this.updatePagedGraphic(pt)
                    .catch(() => {
                    // this.hideLoader();
                })
                    .finally(() => {
                });
            });
            //tutti gli altri grafici
            let otherChart = this.graphConfigs.filter((gc) => {
                return (gc.pageNumber == null || gc.pageSize == null);
            });
            //this.showLoader();
            await this.updateGraphics(otherChart, true)
                .finally(() => {
                res(true);
            })
                .catch((er) => {
                rej(false);
            });
        });
    }
    async updateGraphicBySelectorDate(filterDateFields) {
        this.showLoader();
        await this.updateGraphic(filterDateFields);
        this.hideLoader();
    }
    updateGraphic(filterDateFields) {
        return new Promise((res, rej) => {
            console.log("update graphic method");
            let ccc = filterDateFields.cardContainerConfig;
            //console.log("update single graphic: "+ccc.id);
            //console.log("sd:", filterDateFields.startDate, " ed: ", filterDateFields.endDate);
            this.graphConfigs.forEach(graphConfig => {
                if (graphConfig.id == ccc.id) {
                    let p = { params: {} };
                    let array = new Array();
                    graphConfig.startDate = filterDateFields.startDate;
                    graphConfig.endDate = filterDateFields.endDate;
                    array.push(graphConfig);
                    const obj = {
                        graphConfigs: array
                    };
                    p.params['graphConfigs'] = encodeURIComponent(JSON.stringify(array));
                    if (array && array.length > 0) {
                        this.dashboardService.getChartsData(obj).subscribe((res) => {
                            let allGraphicConfigValues = res.payload;
                            let graphicConfigValues = allGraphicConfigValues.filter((el) => { return el.graphicInfo.id == graphConfig.id; });
                            let graphic = null;
                            if (graphicConfigValues != null && graphicConfigValues.length > 0) {
                                let singleGraphicConfigValue = null;
                                graphConfig.yaxis?.forEach((yax) => {
                                    singleGraphicConfigValue = this.findCorrectChartValues(graphicConfigValues, yax);
                                    //console.log("yax:",yax," values: ", singleGraphicConfigValue);
                                    if (singleGraphicConfigValue) {
                                        let graphicValues = singleGraphicConfigValue.result;
                                        graphic = GraphicFactory.createGraphic(graphConfig, graphicValues);
                                    }
                                    else {
                                        console.info("no data found for yaxis:", yax);
                                        graphic = GraphicFactory.createGraphic(graphConfig, null);
                                    }
                                });
                            }
                            else {
                                graphic = GraphicFactory.createGraphic(graphConfig, null);
                            }
                            //console.log(graphic);
                            let ccc = this.graphicCardContainers[graphConfig.id];
                            ccc.loaderVisible = false;
                            if (graphConfig.helpKey) {
                                ccc.helpKey = graphConfig.helpKey;
                            }
                            this._updateGraph(ccc, graphConfig, graphic);
                            /* allGraphicConfigValues.forEach(singleGraphicConfigValue => {
                              let graphicValues = singleGraphicConfigValue.result;
                              let graphic = GraphicFactory.createGraphic(graphConfig, graphicValues);
                              ccc.loaderVisible = true;
                              this._updateGraph(ccc, graphConfig, graphic);
                            }); */
                            //res(true);
                        }, (error) => {
                            console.error(error);
                            this.graphConfigs.forEach(graphConfig => {
                                let ccc = this.graphicCardContainers[graphConfig.id];
                                ccc.loaderVisible = false;
                                if (graphConfig.helpKey) {
                                    ccc.helpKey = graphConfig.helpKey;
                                }
                                let graphic = GraphicFactory.createGraphic(graphConfig, null);
                                this._updateGraph(ccc, graphConfig, graphic);
                            });
                            //rej(false);
                        });
                    }
                }
            });
        });
    }
    _updateGraph(cardContainerConfig, graphConfig, graphic) {
        let graphicCardIndex = this.graphicCards.findIndex((gc) => {
            return gc.cardContainerConfig.id == cardContainerConfig.id;
        });
        if (graphicCardIndex >= 0) {
            let graphicCard = this.graphicCards[graphicCardIndex];
            if (graphConfig.type != 'TABLE' && graphConfig.type != 'HEATMAP') {
                //console.log(graphic.graphicData)
                graphicCard.table = null;
                graphicCard.heatmap = null;
                graphicCard.graphic = {
                    data: graphic.graphicData, layout: graphic.graphicLayout,
                    config: { responsive: true }, possibleMetrics: graphConfig.possibleMetrics,
                    possibleMultipleMetrics: graphConfig.multipleDatasourceMetrics != null ? this.multipleDatasourceMetricsList : null
                };
            }
            else if (graphConfig.type == 'TABLE') {
                graphicCard.graphic = null;
                graphicCard.heatmap = null;
                graphicCard.table = { data: graphic.graphicData, layout: graphic.graphicLayout, clickEventInfo: graphic.clickEventInfo, };
            }
            //heatmap case
            else {
                graphicCard.graphic = null;
                graphicCard.table = null;
                graphicCard.heatmap = { data: graphic.graphicData, layout: graphic.graphicLayout, clickEventInfo: graphic.clickEventInfo, };
            }
            this.graphicCards.splice(graphicCardIndex, 1, graphicCard);
        }
    }
    getRemoteData(graphicConfig, force) {
        let array = new Array();
        array.push(graphicConfig);
        const obj = {
            graphConfigs: array
        };
        return this.dashboardService.getChartsData(obj, force);
    }
    getRemoteMultiData(confs) {
        let p = { params: {} };
        let array = new Array();
        confs.forEach((el) => {
            array.push(el.graphicConfig);
        });
        // array.push(graphicConfig);
        const obj = {
            graphConfigs: array
        };
        p.params['graphConfigs'] = encodeURIComponent(JSON.stringify(array));
        return this.dashboardService.getChartsData(obj);
    }
    getGraphicCard(graphicConfig, cardContainer, timeout) {
        return new Promise((resolve, reject) => {
            if (!timeout)
                timeout = 0;
            setTimeout(() => {
                let p = { params: {} };
                let array = new Array();
                console.log("graphic card graphic config:" + graphicConfig);
                array.push(graphicConfig);
                const obj = {
                    graphConfigs: array
                };
                //console.log(graphicConfig);
                p.params['graphConfigs'] = encodeURIComponent(JSON.stringify(array));
                if (array && array.length > 0) {
                    this.dashboardService.getChartsData(obj).subscribe((res) => {
                        let allGraphicConfigValues = res.payload;
                        let allGraphicsValuesMap = {};
                        let toGraph = false;
                        for (const singleGraphicConfigValue of allGraphicConfigValues) {
                            if (singleGraphicConfigValue.result) {
                                allGraphicsValuesMap[singleGraphicConfigValue.graphicInfo.tableName] = singleGraphicConfigValue.result;
                                toGraph = true;
                            }
                        }
                        if (toGraph) {
                            let graphic = GraphicFactory.createGraphicObj(graphicConfig, allGraphicsValuesMap, this.translateService);
                            let graphicCard = this.initGraphicCards(graphicConfig, graphic, cardContainer);
                            if (graphicConfig.type != 'TABLE' && graphicConfig.type != 'HEATMAP') {
                                //console.log(graphic.graphicData)
                                graphicCard.table = null;
                                graphicCard.heatmap = null;
                                graphicCard.graphic = {
                                    data: graphic.graphicData, layout: graphic.graphicLayout,
                                    config: { responsive: true }, possibleMetrics: graphicConfig.possibleMetrics
                                };
                            }
                            else if (graphicConfig.type == 'TABLE') {
                                graphicCard.graphic = null;
                                graphicCard.heatmap = null;
                                graphicCard.table = { data: graphic.graphicData, layout: graphic.graphicLayout, clickEventInfo: graphic.clickEventInfo, options: graphic.graphicOptions };
                            }
                            //heatmap case
                            else {
                                graphicCard.graphic = null;
                                graphicCard.table = null;
                                graphicCard.heatmap = { data: graphic.graphicData, layout: graphic.graphicLayout, clickEventInfo: graphic.clickEventInfo, options: graphic.graphicOptions };
                            }
                            if (graphicConfig.statusMapping) {
                                graphicCard.cardContainerConfig.statusMapping = graphicConfig.statusMapping;
                            }
                            resolve(graphicCard);
                        }
                        else {
                            let graphic = GraphicFactory.createGraphicObj(graphicConfig, null);
                            let graphicCard = this.initGraphicCards(graphicConfig, graphic, cardContainer);
                            graphicCard.cardContainerConfig.loaderVisible = false;
                            resolve(graphicCard);
                        }
                    }, (error) => {
                        console.error(error);
                        reject(null);
                    });
                }
            }, timeout);
        });
    }
    getGraphicMultipleCard(confs, timeout, rawDataFunction) {
        return new Promise((resolve, reject) => {
            if (!timeout)
                timeout = 0;
            setTimeout(() => {
                let p = { params: {} };
                let array = new Array();
                // console.log("graphic card graphic config:", confs);
                confs.forEach((el) => {
                    array.push(el.graphicConfig);
                });
                const obj = {
                    graphConfigs: array
                };
                //console.log(graphicConfig);
                p.params['graphConfigs'] = encodeURIComponent(JSON.stringify(array));
                if (array && array.length > 0) {
                    this.dashboardService.getChartsData(obj).subscribe((res) => {
                        let allGraphicConfigValues = res.payload;
                        if (rawDataFunction)
                            rawDataFunction(cloneDeep(allGraphicConfigValues));
                        //console.log(allGraphicConfigValues);
                        let allGraphicsValuesMap = {};
                        let toGraph = false;
                        for (const singleGraphicConfigValue of allGraphicConfigValues) {
                            if (singleGraphicConfigValue.result) {
                                allGraphicsValuesMap[singleGraphicConfigValue.graphicInfo.tableName] = singleGraphicConfigValue.result;
                                toGraph = true;
                            }
                        }
                        let graphicCards = [];
                        if (toGraph) {
                            confs.forEach((el) => {
                                el.graphicConfig.id;
                                allGraphicConfigValues[0].graphicInfo.id;
                                let allGraphicsValuesMapPartial = {};
                                for (const it of allGraphicConfigValues) {
                                    if (it.graphicInfo.id == el.graphicConfig.id)
                                        allGraphicsValuesMapPartial[it.graphicInfo.tableName] = it.result;
                                }
                                let graphic = GraphicFactory.createGraphicObj(el.graphicConfig, allGraphicsValuesMapPartial);
                                let graphicCard = this.initGraphicCards(el.graphicConfig, graphic, el.cardContainer);
                                if (el.graphicConfig.type != 'TABLE' && el.graphicConfig.type != 'HEATMAP') {
                                    //console.log(graphic.graphicData)
                                    graphicCard.table = null;
                                    graphicCard.heatmap = null;
                                    graphicCard.graphic = {
                                        data: graphic.graphicData, layout: graphic.graphicLayout,
                                        config: { responsive: true }, possibleMetrics: el.graphicConfig.possibleMetrics
                                    };
                                }
                                else if (el.graphicConfig.type == 'TABLE') {
                                    graphicCard.graphic = null;
                                    graphicCard.heatmap = null;
                                    graphicCard.table = { data: graphic.graphicData, layout: graphic.graphicLayout, clickEventInfo: graphic.clickEventInfo, options: graphic.graphicOptions };
                                }
                                //heatmap case
                                else {
                                    graphicCard.graphic = null;
                                    graphicCard.table = null;
                                    graphicCard.heatmap = { data: graphic.graphicData, layout: graphic.graphicLayout, clickEventInfo: graphic.clickEventInfo, options: graphic.graphicOptions };
                                }
                                if (el.graphicConfig.statusMapping) {
                                    graphicCard.cardContainerConfig.statusMapping = el.graphicConfig.statusMapping;
                                }
                                graphicCards.push(graphicCard);
                            });
                            resolve(graphicCards);
                        }
                        else {
                            confs.forEach(conf => {
                                const graphConfig = conf.graphicConfig;
                                conf.cardContainer.loaderVisible = false;
                                let graphic = GraphicFactory.createGraphic(graphConfig, null);
                                let graphicCard = this.initGraphicCards(conf.graphicConfig, graphic, conf.cardContainer);
                                graphicCards.push(graphicCard);
                            });
                            resolve(graphicCards);
                        }
                    }, (error) => {
                        console.error(error);
                        let graphicCards = [];
                        confs.forEach(conf => {
                            const graphConfig = conf.graphicConfig;
                            conf.cardContainer.loaderVisible = false;
                            let graphic = GraphicFactory.createGraphic(graphConfig, null);
                            let graphicCard = this.initGraphicCards(conf.graphicConfig, graphic, conf.cardContainer);
                            graphicCards.push(graphicCard);
                        });
                        resolve(graphicCards);
                    });
                }
            }, timeout);
        });
    }
    updateGraphicMetric(graphConfig, translateService) {
        //console.log('updateGraphicMetric')
        return new Promise((resolve, reject) => {
            //console.log("update single graphic: "+ccc.id);
            //console.log("sd:", filterDateFields.startDate, " ed: ", filterDateFields.endDate);
            let p = { params: {} };
            let array = new Array();
            array.push(graphConfig);
            const obj = {
                graphConfigs: array
            };
            console.log("update graphic metric method");
            p.params['graphConfigs'] = encodeURIComponent(JSON.stringify(array));
            if (array && array.length > 0) {
                this.dashboardService.getChartsData(obj).subscribe((res) => {
                    let allGraphicConfigValues = res.payload;
                    console.log("all values:", allGraphicConfigValues);
                    let graphicConfigValues = allGraphicConfigValues.filter((el) => { return el.graphicInfo.id == graphConfig.id; });
                    let graphic = null;
                    if (graphicConfigValues != null && graphicConfigValues.length > 0) {
                        let singleGraphicConfigValue = null;
                        graphConfig.yaxis?.forEach((yax) => {
                            singleGraphicConfigValue = this.findCorrectChartValues(graphicConfigValues, yax);
                            //console.log("yax:",yax," values: ", singleGraphicConfigValue);
                            if (singleGraphicConfigValue) {
                                let graphicValues = singleGraphicConfigValue.result;
                                graphic = GraphicFactory.createGraphic(graphConfig, graphicValues, translateService);
                                let graphicCardIndex = this.graphicCards.findIndex((gc) => {
                                    return gc.cardContainerConfig.id == graphConfig.id;
                                });
                                let graphicCard = this.graphicCards[graphicCardIndex];
                                if (graphConfig.type != 'TABLE' && graphConfig.type != 'HEATMAP') {
                                    //console.log(graphic.graphicData)
                                    graphicCard.table = null;
                                    graphicCard.heatmap = null;
                                    //aggiornamento ticks asse y
                                    if (graphic.graphicLayout.yaxis) {
                                        if (graphicCard.graphic != null) {
                                            graphicCard.graphic.layout.yaxis = graphic.graphicLayout.yaxis;
                                        }
                                    }
                                    else {
                                        if (graphicCard.graphic != null) {
                                            delete graphicCard.graphic.layout.yaxis;
                                        }
                                    }
                                    graphicCard.graphic = {
                                        data: graphic.graphicData, layout: graphicCard.graphic.layout,
                                        config: { responsive: true }, possibleMetrics: graphConfig.possibleMetrics
                                    };
                                }
                                else if (graphConfig.type == 'TABLE') {
                                    graphicCard.graphic = null;
                                    graphicCard.heatmap = null;
                                    graphicCard.table = { data: graphic.graphicData, layout: graphic.graphicLayout, clickEventInfo: graphic.clickEventInfo, };
                                }
                                //heatmap case
                                else {
                                    graphicCard.graphic = null;
                                    graphicCard.table = null;
                                    graphicCard.heatmap = { data: graphic.graphicData, layout: graphic.graphicLayout, clickEventInfo: graphic.clickEventInfo, };
                                }
                                graphicCard.cardContainerConfig = this.graphicCards[graphicCardIndex].cardContainerConfig;
                                //forzo la scomparsa del loader
                                graphicCard.cardContainerConfig.loaderVisible = false;
                                this.graphicCards.splice(graphicCardIndex, 1, graphicCard);
                            }
                            else {
                                console.info("no data found for yaxis:", yax);
                                graphic = GraphicFactory.createGraphic(graphConfig, null);
                            }
                        });
                    }
                    resolve(true);
                }, (error) => {
                    console.error(error);
                    reject(false);
                });
            }
        });
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.9", ngImport: i0, type: BaseDashboardComponent, deps: [{ token: i1$1.MatDialog }, { token: i2.MatSnackBar }, { token: i0.Injector }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.9", type: BaseDashboardComponent, selector: "app-base-dashboard", usesInheritance: true, ngImport: i0, template: "<p>\n  base-dashboard works!\n</p>\n", styles: [""] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.9", ngImport: i0, type: BaseDashboardComponent, decorators: [{
            type: Component,
            args: [{ selector: 'app-base-dashboard', template: "<p>\n  base-dashboard works!\n</p>\n" }]
        }], ctorParameters: function () { return [{ type: i1$1.MatDialog }, { type: i2.MatSnackBar }, { type: i0.Injector }]; } });

class PlotlyService {
    static { this.instances = []; }
    static { this.plotly = undefined; }
    static setModuleName(moduleName) {
        PlotlyService.moduleName = moduleName;
    }
    static getModuleName() {
        return PlotlyService.moduleName;
    }
    static setPlotly(plotly) {
        if (typeof plotly === 'object' && typeof plotly.react !== 'function') {
            throw new Error('Invalid plotly.js version. Please, use any version above 1.40.0');
        }
        PlotlyService.plotly = plotly;
    }
    static insert(instance) {
        const index = PlotlyService.instances.indexOf(instance);
        if (index === -1) {
            PlotlyService.instances.push(instance);
        }
        return instance;
    }
    static remove(div) {
        const index = PlotlyService.instances.indexOf(div);
        if (index >= 0) {
            PlotlyService.instances.splice(index, 1);
            PlotlyService.plotly.purge(div);
        }
    }
    getInstanceByDivId(id) {
        for (const instance of PlotlyService.instances) {
            if (instance && instance.id === id) {
                return instance;
            }
        }
        return undefined;
    }
    async getPlotly() {
        await this.waitFor(() => this._getPlotly() !== 'waiting');
        return this._getPlotly();
    }
    _getPlotly() {
        if (typeof PlotlyService.plotly === 'undefined') {
            const msg = PlotlyService.moduleName === 'ViaCDN'
                ? `Error loading Peer dependency plotly.js from CDN url`
                : `Peer dependency plotly.js isn't installed`;
            throw new Error(msg);
        }
        return PlotlyService.plotly;
    }
    waitFor(fn) {
        return new Promise((resolve) => {
            const localFn = () => {
                fn() ? resolve() : setTimeout(localFn, 10);
            };
            localFn();
        });
    }
    // tslint:disable max-line-length
    async newPlot(div, data, layout, config, frames) {
        await this.waitFor(() => this._getPlotly() !== 'waiting');
        if (frames) {
            const obj = { data, layout, config, frames };
            return this._getPlotly().newPlot(div, obj).then(() => PlotlyService.insert(div));
        }
        return this._getPlotly().newPlot(div, data, layout, config).then(() => PlotlyService.insert(div));
    }
    plot(div, data, layout, config, frames) {
        if (frames) {
            const obj = { data, layout, config, frames };
            if (typeof (this._getPlotly().plot) === 'function') {
                return this._getPlotly().plot(div, obj);
            }
            else {
                // Adds support for Plotly 2.0.0 release candidates
                return this._getPlotly().newPlot(div, obj);
            }
        }
        if (typeof (this._getPlotly().plot) === 'function') {
            return this._getPlotly().plot(div, data, layout, config);
        }
        else {
            // Adds support for Plotly 2.0.0 release candidates
            return this._getPlotly().newPlot(div, data, layout, config);
        }
    }
    update(div, data, layout, config, frames) {
        if (frames) {
            const obj = { data, layout, config, frames };
            return this._getPlotly().react(div, obj);
        }
        return this._getPlotly().react(div, data, layout, config);
    }
    // tslint:enable max-line-length
    resize(div) {
        return this._getPlotly().Plots.resize(div);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.9", ngImport: i0, type: PlotlyService, deps: [], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "16.2.9", ngImport: i0, type: PlotlyService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.9", ngImport: i0, type: PlotlyService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }] });

// @dynamic
class PlotlyComponent {
    constructor(plotly, iterableDiffers, keyValueDiffers) {
        this.plotly = plotly;
        this.iterableDiffers = iterableDiffers;
        this.keyValueDiffers = keyValueDiffers;
        this.defaultClassName = 'js-plotly-plot';
        this.revision = 0;
        this.debug = false;
        this.useResizeHandler = false;
        this.updateOnLayoutChange = true;
        this.updateOnDataChange = true;
        this.updateOnlyWithRevision = false;
        this.initialized = new EventEmitter();
        this.update = new EventEmitter();
        this.purge = new EventEmitter();
        this.error = new EventEmitter();
        this.afterExport = new EventEmitter();
        this.afterPlot = new EventEmitter();
        this.animated = new EventEmitter();
        this.animatingFrame = new EventEmitter();
        this.animationInterrupted = new EventEmitter();
        this.autoSize = new EventEmitter();
        this.beforeExport = new EventEmitter();
        this.buttonClicked = new EventEmitter();
        this.click = new EventEmitter();
        this.plotlyClick = new EventEmitter();
        this.clickAnnotation = new EventEmitter();
        this.deselect = new EventEmitter();
        this.doubleClick = new EventEmitter();
        this.framework = new EventEmitter();
        this.hover = new EventEmitter();
        this.legendClick = new EventEmitter();
        this.legendDoubleClick = new EventEmitter();
        this.react = new EventEmitter();
        this.relayout = new EventEmitter();
        this.restyle = new EventEmitter();
        this.redraw = new EventEmitter();
        this.selected = new EventEmitter();
        this.selecting = new EventEmitter();
        this.sliderChange = new EventEmitter();
        this.sliderEnd = new EventEmitter();
        this.sliderStart = new EventEmitter();
        this.transitioning = new EventEmitter();
        this.transitionInterrupted = new EventEmitter();
        this.unhover = new EventEmitter();
        this.relayouting = new EventEmitter();
        this.treemapclick = new EventEmitter();
        this.sunburstclick = new EventEmitter();
        this.eventNames = ['afterExport', 'afterPlot', 'animated', 'animatingFrame', 'animationInterrupted', 'autoSize',
            'beforeExport', 'buttonClicked', 'clickAnnotation', 'deselect', 'doubleClick', 'framework', 'hover',
            'legendClick', 'legendDoubleClick', 'react', 'relayout', 'restyle', 'redraw', 'selected', 'selecting', 'sliderChange',
            'sliderEnd', 'sliderStart', 'transitioning', 'transitionInterrupted', 'unhover', 'relayouting', 'treemapclick',
            'sunburstclick'];
    }
    ngOnInit() {
        this.createPlot().then(() => {
            const figure = this.createFigure();
            this.initialized.emit(figure);
        });
        if (this.click.observers.length > 0) {
            const msg = 'DEPRECATED: Reconsider using `(plotlyClick)` instead of `(click)` to avoid event conflict. '
                + 'Please check https://github.com/plotly/angular-plotly.js#FAQ';
            console.error(msg);
        }
    }
    ngOnDestroy() {
        if (typeof this.resizeHandler === 'function') {
            this.getWindow().removeEventListener('resize', this.resizeHandler);
            this.resizeHandler = undefined;
        }
        const figure = this.createFigure();
        this.purge.emit(figure);
        PlotlyService.remove(this.plotlyInstance);
    }
    ngOnChanges(changes) {
        let shouldUpdate = false;
        const revision = changes['revision'];
        if (revision && !revision.isFirstChange()) {
            shouldUpdate = true;
        }
        const debug = changes['debug'];
        if (debug && !debug.isFirstChange()) {
            shouldUpdate = true;
        }
        if (shouldUpdate) {
            this.updatePlot();
        }
        this.updateWindowResizeHandler();
    }
    ngDoCheck() {
        if (this.updateOnlyWithRevision) {
            return false;
        }
        let shouldUpdate = false;
        if (this.updateOnLayoutChange) {
            if (this.layoutDiffer) {
                let m = new Map();
                for (const key in this.layout) {
                    if (Object.prototype.hasOwnProperty.call(this.layout, key)) {
                        m.set(key, this.layout[key]);
                    }
                }
                const layoutHasDiff = this.layoutDiffer.diff(m);
                if (layoutHasDiff) {
                    shouldUpdate = true;
                }
            }
            else if (this.layout) {
                this.layoutDiffer = this.keyValueDiffers.find(this.layout).create();
            }
            else {
                this.layoutDiffer = undefined;
            }
        }
        if (this.updateOnDataChange) {
            if (this.dataDiffer) {
                const dataHasDiff = this.dataDiffer.diff(this.data);
                if (dataHasDiff) {
                    shouldUpdate = true;
                }
            }
            else if (Array.isArray(this.data)) {
                this.dataDiffer = this.iterableDiffers.find(this.data).create(this.dataDifferTrackBy);
            }
            else {
                this.dataDiffer = undefined;
            }
        }
        if (shouldUpdate && this.plotlyInstance) {
            this.updatePlot();
        }
    }
    getWindow() {
        return window;
    }
    getClassName() {
        let classes = [this.defaultClassName];
        if (Array.isArray(this.className)) {
            classes = classes.concat(this.className);
        }
        else if (this.className) {
            classes.push(this.className);
        }
        return classes.join(' ');
    }
    createPlot() {
        return this.plotly.newPlot(this.plotEl.nativeElement, this.data ?? [], this.layout, this.config, this.frames).then(plotlyInstance => {
            this.plotlyInstance = plotlyInstance;
            this.getWindow().gd = this.debug ? plotlyInstance : undefined;
            this.eventNames.forEach(name => {
                const eventName = `plotly_${name.toLowerCase()}`;
                plotlyInstance.on(eventName, (data) => this[name].emit(data));
            });
            plotlyInstance.on('plotly_click', (data) => {
                this.click.emit(data);
                this.plotlyClick.emit(data);
            });
            this.updateWindowResizeHandler();
        }, err => {
            console.error('Error while plotting:', err);
            this.error.emit(err);
        });
    }
    createFigure() {
        const p = this.plotlyInstance;
        const figure = {
            data: p.data,
            layout: p.layout,
            frames: p._transitionData ? p._transitionData._frames : null
        };
        return figure;
    }
    updatePlot() {
        if (!this.plotlyInstance) {
            const error = new Error(`Plotly component wasn't initialized`);
            this.error.emit(error);
            throw error;
        }
        const layout = { ...this.layout };
        return this.plotly.update(this.plotlyInstance, this.data ?? [], layout, this.config, this.frames).then(() => {
            const figure = this.createFigure();
            this.update.emit(figure);
        }, err => {
            console.error('Error while updating plot:', err);
            this.error.emit(err);
        });
    }
    updateWindowResizeHandler() {
        if (this.useResizeHandler) {
            if (this.resizeHandler === undefined) {
                this.resizeHandler = () => this.plotly.resize(this.plotlyInstance);
                this.getWindow().addEventListener('resize', this.resizeHandler);
            }
        }
        else {
            if (typeof this.resizeHandler === 'function') {
                this.getWindow().removeEventListener('resize', this.resizeHandler);
                this.resizeHandler = undefined;
            }
        }
    }
    dataDifferTrackBy(_, item) {
        const obj = Object.assign({}, item, { uid: '' });
        return JSON.stringify(obj);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.9", ngImport: i0, type: PlotlyComponent, deps: [{ token: PlotlyService }, { token: i0.IterableDiffers }, { token: i0.KeyValueDiffers }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.9", type: PlotlyComponent, selector: "plotly-plot", inputs: { data: "data", layout: "layout", config: "config", frames: "frames", style: "style", divId: "divId", revision: "revision", className: "className", debug: "debug", useResizeHandler: "useResizeHandler", updateOnLayoutChange: "updateOnLayoutChange", updateOnDataChange: "updateOnDataChange", updateOnlyWithRevision: "updateOnlyWithRevision" }, outputs: { initialized: "initialized", update: "update", purge: "purge", error: "error", afterExport: "afterExport", afterPlot: "afterPlot", animated: "animated", animatingFrame: "animatingFrame", animationInterrupted: "animationInterrupted", autoSize: "autoSize", beforeExport: "beforeExport", buttonClicked: "buttonClicked", click: "click", plotlyClick: "plotlyClick", clickAnnotation: "clickAnnotation", deselect: "deselect", doubleClick: "doubleClick", framework: "framework", hover: "hover", legendClick: "legendClick", legendDoubleClick: "legendDoubleClick", react: "react", relayout: "relayout", restyle: "restyle", redraw: "redraw", selected: "selected", selecting: "selecting", sliderChange: "sliderChange", sliderEnd: "sliderEnd", sliderStart: "sliderStart", transitioning: "transitioning", transitionInterrupted: "transitionInterrupted", unhover: "unhover", relayouting: "relayouting", treemapclick: "treemapclick", sunburstclick: "sunburstclick" }, providers: [PlotlyService], viewQueries: [{ propertyName: "plotEl", first: true, predicate: ["plot"], descendants: true, static: true }], usesOnChanges: true, ngImport: i0, template: `<div #plot [attr.id]="divId" [ngClass]="getClassName()" [ngStyle]="style">
    <ng-content></ng-content>
  </div>`, isInline: true, dependencies: [{ kind: "directive", type: i4.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "directive", type: i4.NgStyle, selector: "[ngStyle]", inputs: ["ngStyle"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.9", ngImport: i0, type: PlotlyComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'plotly-plot',
                    template: `<div #plot [attr.id]="divId" [ngClass]="getClassName()" [ngStyle]="style">
    <ng-content></ng-content>
  </div>`,
                    providers: [PlotlyService],
                }]
        }], ctorParameters: function () { return [{ type: PlotlyService }, { type: i0.IterableDiffers }, { type: i0.KeyValueDiffers }]; }, propDecorators: { plotEl: [{
                type: ViewChild,
                args: ['plot', { static: true }]
            }], data: [{
                type: Input
            }], layout: [{
                type: Input
            }], config: [{
                type: Input
            }], frames: [{
                type: Input
            }], style: [{
                type: Input
            }], divId: [{
                type: Input
            }], revision: [{
                type: Input
            }], className: [{
                type: Input
            }], debug: [{
                type: Input
            }], useResizeHandler: [{
                type: Input
            }], updateOnLayoutChange: [{
                type: Input
            }], updateOnDataChange: [{
                type: Input
            }], updateOnlyWithRevision: [{
                type: Input
            }], initialized: [{
                type: Output
            }], update: [{
                type: Output
            }], purge: [{
                type: Output
            }], error: [{
                type: Output
            }], afterExport: [{
                type: Output
            }], afterPlot: [{
                type: Output
            }], animated: [{
                type: Output
            }], animatingFrame: [{
                type: Output
            }], animationInterrupted: [{
                type: Output
            }], autoSize: [{
                type: Output
            }], beforeExport: [{
                type: Output
            }], buttonClicked: [{
                type: Output
            }], click: [{
                type: Output
            }], plotlyClick: [{
                type: Output
            }], clickAnnotation: [{
                type: Output
            }], deselect: [{
                type: Output
            }], doubleClick: [{
                type: Output
            }], framework: [{
                type: Output
            }], hover: [{
                type: Output
            }], legendClick: [{
                type: Output
            }], legendDoubleClick: [{
                type: Output
            }], react: [{
                type: Output
            }], relayout: [{
                type: Output
            }], restyle: [{
                type: Output
            }], redraw: [{
                type: Output
            }], selected: [{
                type: Output
            }], selecting: [{
                type: Output
            }], sliderChange: [{
                type: Output
            }], sliderEnd: [{
                type: Output
            }], sliderStart: [{
                type: Output
            }], transitioning: [{
                type: Output
            }], transitionInterrupted: [{
                type: Output
            }], unhover: [{
                type: Output
            }], relayouting: [{
                type: Output
            }], treemapclick: [{
                type: Output
            }], sunburstclick: [{
                type: Output
            }] } });

class DateSelectorComponent {
    constructor() {
        this.expanded = true;
        this.filterDatesEvent = new EventEmitter();
        this.filterDates = {
            startDate: Date,
            endDate: Date
        };
        this.filterCollapsed = false;
        this.invalidDateInterval = false;
        // filterSelected = 'Intervallo di date';
        this.filterSelected = 'Ultimi tre mesi';
        //,'Intervallo di date'
        this.possibleFilterings = ['Ieri', 'Ultima settimana', 'Ultimi tre mesi', 'Intervallo di date'];
        this.startFilteringDate = new FormControl(null, Validators.required);
        this.endFilteringDate = new FormControl(null, Validators.required);
    }
    ngOnInit() {
        let sd = DateUtils.getZeroedTimeDate(this.startDate);
        let ed = DateUtils.getZeroedTimeDate(this.endDate);
        this.filterDates.startDate = sd;
        this.filterDates.endDate = ed;
        this.startFilteringDate = new FormControl(this.filterDates.startDate, Validators.required);
        this.endFilteringDate = new FormControl(this.filterDates.endDate, Validators.required);
        this.filterCollapsed = !this.expanded;
        this._onChange();
    }
    toggleCollapse() {
        this.filterCollapsed = !this.filterCollapsed;
    }
    ngAfterViewInit() {
    }
    selectionChange(obj) {
        console.log(obj);
        this.filterSelected = obj.value;
        this._onChange();
    }
    onChange(mrChange) {
        //this.showLoader();
        this.filterSelected = mrChange.value;
        this._onChange();
    }
    _onChange() {
        let sd;
        let ed;
        const yesterday = DateUtils.getPastDaysDate(new Date(), 1);
        if (this.filterSelected == 'Ultima settimana') {
            ed = DateUtils.getZeroedTimeDate(yesterday);
            sd = DateUtils.getZeroedTimeDate();
            sd = DateUtils.getPastDaysDate(sd, 7);
            console.log('filtering Ultima settimana');
        }
        else if (this.filterSelected == 'Ultimi tre mesi') {
            ed = DateUtils.getZeroedTimeDate(yesterday);
            sd = DateUtils.getZeroedTimeDate();
            sd = DateUtils.getPastMonthsDate(sd, 3);
            console.log('filtering Ultimi tre mesi');
        }
        else if (this.filterSelected == 'Intervallo di date') {
            sd = DateUtils.getZeroedTimeDate(this.startFilteringDate.value ?? yesterday);
            ed = DateUtils.getZeroedTimeDate(this.endFilteringDate.value ?? yesterday);
            //console.log("start date: ",sd," end date: ",ed);
            console.log('filtering Intervallo di date');
        }
        else {
            sd = DateUtils.getZeroedTimeDate(yesterday);
            ed = DateUtils.getZeroedTimeDate(yesterday);
            //console.log("start date: ",sd," end date: ",ed);
            console.log('filtering ultimo giorno');
        }
        this.filterDates.startDate = sd;
        this.filterDates.endDate = ed;
        this.checkFilterDates();
    }
    checkFilterDates() {
        if (this.filterDates.startDate.getTime() > this.filterDates.endDate.getTime()) {
            this.invalidDateInterval = true;
        }
        else {
            this.invalidDateInterval = false;
            this.filterDatesEvent.emit(this.filterDates);
        }
    }
    onChangeFilterDate(mrChange) {
        const yesterday = DateUtils.getPastDaysDate(new Date(), 1);
        this.filterDates.startDate = DateUtils.getZeroedTimeDate(this.startFilteringDate.value ?? yesterday);
        this.filterDates.endDate = DateUtils.getZeroedTimeDate(this.endFilteringDate.value ?? yesterday);
        this.checkFilterDates();
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.9", ngImport: i0, type: DateSelectorComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.9", type: DateSelectorComponent, selector: "app-date-selector", inputs: { action: "action", startDate: "startDate", endDate: "endDate", expanded: "expanded" }, outputs: { filterDatesEvent: "filterDatesEvent" }, ngImport: i0, template: "<div class=\"date-selector\" fxLayout=\"row\" fxLayoutAlign=\"flex-end center\"\n    [ngClass]=\"expanded ? 'expanded' : 'collapsed'\">\n\n    <button *ngIf=\"!expanded\" class=\"expand-action\" mat-icon-button (click)=\"toggleCollapse()\"\n        [color]=\"filterCollapsed ?  '':'accent'\" matTooltip=\"Filtra i risultati\" aria-label=\"filtra i risultati\">\n        <mat-icon class=\"animated-filter_list\" [ngClass]=\"{'animate': !filterCollapsed}\">filter_list</mat-icon>\n    </button>\n    <div class=\"date-selector-wrapper\" [ngClass]=\"{'collapsed': filterCollapsed}\" [fxLayout]=\"expanded ? 'row-reverse' : 'row'\" fxLayoutAlign=\"center center\" fxLayoutGap=\"8px\">\n        <ng-container *ngIf=\"expanded; else elseExpanded\">\n            <mat-form-field appearance=\"outline\">\n                <mat-label>Filtra i risultati</mat-label>\n                <mat-select [(ngModel)]=\"filterSelected\" (selectionChange)=\"selectionChange($event)\">\n                    <mat-option *ngFor=\"let possibleFilter of possibleFilterings\" [value]=\"possibleFilter\">\n                        {{possibleFilter}}\n                    </mat-option>\n                </mat-select>\n            </mat-form-field>\n        </ng-container>\n        <ng-template #elseExpanded>\n            <strong class=\"mr-lg-8\">Filtra i risultati: </strong>\n            <mat-radio-group [(ngModel)]=\"filterSelected\" (change)=\"onChange($event)\">\n                <mat-radio-button class=\"mr-lg-8\" *ngFor=\"let possibleFilter of possibleFilterings\"\n                    [value]=\"possibleFilter\">\n                    <span>{{possibleFilter}}</span>\n                </mat-radio-button>\n            </mat-radio-group>\n        </ng-template>\n        \n        <mat-form-field [hidden]=\"filterSelected != 'Intervallo di date'\" appearance=\"outline\">\n            <mat-label>Data di fine</mat-label>\n            <input matInput [matDatepicker]=\"endDateFiltering\" placeholder=\"Scegli una data\"\n                (dateInput)=\"onChangeFilterDate($event)\" [formControl]=\"endFilteringDate\">\n            <mat-datepicker-toggle matSuffix [for]=\"endDateFiltering\">\n                <mat-icon matDatepickerToggleIcon>keyboard_arrow_down</mat-icon>\n            </mat-datepicker-toggle>\n            <mat-datepicker #endDateFiltering></mat-datepicker>\n        </mat-form-field>\n        \n        <mat-form-field [hidden]=\"filterSelected != 'Intervallo di date'\" appearance=\"outline\">\n            <mat-label>Data di inizio</mat-label>\n            <input matInput [matDatepicker]=\"startDateFiltering\" placeholder=\"Scegli una data\"\n                (dateInput)=\"onChangeFilterDate($event)\" [formControl]=\"startFilteringDate\">\n            <mat-datepicker-toggle matSuffix [for]=\"startDateFiltering\">\n                <mat-icon matDatepickerToggleIcon>keyboard_arrow_down</mat-icon>\n            </mat-datepicker-toggle>\n            <mat-datepicker #startDateFiltering></mat-datepicker>\n        </mat-form-field>\n       \n\n        <mat-error *ngIf=\"invalidDateInterval\">\n            Intervallo di date non valido\n        </mat-error>\n        <!-- </div> -->\n    </div>\n</div>", styles: [".date-selector{position:relative}.date-selector.collapsed .date-selector-wrapper{font-size:.8em;font-weight:400;max-width:100%;transition:all .5s ease;overflow:hidden;position:absolute;right:45px;white-space:nowrap}.date-selector.collapsed .date-selector-wrapper.collapsed{max-width:0}.date-selector.expanded .date-selector-wrapper{font-size:.8em}.animated-filter_list{transform:skew(0);transition:transform .2s ease}.animated-filter_list.animate{transform:skew(-30deg)}\n"], dependencies: [{ kind: "directive", type: i4.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "directive", type: i4.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i4.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i4$1.DefaultLayoutDirective, selector: "  [fxLayout], [fxLayout.xs], [fxLayout.sm], [fxLayout.md],  [fxLayout.lg], [fxLayout.xl], [fxLayout.lt-sm], [fxLayout.lt-md],  [fxLayout.lt-lg], [fxLayout.lt-xl], [fxLayout.gt-xs], [fxLayout.gt-sm],  [fxLayout.gt-md], [fxLayout.gt-lg]", inputs: ["fxLayout", "fxLayout.xs", "fxLayout.sm", "fxLayout.md", "fxLayout.lg", "fxLayout.xl", "fxLayout.lt-sm", "fxLayout.lt-md", "fxLayout.lt-lg", "fxLayout.lt-xl", "fxLayout.gt-xs", "fxLayout.gt-sm", "fxLayout.gt-md", "fxLayout.gt-lg"] }, { kind: "directive", type: i4$1.DefaultLayoutGapDirective, selector: "  [fxLayoutGap], [fxLayoutGap.xs], [fxLayoutGap.sm], [fxLayoutGap.md],  [fxLayoutGap.lg], [fxLayoutGap.xl], [fxLayoutGap.lt-sm], [fxLayoutGap.lt-md],  [fxLayoutGap.lt-lg], [fxLayoutGap.lt-xl], [fxLayoutGap.gt-xs], [fxLayoutGap.gt-sm],  [fxLayoutGap.gt-md], [fxLayoutGap.gt-lg]", inputs: ["fxLayoutGap", "fxLayoutGap.xs", "fxLayoutGap.sm", "fxLayoutGap.md", "fxLayoutGap.lg", "fxLayoutGap.xl", "fxLayoutGap.lt-sm", "fxLayoutGap.lt-md", "fxLayoutGap.lt-lg", "fxLayoutGap.lt-xl", "fxLayoutGap.gt-xs", "fxLayoutGap.gt-sm", "fxLayoutGap.gt-md", "fxLayoutGap.gt-lg"] }, { kind: "directive", type: i4$1.DefaultLayoutAlignDirective, selector: "  [fxLayoutAlign], [fxLayoutAlign.xs], [fxLayoutAlign.sm], [fxLayoutAlign.md],  [fxLayoutAlign.lg], [fxLayoutAlign.xl], [fxLayoutAlign.lt-sm], [fxLayoutAlign.lt-md],  [fxLayoutAlign.lt-lg], [fxLayoutAlign.lt-xl], [fxLayoutAlign.gt-xs], [fxLayoutAlign.gt-sm],  [fxLayoutAlign.gt-md], [fxLayoutAlign.gt-lg]", inputs: ["fxLayoutAlign", "fxLayoutAlign.xs", "fxLayoutAlign.sm", "fxLayoutAlign.md", "fxLayoutAlign.lg", "fxLayoutAlign.xl", "fxLayoutAlign.lt-sm", "fxLayoutAlign.lt-md", "fxLayoutAlign.lt-lg", "fxLayoutAlign.lt-xl", "fxLayoutAlign.gt-xs", "fxLayoutAlign.gt-sm", "fxLayoutAlign.gt-md", "fxLayoutAlign.gt-lg"] }, { kind: "directive", type: i3.DefaultClassDirective, selector: "  [ngClass], [ngClass.xs], [ngClass.sm], [ngClass.md], [ngClass.lg], [ngClass.xl],  [ngClass.lt-sm], [ngClass.lt-md], [ngClass.lt-lg], [ngClass.lt-xl],  [ngClass.gt-xs], [ngClass.gt-sm], [ngClass.gt-md], [ngClass.gt-lg]", inputs: ["ngClass", "ngClass.xs", "ngClass.sm", "ngClass.md", "ngClass.lg", "ngClass.xl", "ngClass.lt-sm", "ngClass.lt-md", "ngClass.lt-lg", "ngClass.lt-xl", "ngClass.gt-xs", "ngClass.gt-sm", "ngClass.gt-md", "ngClass.gt-lg"] }, { kind: "component", type: i6.MatIconButton, selector: "button[mat-icon-button]", inputs: ["disabled", "disableRipple", "color"], exportAs: ["matButton"] }, { kind: "directive", type: i7.DefaultValueAccessor, selector: "input:not([type=checkbox])[formControlName],textarea[formControlName],input:not([type=checkbox])[formControl],textarea[formControl],input:not([type=checkbox])[ngModel],textarea[ngModel],[ngDefaultControl]" }, { kind: "directive", type: i7.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { kind: "directive", type: i7.NgModel, selector: "[ngModel]:not([formControlName]):not([formControl])", inputs: ["name", "disabled", "ngModel", "ngModelOptions"], outputs: ["ngModelChange"], exportAs: ["ngModel"] }, { kind: "component", type: i8.MatOption, selector: "mat-option", exportAs: ["matOption"] }, { kind: "component", type: i7$1.MatDatepicker, selector: "mat-datepicker", exportAs: ["matDatepicker"] }, { kind: "directive", type: i7$1.MatDatepickerInput, selector: "input[matDatepicker]", inputs: ["matDatepicker", "min", "max", "matDatepickerFilter"], exportAs: ["matDatepickerInput"] }, { kind: "component", type: i7$1.MatDatepickerToggle, selector: "mat-datepicker-toggle", inputs: ["for", "tabIndex", "aria-label", "disabled", "disableRipple"], exportAs: ["matDatepickerToggle"] }, { kind: "directive", type: i7$1.MatDatepickerToggleIcon, selector: "[matDatepickerToggleIcon]" }, { kind: "component", type: i10.MatFormField, selector: "mat-form-field", inputs: ["hideRequiredMarker", "color", "floatLabel", "appearance", "subscriptSizing", "hintLabel"], exportAs: ["matFormField"] }, { kind: "directive", type: i10.MatLabel, selector: "mat-label" }, { kind: "directive", type: i10.MatError, selector: "mat-error, [matError]", inputs: ["id"] }, { kind: "directive", type: i10.MatSuffix, selector: "[matSuffix], [matIconSuffix], [matTextSuffix]", inputs: ["matTextSuffix"] }, { kind: "component", type: i2$1.MatIcon, selector: "mat-icon", inputs: ["color", "inline", "svgIcon", "fontSet", "fontIcon"], exportAs: ["matIcon"] }, { kind: "directive", type: i12.MatInput, selector: "input[matInput], textarea[matInput], select[matNativeControl],      input[matNativeControl], textarea[matNativeControl]", inputs: ["disabled", "id", "placeholder", "name", "required", "type", "errorStateMatcher", "aria-describedby", "value", "readonly"], exportAs: ["matInput"] }, { kind: "directive", type: i11.MatRadioGroup, selector: "mat-radio-group", exportAs: ["matRadioGroup"] }, { kind: "component", type: i11.MatRadioButton, selector: "mat-radio-button", inputs: ["disableRipple", "tabIndex"], exportAs: ["matRadioButton"] }, { kind: "component", type: i13.MatSelect, selector: "mat-select", inputs: ["disabled", "disableRipple", "tabIndex", "panelWidth", "hideSingleSelectionIndicator"], exportAs: ["matSelect"] }, { kind: "directive", type: i13$1.MatTooltip, selector: "[matTooltip]", exportAs: ["matTooltip"] }, { kind: "directive", type: i7.FormControlDirective, selector: "[formControl]", inputs: ["formControl", "disabled", "ngModel"], outputs: ["ngModelChange"], exportAs: ["ngForm"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.9", ngImport: i0, type: DateSelectorComponent, decorators: [{
            type: Component,
            args: [{ selector: 'app-date-selector', template: "<div class=\"date-selector\" fxLayout=\"row\" fxLayoutAlign=\"flex-end center\"\n    [ngClass]=\"expanded ? 'expanded' : 'collapsed'\">\n\n    <button *ngIf=\"!expanded\" class=\"expand-action\" mat-icon-button (click)=\"toggleCollapse()\"\n        [color]=\"filterCollapsed ?  '':'accent'\" matTooltip=\"Filtra i risultati\" aria-label=\"filtra i risultati\">\n        <mat-icon class=\"animated-filter_list\" [ngClass]=\"{'animate': !filterCollapsed}\">filter_list</mat-icon>\n    </button>\n    <div class=\"date-selector-wrapper\" [ngClass]=\"{'collapsed': filterCollapsed}\" [fxLayout]=\"expanded ? 'row-reverse' : 'row'\" fxLayoutAlign=\"center center\" fxLayoutGap=\"8px\">\n        <ng-container *ngIf=\"expanded; else elseExpanded\">\n            <mat-form-field appearance=\"outline\">\n                <mat-label>Filtra i risultati</mat-label>\n                <mat-select [(ngModel)]=\"filterSelected\" (selectionChange)=\"selectionChange($event)\">\n                    <mat-option *ngFor=\"let possibleFilter of possibleFilterings\" [value]=\"possibleFilter\">\n                        {{possibleFilter}}\n                    </mat-option>\n                </mat-select>\n            </mat-form-field>\n        </ng-container>\n        <ng-template #elseExpanded>\n            <strong class=\"mr-lg-8\">Filtra i risultati: </strong>\n            <mat-radio-group [(ngModel)]=\"filterSelected\" (change)=\"onChange($event)\">\n                <mat-radio-button class=\"mr-lg-8\" *ngFor=\"let possibleFilter of possibleFilterings\"\n                    [value]=\"possibleFilter\">\n                    <span>{{possibleFilter}}</span>\n                </mat-radio-button>\n            </mat-radio-group>\n        </ng-template>\n        \n        <mat-form-field [hidden]=\"filterSelected != 'Intervallo di date'\" appearance=\"outline\">\n            <mat-label>Data di fine</mat-label>\n            <input matInput [matDatepicker]=\"endDateFiltering\" placeholder=\"Scegli una data\"\n                (dateInput)=\"onChangeFilterDate($event)\" [formControl]=\"endFilteringDate\">\n            <mat-datepicker-toggle matSuffix [for]=\"endDateFiltering\">\n                <mat-icon matDatepickerToggleIcon>keyboard_arrow_down</mat-icon>\n            </mat-datepicker-toggle>\n            <mat-datepicker #endDateFiltering></mat-datepicker>\n        </mat-form-field>\n        \n        <mat-form-field [hidden]=\"filterSelected != 'Intervallo di date'\" appearance=\"outline\">\n            <mat-label>Data di inizio</mat-label>\n            <input matInput [matDatepicker]=\"startDateFiltering\" placeholder=\"Scegli una data\"\n                (dateInput)=\"onChangeFilterDate($event)\" [formControl]=\"startFilteringDate\">\n            <mat-datepicker-toggle matSuffix [for]=\"startDateFiltering\">\n                <mat-icon matDatepickerToggleIcon>keyboard_arrow_down</mat-icon>\n            </mat-datepicker-toggle>\n            <mat-datepicker #startDateFiltering></mat-datepicker>\n        </mat-form-field>\n       \n\n        <mat-error *ngIf=\"invalidDateInterval\">\n            Intervallo di date non valido\n        </mat-error>\n        <!-- </div> -->\n    </div>\n</div>", styles: [".date-selector{position:relative}.date-selector.collapsed .date-selector-wrapper{font-size:.8em;font-weight:400;max-width:100%;transition:all .5s ease;overflow:hidden;position:absolute;right:45px;white-space:nowrap}.date-selector.collapsed .date-selector-wrapper.collapsed{max-width:0}.date-selector.expanded .date-selector-wrapper{font-size:.8em}.animated-filter_list{transform:skew(0);transition:transform .2s ease}.animated-filter_list.animate{transform:skew(-30deg)}\n"] }]
        }], ctorParameters: function () { return []; }, propDecorators: { action: [{
                type: Input
            }], startDate: [{
                type: Input
            }], endDate: [{
                type: Input
            }], expanded: [{
                type: Input
            }], filterDatesEvent: [{
                type: Output
            }] } });

class HelpInlineComponent {
    // content: string = 'content';
    // name: string = 'name';
    constructor(dialog, iconRegistry, sanitizer) {
        // this.mode = this.mode ? this.mode : 'dialog';
        // this.dialogWidth = this.dialogWidth ? this.dialogWidth : '450px';
        // this.status = this.status ? this.status: 'ok';
        this.dialog = dialog;
        this.iconRegistry = iconRegistry;
        this.sanitizer = sanitizer;
        /**
         *  dialog | tooltip.
         * Default tooltip
         *  */
        this.mode = 'dialog';
        /**
         * colore della mat-icon.
         * Default accent
         *
        */
        this.color = 'accent';
        /**
         * mat icon.
         * Default icon
         * */
        this.icon = 'help';
        /**
         * dimensione del dialog.
         * Default 360px
         * */
        this.dialogWidth = '640px';
        this.infoCollapsed = true;
    }
    // openDialog(): void {
    //   const dialogRef = this.dialog.open(HelpInlineDialog, {
    //     width: '250px',
    //     data: {name: this.name, content: this.content},
    //   });
    // }
    ngOnInit() {
        // this.description = this.description ? this.description : null;
        // this.title = this.title ? this.title : null;
        // this.label = this.label ? this.label : '';
        // this.dialogWidth = this.dialogWidth ? this.dialogWidth : '450px';
        // this.status = this.status ? this.status : 'ok';
        if (this.svgicon != null) {
            this.icon = null;
            this.iconRegistry.addSvgIcon(this.svgicon, this.sanitizer.bypassSecurityTrustResourceUrl('~src/assets/icons/custom/' + this.svgicon + '.svg'));
        }
        if (this.status) {
            // console.log('tatus in hil', this.status);
            this.setStatus(this.status);
        }
    }
    ngOnChanges(changes) {
        // console.log('changes',changes);
        if (changes['status']) {
            this.status = changes['status'].currentValue;
            // console.log(this.status);
            this.setStatus(this.status);
        }
        if (changes['dialogWidth']) {
            //console.log('dialogWidth has changed')
            this.dialogWidth = changes['dialogWidth'].currentValue;
        }
        if (changes['label']) {
            this.label = changes['label'].currentValue;
        }
        if (changes['mode']) {
            this.mode = changes['mode'].currentValue;
        }
        if (changes['icon']) {
            this.icon = changes['icon'].currentValue;
        }
        if (changes['description']) {
            this.description = changes['description'].currentValue;
        }
        if (changes['title']) {
            this.title = changes['title'].currentValue;
        }
    }
    toggleInfo() {
        if (this.mode == 'dialog') {
            // console.log(this.mode);
            const dialogRef = this.dialog.open(HelpInlineDialog, {
                width: this.dialogWidth,
                data: { title: this.title, content: this.description },
            });
            dialogRef.afterClosed().subscribe(result => {
                // console.log('The dialog was closed');
            });
        }
        else {
            this.infoCollapsed = !this.infoCollapsed;
        }
    }
    setStatus(status) {
        if (!status)
            return;
        switch (status) {
            case 'danger':
            case 'error':
                this.btnClass = "text-danger";
                this.icon = "error";
                break;
            case 'warning':
                this.btnClass = "text-warning";
                this.icon = "warning";
                break;
            case 'success':
            case 'ok':
                this.btnClass = "";
                this.icon = "help";
                break;
            default:
                this.btnClass = "";
                this.icon = "help";
                break;
        }
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.9", ngImport: i0, type: HelpInlineComponent, deps: [{ token: i1$1.MatDialog }, { token: i2$1.MatIconRegistry }, { token: i3$1.DomSanitizer }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.9", type: HelpInlineComponent, selector: "app-help-inline", inputs: { description: "description", title: "title", mode: "mode", label: "label", color: "color", btnClass: "btnClass", icon: "icon", svgicon: "svgicon", dialogWidth: "dialogWidth", status: "status", translateParams: "translateParams" }, usesOnChanges: true, ngImport: i0, template: "<ng-container *ngIf=\"title || description || label\">\n    <div class=\"more-info-wrapper\">\n    <button mat-icon-button \n    (click)=\"toggleInfo()\" \n    [matTooltip]=\"infoCollapsed ? label ? label : 'Spiegami cosa \u00E8 questo' : ''\"\n    aria-label=\"Maggiori dettagli\"\n    [color]=\"color ? color : mode == 'dialog' ? 'accent' : ''\"\n    [class.animate-help]=\"mode == 'dialog'\"\n    [ngClass]=\"btnClass\"\n    [disableRipple]=\"'true'\">\n    <ng-container *ngIf=\"icon; else elseSvgicon\">\n        <mat-icon [ngClass]=\"'mat-icon-'+icon\" >{{ icon }}</mat-icon>\n    </ng-container>\n    <ng-template #elseSvgicon>\n        <mat-icon *ngIf=\"svgicon\" [ngClass]=\"'mat-icon-'+svgicon\" [svgIcon]=\"svgicon\"></mat-icon>\n    </ng-template> \n    </button>\n    <div *ngIf=\"mode != 'dialog' && description != null\" [innerText]=\"description\" class=\"more-info\"\n        [ngClass]=\"{'collapsed': infoCollapsed }\" translate></div>\n</div>\n</ng-container>\n", styles: [".more-info-wrapper{position:relative;display:inline-block;top:-2px}.more-info-wrapper .more-info{position:absolute;background:rgba(51,51,51,.9);color:#fff;padding:8px;border-radius:4px;box-shadow:2px 2px 3px #000000b3;top:40px;transition:all .3s ease;opacity:1;transform:none;transform-origin:top left;font-size:80%}.more-info-wrapper .more-info:before{content:\"\";position:absolute;top:-10px;left:10px;border-bottom:10px solid rgba(51,51,51,.9);border-right:10px solid transparent;border-left:10px solid transparent}.more-info-wrapper .more-info.collapsed{opacity:0;transform:scale(0)}.animate-help:not(:hover){opacity:.5}.animate-help .mat-icon-help{transition:all .3s ease;transform:none;transform-origin:center bottom}.animate-help .mat-icon-help:before{content:\"\";position:absolute;width:10px;height:5px;background:currentColor;margin:auto;bottom:9px;left:0;right:0;border-radius:0 0 3px 3px;opacity:0;transition:all .3s ease}.animate-help .mat-icon-help:after{width:100%;height:100%;content:\"\";border-radius:50%;border:3px dotted currentColor;position:absolute;left:0%;top:0%;opacity:0}.animate-help:hover{opacity:1}.animate-help:hover .mat-icon-help{transform:scale(1.2) translate(-5px) rotate(20deg)}.animate-help:hover .mat-icon-help:before{opacity:1;bottom:-4px}.animate-help:hover .mat-icon-help:after{width:120%;height:120%;left:-10%;top:-10%;opacity:.4}::ng-deep app-help-inline{display:inline-block}::ng-deep .help-dialog-wrapper{position:relative;margin:var(--help-dialog-outer-padding, 24px)}::ng-deep .help-dialog-title{pointer-events:none}::ng-deep .left-tab{margin-left:10px}::ng-deep .double-left-tab{margin-left:25px}::ng-deep .circled-icon{position:absolute!important;top:-16px;right:-16px}@keyframes translate{0%{transform:translate(0)}to{transform:translate(16px,-16px)}}\n"], dependencies: [{ kind: "directive", type: i4.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "directive", type: i4.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i3.DefaultClassDirective, selector: "  [ngClass], [ngClass.xs], [ngClass.sm], [ngClass.md], [ngClass.lg], [ngClass.xl],  [ngClass.lt-sm], [ngClass.lt-md], [ngClass.lt-lg], [ngClass.lt-xl],  [ngClass.gt-xs], [ngClass.gt-sm], [ngClass.gt-md], [ngClass.gt-lg]", inputs: ["ngClass", "ngClass.xs", "ngClass.sm", "ngClass.md", "ngClass.lg", "ngClass.xl", "ngClass.lt-sm", "ngClass.lt-md", "ngClass.lt-lg", "ngClass.lt-xl", "ngClass.gt-xs", "ngClass.gt-sm", "ngClass.gt-md", "ngClass.gt-lg"] }, { kind: "component", type: i6.MatIconButton, selector: "button[mat-icon-button]", inputs: ["disabled", "disableRipple", "color"], exportAs: ["matButton"] }, { kind: "component", type: i2$1.MatIcon, selector: "mat-icon", inputs: ["color", "inline", "svgIcon", "fontSet", "fontIcon"], exportAs: ["matIcon"] }, { kind: "directive", type: i13$1.MatTooltip, selector: "[matTooltip]", exportAs: ["matTooltip"] }, { kind: "directive", type: i20.TranslateDirective, selector: "[translate],[ngx-translate]", inputs: ["translate", "translateParams"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.9", ngImport: i0, type: HelpInlineComponent, decorators: [{
            type: Component,
            args: [{ selector: 'app-help-inline', template: "<ng-container *ngIf=\"title || description || label\">\n    <div class=\"more-info-wrapper\">\n    <button mat-icon-button \n    (click)=\"toggleInfo()\" \n    [matTooltip]=\"infoCollapsed ? label ? label : 'Spiegami cosa \u00E8 questo' : ''\"\n    aria-label=\"Maggiori dettagli\"\n    [color]=\"color ? color : mode == 'dialog' ? 'accent' : ''\"\n    [class.animate-help]=\"mode == 'dialog'\"\n    [ngClass]=\"btnClass\"\n    [disableRipple]=\"'true'\">\n    <ng-container *ngIf=\"icon; else elseSvgicon\">\n        <mat-icon [ngClass]=\"'mat-icon-'+icon\" >{{ icon }}</mat-icon>\n    </ng-container>\n    <ng-template #elseSvgicon>\n        <mat-icon *ngIf=\"svgicon\" [ngClass]=\"'mat-icon-'+svgicon\" [svgIcon]=\"svgicon\"></mat-icon>\n    </ng-template> \n    </button>\n    <div *ngIf=\"mode != 'dialog' && description != null\" [innerText]=\"description\" class=\"more-info\"\n        [ngClass]=\"{'collapsed': infoCollapsed }\" translate></div>\n</div>\n</ng-container>\n", styles: [".more-info-wrapper{position:relative;display:inline-block;top:-2px}.more-info-wrapper .more-info{position:absolute;background:rgba(51,51,51,.9);color:#fff;padding:8px;border-radius:4px;box-shadow:2px 2px 3px #000000b3;top:40px;transition:all .3s ease;opacity:1;transform:none;transform-origin:top left;font-size:80%}.more-info-wrapper .more-info:before{content:\"\";position:absolute;top:-10px;left:10px;border-bottom:10px solid rgba(51,51,51,.9);border-right:10px solid transparent;border-left:10px solid transparent}.more-info-wrapper .more-info.collapsed{opacity:0;transform:scale(0)}.animate-help:not(:hover){opacity:.5}.animate-help .mat-icon-help{transition:all .3s ease;transform:none;transform-origin:center bottom}.animate-help .mat-icon-help:before{content:\"\";position:absolute;width:10px;height:5px;background:currentColor;margin:auto;bottom:9px;left:0;right:0;border-radius:0 0 3px 3px;opacity:0;transition:all .3s ease}.animate-help .mat-icon-help:after{width:100%;height:100%;content:\"\";border-radius:50%;border:3px dotted currentColor;position:absolute;left:0%;top:0%;opacity:0}.animate-help:hover{opacity:1}.animate-help:hover .mat-icon-help{transform:scale(1.2) translate(-5px) rotate(20deg)}.animate-help:hover .mat-icon-help:before{opacity:1;bottom:-4px}.animate-help:hover .mat-icon-help:after{width:120%;height:120%;left:-10%;top:-10%;opacity:.4}::ng-deep app-help-inline{display:inline-block}::ng-deep .help-dialog-wrapper{position:relative;margin:var(--help-dialog-outer-padding, 24px)}::ng-deep .help-dialog-title{pointer-events:none}::ng-deep .left-tab{margin-left:10px}::ng-deep .double-left-tab{margin-left:25px}::ng-deep .circled-icon{position:absolute!important;top:-16px;right:-16px}@keyframes translate{0%{transform:translate(0)}to{transform:translate(16px,-16px)}}\n"] }]
        }], ctorParameters: function () { return [{ type: i1$1.MatDialog }, { type: i2$1.MatIconRegistry }, { type: i3$1.DomSanitizer }]; }, propDecorators: { description: [{
                type: Input
            }], title: [{
                type: Input
            }], mode: [{
                type: Input
            }], label: [{
                type: Input
            }], color: [{
                type: Input
            }], btnClass: [{
                type: Input
            }], icon: [{
                type: Input
            }], svgicon: [{
                type: Input
            }], dialogWidth: [{
                type: Input
            }], status: [{
                type: Input
            }], translateParams: [{
                type: Input
            }] } });
class HelpInlineDialog {
    constructor(dialogRef, data) {
        this.dialogRef = dialogRef;
        this.data = data;
    }
    onNoClick() {
        this.dialogRef.close();
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.9", ngImport: i0, type: HelpInlineDialog, deps: [{ token: i1$1.MatDialogRef }, { token: MAT_DIALOG_DATA }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.9", type: HelpInlineDialog, selector: "help-inline-dialog", ngImport: i0, template: "<div class=\"help-dialog-wrapper\">\n<button mat-icon-button (click)=\"onNoClick()\" class=\"circled-icon\" [disableRipple]=\"'true'\" color=\"warn\" ><mat-icon>cancel</mat-icon></button>\n<h1 *ngIf=\"data.title\" mat-dialog-title class=\"help-dialog-title\" [innerHTML]=\"data.title\"></h1>\n<div *ngIf=\"data.content\" mat-dialog-content  class=\"help-dialog-content\" [innerHTML]=\"data.content\"></div>\n</div>", dependencies: [{ kind: "directive", type: i4.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "component", type: i6.MatIconButton, selector: "button[mat-icon-button]", inputs: ["disabled", "disableRipple", "color"], exportAs: ["matButton"] }, { kind: "directive", type: i1$1.MatDialogTitle, selector: "[mat-dialog-title], [matDialogTitle]", inputs: ["id"], exportAs: ["matDialogTitle"] }, { kind: "directive", type: i1$1.MatDialogContent, selector: "[mat-dialog-content], mat-dialog-content, [matDialogContent]" }, { kind: "component", type: i2$1.MatIcon, selector: "mat-icon", inputs: ["color", "inline", "svgIcon", "fontSet", "fontIcon"], exportAs: ["matIcon"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.9", ngImport: i0, type: HelpInlineDialog, decorators: [{
            type: Component,
            args: [{ selector: 'help-inline-dialog', template: "<div class=\"help-dialog-wrapper\">\n<button mat-icon-button (click)=\"onNoClick()\" class=\"circled-icon\" [disableRipple]=\"'true'\" color=\"warn\" ><mat-icon>cancel</mat-icon></button>\n<h1 *ngIf=\"data.title\" mat-dialog-title class=\"help-dialog-title\" [innerHTML]=\"data.title\"></h1>\n<div *ngIf=\"data.content\" mat-dialog-content  class=\"help-dialog-content\" [innerHTML]=\"data.content\"></div>\n</div>" }]
        }], ctorParameters: function () { return [{ type: i1$1.MatDialogRef }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [MAT_DIALOG_DATA]
                }] }]; } });

class StringFormatterPipe {
    constructor() { }
    transform(word, maxLength) {
        let defaultMaxLength = 150;
        if (word == null) {
            return null;
        }
        if (typeof word == 'string') {
            if (this.isHTML(word)) {
                return word;
            }
            if (maxLength) {
                defaultMaxLength = maxLength;
            }
            /* if (word.startsWith('<') && word.endsWith('>')) {
              return word;
            } */
            if (word.length > defaultMaxLength) {
                return word.slice(0, defaultMaxLength) + '...';
            }
        }
        return word;
    }
    isHTML(text) {
        const htmlRegex = new RegExp(/<\/?[a-z][\s\S]*>/i);
        return !!htmlRegex.test(text);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.9", ngImport: i0, type: StringFormatterPipe, deps: [], target: i0.ɵɵFactoryTarget.Pipe }); }
    static { this.ɵpipe = i0.ɵɵngDeclarePipe({ minVersion: "14.0.0", version: "16.2.9", ngImport: i0, type: StringFormatterPipe, name: "stringFormatter" }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.9", ngImport: i0, type: StringFormatterPipe, decorators: [{
            type: Pipe,
            args: [{
                    name: 'stringFormatter'
                }]
        }], ctorParameters: function () { return []; } });

class HeatmapObj {
    constructor(key, value) {
        this.key = key;
        this.value = value;
    }
}
class DynamicDashboardCardComponent extends BaseDashboardComponent {
    /* localTableDataSource: boolean = false; */
    constructor(document, 
    // private route: ActivatedRoute,
    dialogMat, snackBarMat, 
    // public account: AccountService,
    errorHandler, injector) {
        super(dialogMat, snackBarMat, injector);
        this.dialogMat = dialogMat;
        this.snackBarMat = snackBarMat;
        this.errorHandler = errorHandler;
        this.tableLimitFilterValuesEnabled = true;
        this.filterDatesEvent = new EventEmitter();
        this.selectedMetricEvent = new EventEmitter();
        this.selectedMultipleMetricViewEvent = new EventEmitter();
        this.selectedLimitPieResults = new EventEmitter();
        this.drawRowsEvent = new EventEmitter();
        this.selectDashboardCard = new EventEmitter();
        this.afterPlotEvent = new EventEmitter();
        this.tablePageEvent = new EventEmitter();
        this.plotlyEvent = new EventEmitter();
        // @ViewChild('heatToSearch') heatmapComponent!: HeatmapComponent
        this.filterDates = {
            startDate: Date,
            endDate: Date,
            cardContainerConfig: CardContainerConfig
        };
        this.matCard = null;
        this.domDocument = null;
        this.showCheckboxes = false;
        this.disableCheckboxes = false;
        this.clickableRows = false;
        this.pageSizeOptions = [5, 10, 20, 30];
        this.pageSize = 10;
        this.limitFilterValues = 6;
        this.plotRowsButtonDisabled = true;
        this.plotRowsButtonVisible = false;
        this.selectedRowsButtonVisible = false;
        this.dashboardCardLoaderVisible = false;
        this.showData = true;
        this.showTable = false;
        this.badTableData = false;
        this.forceResize = false;
        this.defaultMaxStringLength = 150;
        this.urlPattern = '^(https?:\\/\\/)?' + // protocol
            '((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|' + // domain name
            '((\\d{1,3}\\.){3}\\d{1,3}))' + // OR ip (v4) address
            '(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*' + // port and path
            '(\\?[;&a-z\\d%_.~+=-]*)?' + // query string
            '(\\#[-a-z\\d_]*)?$';
        this.domDocument = document;
        this.badConditions = ['nodata', 'error'];
        this.warningConditions = ['warning'];
        this.heatmapLocations = [];
        this.heatmapConfigs = { minHeight: 0, title: '', subject: '' };
        this.graphicType = '';
        //// // console.log('dashboard-card.component constructor')
    }
    async ngOnInit() {
        this.currLang = this.translateService.defaultLang + "-" + this.translateService.defaultLang.toUpperCase();
        // await this.account.getAccount().then((res: any) => {
        //   this.myAccount = res;
        //   //// // console.log(res);
        // });
        //this.cardContainerConfig.loaderVisible = true;
        //console.log("card container config:",this.cardContainerConfig);
        // perchè si fa il controllo della pagina sul componente???
        // this.checkAccessToPage().then(v=>{});
        //    console.log("card container config: ", this.cardContainerConfig);
        // this.tenantId = this.route.snapshot.params['tenantId'];
        if (this.table) {
            this.graphicType = 'graphic-card-table';
            //console.log("tabella: ",this.table);
            //check integrità tabella
            if (this.table.data && this.table.data.length > 0) {
                //console.log("table data: ",this.table.data);
                if (this.table.data[0].colHeader == null || this.table.data[0].colHeader == '') {
                    this.badTableData = true;
                }
                else if (this.table.data[0].rowHeader == null || this.table.data[0].rowHeader == '') {
                    this.badTableData = true;
                }
                else {
                    this.badTableData = false;
                }
            }
            else {
                this.badTableData = true;
            }
            this.checkCheckboxesAndAddRow();
            if (!this.badTableData) {
                //console.log("table config: ",this.graphicConfig.graphConfiguration);
                //in caso di indicazione di pagenumber e pagesize si va di tabella paginata lato server
                if (this.graphicConfig != null && this.graphicConfig.graphConfiguration != null && (this.graphicConfig.graphConfiguration.pageNumber != null &&
                    this.graphicConfig.graphConfiguration.pageSize != null)) {
                    this.newPagedSource(new TableDataSourceComponent(this.dashboardService.getPagedChartData.bind(this.dashboardService), this.setDataCounter.bind(this)), this.getPagedChartData.bind(this), this.getPagedChartData.bind(this));
                    this.getPagedChartData();
                    console.log("initialized paged datasource ");
                    //this.table.data = this.dataSource.data;
                    //this.cardContainerConfig.loaderVisible = true;
                    if (this.table.data.length > 0) {
                        this.showTable = true;
                    }
                    //console.log("datasource: ",this.dataSource);
                }
                else {
                    this.newDataSource(this.table.data, true, this._sorting.bind(this)).then(() => {
                        console.log("-------------------- initialized normal data source ");
                        if (this.dataSource.data.length > 0) {
                            // this.sorting();
                        }
                        //console.log("normal datasource: ",this.table.data);
                        if (this.table && this.table.options && this.table.options.sort) {
                            let dir = 'asc';
                            if (this.table.options.sortOrder != null && this.table.options.sortOrder.length > 0) {
                                dir = this.table.options.sortOrder;
                            }
                            const sortState = { active: this.table.options.sort, direction: dir };
                            if (this.sort) {
                                this.sort.active = sortState.active;
                                this.sort.direction = sortState.direction;
                                this.sort.sortChange.emit(sortState);
                            }
                        }
                        if (this.dataSource.data.length > 0) {
                            this.showTable = true;
                        }
                        // console.log(this.table);
                        // this.cardContainerConfig.loaderVisible = false;
                    });
                }
                this.colHeaders = this.table.layout;
                this.displayedColumns = this.table.layout;
                if (this.showCheckboxes) {
                    if (this.displayedColumns.indexOf('checkboxesHeader') == -1)
                        this.displayedColumns.unshift('checkboxesHeader');
                }
            }
        }
        if (this.heatmap) {
            this.graphicType = 'graphic-card-heatmap';
            //console.log("heatmap: ",this.heatmap);
            //check integrità tabella
            if (this.heatmap.data.length > 0) {
                //console.log("heatmap data: ",this.heatmap.data);
                let heatInput = this.buildMapObjectFromTable(this.graphicConfig, this.heatmap.data);
                this.heatmapLocations = JSON.parse(JSON.stringify(heatInput));
                // console.log("heatmap data: ",this.heatmapLocations);
                let cardContentHeight = this.getMapAvailableHeight();
                this.heatmapConfigs.minHeight = cardContentHeight;
                this.heatmapConfigs.title = this.cardContainerConfig.title;
                // this.heatmapComponent.ngOnInit();
                // let cardHeight = this.setMapHeightByCardSettings();
                // console.log(this.heatmapLocations, this.heatmapComponent, cardHeight);
                /* if (this.heatmap.data[0].colHeader == null || this.heatmap.data[0].colHeader == '') {
                  this.badTableData = true;
                }
                if (this.heatmap.data[0].rowHeader == null || this.heatmap.data[0].rowHeader == '') {
                  this.badTableData = true;
                } */
            }
        }
        //console.log('dashboard-card-component', this.graphic);
        if (this.graphic) {
            if (this.graphic.data && this.graphic.data.length > 0) {
                this.graphicType = this.graphic.data[0].type ? 'graphic-card-' + this.graphic.data[0].type : '';
            }
            if (this.graphic.layout) {
                this.graphic.config.displaylogo = false;
                this.graphic.layout.title = null;
            }
            if (this.graphic.data.length == 0) {
                //this.cardContainerConfig.loaderVisible = false;
            }
        }
        //console.log(this.cardContainerConfig);
        // console.log("graphic: ", this.graphic);
        this.setHelpInline(this.cardContainerConfig);
        //// console.log("date fields required?",this.cardContainerConfig.isRequiredDateFields);
        if (this.cardContainerConfig.statusMapping && this.status) {
            // // console.log('ccsm' , this.cardContainerConfig.statusMapping, this.status);
            // TODO gestire status errore che arriva del tipo cassandra_error o app_error ...
            let mapping = this.findStatusMapping(this.cardContainerConfig.statusMapping, this.status);
            // if (this.cardContainerConfig.statusMapping[this.status]) {
            if (mapping) {
                const statusMapping = this.cardContainerConfig.statusMapping;
                // let mapping = statusMapping.find((el) => el.key == this.status);
                // console.log(mapping['key'])
                switch (true) {
                    case this.badConditions.includes(mapping['key']):
                        this.healthStatus = 'error';
                        break;
                    case this.warningConditions.includes(mapping['key']):
                        this.healthStatus = 'warning';
                        break;
                    default:
                        this.healthStatus = 'ok';
                        break;
                }
                if (mapping.action == 'showMessage') {
                    this.showData = false;
                    this.messageKey = mapping.key;
                    this.dataMessage = mapping.message;
                    if (mapping.messageKey)
                        this.dataMessage = mapping.messageKey;
                }
                else if (mapping.action == 'evaluateData' && mapping.conditions) {
                    for (const cond of mapping.conditions) {
                        switch (cond.condition) {
                            case 'is null':
                                if ((this.graphic && this.graphic.data && this.graphic.data.length <= 0) ||
                                    (this.table) || (this.heatmap)) {
                                    this.showData = false;
                                    this.dataMessage = cond.message;
                                    if (cond.messageKey)
                                        this.dataMessage = cond.messageKey;
                                    if (cond.conditionKey) {
                                        this.conditionKey = cond.conditionKey;
                                        if (this.badConditions.includes(this.conditionKey)) {
                                            this.healthStatus = 'error';
                                        }
                                        if (this.warningConditions.includes(this.conditionKey)) {
                                            this.healthStatus = 'warning';
                                        }
                                    }
                                }
                                break;
                            default:
                                break;
                        }
                    }
                }
            }
            else {
                this.showData = true;
            }
        }
    }
    isSortingDisabled(header) {
        if (header == 'rowHeader') {
            return false;
        }
        if (this.graphicConfig == null) {
            return false;
        }
        //console.log("issortingdisabled for header: ",header);
        const gc = this.graphicConfig.graphConfiguration;
        if (gc != null) {
            let yax = gc.yaxis?.find((ele) => ele.label == header);
            if (yax != null && (yax.valueFunction == null || yax.valueFunction == '')) {
                return false;
            }
        }
        return true;
    }
    getPagedChartData() {
        //console.log("paging chart:",this.graphicConfig.graphConfiguration);
        const gc = this.graphicConfig.graphConfiguration;
        if (this.dataSource instanceof PagedDataSource) {
            this.dataSource.loadingPagedData = true;
            let cust = {};
            let sortParams = null;
            let direction = 'ASC';
            if (this.sort && this.sort.active) {
                if (gc != null && gc.tableHeaderMaps != null) {
                    let headerMapEle = gc.tableHeaderMaps.find((el) => el.tableField == this.sort.active);
                    sortParams = headerMapEle ? headerMapEle.originalField : null;
                }
            }
            if (this.sort && this.sort.direction) {
                if (this.sort.direction == 'asc')
                    direction = 'ASC';
                else
                    direction = 'DESC';
            }
            // this.checkedAll = this.checkAllChecked(this.selection.selected,this.dataSource.data);
            // 'selectedElements', this.checkedAll)
            this.cardContainerConfig.loaderVisible = false;
            return this.setLoadDataSubscription(this.dataSource.loadChartData(cust, this.filterKeys, this.filterValue, sortParams ? "" + sortParams : "", direction, this.paginator.pageIndex, this.paginator.pageSize, this.graphicConfig.graphConfiguration, this._buildTablePagedDatasource.bind(this), true));
        }
        return new Subscription();
    }
    _buildTablePagedDatasource() {
        this.buildTablePagedDatasource(this.graphicConfig.graphConfiguration, this.dataSource.data);
    }
    //TODO: Modificare questo metodo per consentire la visualizzazione di "Nessun dato disponibile"
    //tenendo in considerazione che la tabella in fase di loading dei dati deve essere visualizzata al fine
    //di inizializzare il sort e il paginator
    _checkData() {
        //console.log("_checkdata");
        return true;
        /* if (this.dataSource instanceof PagedDataSource){
          console.log("paged");
          if(this.dataSource.loadingPagedData){
            console.log("false")
            return false;
          }
          else{
            console.log("return")
            return this.checkData();
          }
        }
        console.log("not paged");
        return this.checkData(); */
    }
    viewPagingTableLoadingData() {
        if (this.dataSource instanceof PagedDataSource) {
            //console.log("loading paged data: ",this.dataSource.loadingPagedData);
            return this.dataSource.loadingPagedData;
        }
        return false;
    }
    buildMapObjectFromTable(graphicConfig, data) {
        let ret = new Array();
        if (data != null) {
            // data.forEach((d) => {
            //   if (d != null) {
            //     let o: Heatmap = new Heatmap(d.rowHeader, d[d['colHeader']]);
            //     o.area = d['colArea'];
            //     ret.push(o);
            //   }
            // });
            // aggregateRequired: null
            // ateco2007: "PRODUZIONE DI SOFTWARE, CONSULENZA INFORMATICA E ATTIVITÀ CONNESSE"
            // id: 2146832
            // idAteco: "620"
            // idTerritorio: "ITC4"
            // regione: "Lombardia"
            // territorio: "Lombardia"
            // typeTerritorio: "Regione"
            // value: 14294
            // TODO: const keyField = graphConfig.....
            const keyField = 'territorio';
            // TODO: const valueField = graphConfig....
            const valueField = 'value';
            // TODO: recuperare gli otherField da graphConfig
            const otherFields = ['typeTerritorio', 'regione', 'provincia', 'idTerritorio'];
            data.forEach((d) => {
                if (d != null) {
                    let o = new HeatmapObj(d[keyField], d[valueField]);
                    if (otherFields) {
                        otherFields.forEach((otf) => {
                            if (otf && d[otf]) {
                                o[otf] = d[otf];
                            }
                        });
                    }
                    ret.push(o);
                }
            });
        }
        //console.log(ret);
        return ret;
    }
    findStatusMapping(statusMapping, status) {
        if (!status)
            return null;
        let mapping = statusMapping.find((el) => el.key == status);
        if (mapping)
            return mapping;
        for (const sm of statusMapping) {
            if (sm.key.indexOf('*') == 0) {
                if (status.indexOf(sm.key.substr(1)) > -1)
                    return sm;
            }
        }
        return null;
    }
    setHelpInline(cardContainerConfig) {
        if (cardContainerConfig && cardContainerConfig.helpKey) {
            this.cardContainerConfig.helpDescription = 'help.' + this.cardContainerConfig.helpKey + '.description';
            this.cardContainerConfig.helpTitle = 'help.' + this.cardContainerConfig.helpKey + '.label';
        }
    }
    applyFilter(event) {
        /* if (this.table.clickEventInfo && this.table.clickEventInfo.onClickEvents && this.table.clickEventInfo.onClickEvents.length > 0) {
            if (this.table.clickEventInfo.onClickEvents[0].type == 'toggleSelect'){
            //console.log("cleaning filtervalues")
              this.filterValues = new Set();
              this.oldFilterValues = new Set();
              this.plotRowsButtonDisabled = true;
          }
        } */
        const filterValue = event.target.value;
        this.dataSource.filter = filterValue.trim().toLowerCase();
    }
    applyStringFilter(filt) {
        //console.log("filtro applicato");
        //console.log("table: ",this.table);
        if (this.table.clickEventInfo && this.table.clickEventInfo.onClickEvents && this.table.clickEventInfo.onClickEvents.length > 0) {
            if (this.table.clickEventInfo.onClickEvents[0].type == 'toggleSelect') {
                //console.log("cleaning filtervalues")
                this.filterValues = new Set();
                this.oldFilterValues = new Set();
                this.plotRowsButtonDisabled = true;
            }
        }
        const filterValue = filt;
        this.dataSource.filter = filterValue.trim().toLowerCase();
    }
    checkCheckboxesAndAddRow() {
        //console.log("clickeventinfo: ",this.table.clickEventInfo);
        if (this.table.clickEventInfo
            && this.table.clickEventInfo.onClickEvents
            && this.table.clickEventInfo.onClickEvents.length > 0) {
            switch (this.table.clickEventInfo.onClickEvents[0].type) {
                case 'toggleSelect':
                    console.log('in check toggleSelect', this.table);
                    this.showCheckboxes = true;
                    this.filterValues = new Set();
                    this.oldFilterValues = new Set();
                    this.selectedRowsButtonVisible = true;
                    break;
                case 'toggleLine':
                    console.log('in check toggleLine', this.table);
                    this.showCheckboxes = true;
                    this.filterValues = new Set();
                    this.oldFilterValues = new Set();
                    this.plotRowsButtonVisible = true;
                    break;
                default:
                    this.showCheckboxes = false;
                    this.clickableRows = true;
                    break;
            }
            // if (this.table.clickEventInfo.type && this.table.clickEventInfo.type != 'toggleLine') {
            //   this.showCheckboxes = false;
            //   this.clickableRows = true;
            // } 
            // else {
            //   this.showCheckboxes = true;
            //   this.filterValues = new Set();
            //   this.oldFilterValues = new Set();
            //   this.plotRowsButtonVisible = true;
            // }
        }
        //aggiungo una nuova colonna per visualizzare le checkboxes in una cella a parte
        if (this.showCheckboxes) {
            // // console.log('table data: ', this.table.data);
            this.table.data.forEach(element => {
                element.checkboxesHeader = element.rowHeader;
            });
        }
    }
    ngOnChanges(changes) {
        if (changes.graphic?.currentValue?.data?.length > 0) {
            if (this.graphic.data && this.graphic.data.length > 0) {
                this.graphicType = this.graphic.data[0].type ? 'graphic-card-' + this.graphic.data[0].type : '';
            }
        }
        if (changes.table?.currentValue?.data || changes.heatmap?.currentValue?.data) {
            this.ngOnInit();
        }
        if (!this.isGridsterElement) {
            if (this.elementCard?.nativeElement?.id) {
                this.setElementSize();
            }
        }
    }
    resize(width, height) {
        if (this.graphic && this.graphic.layout) {
            //console.log("cardcontainerid:"+this.cardContainerConfig.id+" graphic width: ",width);
            this.graphic.layout.width = width;
            if (this.elHeader) {
                let containerDiv = this.domDocument.getElementById('dash-header-' + this.cardContainerConfig.id);
                let containerDivHeight = 0;
                if (containerDiv && containerDiv.offsetHeight) {
                    containerDivHeight = containerDiv.offsetHeight;
                }
                /* var indicatorExtra = 0;
                if (this.isIndicator(this.graphic)){
                  indicatorExtra = 10;
                } */
                this.graphic.layout.height = (height - containerDivHeight - 20) + "";
                //console.log("resize elheader: ", height, containerDivHeight);
            }
            else {
                this.graphic.layout.height = height;
                //console.log("resize not elheader: ", this.graphic.layout);
            }
        }
    }
    getMapAvailableHeight() {
        // let containerDiv = this.domDocument.getElementById('dash-header-' + this.cardContainerConfig.id);
        // let cardContent = this.elementCardContent.nativeElement;
        let cardElement = this.elementCard.nativeElement.offsetHeight;
        let cardHeader = this.domDocument.getElementById('dash-header-' + this.cardContainerConfig.id).offsetHeight;
        let calculatedArea = cardElement - cardHeader - 20;
        // console.log(calculatedArea);
        return calculatedArea;
    }
    isIndicator(graphic) {
        if (this.graphic && this.graphic.data && graphic.data[0] && graphic.data[0].type == 'indicator') {
            return true;
        }
        return false;
    }
    showHeader(headerIndex) {
        if (this.showCheckboxes) {
            if (headerIndex > 1) {
                return true;
            }
        }
        else {
            if (headerIndex > 0) {
                return true;
            }
            else if (this.colHeaders[headerIndex] != 'rowHeader') {
                return true;
            }
        }
        return false;
    }
    showElement(headerIndex) {
        if (this.showCheckboxes) {
            if (headerIndex > 0) {
                return true;
            }
        }
        else {
            return true;
        }
        return true;
    }
    /**
     * After view init
     */
    ngAfterViewInit() {
        if (!this.isGridsterElement) {
            if (this.elementCard?.nativeElement?.id) {
                this.setElementSize();
            }
        }
    }
    afterPlot($event) {
        //console.log("evento: ",$event);
        let cardContainer = this.domDocument.getElementById(this.cardContainerConfig.id);
        //console.log('after plot card container id: ', this.cardContainerConfig.id, " card container found: ",cardContainer);
        //in caso di gridster il resize va eseguito solo quando non si sta modificando la griglia.
        if (cardContainer && (!this.isGridsterElement || this.forceAfterPlotForGridster)) {
            //console.log('ge: ',cardContainer);//
            //console.log('resizing - ge width: ',cardContainer.offsetWidth, ' height:', cardContainer.offsetHeight);
            this.resize(cardContainer.offsetWidth, cardContainer.offsetHeight);
            this.afterPlotEvent.emit(this.cardContainerConfig.id);
        }
    }
    getId() {
        return this.cardContainerConfig.id;
    }
    setElementSize(width, height) {
        if (width) {
            this.cardContainerConfig.width = width;
        }
        if (height) {
            this.cardContainerConfig.height = height;
        }
        this.resize(this.cardContainerConfig.width, this.cardContainerConfig.height);
        // this.matCard = this.domDocument.getElementById('dash-matcard-'+id);
        // this.containerDiv = this.domDocument.getElementById(id);
        // if(this.cardContainerConfig.width){
        //   this.containerDiv.style.width =  this.cardContainerConfig.width;
        //   this.graphic.layout.width =  this.cardContainerConfig.width;
        // }
        // if(this.cardContainerConfig.height){
        //   this.containerDiv.style.height = this.cardContainerConfig.height;
        //   this.graphic.layout.height =  this.cardContainerConfig.height;
        // }
        //console.log("set element size width: ",this.cardContainerConfig.width ," height: ",this.cardContainerConfig.height);
        //this.resize(this.cardContainerConfig.width, this.cardContainerConfig.height);
    }
    updateCardGraphicBySelectorDate(filterDateFields) {
        this.filterDates.startDate = filterDateFields.startDate;
        this.filterDates.endDate = filterDateFields.endDate;
        this.filterDates.cardContainerConfig = this.cardContainerConfig;
        this.filterDatesEvent.emit(this.filterDates);
    }
    newMetricSelected(event) {
        // console.log("new element selected: ", event.value);
        this.cardContainerConfig.loaderVisible = true;
        this.selectedMetricEvent.emit({ graphicConfig: this.graphicConfig, selectedMetric: event });
    }
    newMultipleMetricSelected(event) {
        //aggiorna graphicConfig
        //console.log(this.selectedMultipleMetric.id);
        this.graphicConfig.multipleDatasourceMetricsVisualization = this.selectedMultipleMetric.id;
        this.selectedMultipleMetricViewEvent.emit({ graphicConfig: this.graphicConfig, newMultipleMetricSelected: event.value });
    }
    newPieLimitValuesSelected(event) {
        // console.log("new element selected: ", event.value);
        let limitPieResults = true;
        this.cardContainerConfig.loaderVisible = true;
        if (this.selectedPieLimitValues == 'ALL') {
            limitPieResults = false;
        }
        this.selectedLimitPieResults.emit({ graphicConfig: this.graphicConfig, limitPieResults: limitPieResults });
    }
    checkViewLimitPieSelect() {
        let viewLimitPieSelect = false;
        if (this.graphic.data.length > 0) {
            viewLimitPieSelect = this.graphic.data.some((d) => d.values.length > 5);
        }
        return viewLimitPieSelect;
    }
    plotNewRows() {
        //// console.log(headerIndex);
        const obj = {
            onClickEvents: this.table.clickEventInfo.onClickEvents,
            filterField: this.table.clickEventInfo.filterField,
            filterValues: this.filterValues
        };
        //// console.log(obj);
        this.drawRowsEvent.emit(obj);
        this.oldFilterValues = new Set(this.filterValues);
        this.plotRowsButtonDisabled = true;
    }
    editDashboardCard() {
        const obj = {};
        this.selectDashboardCard.emit(obj);
    }
    ngOnDestroy() {
        //this.observer.unobserve(this.expandedContainer);
    }
    updateSelectedLabel(event, label) {
        if (event.checked) {
            if (this.filterValues.has(label)) {
                this.plotRowsButtonDisabled = true;
            }
            else {
                this.filterValues.add(label);
                this.plotRowsButtonDisabled = false;
            }
        }
        else {
            if (this.filterValues.has(label)) {
                this.filterValues.delete(label);
                this.plotRowsButtonDisabled = false;
            }
            else {
                this.filterValues.add(label);
                this.plotRowsButtonDisabled = true;
            }
        }
        if (this.eqSet(this.filterValues, this.oldFilterValues)) {
            this.plotRowsButtonDisabled = true;
        }
        /*  if (this.filterValues.size == 0) {
           this.plotRowsButtonDisabled = true;
         } */
        if (this.filterValues.size >= 6) {
            //Disable checkbox
            this.disableCheckboxes = true;
        }
        //// console.log("filtervalues",this.filterValues);
    }
    eqSet(as, bs) {
        let ret = true;
        if ((as && !bs) || (!as && bs)) {
            return false;
        }
        if (as.size !== bs.size) {
            return false;
        }
        as.forEach(a => {
            // console.log(bs, " - ", a);
            if (!bs.has(a)) {
                ret = false;
            }
        });
        return ret;
    }
    matCheckboxChecked(value) {
        if (this.filterValues.has(value)) {
            return true;
        }
        return false;
    }
    clickRow(element) {
        // // console.log('element clicked', element);
        // // console.log('clicked', this.table.clickEventInfo.onClickEvents)
        if (this.table && this.table.clickEventInfo && this.table.clickEventInfo.onClickEvents) {
            this.table.clickEventInfo.onClickEvents.forEach(el => {
                if (el.funct) {
                    if (el.params)
                        el.funct(element, el.params);
                    else
                        el.funct(element);
                }
            });
        }
    }
    handlePageEvent(event) {
        let rows = this.domDocument.getElementsByTagName('tr');
        let maxRowHeight = 0;
        let meanRowHeight = 0;
        if (rows != null && rows.length > 1) {
            //scarto la riga dell'header
            for (var i = 0; i < rows.length; i++) {
                let element = rows.item(i);
                if (!element)
                    continue;
                meanRowHeight += element.clientHeight;
                if (element.clientHeight > maxRowHeight) {
                    maxRowHeight = element.clientHeight;
                }
            }
            meanRowHeight = meanRowHeight / rows.length;
            maxRowHeight = (maxRowHeight + meanRowHeight) / 2;
        }
        const obj = {
            pageEvent: event,
            cardContainerId: this.cardContainerConfig.id,
            maxRowHeight: maxRowHeight
        };
        //// console.log(obj);
        if (this.dataSource instanceof PagedDataSource) {
            //console.log(this.graphicConfig.graphConfiguration);
            this.graphicConfig.graphConfiguration.pageSize = event.pageSize;
            this.graphicConfig.graphConfiguration.pageNumber = event.pageIndex;
            this.getPagedChartData()?.add(() => {
                if (this.pageSize != event.pageSize && (this.pageSize < event.length || event.pageSize < event.length)) {
                    this.tablePageEvent.emit(obj);
                    //console.log(obj);
                }
                this.pageSize = event.pageSize;
            });
        }
        else {
            //adattamento della dimensione della tabella solo in caso di cambio del pagesize
            if (this.pageSize != event.pageSize && (this.pageSize < event.length || event.pageSize < event.length)) {
                this.tablePageEvent.emit(obj);
            }
            this.pageSize = event.pageSize;
        }
    }
    emitPlotlyEvent(event) {
        this.plotlyEvent.emit(event);
    }
    //verifica dell'elemento
    checkElement(value, element, header) {
        //console.log("------------- checkelement");
        //mostro eventuali url
        if (header == 'rowHeader' && typeof value == 'string') {
            //verifico se l'elemento è il rowheader ed ha unit=url costruisco l'url. Non mi interesso degli altri elementi perché saranno costruiti correttamente 
            //nel table.ts
            let rowheaderUnit = element['rowHeaderUnit'];
            if (rowheaderUnit && rowheaderUnit.toUpperCase() == 'URL') {
                //Se è un url valido genero l'hyperlink
                if (this.isValidUrl(value)) {
                    value = this.generateHyperlink(value);
                }
                //Se non è un url valido perché non contiene protocollo e dominio, lo concateno col dominio indicato
                else if (!this.isValidUrl(value) && this.cardContainerConfig.domain != null) {
                    value = this.generateHyperlink(this.cardContainerConfig.domain + value);
                }
            }
            return value;
        }
        if (Number.isNaN(value)) {
            value = null;
        }
        //mostro eventuali numeri formattati secondo il locale
        if (typeof value == 'number') {
            value = value.toLocaleString(this.currLang, { minimumFractionDigits: 0, maximumFractionDigits: 3 });
        }
        //console.log("element: ",element,"header: ", header, "value: ",value);
        return value;
    }
    sorting() {
        this.dataSource.sortingDataAccessor = this._sorting.bind(this);
    }
    _sorting(item, property) {
        //console.log("sorting");
        if (this.numberColumns && this.numberColumns.indexOf(property) > -1) {
            return this.convertCurrency(item[property]);
        }
        else {
            let convertedDate = this.tryConvertToDate(item[property]);
            if (convertedDate.isValid) {
                return convertedDate.time;
            }
            return item[property];
        }
    }
    ;
    // NON PIU' NECESSARIO!
    //https://gist.github.com/armueller/f21a3ca3cb941c08a1a6944a89956741
    sortingTable(sortState) {
    }
    sortingTableOrig(sortState) {
        //console.log('sorting:',sortState);
        let newData = new Array();
        if (sortState.active && sortState.direction != '') {
            const isAsc = sortState.direction === 'asc';
            if (this.numberColumns && this.numberColumns.indexOf(sortState.active)) {
                newData = this.dataSource.data;
                newData.sort((a, b) => {
                    const valA = this.convertCurrency(a[sortState.active]);
                    const valB = this.convertCurrency(b[sortState.active]);
                    return this.compareNumber(valA, valB, isAsc);
                });
            }
            else {
                newData = this.dataSource.data.sort((a, b) => {
                    return this.compare(a[sortState.active], b[sortState.active], isAsc);
                });
            }
            this.newDataSource(newData, true).then((v) => {
                this.sorting();
            });
        }
    }
    compareNumber(a, b, isAsc) {
        if (a == null && b == null)
            return 0;
        if (a == null)
            if (isAsc)
                return -1;
            else
                return 1;
        if (b == null)
            if (isAsc)
                return 1;
            else
                return -1;
        if (isAsc)
            return a - b;
        else
            return b - a;
    }
    compare(a, b, isAsc) {
        // equal items sort equally
        if (a === null && b === null) {
            return 0;
        }
        // nulls sort after anything else
        else if (a === null) {
            return 1;
        }
        else if (b === null) {
            return -1;
        }
        // otherwise, if we're ascending, lowest sorts first
        else if (isAsc) {
            return a < b ? -1 : (a === b ? 0 : 1);
        }
        // if descending, highest sorts first
        else {
            return a < b ? 1 : (a === b ? 0 : -1);
        }
    }
    //verifico se sia a che b siano date nel formato dd/mm/yyyy oppure yyyy/mm/dd
    tryConvertToDate(a) {
        let result = { isValid: false, time: null };
        if (a == null) {
            return result;
        }
        else if (moment$1(a, "DD/MM/YYYY", true).isValid()) {
            //console.log("comparing date:",aDate, bDate);
            result.isValid = true;
            result.time = moment$1(a, "DD/MM/YYYY").toDate().getTime();
            return result;
        }
        else if (moment$1(a, "YYYY/MM/DD", true).isValid()) {
            result.isValid = true;
            result.time = moment$1(a, "YYYY/MM/DD").toDate().getTime();
            return result;
        }
        return result;
    }
    convertCurrency(currency) {
        if (!currency)
            return null;
        currency = currency.replaceAll('.', '');
        currency = currency.replaceAll(',', '.');
        return Math.round(Number(currency.replace(/[^0-9.-]+/g, ""))) * 100;
    }
    // isValidUrl(element: any) {
    //   if (typeof element == 'string') {
    //     return this.isValidUrl(element);
    //   }
    //   else {
    //     return false;
    //   }
    // }
    generateHyperlink(url) {
        //console.log("hyperlink matched:",url);
        let el = "<a href=\"" + url + "\"  target=\"_blank\">" + url + "</a>";
        return el;
    }
    tooltipDisabledTable(text) {
        if (text == null) {
            return true;
        }
        if (typeof text == 'string') {
            if (this.isHTML(text) || text.length < this.defaultMaxStringLength) {
                return true;
            }
        }
        if (typeof text == 'number') {
            return true;
        }
        return false;
    }
    isValidUrl(url) {
        if (typeof url == 'string') {
            const pattern = new RegExp(this.urlPattern, 'i'); // fragment locator
            return !!pattern.test(url);
        }
        else {
            return false;
        }
    }
    isHTML(text) {
        const htmlRegex = new RegExp(/<\/?[a-z][\s\S]*>/i);
        return !!htmlRegex.test(text);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.9", ngImport: i0, type: DynamicDashboardCardComponent, deps: [{ token: DOCUMENT }, { token: i1$1.MatDialog }, { token: i2.MatSnackBar }, { token: i3$2.ErrorHandlerService }, { token: i0.Injector }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.9", type: DynamicDashboardCardComponent, selector: "ngx-dynamic-dashboard-card, ngx-dashboard-card", inputs: { graphicConfig: "graphicConfig", graphic: "graphic", table: "table", heatmap: "heatmap", cardContainerConfig: "cardContainerConfig", action: "action", status: "status", isGridsterElement: "isGridsterElement", forceAfterPlotForGridster: "forceAfterPlotForGridster", newContainerWidth: "newContainerWidth", numberColumns: "numberColumns", tableLimitFilterValuesEnabled: "tableLimitFilterValuesEnabled" }, outputs: { filterDatesEvent: "filterDatesEvent", selectedMetricEvent: "selectedMetricEvent", selectedMultipleMetricViewEvent: "selectedMultipleMetricViewEvent", selectedLimitPieResults: "selectedLimitPieResults", drawRowsEvent: "drawRowsEvent", selectDashboardCard: "selectDashboardCard", afterPlotEvent: "afterPlotEvent", tablePageEvent: "tablePageEvent", plotlyEvent: "plotlyEvent" }, viewQueries: [{ propertyName: "elementCard", first: true, predicate: ["elementCard"], descendants: true }, { propertyName: "elHeader", first: true, predicate: ["elHeader"], descendants: true }, { propertyName: "plotlyGraph", first: true, predicate: ["plotlyGraph"], descendants: true }, { propertyName: "tdRef", first: true, predicate: ["tr"], descendants: true }, { propertyName: "filterElement", first: true, predicate: ["input"], descendants: true }, { propertyName: "elementCardContent", first: true, predicate: ["cardContent"], descendants: true }, { propertyName: "buttonPlotRows", first: true, predicate: ["buttonPlotRows"], descendants: true }, { propertyName: "buttonSelectRows", first: true, predicate: ["buttonSelectRows"], descendants: true }], usesInheritance: true, usesOnChanges: true, ngImport: i0, template: "<div id=\"dash-container-{{cardContainerConfig.id}}\" #elementCard class=\"dashboard-card-wrapper\" \n    [ngClass]=\"cardContainerConfig.cssClasses\" [class.status-dander]=\"healthStatus == 'danger'\" \n    [class.status-warning]=\"healthStatus == 'warning'\">\n    \n    <mat-card id=\"dash-matcard-{{cardContainerConfig.id}}\" class=\"dashboard-card {{ graphicType }} mat-elevation-z0\" [ngClass]=\"{'hasIcon' : cardContainerConfig.iconHeader , 'hide-shadow' : cardContainerConfig.hideShadowBorder, 'bg-rating-error' : healthStatus == 'error','bg-rating-warning' : healthStatus == 'warning'}\">\n      <mat-icon color=\"primary\" class=\"icon-card\" *ngIf=\"cardContainerConfig.iconHeader\">{{ cardContainerConfig.iconHeader }}</mat-icon>\n      <mat-card-header  class=\"mb-0\" id=\"dash-header-{{cardContainerConfig.id}}\" #elHeader fxLayout=\"row\" fxLayoutAlign=\"center center\">\n        <mat-card-title *ngIf=\"cardContainerConfig.title\" fxLayout=\"row\" fxLayoutAlign=\"flex-start center\" fxFlex=\"100\">\n          <app-help-inline *ngIf=\"cardContainerConfig.helpDescription || cardContainerConfig.helpTitle\" [mode]=\"'dialog'\" [description]=\"cardContainerConfig.helpDescription\" [title]=\"cardContainerConfig.helpTitle\" [status]=\"healthStatus\" [dialogWidth]=\"cardContainerConfig.helpWidth\"></app-help-inline>\n          <span translate [innerHTML]=\"cardContainerConfig.title\"></span>\n        </mat-card-title>\n       \n        <div class=\"card-actions\" fxFlex=\"1 1 auto\" fxLayoutAlign=\"flex-end center\">\n          <app-date-selector *ngIf=\"cardContainerConfig.isRequiredDateFields\" [startDate]=\"startFilteringDate\"\n            [endDate]=\"endFilteringDate\" (filterDatesEvent)=\"updateCardGraphicBySelectorDate($event)\" [expanded]=\"true\">\n          </app-date-selector>\n          <ng-container *ngIf=\"graphic && graphic.data.length > 0\">\n            <!--mat select change limit pie-->\n            <mat-form-field class=\"mr-16\" appearance=\"outline\" \n              *ngIf=\"graphic.data[0].type == 'pie' && checkViewLimitPieSelect() && graphicConfig != null\">\n              <mat-label translate>label.filter_results</mat-label>\n              <mat-select [(ngModel)]=\"selectedPieLimitValues\" (selectionChange)=\"newPieLimitValuesSelected($event)\">\n                <mat-option value=\"TOPFIVE\">\n                  <span translate>label.top_five</span>\n                </mat-option>\n                <mat-option value=\"ALL\">\n                  <span translate>label.all</span>\n                </mat-option>\n              </mat-select>\n            </mat-form-field>\n            <!--mat select change possible metrics-->\n            <mat-form-field appearance=\"outline\" *ngIf=\"graphic.possibleMetrics\">\n              <mat-label translate>dashboard.widget.possibleMetrics</mat-label>\n              <mat-select [(ngModel)]=\"selectedMetric\" (selectionChange)=\"newMetricSelected($event)\">\n                <mat-option *ngFor=\"let pm of graphic.possibleMetrics\" [value]=\"pm\">\n                  {{pm.label}}\n                </mat-option>\n              </mat-select>\n            </mat-form-field>\n            <!--mat select change combination of metrics-->\n            <mat-form-field appearance=\"outline\" *ngIf=\"graphic.possibleMultipleMetrics\">\n              <mat-label translate>dashboard.widget.possible_multiple_metrics_view</mat-label>\n              <mat-select [(ngModel)]=\"selectedMultipleMetric\" (selectionChange)=\"newMultipleMetricSelected($event)\">\n                <mat-option *ngFor=\"let pm of graphic.possibleMultipleMetrics\" [value]=\"pm\">\n                  {{pm.label}}\n                </mat-option>\n              </mat-select>\n            </mat-form-field>\n          </ng-container>\n          <ng-container *ngIf=\"table && showCheckboxes && plotRowsButtonVisible\">\n            <button (click)=\"plotNewRows()\" mat-flat-button *ngIf=\"plotRowsButtonVisible\"\n              [disabled]=\"plotRowsButtonDisabled\" color=\"primary\" #buttonPlotRows>\n              <span translate>label.plotrows</span></button>\n          </ng-container>\n          <ng-container  *ngIf=\"table && cardContainerConfig.isRequiredTableFilter\">\n            <!-- <span class=\"spacer\" fxFlex=\"1 1 0\"></span> -->\n            <mat-form-field appearance=\"outline\">\n              <mat-label>Filtra risultati</mat-label>\n              <input matInput (keyup)=\"applyFilter($event)\" placeholder=\"Filtra\" #input>\n            </mat-form-field>\n          </ng-container>\n          <!-- <button mat-icon-button (click)=\"editDashboardCard()\" matTooltip=\"Modifica widget\">\n            <mat-icon class=\"animate-pen\">settings</mat-icon>\n          </button> -->\n        </div>\n      </mat-card-header>\n      \n      <mat-card-content *ngIf=\"showData;else noShowData\" class=\"container-card\" [ngClass]=\"{'graphic-chart':graphic , 'table-chart':table }\" #cardContent>\n              \n        <!--start grafic definition-->\n        <div *ngIf=\"graphic && !cardContainerConfig.loaderVisible\" class=\"grahpic-data\">\n         <!-- <span style=\"position:absolute; top:0\">{{ graphic.layout.width }} -  {{ graphic.layout.height }}</span> -->\n          <plotly-plot *ngIf=\"graphic.data.length > 0; else elseBlock\" \n              [data]=\"graphic.data\" [layout]=\"graphic.layout\" [config] =\"graphic.config\" #plotlyGraph \n              (afterPlot)=\"afterPlot($event)\" (initialized)=\"afterPlot($event)\" [updateOnLayoutChange]=\"true\"\n              (plotlyClick)=\"emitPlotlyEvent($event)\" (hover)=\"emitPlotlyEvent($event)\"></plotly-plot>\n        </div>\n         <ng-template #elseBlock>\n            <div class=\"no-data\">\n            \n             <mat-icon class=\"icon-nodata\">warning</mat-icon><span translate>label.nodata</span> \n                <!-- <img class=\"placeholder-nodata\"[src]=\"'/assets/images/placeholders/chart_2.png'\"> -->\n            </div>\n          </ng-template>\n        \n        <!--start table definition-->\n        <div *ngIf=\"table && !cardContainerConfig.loaderVisible\" class=\"table-data\">\n            <!-- <ng-container *ngIf=\"showCheckboxes\">\n                <button (click)=\"plotNewRows()\" mat-flat-button [visible]=\"plotRowsButtonVisible\" [disabled]=\"plotRowsButtonDisabled\" color=\"primary\">\n                  Disegna righe selezionate nel grafico</button>\n            </ng-container> -->\n            <div class=\"mobile-sort-button-container\">\n                <button class=\"mobile-sort-button mb-8\" (click)=\"toggleOrderBlock()\" mat-flat-button>Ordina</button>\n            </div>\n            <div class=\"table-wrapper\" >\n              <table  #dataTableElement *ngIf=\"_checkData(); else elseBlock\"  class=\"mat-table-responsive striped dense hoverable\" \n                mat-table [dataSource]=\"dataSource\" matSort (matSortChange)=\"sortingTable($event)\">\n                <ng-container *ngFor=\"let header of colHeaders; let headerIndex = index\" matColumnDef=\"{{header}}\">\n                  <th mat-header-cell *matHeaderCellDef mat-sort-header [disabled]=\"isSortingDisabled(header)\"> \n                    <!--Evitare di vedere il primo e il secondo elemento (nel caso sia necessario vedere le checkbox)-->\n                    <ng-container *ngIf=\"showHeader(headerIndex)\">\n                      {{header | translate}}\n                    </ng-container>\n                  </th>\n                  <td mat-cell *matCellDef=\"let element\">\n                    <!--manca il disabled-->\n                    <mat-checkbox *ngIf=\"headerIndex == 0 && showCheckboxes\" [checked]=\"matCheckboxChecked(element[header])\"\n                      (change)=\"updateSelectedLabel($event, element[header])\" \n                      [disabled]=\"tableLimitFilterValuesEnabled && filterValues.size >= limitFilterValues && !matCheckboxChecked(element[header])\">\n                      <span matTooltip=\"Aggiungi / rimuovi la riga al grafico\" matTooltipPosition=\"right\">&nbsp;</span></mat-checkbox>\n                    <span class=\"mobile-label\">{{header | translate}}:</span>\n                    <label *ngIf=\"element[header] != null && showElement(headerIndex)\" \n                      matTooltip=\"{{(element[header] != null && showElement(headerIndex)) ? element[header] : null}}\"\n                      [matTooltipDisabled]=\"tooltipDisabledTable(element[header])\">\n                      \n                      <!-- <span [innerHTML]=\"validUrl(element[header])\"></span> -->\n                      <!-- <button class=\"link_icon_button\" mat-icon-button *ngIf=\"validUrl(element[header])\">\n                        <a mat-icon target=\"_blank\" href=\"{{element[header]}}\"><mat-icon >open_in_new</mat-icon></a>\n                      </button> -->\n                      <!-- <a *ngIf=\"isValidUrl(element[header]); else elseBlock\" [attr.href]=\"element[header]\" target=\"_blank\">\n                        {{(element[header].length>36)? (element[header] | slice:0:36)+'...':(element[header])}}\n                      </a> -->\n                      \n                        <span innerHTML=\"{{checkElement(element[header], element, header) | stringFormatter}}\"></span>\n                    </label>\n                  </td>\n                </ng-container>\n                <tr mat-header-row *matHeaderRowDef=\"displayedColumns; sticky: true\"></tr>\n                <tr mat-row *matRowDef=\"let element; columns: displayedColumns;\" \n                (click)=\"clickRow(element)\" [ngClass]=\"{'clickableRow': clickableRows}\"></tr>\n              </table>\n              <ng-template #elseBlock>\n                <div class=\"no-data\">\n                  <mat-icon class=\"icon-nodata\">warning</mat-icon><span translate>label.nodata</span> \n                  <!-- <img class=\"placeholder-nodata\" [src]=\"'/assets/images/placeholders/table.png'\"> -->\n                </div>\n              </ng-template>\n              <div class=\"table-actions\" fxLayout=\"row\" fxLayoutAlign=\"space-between center\">\n                <button  mat-flat-button *ngIf=\"table && showCheckboxes && selectedRowsButtonVisible\" \n                color=\"primary\" \n                (click)=\"plotNewRows()\"\n                [disabled]=\"plotRowsButtonDisabled\" \n                color=\"primary\"\n                #buttonSelectRows>\n                  <span translate>label.select_target</span>\n                  </button>\n                  <div class=\"spacer\" fxFlex=\"1 1 auto\"></div>\n                <mat-paginator [length]=\"data.length\" [pageSize]=\"pageSize\" [pageSizeOptions]=\"pageSizeOptions\" (page)=\"handlePageEvent($event)\"\n                showFirstLastButtons>\n                <!-- <mat-paginator *ngIf=\"!checkData()\" [length]=\"data?.length\" [pageSize]=\"pageSize\" [pageSizeOptions]=\"pageSizeOptions\"\n                [pageIndex]=\"pageNo\" showFirstLastButtons> -->\n              </mat-paginator>\n              </div>\n              \n            </div>\n        </div>\n\n        <div *ngIf=\"heatmap  && !cardContainerConfig.loaderVisible\" #heatmapContent>\n          <!-- map heatmap {{ heatmapLocations }} -->\n          <!-- <app-heatmap  [mapid]=\"'map-'+cardContainerConfig.id\" [heatmapLocations]=\"heatmapLocations\" [heatmapConfigs]='heatmapConfigs' #heatToSearch></app-heatmap> -->\n        </div>\n        <!-- start custom content -->\n        <ng-content select=\"[custom]\"></ng-content>\n        \n      </mat-card-content>\n      <ng-template #noShowData>\n        <div class=\"no-data p-16\">\n            <!-- <mat-icon class=\"icon-nodata has-heath-status\">{{healthStatus}}</mat-icon>  -->\n            <span [innerHTML]=\"dataMessage | translate\"></span>\n        </div>\n      </ng-template>\n    <!--end table definition-->\n    </mat-card>\n  </div>", styles: [".container-card.graphic-chart{margin:0 -16px;min-height:75px}::ng-deep .dashboard-card-header .mat-card-header-text{width:100%}.icon-card{width:100px;margin:auto;border-radius:7px;display:block;height:100px;line-height:100px;text-align:center;font-size:3em;position:absolute;left:20px;top:0;bottom:0;margin:auto!important;z-index:1}.hasIcon{padding-left:140px;position:relative}.mat-table{text-align:center}.card-actions .mat-form-field{min-width:150px}.hide-shadow{box-shadow:none!important}.no-data{display:flex;align-items:center;justify-content:center;flex-direction:column;position:relative;z-index:1}.no-data .icon-nodata{position:relative;left:0;top:0;height:100%;font-size:4em;width:100%;margin:auto;display:flex;align-items:center;justify-content:center;opacity:.2}.placeholder-nodata{max-height:300px}::ng-deep .js-plotly-plot .plotly,::ng-deep .js-plotly-plot .plotly div,::ng-deep .js-plotly-plot .plotly svg{max-width:100%;margin:auto}::ng-deep .js-plotly-plot .modebar-container{filter:invert(1)}::ng-deep .js-plotly-plot .modebar-container .modebar-group{background:transparent!important}::ng-deep .js-plotly-plot .plotly .main-svg:nth-child(1){position:relative}.link_icon_button{width:24px;height:24px;line-height:12px}.link_icon_button .mat-icon{min-width:12px;min-height:12px;font-size:12px}\n"], dependencies: [{ kind: "directive", type: i4.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "directive", type: i4.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i4.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i4$1.DefaultLayoutDirective, selector: "  [fxLayout], [fxLayout.xs], [fxLayout.sm], [fxLayout.md],  [fxLayout.lg], [fxLayout.xl], [fxLayout.lt-sm], [fxLayout.lt-md],  [fxLayout.lt-lg], [fxLayout.lt-xl], [fxLayout.gt-xs], [fxLayout.gt-sm],  [fxLayout.gt-md], [fxLayout.gt-lg]", inputs: ["fxLayout", "fxLayout.xs", "fxLayout.sm", "fxLayout.md", "fxLayout.lg", "fxLayout.xl", "fxLayout.lt-sm", "fxLayout.lt-md", "fxLayout.lt-lg", "fxLayout.lt-xl", "fxLayout.gt-xs", "fxLayout.gt-sm", "fxLayout.gt-md", "fxLayout.gt-lg"] }, { kind: "directive", type: i4$1.DefaultLayoutAlignDirective, selector: "  [fxLayoutAlign], [fxLayoutAlign.xs], [fxLayoutAlign.sm], [fxLayoutAlign.md],  [fxLayoutAlign.lg], [fxLayoutAlign.xl], [fxLayoutAlign.lt-sm], [fxLayoutAlign.lt-md],  [fxLayoutAlign.lt-lg], [fxLayoutAlign.lt-xl], [fxLayoutAlign.gt-xs], [fxLayoutAlign.gt-sm],  [fxLayoutAlign.gt-md], [fxLayoutAlign.gt-lg]", inputs: ["fxLayoutAlign", "fxLayoutAlign.xs", "fxLayoutAlign.sm", "fxLayoutAlign.md", "fxLayoutAlign.lg", "fxLayoutAlign.xl", "fxLayoutAlign.lt-sm", "fxLayoutAlign.lt-md", "fxLayoutAlign.lt-lg", "fxLayoutAlign.lt-xl", "fxLayoutAlign.gt-xs", "fxLayoutAlign.gt-sm", "fxLayoutAlign.gt-md", "fxLayoutAlign.gt-lg"] }, { kind: "directive", type: i4$1.DefaultFlexDirective, selector: "  [fxFlex], [fxFlex.xs], [fxFlex.sm], [fxFlex.md],  [fxFlex.lg], [fxFlex.xl], [fxFlex.lt-sm], [fxFlex.lt-md],  [fxFlex.lt-lg], [fxFlex.lt-xl], [fxFlex.gt-xs], [fxFlex.gt-sm],  [fxFlex.gt-md], [fxFlex.gt-lg]", inputs: ["fxFlex", "fxFlex.xs", "fxFlex.sm", "fxFlex.md", "fxFlex.lg", "fxFlex.xl", "fxFlex.lt-sm", "fxFlex.lt-md", "fxFlex.lt-lg", "fxFlex.lt-xl", "fxFlex.gt-xs", "fxFlex.gt-sm", "fxFlex.gt-md", "fxFlex.gt-lg"] }, { kind: "directive", type: i3.DefaultClassDirective, selector: "  [ngClass], [ngClass.xs], [ngClass.sm], [ngClass.md], [ngClass.lg], [ngClass.xl],  [ngClass.lt-sm], [ngClass.lt-md], [ngClass.lt-lg], [ngClass.lt-xl],  [ngClass.gt-xs], [ngClass.gt-sm], [ngClass.gt-md], [ngClass.gt-lg]", inputs: ["ngClass", "ngClass.xs", "ngClass.sm", "ngClass.md", "ngClass.lg", "ngClass.xl", "ngClass.lt-sm", "ngClass.lt-md", "ngClass.lt-lg", "ngClass.lt-xl", "ngClass.gt-xs", "ngClass.gt-sm", "ngClass.gt-md", "ngClass.gt-lg"] }, { kind: "component", type: i6.MatButton, selector: "    button[mat-button], button[mat-raised-button], button[mat-flat-button],    button[mat-stroked-button]  ", inputs: ["disabled", "disableRipple", "color"], exportAs: ["matButton"] }, { kind: "directive", type: i7.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { kind: "directive", type: i7.NgModel, selector: "[ngModel]:not([formControlName]):not([formControl])", inputs: ["name", "disabled", "ngModel", "ngModelOptions"], outputs: ["ngModelChange"], exportAs: ["ngModel"] }, { kind: "component", type: i8.MatOption, selector: "mat-option", exportAs: ["matOption"] }, { kind: "component", type: i10$1.MatCard, selector: "mat-card", inputs: ["appearance"], exportAs: ["matCard"] }, { kind: "directive", type: i10$1.MatCardContent, selector: "mat-card-content" }, { kind: "component", type: i10$1.MatCardHeader, selector: "mat-card-header" }, { kind: "directive", type: i10$1.MatCardTitle, selector: "mat-card-title, [mat-card-title], [matCardTitle]" }, { kind: "component", type: i9.MatCheckbox, selector: "mat-checkbox", inputs: ["disableRipple", "color", "tabIndex"], exportAs: ["matCheckbox"] }, { kind: "component", type: i10.MatFormField, selector: "mat-form-field", inputs: ["hideRequiredMarker", "color", "floatLabel", "appearance", "subscriptSizing", "hintLabel"], exportAs: ["matFormField"] }, { kind: "directive", type: i10.MatLabel, selector: "mat-label" }, { kind: "component", type: i2$1.MatIcon, selector: "mat-icon", inputs: ["color", "inline", "svgIcon", "fontSet", "fontIcon"], exportAs: ["matIcon"] }, { kind: "directive", type: i12.MatInput, selector: "input[matInput], textarea[matInput], select[matNativeControl],      input[matNativeControl], textarea[matNativeControl]", inputs: ["disabled", "id", "placeholder", "name", "required", "type", "errorStateMatcher", "aria-describedby", "value", "readonly"], exportAs: ["matInput"] }, { kind: "component", type: i1.MatPaginator, selector: "mat-paginator", inputs: ["disabled"], exportAs: ["matPaginator"] }, { kind: "component", type: i13.MatSelect, selector: "mat-select", inputs: ["disabled", "disableRipple", "tabIndex", "panelWidth", "hideSingleSelectionIndicator"], exportAs: ["matSelect"] }, { kind: "directive", type: i17.MatSort, selector: "[matSort]", inputs: ["matSortDisabled", "matSortActive", "matSortStart", "matSortDirection", "matSortDisableClear"], outputs: ["matSortChange"], exportAs: ["matSort"] }, { kind: "component", type: i17.MatSortHeader, selector: "[mat-sort-header]", inputs: ["disabled", "mat-sort-header", "arrowPosition", "start", "sortActionDescription", "disableClear"], exportAs: ["matSortHeader"] }, { kind: "component", type: i18.MatTable, selector: "mat-table, table[mat-table]", exportAs: ["matTable"] }, { kind: "directive", type: i18.MatHeaderCellDef, selector: "[matHeaderCellDef]" }, { kind: "directive", type: i18.MatHeaderRowDef, selector: "[matHeaderRowDef]", inputs: ["matHeaderRowDef", "matHeaderRowDefSticky"] }, { kind: "directive", type: i18.MatColumnDef, selector: "[matColumnDef]", inputs: ["sticky", "matColumnDef"] }, { kind: "directive", type: i18.MatCellDef, selector: "[matCellDef]" }, { kind: "directive", type: i18.MatRowDef, selector: "[matRowDef]", inputs: ["matRowDefColumns", "matRowDefWhen"] }, { kind: "directive", type: i18.MatHeaderCell, selector: "mat-header-cell, th[mat-header-cell]" }, { kind: "directive", type: i18.MatCell, selector: "mat-cell, td[mat-cell]" }, { kind: "component", type: i18.MatHeaderRow, selector: "mat-header-row, tr[mat-header-row]", exportAs: ["matHeaderRow"] }, { kind: "component", type: i18.MatRow, selector: "mat-row, tr[mat-row]", exportAs: ["matRow"] }, { kind: "directive", type: i13$1.MatTooltip, selector: "[matTooltip]", exportAs: ["matTooltip"] }, { kind: "directive", type: i20.TranslateDirective, selector: "[translate],[ngx-translate]", inputs: ["translate", "translateParams"] }, { kind: "component", type: PlotlyComponent, selector: "plotly-plot", inputs: ["data", "layout", "config", "frames", "style", "divId", "revision", "className", "debug", "useResizeHandler", "updateOnLayoutChange", "updateOnDataChange", "updateOnlyWithRevision"], outputs: ["initialized", "update", "purge", "error", "afterExport", "afterPlot", "animated", "animatingFrame", "animationInterrupted", "autoSize", "beforeExport", "buttonClicked", "click", "plotlyClick", "clickAnnotation", "deselect", "doubleClick", "framework", "hover", "legendClick", "legendDoubleClick", "react", "relayout", "restyle", "redraw", "selected", "selecting", "sliderChange", "sliderEnd", "sliderStart", "transitioning", "transitionInterrupted", "unhover", "relayouting", "treemapclick", "sunburstclick"] }, { kind: "component", type: DateSelectorComponent, selector: "app-date-selector", inputs: ["action", "startDate", "endDate", "expanded"], outputs: ["filterDatesEvent"] }, { kind: "component", type: HelpInlineComponent, selector: "app-help-inline", inputs: ["description", "title", "mode", "label", "color", "btnClass", "icon", "svgicon", "dialogWidth", "status", "translateParams"] }, { kind: "pipe", type: i20.TranslatePipe, name: "translate" }, { kind: "pipe", type: StringFormatterPipe, name: "stringFormatter" }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.9", ngImport: i0, type: DynamicDashboardCardComponent, decorators: [{
            type: Component,
            args: [{ selector: 'ngx-dynamic-dashboard-card, ngx-dashboard-card', template: "<div id=\"dash-container-{{cardContainerConfig.id}}\" #elementCard class=\"dashboard-card-wrapper\" \n    [ngClass]=\"cardContainerConfig.cssClasses\" [class.status-dander]=\"healthStatus == 'danger'\" \n    [class.status-warning]=\"healthStatus == 'warning'\">\n    \n    <mat-card id=\"dash-matcard-{{cardContainerConfig.id}}\" class=\"dashboard-card {{ graphicType }} mat-elevation-z0\" [ngClass]=\"{'hasIcon' : cardContainerConfig.iconHeader , 'hide-shadow' : cardContainerConfig.hideShadowBorder, 'bg-rating-error' : healthStatus == 'error','bg-rating-warning' : healthStatus == 'warning'}\">\n      <mat-icon color=\"primary\" class=\"icon-card\" *ngIf=\"cardContainerConfig.iconHeader\">{{ cardContainerConfig.iconHeader }}</mat-icon>\n      <mat-card-header  class=\"mb-0\" id=\"dash-header-{{cardContainerConfig.id}}\" #elHeader fxLayout=\"row\" fxLayoutAlign=\"center center\">\n        <mat-card-title *ngIf=\"cardContainerConfig.title\" fxLayout=\"row\" fxLayoutAlign=\"flex-start center\" fxFlex=\"100\">\n          <app-help-inline *ngIf=\"cardContainerConfig.helpDescription || cardContainerConfig.helpTitle\" [mode]=\"'dialog'\" [description]=\"cardContainerConfig.helpDescription\" [title]=\"cardContainerConfig.helpTitle\" [status]=\"healthStatus\" [dialogWidth]=\"cardContainerConfig.helpWidth\"></app-help-inline>\n          <span translate [innerHTML]=\"cardContainerConfig.title\"></span>\n        </mat-card-title>\n       \n        <div class=\"card-actions\" fxFlex=\"1 1 auto\" fxLayoutAlign=\"flex-end center\">\n          <app-date-selector *ngIf=\"cardContainerConfig.isRequiredDateFields\" [startDate]=\"startFilteringDate\"\n            [endDate]=\"endFilteringDate\" (filterDatesEvent)=\"updateCardGraphicBySelectorDate($event)\" [expanded]=\"true\">\n          </app-date-selector>\n          <ng-container *ngIf=\"graphic && graphic.data.length > 0\">\n            <!--mat select change limit pie-->\n            <mat-form-field class=\"mr-16\" appearance=\"outline\" \n              *ngIf=\"graphic.data[0].type == 'pie' && checkViewLimitPieSelect() && graphicConfig != null\">\n              <mat-label translate>label.filter_results</mat-label>\n              <mat-select [(ngModel)]=\"selectedPieLimitValues\" (selectionChange)=\"newPieLimitValuesSelected($event)\">\n                <mat-option value=\"TOPFIVE\">\n                  <span translate>label.top_five</span>\n                </mat-option>\n                <mat-option value=\"ALL\">\n                  <span translate>label.all</span>\n                </mat-option>\n              </mat-select>\n            </mat-form-field>\n            <!--mat select change possible metrics-->\n            <mat-form-field appearance=\"outline\" *ngIf=\"graphic.possibleMetrics\">\n              <mat-label translate>dashboard.widget.possibleMetrics</mat-label>\n              <mat-select [(ngModel)]=\"selectedMetric\" (selectionChange)=\"newMetricSelected($event)\">\n                <mat-option *ngFor=\"let pm of graphic.possibleMetrics\" [value]=\"pm\">\n                  {{pm.label}}\n                </mat-option>\n              </mat-select>\n            </mat-form-field>\n            <!--mat select change combination of metrics-->\n            <mat-form-field appearance=\"outline\" *ngIf=\"graphic.possibleMultipleMetrics\">\n              <mat-label translate>dashboard.widget.possible_multiple_metrics_view</mat-label>\n              <mat-select [(ngModel)]=\"selectedMultipleMetric\" (selectionChange)=\"newMultipleMetricSelected($event)\">\n                <mat-option *ngFor=\"let pm of graphic.possibleMultipleMetrics\" [value]=\"pm\">\n                  {{pm.label}}\n                </mat-option>\n              </mat-select>\n            </mat-form-field>\n          </ng-container>\n          <ng-container *ngIf=\"table && showCheckboxes && plotRowsButtonVisible\">\n            <button (click)=\"plotNewRows()\" mat-flat-button *ngIf=\"plotRowsButtonVisible\"\n              [disabled]=\"plotRowsButtonDisabled\" color=\"primary\" #buttonPlotRows>\n              <span translate>label.plotrows</span></button>\n          </ng-container>\n          <ng-container  *ngIf=\"table && cardContainerConfig.isRequiredTableFilter\">\n            <!-- <span class=\"spacer\" fxFlex=\"1 1 0\"></span> -->\n            <mat-form-field appearance=\"outline\">\n              <mat-label>Filtra risultati</mat-label>\n              <input matInput (keyup)=\"applyFilter($event)\" placeholder=\"Filtra\" #input>\n            </mat-form-field>\n          </ng-container>\n          <!-- <button mat-icon-button (click)=\"editDashboardCard()\" matTooltip=\"Modifica widget\">\n            <mat-icon class=\"animate-pen\">settings</mat-icon>\n          </button> -->\n        </div>\n      </mat-card-header>\n      \n      <mat-card-content *ngIf=\"showData;else noShowData\" class=\"container-card\" [ngClass]=\"{'graphic-chart':graphic , 'table-chart':table }\" #cardContent>\n              \n        <!--start grafic definition-->\n        <div *ngIf=\"graphic && !cardContainerConfig.loaderVisible\" class=\"grahpic-data\">\n         <!-- <span style=\"position:absolute; top:0\">{{ graphic.layout.width }} -  {{ graphic.layout.height }}</span> -->\n          <plotly-plot *ngIf=\"graphic.data.length > 0; else elseBlock\" \n              [data]=\"graphic.data\" [layout]=\"graphic.layout\" [config] =\"graphic.config\" #plotlyGraph \n              (afterPlot)=\"afterPlot($event)\" (initialized)=\"afterPlot($event)\" [updateOnLayoutChange]=\"true\"\n              (plotlyClick)=\"emitPlotlyEvent($event)\" (hover)=\"emitPlotlyEvent($event)\"></plotly-plot>\n        </div>\n         <ng-template #elseBlock>\n            <div class=\"no-data\">\n            \n             <mat-icon class=\"icon-nodata\">warning</mat-icon><span translate>label.nodata</span> \n                <!-- <img class=\"placeholder-nodata\"[src]=\"'/assets/images/placeholders/chart_2.png'\"> -->\n            </div>\n          </ng-template>\n        \n        <!--start table definition-->\n        <div *ngIf=\"table && !cardContainerConfig.loaderVisible\" class=\"table-data\">\n            <!-- <ng-container *ngIf=\"showCheckboxes\">\n                <button (click)=\"plotNewRows()\" mat-flat-button [visible]=\"plotRowsButtonVisible\" [disabled]=\"plotRowsButtonDisabled\" color=\"primary\">\n                  Disegna righe selezionate nel grafico</button>\n            </ng-container> -->\n            <div class=\"mobile-sort-button-container\">\n                <button class=\"mobile-sort-button mb-8\" (click)=\"toggleOrderBlock()\" mat-flat-button>Ordina</button>\n            </div>\n            <div class=\"table-wrapper\" >\n              <table  #dataTableElement *ngIf=\"_checkData(); else elseBlock\"  class=\"mat-table-responsive striped dense hoverable\" \n                mat-table [dataSource]=\"dataSource\" matSort (matSortChange)=\"sortingTable($event)\">\n                <ng-container *ngFor=\"let header of colHeaders; let headerIndex = index\" matColumnDef=\"{{header}}\">\n                  <th mat-header-cell *matHeaderCellDef mat-sort-header [disabled]=\"isSortingDisabled(header)\"> \n                    <!--Evitare di vedere il primo e il secondo elemento (nel caso sia necessario vedere le checkbox)-->\n                    <ng-container *ngIf=\"showHeader(headerIndex)\">\n                      {{header | translate}}\n                    </ng-container>\n                  </th>\n                  <td mat-cell *matCellDef=\"let element\">\n                    <!--manca il disabled-->\n                    <mat-checkbox *ngIf=\"headerIndex == 0 && showCheckboxes\" [checked]=\"matCheckboxChecked(element[header])\"\n                      (change)=\"updateSelectedLabel($event, element[header])\" \n                      [disabled]=\"tableLimitFilterValuesEnabled && filterValues.size >= limitFilterValues && !matCheckboxChecked(element[header])\">\n                      <span matTooltip=\"Aggiungi / rimuovi la riga al grafico\" matTooltipPosition=\"right\">&nbsp;</span></mat-checkbox>\n                    <span class=\"mobile-label\">{{header | translate}}:</span>\n                    <label *ngIf=\"element[header] != null && showElement(headerIndex)\" \n                      matTooltip=\"{{(element[header] != null && showElement(headerIndex)) ? element[header] : null}}\"\n                      [matTooltipDisabled]=\"tooltipDisabledTable(element[header])\">\n                      \n                      <!-- <span [innerHTML]=\"validUrl(element[header])\"></span> -->\n                      <!-- <button class=\"link_icon_button\" mat-icon-button *ngIf=\"validUrl(element[header])\">\n                        <a mat-icon target=\"_blank\" href=\"{{element[header]}}\"><mat-icon >open_in_new</mat-icon></a>\n                      </button> -->\n                      <!-- <a *ngIf=\"isValidUrl(element[header]); else elseBlock\" [attr.href]=\"element[header]\" target=\"_blank\">\n                        {{(element[header].length>36)? (element[header] | slice:0:36)+'...':(element[header])}}\n                      </a> -->\n                      \n                        <span innerHTML=\"{{checkElement(element[header], element, header) | stringFormatter}}\"></span>\n                    </label>\n                  </td>\n                </ng-container>\n                <tr mat-header-row *matHeaderRowDef=\"displayedColumns; sticky: true\"></tr>\n                <tr mat-row *matRowDef=\"let element; columns: displayedColumns;\" \n                (click)=\"clickRow(element)\" [ngClass]=\"{'clickableRow': clickableRows}\"></tr>\n              </table>\n              <ng-template #elseBlock>\n                <div class=\"no-data\">\n                  <mat-icon class=\"icon-nodata\">warning</mat-icon><span translate>label.nodata</span> \n                  <!-- <img class=\"placeholder-nodata\" [src]=\"'/assets/images/placeholders/table.png'\"> -->\n                </div>\n              </ng-template>\n              <div class=\"table-actions\" fxLayout=\"row\" fxLayoutAlign=\"space-between center\">\n                <button  mat-flat-button *ngIf=\"table && showCheckboxes && selectedRowsButtonVisible\" \n                color=\"primary\" \n                (click)=\"plotNewRows()\"\n                [disabled]=\"plotRowsButtonDisabled\" \n                color=\"primary\"\n                #buttonSelectRows>\n                  <span translate>label.select_target</span>\n                  </button>\n                  <div class=\"spacer\" fxFlex=\"1 1 auto\"></div>\n                <mat-paginator [length]=\"data.length\" [pageSize]=\"pageSize\" [pageSizeOptions]=\"pageSizeOptions\" (page)=\"handlePageEvent($event)\"\n                showFirstLastButtons>\n                <!-- <mat-paginator *ngIf=\"!checkData()\" [length]=\"data?.length\" [pageSize]=\"pageSize\" [pageSizeOptions]=\"pageSizeOptions\"\n                [pageIndex]=\"pageNo\" showFirstLastButtons> -->\n              </mat-paginator>\n              </div>\n              \n            </div>\n        </div>\n\n        <div *ngIf=\"heatmap  && !cardContainerConfig.loaderVisible\" #heatmapContent>\n          <!-- map heatmap {{ heatmapLocations }} -->\n          <!-- <app-heatmap  [mapid]=\"'map-'+cardContainerConfig.id\" [heatmapLocations]=\"heatmapLocations\" [heatmapConfigs]='heatmapConfigs' #heatToSearch></app-heatmap> -->\n        </div>\n        <!-- start custom content -->\n        <ng-content select=\"[custom]\"></ng-content>\n        \n      </mat-card-content>\n      <ng-template #noShowData>\n        <div class=\"no-data p-16\">\n            <!-- <mat-icon class=\"icon-nodata has-heath-status\">{{healthStatus}}</mat-icon>  -->\n            <span [innerHTML]=\"dataMessage | translate\"></span>\n        </div>\n      </ng-template>\n    <!--end table definition-->\n    </mat-card>\n  </div>", styles: [".container-card.graphic-chart{margin:0 -16px;min-height:75px}::ng-deep .dashboard-card-header .mat-card-header-text{width:100%}.icon-card{width:100px;margin:auto;border-radius:7px;display:block;height:100px;line-height:100px;text-align:center;font-size:3em;position:absolute;left:20px;top:0;bottom:0;margin:auto!important;z-index:1}.hasIcon{padding-left:140px;position:relative}.mat-table{text-align:center}.card-actions .mat-form-field{min-width:150px}.hide-shadow{box-shadow:none!important}.no-data{display:flex;align-items:center;justify-content:center;flex-direction:column;position:relative;z-index:1}.no-data .icon-nodata{position:relative;left:0;top:0;height:100%;font-size:4em;width:100%;margin:auto;display:flex;align-items:center;justify-content:center;opacity:.2}.placeholder-nodata{max-height:300px}::ng-deep .js-plotly-plot .plotly,::ng-deep .js-plotly-plot .plotly div,::ng-deep .js-plotly-plot .plotly svg{max-width:100%;margin:auto}::ng-deep .js-plotly-plot .modebar-container{filter:invert(1)}::ng-deep .js-plotly-plot .modebar-container .modebar-group{background:transparent!important}::ng-deep .js-plotly-plot .plotly .main-svg:nth-child(1){position:relative}.link_icon_button{width:24px;height:24px;line-height:12px}.link_icon_button .mat-icon{min-width:12px;min-height:12px;font-size:12px}\n"] }]
        }], ctorParameters: function () { return [{ type: undefined, decorators: [{
                    type: Inject,
                    args: [DOCUMENT]
                }] }, { type: i1$1.MatDialog }, { type: i2.MatSnackBar }, { type: i3$2.ErrorHandlerService }, { type: i0.Injector }]; }, propDecorators: { graphicConfig: [{
                type: Input
            }], graphic: [{
                type: Input
            }], table: [{
                type: Input
            }], heatmap: [{
                type: Input
            }], cardContainerConfig: [{
                type: Input
            }], action: [{
                type: Input
            }], status: [{
                type: Input
            }], isGridsterElement: [{
                type: Input
            }], forceAfterPlotForGridster: [{
                type: Input
            }], newContainerWidth: [{
                type: Input
            }], numberColumns: [{
                type: Input
            }], tableLimitFilterValuesEnabled: [{
                type: Input
            }], filterDatesEvent: [{
                type: Output
            }], selectedMetricEvent: [{
                type: Output
            }], selectedMultipleMetricViewEvent: [{
                type: Output
            }], selectedLimitPieResults: [{
                type: Output
            }], drawRowsEvent: [{
                type: Output
            }], selectDashboardCard: [{
                type: Output
            }], afterPlotEvent: [{
                type: Output
            }], tablePageEvent: [{
                type: Output
            }], plotlyEvent: [{
                type: Output
            }], elementCard: [{
                type: ViewChild,
                args: ['elementCard']
            }], elHeader: [{
                type: ViewChild,
                args: ['elHeader']
            }], plotlyGraph: [{
                type: ViewChild,
                args: ['plotlyGraph']
            }], tdRef: [{
                type: ViewChild,
                args: ['tr']
            }], filterElement: [{
                type: ViewChild,
                args: ['input']
            }], elementCardContent: [{
                type: ViewChild,
                args: ['cardContent']
            }], buttonPlotRows: [{
                type: ViewChild,
                args: ['buttonPlotRows']
            }], buttonSelectRows: [{
                type: ViewChild,
                args: ['buttonSelectRows']
            }] } });

class SharedModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.9", ngImport: i0, type: SharedModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "16.2.9", ngImport: i0, type: SharedModule, declarations: [PlotlyComponent], imports: [CommonModule], exports: [PlotlyComponent] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "16.2.9", ngImport: i0, type: SharedModule, providers: [PlotlyService], imports: [CommonModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.9", ngImport: i0, type: SharedModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [PlotlyComponent],
                    imports: [
                        CommonModule,
                    ],
                    providers: [PlotlyService],
                    exports: [PlotlyComponent]
                }]
        }] });

class PlotlyViaWindowModule {
    constructor() {
        const plotly = window.Plotly;
        if (typeof plotly === 'undefined') {
            throw new Error(`Plotly object not found on window.`);
        }
        PlotlyService.setPlotly(plotly);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.9", ngImport: i0, type: PlotlyViaWindowModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "16.2.9", ngImport: i0, type: PlotlyViaWindowModule, imports: [CommonModule, SharedModule], exports: [SharedModule] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "16.2.9", ngImport: i0, type: PlotlyViaWindowModule, providers: [PlotlyService], imports: [CommonModule, SharedModule, SharedModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.9", ngImport: i0, type: PlotlyViaWindowModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [],
                    imports: [CommonModule, SharedModule],
                    providers: [PlotlyService],
                    exports: [SharedModule],
                }]
        }], ctorParameters: function () { return []; } });

class NgxDynamicDashboardModule {
    constructor(plotlyService) {
        // plotly as module
        // PlotlyJS.register(ItalianLocale);
        // PlotlyJS.setPlotConfig({ locale: 'it-IT' })
        this.plotlyService = plotlyService;
        // plotly as window
        // window.Plotly.register(ItalianLocale);
        // window.Plotly.setPlotConfig({ locale: 'it-IT' })
        this._setupPlotlyWithLocale();
        // plotly as cdn
        // // let plotly = this.plotlyService.getPlotly();
        // // this.plotlyService.getPlotly().register(ItalianLocale);
        // // this.plotlyService.getPlotly().setPlotConfig({ locale: 'it-IT' });
        // this._setupPlotlyWithLocale();
    }
    async _setupPlotlyWithLocale() {
        const plotly = await this.plotlyService.getPlotly();
        if (!plotly || plotly == 'waiting') {
            setTimeout(() => {
                this._setupPlotlyWithLocale();
            }, 100);
            return;
        }
        plotly.register(ItalianLocale);
        plotly.setPlotConfig({ locale: 'it-IT' });
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.9", ngImport: i0, type: NgxDynamicDashboardModule, deps: [{ token: PlotlyService }], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "16.2.9", ngImport: i0, type: NgxDynamicDashboardModule, declarations: [NgxDynamicDashboardComponent,
            NgxDynamicDashboardCustomPaginator,
            AdminEditComponent,
            AdminMessageComponent,
            DynamicDashboardCardComponent,
            StringFormatterPipe,
            DateSelectorComponent,
            HelpInlineComponent,
            HelpInlineDialog], imports: [CommonModule,
            FlexLayoutModule,
            MareLoaderModule,
            MareAuthModule,
            MatToolbarModule,
            MatButtonModule,
            FormsModule,
            // SharedModule,
            MatAutocompleteModule,
            // MatBadgeModule,
            // MatButtonToggleModule,
            MatCardModule,
            MatCheckboxModule,
            MatChipsModule,
            MatDatepickerModule,
            MatDialogModule,
            MatDividerModule,
            MatExpansionModule,
            MatFormFieldModule,
            // MatGridListModule,
            MatIconModule,
            MatInputModule,
            MatListModule,
            MatMenuModule,
            MatNativeDateModule,
            MatOptionModule,
            MatPaginatorModule,
            MatProgressBarModule,
            MatProgressSpinnerModule,
            MatRadioModule,
            MatSelectModule,
            // MatSidenavModule,
            MatSlideToggleModule,
            MatSortModule,
            MatStepperModule,
            MatTableExporterModule,
            MatTableModule,
            // MatTabsModule,
            MatTooltipModule,
            GridsterModule,
            MatSnackBarModule,
            // DashboardCardModule,
            ReactiveFormsModule,
            TranslateModule,
            // PlotlyModule,
            PlotlyViaWindowModule
            // HeatmapModule
        ], exports: [NgxDynamicDashboardComponent,
            DynamicDashboardCardComponent] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "16.2.9", ngImport: i0, type: NgxDynamicDashboardModule, imports: [CommonModule,
            FlexLayoutModule,
            MareLoaderModule,
            MareAuthModule,
            MatToolbarModule,
            MatButtonModule,
            FormsModule,
            // SharedModule,
            MatAutocompleteModule,
            // MatBadgeModule,
            // MatButtonToggleModule,
            MatCardModule,
            MatCheckboxModule,
            MatChipsModule,
            MatDatepickerModule,
            MatDialogModule,
            MatDividerModule,
            MatExpansionModule,
            MatFormFieldModule,
            // MatGridListModule,
            MatIconModule,
            MatInputModule,
            MatListModule,
            MatMenuModule,
            MatNativeDateModule,
            MatOptionModule,
            MatPaginatorModule,
            MatProgressBarModule,
            MatProgressSpinnerModule,
            MatRadioModule,
            MatSelectModule,
            // MatSidenavModule,
            MatSlideToggleModule,
            MatSortModule,
            MatStepperModule,
            MatTableExporterModule,
            MatTableModule,
            // MatTabsModule,
            MatTooltipModule,
            GridsterModule,
            MatSnackBarModule,
            // DashboardCardModule,
            ReactiveFormsModule,
            TranslateModule,
            // PlotlyModule,
            PlotlyViaWindowModule
            // HeatmapModule
        ] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.9", ngImport: i0, type: NgxDynamicDashboardModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [
                        NgxDynamicDashboardComponent,
                        NgxDynamicDashboardCustomPaginator,
                        AdminEditComponent,
                        AdminMessageComponent,
                        DynamicDashboardCardComponent,
                        StringFormatterPipe,
                        DateSelectorComponent,
                        HelpInlineComponent,
                        HelpInlineDialog,
                    ],
                    imports: [
                        CommonModule,
                        FlexLayoutModule,
                        MareLoaderModule,
                        MareAuthModule,
                        MatToolbarModule,
                        MatButtonModule,
                        FormsModule,
                        // SharedModule,
                        MatAutocompleteModule,
                        // MatBadgeModule,
                        // MatButtonToggleModule,
                        MatCardModule,
                        MatCheckboxModule,
                        MatChipsModule,
                        MatDatepickerModule,
                        MatDialogModule,
                        MatDividerModule,
                        MatExpansionModule,
                        MatFormFieldModule,
                        // MatGridListModule,
                        MatIconModule,
                        MatInputModule,
                        MatListModule,
                        MatMenuModule,
                        MatNativeDateModule,
                        MatOptionModule,
                        MatPaginatorModule,
                        MatProgressBarModule,
                        MatProgressSpinnerModule,
                        MatRadioModule,
                        MatSelectModule,
                        // MatSidenavModule,
                        MatSlideToggleModule,
                        MatSortModule,
                        MatStepperModule,
                        MatTableExporterModule,
                        MatTableModule,
                        // MatTabsModule,
                        MatTooltipModule,
                        GridsterModule,
                        MatSnackBarModule,
                        // DashboardCardModule,
                        ReactiveFormsModule,
                        TranslateModule,
                        // PlotlyModule,
                        PlotlyViaWindowModule
                        // HeatmapModule
                    ],
                    exports: [
                        NgxDynamicDashboardComponent,
                        DynamicDashboardCardComponent
                    ]
                }]
        }], ctorParameters: function () { return [{ type: PlotlyService }]; } });

class StatusMappingObject {
}

class YAxis {
    constructor(id, idFieldName, table, xaxis, value, label, color, dataFilter, dataAggregate, valuesList, onClick, valueFunction) {
        this.sortByField = false;
        this.id = id;
        this.idFieldName = idFieldName;
        this.table = table;
        this.xaxis = xaxis;
        this.value = value;
        this.label = label;
        this.color = color;
        if (dataFilter) {
            this.dataFilter = dataFilter;
        }
        if (dataAggregate) {
            this.dataAggregate = {
                aggregationField: dataAggregate.aggregationField,
                aggregationFunctionString: dataAggregate.aggregationFunctionString,
                groupByField: dataAggregate.groupByField
            };
        }
        // if(this.dataAggregate && !this.dataAggregate.aggregationFunctionString){
        //   this.dataAggregate.aggregationFunctionString = 'sum'
        // }
        if (valuesList)
            this.valuesList = valuesList;
        if (onClick)
            this.onClick = onClick;
        if (valueFunction)
            this.valueFunction = valueFunction;
    }
}

class Shapes {
    constructor(type, xref, yref, x0, y0, x1, y1, fillcolor, opacity) {
        this.type = type;
        this.xref = xref;
        this.yref = yref;
        this.x0 = x0;
        this.y0 = y0;
        this.x1 = x1;
        this.y1 = y1;
        this.fillcolor = fillcolor;
        this.opacity = opacity ? opacity : 0.2;
    }
}

/*
 * Public API Surface of ngx-dynamic-dashboard
 */

/**
 * Generated bundle index. Do not edit.
 */

export { Bar, BaseTrace, Bubble, CardContainerConfig, DynamicDashboardCardComponent, Funnel, GraphicConfig, GraphicFactory, Heatmap, HeatmapObj, Indicator, Line, Maparea, NgxDynamicDashboardComponent, NgxDynamicDashboardModule, NgxDynamicDashboardService, Pie, Radar, Shapes, StatusMappingObject, Table, Trace, YAxis };
